/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import type * as Types from "./base-types";

import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export * from "./base-types";
export type GetAdminDebugRepairPlanQueryVariables = Exact<{
  id: string;
}>;

export type GetAdminDebugRepairPlanQuery = {
  __typename: "Query";
  adminDebugRepairPlan: {
    __typename: "AdminDebugRepairPlan";
    id: string;
    repair: string;
    state: string;
    outcome: string | null;
    callerUserId: any;
    createdAt: string;
    expiresAt: string;
    build: string;
    runningBuild: string;
    refusal: string | null;
    planText: string;
  } | null;
};

export type IssueAdminDebugRepairApprovalMutationVariables = Exact<{
  planId: string;
}>;

export type IssueAdminDebugRepairApprovalMutation = {
  __typename: "Mutation";
  adminIssueDebugRepairApproval: {
    __typename: "AdminDebugRepairApprovalResult";
    success: boolean;
    message: string | null;
    planId: string;
    approvalCode: string | null;
    expiresAt: string | null;
  };
};

export type AdminTriggerTmDataImportMutationVariables = Exact<{ [key: string]: never }>;

export type AdminTriggerTmDataImportMutation = {
  __typename: "Mutation";
  adminTriggerTMDataImport: { __typename: "AdminActionResult"; success: boolean; message: string | null };
};

export type AdminTriggerClubImportMutationVariables = Exact<{ [key: string]: never }>;

export type AdminTriggerClubImportMutation = {
  __typename: "Mutation";
  adminTriggerClubImport: { __typename: "AdminActionResult"; success: boolean; message: string | null };
};

export type AdminStartEasySpeakArchiveImportMutationVariables = Exact<{
  instance: string;
  easySpeakClubId: number;
  clubId: number;
  maxDate?: string | null | undefined;
  dryRun?: boolean | null | undefined;
}>;

export type AdminStartEasySpeakArchiveImportMutation = {
  __typename: "Mutation";
  adminStartEasySpeakArchiveImport: {
    __typename: "AdminStartArchiveImportResult";
    accepted: boolean;
    jobId: string | null;
    message: string | null;
  };
};

export type AdminCloseEasySpeakIdentityFlagsMutationVariables = Exact<{
  flagIds: Array<any> | any;
  resolution: string;
}>;

export type AdminCloseEasySpeakIdentityFlagsMutation = {
  __typename: "Mutation";
  adminCloseEasySpeakIdentityFlags: {
    __typename: "AdminCloseEasySpeakIdentityFlagsResult";
    success: boolean;
    closed: number;
    message: string | null;
  };
};

export type AdminRunEasySpeakAutoStageMutationVariables = Exact<{
  instance?: string | null | undefined;
  clubIds?: Array<number> | number | null | undefined;
  maxClubs?: number | null | undefined;
}>;

export type AdminRunEasySpeakAutoStageMutation = {
  __typename: "Mutation";
  adminRunEasySpeakAutoStage: { __typename: "AdminRunAutoStageResult"; accepted: boolean; message: string | null };
};

export type AdminMintEasySpeakCaptureTokenMutationVariables = Exact<{
  instance: string;
  label?: string | null | undefined;
}>;

export type AdminMintEasySpeakCaptureTokenMutation = {
  __typename: "Mutation";
  adminMintEasySpeakCaptureToken: {
    __typename: "AdminMintCaptureTokenResult";
    success: boolean;
    message: string | null;
    token: string | null;
    summary: {
      __typename: "AdminCaptureTokenSummary";
      id: any;
      label: string;
      instance: string;
      createdByEmail: string;
      createdAt: string;
      expiresAt: string;
      revokedAt: string | null;
      lastUsedAt: string | null;
      pagesUsed: number;
      maxPages: number;
      bytesUsed: any;
      maxBytes: any;
      live: boolean;
      refusedReason: string | null;
    } | null;
  };
};

export type AdminRevokeEasySpeakCaptureTokenMutationVariables = Exact<{
  id: any;
}>;

export type AdminRevokeEasySpeakCaptureTokenMutation = {
  __typename: "Mutation";
  adminRevokeEasySpeakCaptureToken: {
    __typename: "AdminRevokeCaptureTokenResult";
    success: boolean;
    message: string | null;
  };
};

export type AdminRequeueMutationOutboxRowsMutationVariables = Exact<{
  ids: Array<any> | any;
}>;

export type AdminRequeueMutationOutboxRowsMutation = {
  __typename: "Mutation";
  adminRequeueMutationOutboxRows: { __typename: "AdminRequeueMutationOutboxRowsResult"; requeued: number };
};

export type AdminNudgeFieldsFragment = {
  __typename: "AdminNudge";
  id: any;
  minMembers: number;
  maxMembers: number;
  isDCPEligible: boolean | null;
  minDCPPoints: number;
  maxDCPPoints: number;
  officersTrainedRnd1: boolean | null;
  officersTrainedRnd2: boolean | null;
  officerListSubmittedOnTime: boolean | null;
  maxPossibleDCPPoints: number | null;
  months: string | null;
  suggestion: string;
  priority: number;
  notes: string | null;
  enabled: boolean;
  updatedAt: string | null;
  version: number;
};

export type GetAdminNudgesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminNudgesQuery = {
  __typename: "Query";
  adminNudges: Array<{
    __typename: "AdminNudge";
    id: any;
    minMembers: number;
    maxMembers: number;
    isDCPEligible: boolean | null;
    minDCPPoints: number;
    maxDCPPoints: number;
    officersTrainedRnd1: boolean | null;
    officersTrainedRnd2: boolean | null;
    officerListSubmittedOnTime: boolean | null;
    maxPossibleDCPPoints: number | null;
    months: string | null;
    suggestion: string;
    priority: number;
    notes: string | null;
    enabled: boolean;
    updatedAt: string | null;
    version: number;
  }>;
};

export type AdminSaveNudgeMutationVariables = Exact<{
  id?: any;
  expectedVersion?: number | null | undefined;
  input: Types.AdminNudgeInput;
}>;

export type AdminSaveNudgeMutation = {
  __typename: "Mutation";
  adminSaveNudge: {
    __typename: "AdminSaveNudgeResult";
    success: boolean;
    message: string | null;
    nudge: {
      __typename: "AdminNudge";
      id: any;
      minMembers: number;
      maxMembers: number;
      isDCPEligible: boolean | null;
      minDCPPoints: number;
      maxDCPPoints: number;
      officersTrainedRnd1: boolean | null;
      officersTrainedRnd2: boolean | null;
      officerListSubmittedOnTime: boolean | null;
      maxPossibleDCPPoints: number | null;
      months: string | null;
      suggestion: string;
      priority: number;
      notes: string | null;
      enabled: boolean;
      updatedAt: string | null;
      version: number;
    } | null;
  };
};

export type AdminSetNudgeEnabledMutationVariables = Exact<{
  id: any;
  enabled: boolean;
}>;

export type AdminSetNudgeEnabledMutation = {
  __typename: "Mutation";
  adminSetNudgeEnabled: { __typename: "AdminDeleteNudgeResult"; success: boolean; message: string | null };
};

export type AdminDeleteNudgeMutationVariables = Exact<{
  id: any;
  expectedVersion: number;
}>;

export type AdminDeleteNudgeMutation = {
  __typename: "Mutation";
  adminDeleteNudge: { __typename: "AdminDeleteNudgeResult"; success: boolean; message: string | null };
};

export type GetAdminStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminStatsQuery = {
  __typename: "Query";
  adminStats: {
    __typename: "AdminStats";
    timestamp: string;
    stats: Array<{ __typename: "AdminStat"; name: string; value: string }>;
    properties: Array<{ __typename: "AdminStat"; name: string; value: string }>;
    config: Array<{
      __typename: "ConfigSection";
      name: string;
      values: Array<{ __typename: "AdminStat"; name: string; value: string }>;
    }>;
  };
};

export type GetAdminClubStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminClubStatusQuery = {
  __typename: "Query";
  adminClubStatus: Array<{
    __typename: "ClubStatus";
    clubId: number;
    shortName: string;
    longName: string;
    district: string;
    division: string;
    area: string;
    memberCount: number;
    guestbookEnabled: boolean;
    webHosting: string;
    memberManagementEnabled: boolean;
    cardPaymentsEnabled: boolean;
    calendarEnabled: boolean;
    listedInTI: boolean;
    isPioneerClub: boolean;
    isCorporate: boolean;
    newMemberFee: number | null;
    monthlyDues: number | null;
    currency: string | null;
    charterDate: string | null;
    tiStatus: string;
    suspendDate: string | null;
  }>;
};

export type GetAdminUsageAnalyticsQueryVariables = Exact<{
  from?: string | null | undefined;
  to?: string | null | undefined;
  clubId?: string | number | null | undefined;
  featureArea?: string | null | undefined;
  officerOnly?: boolean | null | undefined;
  converted?: boolean | null | undefined;
}>;

export type GetAdminUsageAnalyticsQuery = {
  __typename: "Query";
  adminUsageAnalytics: {
    __typename: "AdminUsageAnalyticsDashboard";
    generatedAt: string;
    fromDate: string;
    toDate: string;
    kpis: {
      __typename: "AdminUsageAnalyticsKpis";
      uniqueUsers: number;
      uniqueClubs: number;
      trialConversionCount: number;
      trialConversionRate: number;
      faqViewCount: number;
      faqViewRate: number;
      docsClickCount: number;
      docsClickRate: number;
      returnedWithin7DaysCount: number;
      returnedWithin7DaysRate: number;
    };
    funnel: Array<{
      __typename: "AdminUsageAnalyticsFunnelStep";
      stepKey: string;
      label: string;
      userCount: number;
      dropOffCount: number;
      dropOffRate: number;
    }>;
    firstActions: Array<{ __typename: "AdminUsageAnalyticsFirstAction"; label: string; count: number }>;
    topRoutes: Array<{
      __typename: "AdminUsageAnalyticsTopRoute";
      segment: string;
      routeName: string;
      featureArea: string;
      count: number;
    }>;
    cohort: Array<{
      __typename: "AdminUsageAnalyticsCohortRow";
      userId: any;
      clubId: number;
      clubName: string;
      isOfficer: boolean;
      firstUnsubscribedVisitAt: string;
      firstKnownLoginAt: string | null;
      firstAction: string;
      lastSeenAt: string;
      converted: boolean;
    }>;
  };
};

export type GetAdminTableStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminTableStatsQuery = {
  __typename: "Query";
  adminTableStats: Array<{ __typename: "TableStat"; tableName: string; count: any }>;
};

export type AdminBrowseClubsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminBrowseClubsQuery = {
  __typename: "Query";
  adminBrowseClubs: Array<{
    __typename: "AdminClubBrowseItem";
    id: any;
    clubId: number;
    shortName: string;
    longName: string;
    districtId: number;
    divisionCode: string;
    areaNumber: number;
    contactEmail: string;
    listedInTI: boolean;
    memberCount: number;
  }>;
};

export type AdminBrowseUsersQueryVariables = Exact<{ [key: string]: never }>;

export type AdminBrowseUsersQuery = {
  __typename: "Query";
  adminBrowseUsers: Array<{
    __typename: "AdminUserBrowseItem";
    id: any;
    userId: any;
    firstName: string;
    lastName: string;
    emailAddress: string;
  }>;
};

export type AdminClubDetailQueryVariables = Exact<{
  clubId: string | number;
}>;

export type AdminClubDetailQuery = { __typename: "Query"; adminClubDetail: string | null };

export type AdminUserDetailQueryVariables = Exact<{
  userId: any;
}>;

export type AdminUserDetailQuery = { __typename: "Query"; adminUserDetail: string | null };

export type AdminBrowseGenericQueryVariables = Exact<{
  typeName: string;
}>;

export type AdminBrowseGenericQuery = { __typename: "Query"; adminBrowseGeneric: string };

export type AdminDetailGenericQueryVariables = Exact<{
  typeName: string;
  id: any;
}>;

export type AdminDetailGenericQuery = { __typename: "Query"; adminDetailGeneric: string | null };

export type AdminAvailableEmailAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminAvailableEmailAccountsQuery = {
  __typename: "Query";
  adminAvailableEmailAccounts: Array<{ __typename: "AdminEmailAccountInfo"; accountId: string; displayName: string }>;
};

export type GetAdminEmailLogQueryVariables = Exact<{
  offset?: any;
  limit?: any;
  clubId?: string | number | null | undefined;
  status?: string | null | undefined;
  recipient?: string | null | undefined;
  subject?: string | null | undefined;
  from?: string | null | undefined;
  to?: string | null | undefined;
}>;

export type GetAdminEmailLogQuery = {
  __typename: "Query";
  adminEmailLog: {
    __typename: "AdminEmailLogPage";
    offset: any;
    limit: any;
    totalCount: number;
    entries: Array<{
      __typename: "AdminEmailLogEntry";
      id: any;
      createdAt: string;
      clubId: number | null;
      clubShortName: string | null;
      clubLongName: string | null;
      triggeredByUserId: any;
      activityType: string | null;
      emailCategory: string;
      templateKey: string | null;
      senderAccountId: string;
      fromAddress: string;
      replyToRecipients: Array<string>;
      toRecipients: Array<string>;
      ccRecipients: Array<string>;
      bccRecipients: Array<string>;
      subject: string;
      textBody: string | null;
      htmlBody: string | null;
      metadataJson: string;
      deliveryTrackingId: string | null;
      smtpMessageId: string | null;
      sendStatus: string;
      failureReason: string | null;
    }>;
  };
};

export type AdminSendClubEmailsMutationVariables = Exact<{
  clubIds: Array<any> | any;
  fromAccountId: string;
  recipientTypes: Array<string> | string;
  emailSubject: string;
  emailBodyMarkdown: string;
  isTest: boolean;
}>;

export type AdminSendClubEmailsMutation = {
  __typename: "Mutation";
  adminSendClubEmails: {
    __typename: "AdminSendEmailsResponse";
    totalClubs: number;
    totalRecipients: number;
    successfulSends: number;
    failures: Array<{ __typename: "AdminEmailFailure"; clubId: any; recipient: string; errorMessage: string }>;
  };
};

export type GetAdminEasySpeakCaptureQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminEasySpeakCaptureQuery = {
  __typename: "Query";
  adminEasySpeakCapture: {
    __typename: "AdminCaptureSettings";
    enabled: boolean;
    ttlSeconds: any;
    maxPages: number;
    maxBytes: any;
    instances: Array<{
      __typename: "AdminCaptureInstanceStatus";
      host: string;
      archiveMarkerPresent: boolean | null;
      pending: number;
      captured: number;
      notFound: number;
      missing: number;
      error: number;
      distinctClubs: number;
      totalBytes: any;
      lastCapturedAt: string | null;
      clubsKnown: number;
      clubsSeeded: number;
      clubListReadAt: string | null;
    }>;
    tokens: Array<{
      __typename: "AdminCaptureTokenSummary";
      id: any;
      label: string;
      instance: string;
      createdByEmail: string;
      createdAt: string;
      expiresAt: string;
      revokedAt: string | null;
      lastUsedAt: string | null;
      pagesUsed: number;
      maxPages: number;
      bytesUsed: any;
      maxBytes: any;
      live: boolean;
      refusedReason: string | null;
    }>;
    archiveImportJobs: Array<{
      __typename: "AdminArchiveImportJob";
      jobId: string;
      instance: string;
      easySpeakClubId: number;
      clubId: number;
      maxDate: string | null;
      dryRun: boolean;
      submittedByEmail: string;
      submittedAt: string;
      state: Types.AdminArchiveImportJobState;
      durationMillis: any;
      error: string | null;
      refusalsTruncated: boolean;
      warnings: Array<string>;
      warningsTruncated: boolean;
      summary: {
        __typename: "AdminArchiveImportSummary";
        considered: number;
        parsed: number;
        refused: number;
        meetingsWritten: number;
        attendanceRows: number;
        roleAssignments: number;
        stamped: number;
        usersTotal: number;
        usersUnmatched: number;
      } | null;
      refusals: Array<{ __typename: "AdminArchiveImportRefusal"; easySpeakMeetingId: number; reason: string }>;
    }>;
    autoStageLastRun: {
      __typename: "AdminAutoStageRun";
      requestedByEmail: string;
      startedAt: string;
      finishedAt: string | null;
      instance: string | null;
      clubIds: Array<number>;
      maxClubs: number | null;
      selected: number;
      state: Types.AdminAutoStageRunState;
      error: string | null;
      summary: {
        __typename: "AdminAutoStageSummary";
        considered: number;
        upToDate: number;
        submitted: number;
        staged: number;
        skipped: number;
        failed: number;
      } | null;
      outcomes: Array<{
        __typename: "AdminAutoStageClubOutcome";
        clubId: number;
        instance: string;
        easySpeakClubId: number;
        outcome: Types.AdminAutoStageOutcomeKind;
        jobId: string | null;
        reason: string | null;
      }>;
    } | null;
  };
};

export type GetAdminEasySpeakSupportQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminEasySpeakSupportQuery = {
  __typename: "Query";
  adminEasySpeakSupport: Array<{
    __typename: "AdminEasySpeakSupportClub";
    clubId: any;
    clubShortName: string | null;
    clubName: string | null;
    unsettledConflicts: number;
    changedSinceDecided: number;
    contestedMappings: number;
    readError: string | null;
  }>;
};

export type GetAdminEasySpeakIdentityReviewQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminEasySpeakIdentityReviewQuery = {
  __typename: "Query";
  adminEasySpeakIdentityReview: Array<{
    __typename: "AdminEasySpeakIdentityReviewEntry";
    instance: string;
    easySpeakUserId: number;
    displayName: string;
    identity: {
      __typename: "AdminEasySpeakAccount";
      userId: any;
      displayName: string | null;
      emailAddress: string | null;
    } | null;
    disputedAccounts: Array<{
      __typename: "AdminEasySpeakAccount";
      userId: any;
      displayName: string | null;
      emailAddress: string | null;
    }>;
    flags: Array<{
      __typename: "AdminEasySpeakIdentityFlag";
      id: any;
      clubId: number;
      clubName: string | null;
      mappingId: any;
      flaggedByEmail: string;
      flaggedAt: string;
      note: string | null;
      flaggedAccount: {
        __typename: "AdminEasySpeakAccount";
        userId: any;
        displayName: string | null;
        emailAddress: string | null;
      };
    }>;
    rows: Array<{
      __typename: "AdminEasySpeakIdentityRow";
      mappingId: any;
      clubId: number;
      clubName: string | null;
      easySpeakClubId: number;
      easySpeakDisplayName: string;
      state: string;
      decisionRevision: string;
      namedAccount: {
        __typename: "AdminEasySpeakAccount";
        userId: any;
        displayName: string | null;
        emailAddress: string | null;
      } | null;
    }>;
    actionRow: {
      __typename: "AdminEasySpeakIdentityRow";
      mappingId: any;
      clubId: number;
      clubName: string | null;
      decisionRevision: string;
    } | null;
  }>;
};

export type GetAdminEasySpeakAutoStagePreviewQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminEasySpeakAutoStagePreviewQuery = {
  __typename: "Query";
  adminEasySpeakAutoStagePreview: {
    __typename: "AdminAutoStagePreview";
    scheduledEnabled: boolean;
    scheduledOperatorProblem: string | null;
    running: string | null;
    clubs: Array<{
      __typename: "AdminAutoStagePreviewClub";
      clubId: number;
      clubName: string | null;
      instance: string;
      easySpeakClubId: number;
      decision: Types.AdminAutoStageDecision;
      waiting: number;
      reason: string | null;
    }>;
  };
};

export type GetAdminMutationOutboxQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminMutationOutboxQuery = {
  __typename: "Query";
  adminMutationOutbox: {
    __typename: "AdminMutationOutbox";
    pending: number;
    failedRowsTruncated: boolean;
    failedRows: Array<{
      __typename: "AdminMutationOutboxFailedRow";
      id: any;
      aggregateType: string;
      aggregateKey: string;
      kind: string;
      attempts: number;
      lastError: string | null;
      createdAt: string;
      ageSeconds: number;
    }>;
  };
};

export type AgendaTemplateMutationFieldsFragment = {
  __typename: "AgendaTemplate";
  id: string;
  name: string;
  description: string;
  isGlobal: boolean;
  clubId: string | null;
  itemCount: number;
  agenda: Array<{
    __typename: "AgendaItem";
    id: string;
    event: string;
    role: string;
    duration: number;
    backgroundColor: string | null;
    greenMark: number;
    amberMark: number;
    redMark: number;
    maxAssignments: number;
    isRepeatableRole: boolean | null;
    rolePosition: number | null;
  }>;
};

export type CreateAgendaTemplateMutationVariables = Exact<{
  clubId: string | number;
  name: string;
  description: string;
  agendaItems: Array<Types.AgendaItemInput> | Types.AgendaItemInput;
}>;

export type CreateAgendaTemplateMutation = {
  __typename: "Mutation";
  createAgendaTemplate: {
    __typename: "AgendaTemplateResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "AgendaTemplate";
      id: string;
      name: string;
      description: string;
      isGlobal: boolean;
      clubId: string | null;
      itemCount: number;
      agenda: Array<{
        __typename: "AgendaItem";
        id: string;
        event: string;
        role: string;
        duration: number;
        backgroundColor: string | null;
        greenMark: number;
        amberMark: number;
        redMark: number;
        maxAssignments: number;
        isRepeatableRole: boolean | null;
        rolePosition: number | null;
      }>;
    } | null;
  };
};

export type UpdateAgendaTemplateMutationVariables = Exact<{
  clubId: string | number;
  templateId: any;
  name: string;
  description: string;
  agendaItems: Array<Types.AgendaItemInput> | Types.AgendaItemInput;
}>;

export type UpdateAgendaTemplateMutation = {
  __typename: "Mutation";
  updateAgendaTemplate: {
    __typename: "AgendaTemplateResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "AgendaTemplate";
      id: string;
      name: string;
      description: string;
      isGlobal: boolean;
      clubId: string | null;
      itemCount: number;
      agenda: Array<{
        __typename: "AgendaItem";
        id: string;
        event: string;
        role: string;
        duration: number;
        backgroundColor: string | null;
        greenMark: number;
        amberMark: number;
        redMark: number;
        maxAssignments: number;
        isRepeatableRole: boolean | null;
        rolePosition: number | null;
      }>;
    } | null;
  };
};

export type DeleteAgendaTemplateMutationVariables = Exact<{
  clubId: string | number;
  templateId: any;
}>;

export type DeleteAgendaTemplateMutation = {
  __typename: "Mutation";
  deleteAgendaTemplate: {
    __typename: "DeleteResult";
    success: boolean;
    message: string | null;
    deletedId: string | null;
    errorCode: string | null;
  };
};

export type SetDefaultAgendaTemplateMutationVariables = Exact<{
  clubId: string | number;
  templateId: any;
}>;

export type SetDefaultAgendaTemplateMutation = {
  __typename: "Mutation";
  setDefaultAgendaTemplate: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type AgendaTemplateFieldsFragment = {
  __typename: "AgendaTemplate";
  id: string;
  name: string;
  description: string;
  isGlobal: boolean;
  clubId: string | null;
  itemCount: number;
  agenda: Array<{
    __typename: "AgendaItem";
    id: string;
    event: string;
    role: string;
    duration: number;
    backgroundColor: string | null;
    greenMark: number;
    amberMark: number;
    redMark: number;
    maxAssignments: number;
    isRepeatableRole: boolean | null;
    rolePosition: number | null;
  }>;
};

export type GetAgendaTemplatesQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetAgendaTemplatesQuery = {
  __typename: "Query";
  agendaTemplates: {
    __typename: "AgendaTemplatesResponse";
    defaultTemplateId: any;
    templates: Array<{
      __typename: "AgendaTemplate";
      id: string;
      name: string;
      description: string;
      isGlobal: boolean;
      clubId: string | null;
      itemCount: number;
      agenda: Array<{
        __typename: "AgendaItem";
        id: string;
        event: string;
        role: string;
        duration: number;
        backgroundColor: string | null;
        greenMark: number;
        amberMark: number;
        redMark: number;
        maxAssignments: number;
        isRepeatableRole: boolean | null;
        rolePosition: number | null;
      }>;
    }>;
  };
};

export type ChatUpdatesSubscriptionVariables = Exact<{
  chatId: string | number;
  sessionId: string;
  nickname: string;
}>;

export type ChatUpdatesSubscription = {
  __typename: "Subscription";
  chatUpdates: { __typename: "ChatUpdateEvent"; eventType: string; payload: any };
};

export type ClubFinanceStoredCostLineFieldsFragment = {
  __typename: "ClubFinanceStoredCostLine";
  label: string;
  amountMinor: number;
  cadence: string;
  cadenceLabel: string;
  category: string;
  categoryLabel: string;
  otherLabel: string | null;
  occursOn: string | null;
};

export type ClubFinanceStoredFxRateFieldsFragment = {
  __typename: "ClubFinanceStoredFxRate";
  rateMicros: any;
  baseCurrency: string;
  quoteCurrency: string;
  enteredOn: string;
  note: string | null;
  source: string;
};

export type ClubFinanceStoredConfigFieldsFragment = {
  __typename: "ClubFinanceStoredConfig";
  currency: string;
  meetingsPerYear: number;
  cardFeeBasisPoints: number;
  unpriceableReasons: Array<string>;
  version: string;
  fxRate: {
    __typename: "ClubFinanceStoredFxRate";
    rateMicros: any;
    baseCurrency: string;
    quoteCurrency: string;
    enteredOn: string;
    note: string | null;
    source: string;
  } | null;
  costLines: Array<{
    __typename: "ClubFinanceStoredCostLine";
    label: string;
    amountMinor: number;
    cadence: string;
    cadenceLabel: string;
    category: string;
    categoryLabel: string;
    otherLabel: string | null;
    occursOn: string | null;
  }>;
};

export type ClubFinanceOpeningBalanceFieldsFragment = {
  __typename: "ClubFinanceOpeningBalance";
  postingId: any;
  amountMinor: any;
  currency: string;
  effectiveOn: string;
  note: string | null;
  recordedAt: string;
};

export type ClubFinanceOptionFieldsFragment = {
  __typename: "ClubFinanceOption";
  token: string;
  label: string;
  note: string | null;
};

export type GetClubFinanceSettingsQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubFinanceSettingsQuery = {
  __typename: "Query";
  clubFinanceSettings: {
    __typename: "ClubFinanceSettings";
    tiChargingCurrency: string | null;
    config: {
      __typename: "ClubFinanceStoredConfig";
      currency: string;
      meetingsPerYear: number;
      cardFeeBasisPoints: number;
      unpriceableReasons: Array<string>;
      version: string;
      fxRate: {
        __typename: "ClubFinanceStoredFxRate";
        rateMicros: any;
        baseCurrency: string;
        quoteCurrency: string;
        enteredOn: string;
        note: string | null;
        source: string;
      } | null;
      costLines: Array<{
        __typename: "ClubFinanceStoredCostLine";
        label: string;
        amountMinor: number;
        cadence: string;
        cadenceLabel: string;
        category: string;
        categoryLabel: string;
        otherLabel: string | null;
        occursOn: string | null;
      }>;
    } | null;
    openingBalances: Array<{
      __typename: "ClubFinanceOpeningBalance";
      postingId: any;
      amountMinor: any;
      currency: string;
      effectiveOn: string;
      note: string | null;
      recordedAt: string;
    }>;
    categoryOptions: Array<{ __typename: "ClubFinanceOption"; token: string; label: string; note: string | null }>;
    cadenceOptions: Array<{ __typename: "ClubFinanceOption"; token: string; label: string; note: string | null }>;
    currencyOptions: Array<{ __typename: "ClubFinanceOption"; token: string; label: string; note: string | null }>;
  };
};

export type SaveClubFinanceConfigMutationVariables = Exact<{
  clubId: string | number;
  config: Types.ClubFinanceConfigInput;
}>;

export type SaveClubFinanceConfigMutation = {
  __typename: "Mutation";
  saveClubFinanceConfig: {
    __typename: "ClubFinanceStoredConfig";
    currency: string;
    meetingsPerYear: number;
    cardFeeBasisPoints: number;
    unpriceableReasons: Array<string>;
    version: string;
    fxRate: {
      __typename: "ClubFinanceStoredFxRate";
      rateMicros: any;
      baseCurrency: string;
      quoteCurrency: string;
      enteredOn: string;
      note: string | null;
      source: string;
    } | null;
    costLines: Array<{
      __typename: "ClubFinanceStoredCostLine";
      label: string;
      amountMinor: number;
      cadence: string;
      cadenceLabel: string;
      category: string;
      categoryLabel: string;
      otherLabel: string | null;
      occursOn: string | null;
    }>;
  };
};

export type SetClubFinanceOpeningBalanceMutationVariables = Exact<{
  clubId: string | number;
  amountMinor: any;
  effectiveOn: string;
  note?: string | null | undefined;
}>;

export type SetClubFinanceOpeningBalanceMutation = {
  __typename: "Mutation";
  setClubFinanceOpeningBalance: {
    __typename: "ClubFinanceOpeningBalance";
    postingId: any;
    amountMinor: any;
    currency: string;
    effectiveOn: string;
    note: string | null;
    recordedAt: string;
  };
};

export type ClubFinanceUnavailableFieldsFragment = { __typename: "ClubFinanceUnavailable"; reasons: Array<string> };

export type ClubFinanceCohortFieldsFragment = {
  __typename: "ClubFinanceCohort";
  paidMembers: number;
  overdueMembers: number;
  unknownMembers: number;
  currentMembers: number;
  countedOn: string;
  overridden: boolean;
  description: string;
};

export type ClubFinanceCostItemFieldsFragment = {
  __typename: "ClubFinanceCostItem";
  label: string;
  category: string;
  categoryLabel: string;
  annualMinor: any;
  derivedFrom: string | null;
};

export type ClubFinanceConversionFieldsFragment = {
  __typename: "ClubFinanceConversion";
  rateMicros: any;
  ratedOn: string;
  source: string;
};

export type ClubFinanceTiChargeFieldsFragment = {
  __typename: "ClubFinanceTICharge";
  memberCount: number;
  periodsPerYear: number;
  duesPerPeriodMinor: number;
  chargeCurrency: string;
  annualChargeMinor: any;
  convertedAnnualMinor: any;
  cardFeeMinor: any;
  annualCostMinor: any;
  assumedMemberPeriods: number;
  newMembersCharged: number;
  joinerChargeMinor: any;
  newMemberFeeMinor: number;
  conversion: { __typename: "ClubFinanceConversion"; rateMicros: any; ratedOn: string; source: string } | null;
};

export type ClubFinanceIncomeFieldsFragment = {
  __typename: "ClubFinanceIncome";
  monthlyDuesMinor: number;
  annualIncomeMinor: any;
  annualSurplusMinor: any;
  breakEvenMembers: number | null;
  breakEvenUnreachable: string | null;
  memberGap: number | null;
};

export type ClubFinanceRosterModelFieldsFragment = {
  __typename: "ClubFinanceRosterModel";
  retentionBasisPoints: number;
  joinersPerMonth: number;
  description: string | null;
};

export type ClubFinanceFlowFieldsFragment = {
  __typename: "ClubFinanceFlow";
  currency: string;
  annualRunningCostMinor: any;
  oneOffMinorInWindow: any;
  twelveMonthSpendMinor: any;
  payingMembers: number;
  disclosure: string;
  rosterModel: {
    __typename: "ClubFinanceRosterModel";
    retentionBasisPoints: number;
    joinersPerMonth: number;
    description: string | null;
  };
  costLines: Array<{
    __typename: "ClubFinanceCostItem";
    label: string;
    category: string;
    categoryLabel: string;
    annualMinor: any;
    derivedFrom: string | null;
  }>;
  tiCharge:
    | {
        __typename: "ClubFinanceTICharge";
        memberCount: number;
        periodsPerYear: number;
        duesPerPeriodMinor: number;
        chargeCurrency: string;
        annualChargeMinor: any;
        convertedAnnualMinor: any;
        cardFeeMinor: any;
        annualCostMinor: any;
        assumedMemberPeriods: number;
        newMembersCharged: number;
        joinerChargeMinor: any;
        newMemberFeeMinor: number;
        conversion: { __typename: "ClubFinanceConversion"; rateMicros: any; ratedOn: string; source: string } | null;
      }
    | { __typename: "ClubFinanceUnavailable"; reasons: Array<string> };
  income:
    | {
        __typename: "ClubFinanceIncome";
        monthlyDuesMinor: number;
        annualIncomeMinor: any;
        annualSurplusMinor: any;
        breakEvenMembers: number | null;
        breakEvenUnreachable: string | null;
        memberGap: number | null;
      }
    | { __typename: "ClubFinanceUnavailable"; reasons: Array<string> };
};

export type ClubFinanceMonthFieldsFragment = {
  __typename: "ClubFinanceMonth";
  month: string;
  currentMembers: number;
  paidMembers: number;
  spendMinor: any;
  incomeMinor: any;
  closingBalanceMinor: any;
};

export type ClubFinanceRunwayFieldsFragment = {
  __typename: "ClubFinanceRunway";
  runwayMonths: number | null;
  projectedBalanceMinor: any;
  months: Array<{
    __typename: "ClubFinanceMonth";
    month: string;
    currentMembers: number;
    paidMembers: number;
    spendMinor: any;
    incomeMinor: any;
    closingBalanceMinor: any;
  }>;
};

export type ClubFinanceStockFieldsFragment = {
  __typename: "ClubFinanceStock";
  openingBalanceMinor: any;
  balanceBasis: string;
  horizonMonths: number;
  monthsOfCover: number | null;
  evenlySpread: Array<string>;
  disclosure: string;
  withIncome:
    | {
        __typename: "ClubFinanceRunway";
        runwayMonths: number | null;
        projectedBalanceMinor: any;
        months: Array<{
          __typename: "ClubFinanceMonth";
          month: string;
          currentMembers: number;
          paidMembers: number;
          spendMinor: any;
          incomeMinor: any;
          closingBalanceMinor: any;
        }>;
      }
    | { __typename: "ClubFinanceUnavailable"; reasons: Array<string> };
};

export type GetClubFinanceProjectionQueryVariables = Exact<{
  clubId: string | number;
  overrides?: Types.ClubFinanceOverridesInput | null | undefined;
}>;

export type GetClubFinanceProjectionQuery = {
  __typename: "Query";
  clubFinanceProjection: {
    __typename: "ClubFinanceProjection";
    asOf: string;
    overridden: boolean;
    cohort: {
      __typename: "ClubFinanceCohort";
      paidMembers: number;
      overdueMembers: number;
      unknownMembers: number;
      currentMembers: number;
      countedOn: string;
      overridden: boolean;
      description: string;
    };
    flow:
      | {
          __typename: "ClubFinanceFlow";
          currency: string;
          annualRunningCostMinor: any;
          oneOffMinorInWindow: any;
          twelveMonthSpendMinor: any;
          payingMembers: number;
          disclosure: string;
          rosterModel: {
            __typename: "ClubFinanceRosterModel";
            retentionBasisPoints: number;
            joinersPerMonth: number;
            description: string | null;
          };
          costLines: Array<{
            __typename: "ClubFinanceCostItem";
            label: string;
            category: string;
            categoryLabel: string;
            annualMinor: any;
            derivedFrom: string | null;
          }>;
          tiCharge:
            | {
                __typename: "ClubFinanceTICharge";
                memberCount: number;
                periodsPerYear: number;
                duesPerPeriodMinor: number;
                chargeCurrency: string;
                annualChargeMinor: any;
                convertedAnnualMinor: any;
                cardFeeMinor: any;
                annualCostMinor: any;
                assumedMemberPeriods: number;
                newMembersCharged: number;
                joinerChargeMinor: any;
                newMemberFeeMinor: number;
                conversion: {
                  __typename: "ClubFinanceConversion";
                  rateMicros: any;
                  ratedOn: string;
                  source: string;
                } | null;
              }
            | { __typename: "ClubFinanceUnavailable"; reasons: Array<string> };
          income:
            | {
                __typename: "ClubFinanceIncome";
                monthlyDuesMinor: number;
                annualIncomeMinor: any;
                annualSurplusMinor: any;
                breakEvenMembers: number | null;
                breakEvenUnreachable: string | null;
                memberGap: number | null;
              }
            | { __typename: "ClubFinanceUnavailable"; reasons: Array<string> };
        }
      | { __typename: "ClubFinanceUnavailable"; reasons: Array<string> };
    stock:
      | {
          __typename: "ClubFinanceStock";
          openingBalanceMinor: any;
          balanceBasis: string;
          horizonMonths: number;
          monthsOfCover: number | null;
          evenlySpread: Array<string>;
          disclosure: string;
          withIncome:
            | {
                __typename: "ClubFinanceRunway";
                runwayMonths: number | null;
                projectedBalanceMinor: any;
                months: Array<{
                  __typename: "ClubFinanceMonth";
                  month: string;
                  currentMembers: number;
                  paidMembers: number;
                  spendMinor: any;
                  incomeMinor: any;
                  closingBalanceMinor: any;
                }>;
              }
            | { __typename: "ClubFinanceUnavailable"; reasons: Array<string> };
        }
      | { __typename: "ClubFinanceUnavailable"; reasons: Array<string> };
  };
};

export type GetClubMetaByShortNameQueryVariables = Exact<{
  shortName: string;
}>;

export type GetClubMetaByShortNameQuery = {
  __typename: "Query";
  clubMetaByShortName: {
    __typename: "ClubMeta";
    clubId: number;
    shortName: string;
    longName: string;
    isOnToastHost: boolean;
    district: number;
    division: string;
    area: number;
    timezone: string | null;
  } | null;
};

export type GetClubInfoQueryVariables = Exact<{
  shortName: string;
}>;

export type GetClubInfoQuery = {
  __typename: "Query";
  clubInfo: {
    __typename: "ClubInfoResponse";
    clubConnection: string;
    isOnToastHost: boolean;
    dcpData: string | null;
    clubMeetingsId: any;
    publicInfo: {
      __typename: "ClubInfoPublic";
      clubId: number;
      shortName: string;
      longName: string;
      contactEmail: string;
      district: number;
      division: string;
      area: number;
      tiStatus: string;
      suspendDate: string | null;
      memberCount: number | null;
      website: {
        __typename: "ClubInfoWebsite";
        clubWebsite: string | null;
        webConfig: {
          __typename: "WebConfig";
          enabled: boolean;
          hostingOption: Types.HostingOption;
          domainName: string | null;
          clubUrl: string | null;
          introductionText: string;
          tagLine: string;
          logoImage: string | null;
          backgroundImage: string | null;
          locationShortDesc: string | null;
          mapLink: string | null;
          meetingTimes: string | null;
          metaDesc: string | null;
          twitterLink: string | null;
          facebookLink: string | null;
          linkedInLink: string | null;
          instagramLink: string | null;
          youtubeLink: string | null;
          meetupLink: string | null;
          eventbriteLink: string | null;
        };
      };
      guestbookConfig: {
        __typename: "ClubInfoGuestbookConfig";
        enabled: boolean;
        firstEmailBody: string;
        reminderEmailBody: string;
      };
      calendar: {
        __typename: "ClubInfoCalendar";
        isEnabled: boolean;
        configState: string;
        futureMeetings: Array<{
          __typename: "ClubInfoMeetingSummary";
          id: string;
          startDate: string;
          description: string;
        }>;
        nextMeeting: {
          __typename: "ClubInfoMeetingSummary";
          id: string;
          startDate: string;
          description: string;
        } | null;
      };
      membershipStatus: {
        __typename: "ClubInfoMembershipStatus";
        enabled: boolean;
        newMemberRegistrationEnabled: boolean;
        cardPaymentsEnabled: boolean;
      } | null;
      clubOfficers: Array<{
        __typename: "ClubInfoOfficer";
        role: string;
        name: string;
        email: string | null;
        termBegin: string;
        termEnd: string;
        userId: any;
        membershipId: string | null;
      }>;
      meetingSchedule: {
        __typename: "ClubInfoMeetingSchedule";
        timezone: string;
        exclusions: Array<string>;
        meetingPatterns: Array<{
          __typename: "MeetingPatternEntry";
          weekNumbers: Array<number>;
          dayOfWeek: string;
          startTime: string;
          durationHours: number;
        }>;
      } | null;
      meetingConfig: {
        __typename: "ClubMeetingConfig";
        autoSyncAgendaToVoting: boolean;
        autoAddAgendaToFeedback: boolean;
        evaluatorVotingRoles: Array<string>;
        allowMemberRoleSelfAssign: boolean;
        memberSpeechRequestAdvanceDays: number;
      } | null;
    };
    managerInfo: {
      __typename: "ClubInfoManager";
      easyspeakId: number | null;
      easyspeakInstance: string | null;
      periodicEmail: boolean;
      listedInTI: boolean;
      guestCount: number;
      memberCount: number;
      stripeConnected: boolean;
      guestbook: {
        __typename: "ClubInfoGuestbook";
        enabled: boolean;
        firstEmailBody: string;
        reminderEmailBody: string;
      };
      notificationPreferences: {
        __typename: "ClubInfoNotificationPreferences";
        copyInboxOnMeetingRole: boolean;
        copyInboxOnMembership: boolean;
        copyInboxOnGuest: boolean;
      };
      membershipStatus: {
        __typename: "ClubInfoMembershipStatus";
        enabled: boolean;
        newMemberRegistrationEnabled: boolean;
        cardPaymentsEnabled: boolean;
      };
      clubOfficers: Array<{
        __typename: "ClubInfoOfficer";
        role: string;
        name: string;
        email: string | null;
        termBegin: string;
        termEnd: string;
        userId: any;
        membershipId: string | null;
      }>;
      emailConfiguration: {
        __typename: "ClubInfoEmailConfig";
        enabled: boolean;
        emailAddress: string;
        emailPassword: string;
        imapServer: string;
        smtpServer: string;
        smtpPort: number;
      } | null;
    } | null;
  } | null;
};

export type GetEasySpeakInstancesQueryVariables = Exact<{ [key: string]: never }>;

export type GetEasySpeakInstancesQuery = {
  __typename: "Query";
  easySpeakInstances: Array<{ __typename: "EasySpeakInstanceOption"; host: string; label: string }>;
};

export type GetEasySpeakMeetingsQueryVariables = Exact<{
  clubId: string | number;
  mappingId?: any;
}>;

export type GetEasySpeakMeetingsQuery = {
  __typename: "Query";
  easySpeakMeetings: Array<{
    __typename: "EasySpeakMeeting";
    id: any;
    easySpeakMeetingId: number;
    meetingNumber: number | null;
    meetingDate: string;
    theme: string | null;
    isImported: boolean;
    isUpcoming: boolean;
    easySpeakUrl: string | null;
    people: Array<{
      __typename: "EasySpeakMeetingPerson";
      mappingId: any;
      easySpeakUserId: number;
      easySpeakName: string;
      attended: boolean;
      status: Types.EasySpeakMeetingPersonStatus;
      toasthostName: string | null;
      roles: Array<{ __typename: "EasySpeakMeetingRole"; roleName: string; speechTitle: string | null }>;
    }>;
  }>;
};

export type GetClubWebConfigQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubWebConfigQuery = {
  __typename: "Query";
  clubWebConfig: {
    __typename: "WebConfig";
    enabled: boolean;
    hostingOption: Types.HostingOption;
    domainName: string | null;
    clubUrl: string | null;
    introductionText: string;
    tagLine: string;
    logoImage: string | null;
    backgroundImage: string | null;
    locationShortDesc: string | null;
    mapLink: string | null;
    meetingTimes: string | null;
    metaDesc: string | null;
    twitterLink: string | null;
    facebookLink: string | null;
    linkedInLink: string | null;
    instagramLink: string | null;
    youtubeLink: string | null;
    meetupLink: string | null;
    eventbriteLink: string | null;
  } | null;
  clubTiWebsiteMismatch: { __typename: "TIWebsiteMismatch"; tiUrl: string; effectiveUrl: string } | null;
};

export type GetClubImagesQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubImagesQuery = {
  __typename: "Query";
  clubImages: Array<{ __typename: "ClubImageMeta"; imageName: string; uploadDate: string; size: any }>;
};

export type GetClubMemberSummariesQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubMemberSummariesQuery = {
  __typename: "Query";
  clubMemberSummaries: Array<{
    __typename: "ClubMemberSummary";
    userId: string | null;
    name: string;
    email: string | null;
    isActive: boolean;
    membershipStatus: string;
  }>;
};

export type GetClubActivityLogQueryVariables = Exact<{
  clubId: string | number;
  first?: number | null | undefined;
  offset?: number | null | undefined;
}>;

export type GetClubActivityLogQuery = {
  __typename: "Query";
  clubActivityLog: {
    __typename: "ActivityLogConnection";
    totalCount: number;
    entries: Array<{
      __typename: "ClubActivityEntry";
      id: string;
      activityType: string;
      activityTypeDisplayName: string;
      userId: string | null;
      shortDesc: string;
      date: string;
      isLegacyLocalTime: boolean;
      info: string;
      emailLogId: any;
      user: { __typename: "User"; id: string | null; displayName: string } | null;
    }>;
    pageInfo: { __typename: "PageInfo"; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type SimpleResultFieldsFragment = {
  __typename: "SimpleResult";
  success: boolean;
  message: string | null;
  errorCode: string | null;
};

export type WebConfigFieldsFragment = {
  __typename: "WebConfig";
  hostingOption: Types.HostingOption;
  domainName: string | null;
  clubUrl: string | null;
  introductionText: string;
  tagLine: string;
  logoImage: string | null;
  backgroundImage: string | null;
  locationShortDesc: string | null;
  mapLink: string | null;
  meetingTimes: string | null;
  metaDesc: string | null;
  twitterLink: string | null;
  facebookLink: string | null;
  linkedInLink: string | null;
  instagramLink: string | null;
  youtubeLink: string | null;
  meetupLink: string | null;
  eventbriteLink: string | null;
};

export type WebConfigResultFieldsFragment = {
  __typename: "WebConfigResult";
  success: boolean;
  message: string | null;
  refreshFailed: boolean;
  data: {
    __typename: "WebConfig";
    hostingOption: Types.HostingOption;
    domainName: string | null;
    clubUrl: string | null;
    introductionText: string;
    tagLine: string;
    logoImage: string | null;
    backgroundImage: string | null;
    locationShortDesc: string | null;
    mapLink: string | null;
    meetingTimes: string | null;
    metaDesc: string | null;
    twitterLink: string | null;
    facebookLink: string | null;
    linkedInLink: string | null;
    instagramLink: string | null;
    youtubeLink: string | null;
    meetupLink: string | null;
    eventbriteLink: string | null;
  } | null;
};

export type GuestbookConfigFieldsFragment = {
  __typename: "GuestbookConfig";
  enabled: boolean;
  welcomeEmailEnabled: boolean;
  firstEmailBody: string;
  returningGuestEmailBody: string;
  reminderEmailBody: string;
};

export type GuestbookConfigResultFieldsFragment = {
  __typename: "GuestbookConfigResult";
  success: boolean;
  message: string | null;
  data: {
    __typename: "GuestbookConfig";
    enabled: boolean;
    welcomeEmailEnabled: boolean;
    firstEmailBody: string;
    returningGuestEmailBody: string;
    reminderEmailBody: string;
  } | null;
};

export type UpdateClubConfigMutationVariables = Exact<{
  clubId: string | number;
  shortName?: string | null | undefined;
  longName?: string | null | undefined;
  contactEmail?: string | null | undefined;
  periodicEmail?: boolean | null | undefined;
  meetingSchedule?: Types.MeetingScheduleInput | null | undefined;
  meetingConfig?: Types.ClubMeetingConfigInput | null | undefined;
}>;

export type UpdateClubConfigMutation = {
  __typename: "Mutation";
  updateClubConfig: { __typename: "SimpleResult"; success: boolean; message: string | null; errorCode: string | null };
};

export type SetClubEasySpeakMappingMutationVariables = Exact<{
  clubId: string | number;
  easyspeakId?: number | null | undefined;
  easyspeakInstance?: string | null | undefined;
}>;

export type SetClubEasySpeakMappingMutation = {
  __typename: "Mutation";
  setClubEasySpeakMapping: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type UpdateNotificationPreferencesMutationVariables = Exact<{
  clubId: string | number;
  copyInboxOnMeetingRole?: boolean | null | undefined;
  copyInboxOnMembership?: boolean | null | undefined;
  copyInboxOnGuest?: boolean | null | undefined;
}>;

export type UpdateNotificationPreferencesMutation = {
  __typename: "Mutation";
  updateNotificationPreferences: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type UpdateWebConfigMutationVariables = Exact<{
  clubId: string | number;
  hostingOption?: Types.HostingOptionInput | null | undefined;
  domainName?: string | null | undefined;
  clubUrl?: string | null | undefined;
  introductionText?: string | null | undefined;
  tagLine?: string | null | undefined;
  logoImage?: string | null | undefined;
  backgroundImage?: string | null | undefined;
  locationShortDesc?: string | null | undefined;
  mapLink?: string | null | undefined;
  meetingTimes?: string | null | undefined;
  metaDesc?: string | null | undefined;
  twitterLink?: string | null | undefined;
  facebookLink?: string | null | undefined;
  linkedInLink?: string | null | undefined;
  instagramLink?: string | null | undefined;
  youtubeLink?: string | null | undefined;
  meetupLink?: string | null | undefined;
  eventbriteLink?: string | null | undefined;
}>;

export type UpdateWebConfigMutation = {
  __typename: "Mutation";
  updateWebConfig: {
    __typename: "WebConfigResult";
    success: boolean;
    message: string | null;
    refreshFailed: boolean;
    data: {
      __typename: "WebConfig";
      hostingOption: Types.HostingOption;
      domainName: string | null;
      clubUrl: string | null;
      introductionText: string;
      tagLine: string;
      logoImage: string | null;
      backgroundImage: string | null;
      locationShortDesc: string | null;
      mapLink: string | null;
      meetingTimes: string | null;
      metaDesc: string | null;
      twitterLink: string | null;
      facebookLink: string | null;
      linkedInLink: string | null;
      instagramLink: string | null;
      youtubeLink: string | null;
      meetupLink: string | null;
      eventbriteLink: string | null;
    } | null;
  };
};

export type UpdateGuestbookConfigMutationVariables = Exact<{
  clubId: string | number;
  enabled?: boolean | null | undefined;
  firstEmailBody?: string | null | undefined;
  returningGuestEmailBody?: string | null | undefined;
  reminderEmailBody?: string | null | undefined;
}>;

export type UpdateGuestbookConfigMutation = {
  __typename: "Mutation";
  updateGuestbookConfig: {
    __typename: "GuestbookConfigResult";
    success: boolean;
    message: string | null;
    data: {
      __typename: "GuestbookConfig";
      enabled: boolean;
      welcomeEmailEnabled: boolean;
      firstEmailBody: string;
      returningGuestEmailBody: string;
      reminderEmailBody: string;
    } | null;
  };
};

export type DeleteClubImageMutationVariables = Exact<{
  clubId: string | number;
  imageName: string;
}>;

export type DeleteClubImageMutation = {
  __typename: "Mutation";
  deleteClubImage: {
    __typename: "ImageDeleteResult";
    success: boolean;
    message: string | null;
    wasLogoImage: boolean;
    wasBackgroundImage: boolean;
  };
};

export type UpdateEmailConfigurationMutationVariables = Exact<{
  clubId: string | number;
  emailConfig: Types.EmailConfigInput;
}>;

export type UpdateEmailConfigurationMutation = {
  __typename: "Mutation";
  updateEmailConfiguration: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type TestEmailConfigurationMutationVariables = Exact<{
  clubId: string | number;
  emailConfig: Types.EmailConfigInput;
}>;

export type TestEmailConfigurationMutation = {
  __typename: "Mutation";
  testEmailConfiguration: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type TriggerPeriodicEmailMutationVariables = Exact<{
  clubId: string | number;
}>;

export type TriggerPeriodicEmailMutation = {
  __typename: "Mutation";
  triggerPeriodicEmail: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type GetClubIdByShortNameQueryVariables = Exact<{
  shortName: string;
}>;

export type GetClubIdByShortNameQuery = { __typename: "Query"; clubIdByShortName: number | null };

export type CheckShortNameAvailabilityQueryVariables = Exact<{
  shortName: string;
  currentClubId?: number | null | undefined;
}>;

export type CheckShortNameAvailabilityQuery = {
  __typename: "Query";
  checkShortNameAvailability: { __typename: "ShortNameAvailabilityResult"; available: boolean; message: string | null };
};

export type GetClubHierarchyQueryVariables = Exact<{ [key: string]: never }>;

export type GetClubHierarchyQuery = {
  __typename: "Query";
  clubHierarchy: Array<{
    __typename: "ClubHierarchyDistrict";
    districtId: number;
    districtName: string;
    divisions: Array<{
      __typename: "ClubHierarchyDivision";
      divisionId: string;
      areas: Array<{
        __typename: "ClubHierarchyArea";
        areaId: string;
        clubs: Array<{
          __typename: "ClubHierarchyClub";
          clubNumber: number;
          clubShortName: string | null;
          clubLongName: string;
          isActive: boolean;
          isSuspended: boolean;
          tiStatus: string;
          suspendDate: string | null;
        }>;
      }>;
    }>;
  }>;
};

export type SearchTiClubsQueryVariables = Exact<{
  search: string;
  limit?: number | null | undefined;
}>;

export type SearchTiClubsQuery = {
  __typename: "Query";
  searchTIClubs: Array<{
    __typename: "TIClubSearchResult";
    clubNumber: number;
    clubName: string;
    district: string;
    division: string;
    area: string;
    city: string | null;
    country: string | null;
    meetingDay: string | null;
    isOnToastHost: boolean;
    isProspective: boolean;
    clubShortName: string | null;
  }>;
};

export type ActivateClubMutationVariables = Exact<{
  clubNumber: number;
}>;

export type ActivateClubMutation = {
  __typename: "Mutation";
  activateClub: {
    __typename: "ActivateClubResult";
    success: boolean;
    message: string | null;
    clubShortName: string | null;
  };
};

export type GetPeriodicEmailPreviewQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetPeriodicEmailPreviewQuery = {
  __typename: "Query";
  periodicEmailPreview: {
    __typename: "PeriodicEmailPreview";
    clubName: string;
    clubId: number;
    emailHtml: string;
  } | null;
};

export type CreateCotEventMutationVariables = Exact<{
  cotId: string | number;
  name: string;
  description: string;
  requiredSessionCount?: number | null | undefined;
  registrationOpensAt?: string | null | undefined;
  registrationClosesAt?: string | null | undefined;
  externalRegistration?: boolean | null | undefined;
  isTest?: boolean | null | undefined;
}>;

export type CreateCotEventMutation = {
  __typename: "Mutation";
  createCOTEvent: {
    __typename: "COTEventResult";
    success: boolean;
    message: string | null;
    event: {
      __typename: "COTEvent";
      id: string;
      isTest: boolean;
      programId: string;
      name: string;
      description: string;
      registrationCount: number;
      matchedCount: number;
      unmatchedCount: number;
      publishStatus: Types.CotEventPublishStatus;
      requiredSessionCount: number;
      registrationOpensAt: string | null;
      registrationClosesAt: string | null;
      externalRegistration: boolean;
    } | null;
  };
};

export type DeleteCotEventMutationVariables = Exact<{
  eventId: string | number;
}>;

export type DeleteCotEventMutation = {
  __typename: "Mutation";
  deleteCOTEvent: { __typename: "COTDeleteResult"; success: boolean; message: string | null; deletedId: string | null };
};

export type UpdateCotEventMutationVariables = Exact<{
  eventId: string | number;
  name?: string | null | undefined;
  description?: string | null | undefined;
  requiredSessionCount?: number | null | undefined;
  registrationOpensAt?: string | null | undefined;
  registrationClosesAt?: string | null | undefined;
  externalRegistration?: boolean | null | undefined;
}>;

export type UpdateCotEventMutation = {
  __typename: "Mutation";
  updateCOTEvent: {
    __typename: "COTEventResult";
    success: boolean;
    message: string | null;
    event: {
      __typename: "COTEvent";
      id: string;
      programId: string;
      name: string;
      description: string;
      publishStatus: Types.CotEventPublishStatus;
      requiredSessionCount: number;
      registrationOpensAt: string | null;
      registrationClosesAt: string | null;
      externalRegistration: boolean;
    } | null;
  };
};

export type PublishCotEventMutationVariables = Exact<{
  eventId: string | number;
}>;

export type PublishCotEventMutation = {
  __typename: "Mutation";
  publishCOTEvent: {
    __typename: "COTEventResult";
    success: boolean;
    message: string | null;
    event: { __typename: "COTEvent"; id: string; publishStatus: Types.CotEventPublishStatus } | null;
  };
};

export type UnpublishCotEventMutationVariables = Exact<{
  eventId: string | number;
}>;

export type UnpublishCotEventMutation = {
  __typename: "Mutation";
  unpublishCOTEvent: {
    __typename: "COTEventResult";
    success: boolean;
    message: string | null;
    event: { __typename: "COTEvent"; id: string; publishStatus: Types.CotEventPublishStatus } | null;
  };
};

export type CancelCotEventMutationVariables = Exact<{
  eventId: string | number;
  reason: string;
}>;

export type CancelCotEventMutation = {
  __typename: "Mutation";
  cancelCOTEvent: {
    __typename: "COTEventResult";
    success: boolean;
    message: string | null;
    event: {
      __typename: "COTEvent";
      id: string;
      publishStatus: Types.CotEventPublishStatus;
      cancelledAt: string | null;
      cancellationReason: string | null;
    } | null;
  };
};

export type CreateCotSessionMutationVariables = Exact<{
  eventId: string | number;
  name: string;
  description: string;
  dateTime: string;
  location?: string | null | undefined;
  joiningUrl?: string | null | undefined;
  duration: number;
  maxAttendees?: number | null | undefined;
  sessionType?: number | null | undefined;
}>;

export type CreateCotSessionMutation = {
  __typename: "Mutation";
  createCOTSession: {
    __typename: "COTSessionResult";
    success: boolean;
    message: string | null;
    session: {
      __typename: "COTSession";
      id: string;
      eventId: string;
      name: string;
      description: string;
      dateTime: string;
      location: string | null;
      joiningUrl: string | null;
      duration: number;
      durationDisplay: string;
      maxAttendees: number | null;
      sessionType: number | null;
      sessionTypeDisplay: string;
      minimumDurationMinutes: number;
      attendanceCount: number;
      qualifyingAttendanceCount: number;
      isFull: boolean;
    } | null;
  };
};

export type UpdateCotSessionMutationVariables = Exact<{
  sessionId: string | number;
  name?: string | null | undefined;
  description?: string | null | undefined;
  dateTime?: string | null | undefined;
  location?: string | null | undefined;
  joiningUrl?: string | null | undefined;
  duration?: number | null | undefined;
  maxAttendees?: number | null | undefined;
  sessionType?: number | null | undefined;
}>;

export type UpdateCotSessionMutation = {
  __typename: "Mutation";
  updateCOTSession: {
    __typename: "COTSessionResult";
    success: boolean;
    message: string | null;
    session: {
      __typename: "COTSession";
      id: string;
      eventId: string;
      name: string;
      description: string;
      dateTime: string;
      location: string | null;
      joiningUrl: string | null;
      duration: number;
      durationDisplay: string;
      maxAttendees: number | null;
      sessionType: number | null;
      sessionTypeDisplay: string;
      minimumDurationMinutes: number;
      attendanceCount: number;
      qualifyingAttendanceCount: number;
      isFull: boolean;
    } | null;
  };
};

export type MarkCotAttendanceLiveMutationVariables = Exact<{
  sessionId: string | number;
  registrationEmails: Array<string> | string;
  registrationIds?: Array<string> | string | null | undefined;
}>;

export type MarkCotAttendanceLiveMutation = {
  __typename: "Mutation";
  markCOTAttendanceLive: {
    __typename: "COTLiveAttendanceResult";
    success: boolean;
    message: string | null;
    items: Array<{
      __typename: "COTLiveAttendanceItem";
      registrationEmail: string;
      attendance: {
        __typename: "COTSessionAttendance";
        name: string;
        email: string;
        joinTime: string;
        leaveTime: string;
        durationMinutes: number;
        role: string | null;
        club: string | null;
        source: Types.CotAttendanceSource;
        registrationId: string | null;
      };
    }>;
    session: {
      __typename: "COTSession";
      id: string;
      attendance: Array<{
        __typename: "COTSessionAttendance";
        email: string;
        source: Types.CotAttendanceSource;
        durationMinutes: number;
        registrationId: string | null;
      }>;
    } | null;
  };
};

export type UnmarkCotAttendanceLiveMutationVariables = Exact<{
  sessionId: string | number;
  registrationEmails: Array<string> | string;
  registrationIds?: Array<string> | string | null | undefined;
}>;

export type UnmarkCotAttendanceLiveMutation = {
  __typename: "Mutation";
  unmarkCOTAttendanceLive: {
    __typename: "COTLiveAttendanceResult";
    success: boolean;
    message: string | null;
    session: {
      __typename: "COTSession";
      id: string;
      attendance: Array<{
        __typename: "COTSessionAttendance";
        email: string;
        source: Types.CotAttendanceSource;
        durationMinutes: number;
        registrationId: string | null;
      }>;
    } | null;
  };
};

export type DeleteCotSessionMutationVariables = Exact<{
  sessionId: string | number;
}>;

export type DeleteCotSessionMutation = {
  __typename: "Mutation";
  deleteCOTSession: {
    __typename: "COTDeleteResult";
    success: boolean;
    message: string | null;
    deletedId: string | null;
  };
};

export type AddCotManualAttendanceMutationVariables = Exact<{
  sessionId: string | number;
  name: string;
  email: string;
  club?: string | null | undefined;
  role?: string | null | undefined;
  joinTime: string;
  leaveTime: string;
}>;

export type AddCotManualAttendanceMutation = {
  __typename: "Mutation";
  addCOTManualAttendance: {
    __typename: "COTUploadResult";
    success: boolean;
    message: string | null;
    recordsProcessed: number;
    recordsMatched: number;
    recordsUnmatched: number;
  };
};

export type UpdateCotAttendanceMutationVariables = Exact<{
  sessionId: string | number;
  originalEmail: string;
  name?: string | null | undefined;
  email?: string | null | undefined;
  club?: string | null | undefined;
  role?: string | null | undefined;
  joinTime?: string | null | undefined;
  leaveTime?: string | null | undefined;
  attendanceRegistrationId?: string | number | null | undefined;
}>;

export type UpdateCotAttendanceMutation = {
  __typename: "Mutation";
  updateCOTAttendance: {
    __typename: "COTAttendanceMutationResult";
    success: boolean;
    message: string | null;
    attendance: {
      __typename: "COTSessionAttendance";
      name: string;
      email: string;
      joinTime: string;
      leaveTime: string;
      durationMinutes: number;
      role: string | null;
      club: string | null;
      registrationId: string | null;
    } | null;
  };
};

export type DeleteCotAttendanceMutationVariables = Exact<{
  sessionId: string | number;
  email: string;
  attendanceRegistrationId?: string | number | null | undefined;
}>;

export type DeleteCotAttendanceMutation = {
  __typename: "Mutation";
  deleteCOTAttendance: {
    __typename: "COTAttendanceMutationResult";
    success: boolean;
    message: string | null;
    attendance: {
      __typename: "COTSessionAttendance";
      name: string;
      email: string;
      durationMinutes: number;
      role: string | null;
      club: string | null;
    } | null;
  };
};

export type OverrideCotOfficerRecordMutationVariables = Exact<{
  cotId: string | number;
  recordId: string | number;
  correctedName?: string | null | undefined;
  correctedEmail?: string | null | undefined;
  correctedMembershipNumber?: string | null | undefined;
  correctedUserId?: string | number | null | undefined;
  notes?: string | null | undefined;
}>;

export type OverrideCotOfficerRecordMutation = {
  __typename: "Mutation";
  overrideCOTOfficerRecord: {
    __typename: "COTOverrideResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: {
      __typename: "COTClubOfficerRecord";
      recordId: string;
      userId: string | null;
      name: string;
      email: string;
      membershipNumber: string;
      hasCompletedTraining: boolean;
      isMatched: boolean;
      effectiveName: string;
      effectiveEmail: string;
      effectiveMembershipNumber: string;
      effectiveUserId: string | null;
      recordOverride: {
        __typename: "COTRecordOverride";
        overriddenBy: string;
        overriddenAt: string;
        correctedName: string | null;
        correctedEmail: string | null;
        correctedMembershipNumber: string | null;
        correctedUserId: string | null;
        notes: string | null;
      } | null;
    } | null;
  };
};

export type UnmergeCotOfficerRecordMutationVariables = Exact<{
  cotId: string | number;
  recordId: string | number;
  mergedFromEmail: string;
}>;

export type UnmergeCotOfficerRecordMutation = {
  __typename: "Mutation";
  unmergeCOTOfficerRecord: {
    __typename: "COTOverrideResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: {
      __typename: "COTClubOfficerRecord";
      recordId: string;
      name: string;
      email: string;
      mergedFromEmails: Array<string>;
    } | null;
  };
};

export type UpdateCotOfficerClubRolesMutationVariables = Exact<{
  cotId: string | number;
  recordId: string | number;
  clubRoles: Array<Types.CotOfficerClubRoleInput> | Types.CotOfficerClubRoleInput;
  expectedClubRolesToken: string;
}>;

export type UpdateCotOfficerClubRolesMutation = {
  __typename: "Mutation";
  updateCOTOfficerClubRoles: {
    __typename: "COTOfficerMutationResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: { __typename: "COTClubOfficerRecord"; recordId: string } | null;
  };
};

export type AddCotOfficerNoteMutationVariables = Exact<{
  cotId: string | number;
  recordId: string | number;
  note: string;
}>;

export type AddCotOfficerNoteMutation = {
  __typename: "Mutation";
  addCOTOfficerNote: {
    __typename: "COTOfficerMutationResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: { __typename: "COTClubOfficerRecord"; recordId: string } | null;
  };
};

export type SetCotManualRoleAssignmentsMutationVariables = Exact<{
  cotId: string | number;
  recordId: string | number;
  roleAssignments: Array<Types.CotManualRoleAssignmentInput> | Types.CotManualRoleAssignmentInput;
  expectedAssignmentToken: string;
}>;

export type SetCotManualRoleAssignmentsMutation = {
  __typename: "Mutation";
  setCOTManualRoleAssignments: {
    __typename: "COTOfficerMutationResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: { __typename: "COTClubOfficerRecord"; recordId: string } | null;
  };
};

export type AddCotManualTrainingCreditMutationVariables = Exact<{
  cotId: string | number;
  recordId: string | number;
  reason: string;
  trainingDate?: string | null | undefined;
  trainingDescription?: string | null | undefined;
}>;

export type AddCotManualTrainingCreditMutation = {
  __typename: "Mutation";
  addCOTManualTrainingCredit: {
    __typename: "COTOfficerMutationResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: { __typename: "COTClubOfficerRecord"; recordId: string } | null;
  };
};

export type RemoveCotManualTrainingCreditMutationVariables = Exact<{
  cotId: string | number;
  recordId: string | number;
  creditId: string | number;
}>;

export type RemoveCotManualTrainingCreditMutation = {
  __typename: "Mutation";
  removeCOTManualTrainingCredit: {
    __typename: "COTOfficerMutationResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: { __typename: "COTClubOfficerRecord"; recordId: string } | null;
  };
};

export type LinkCotRegistrationToOfficerMutationVariables = Exact<{
  cotId: string | number;
  eventId: string | number;
  email: string;
  registrationId?: string | null | undefined;
  targetOfficerEmail?: string | null | undefined;
  targetOfficerRecordId?: string | null | undefined;
  createFromMember?: boolean | null | undefined;
  createNew: boolean;
  clubRoles: Array<Types.CotOfficerClubRoleInput> | Types.CotOfficerClubRoleInput;
  targetClubId?: string | number | null | undefined;
  notes?: string | null | undefined;
}>;

export type LinkCotRegistrationToOfficerMutation = {
  __typename: "Mutation";
  linkCOTRegistrationToOfficer: {
    __typename: "COTOfficerMutationResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: { __typename: "COTClubOfficerRecord"; recordId: string; name: string; email: string } | null;
  };
};

export type RefreshCotCompletionStatusMutationVariables = Exact<{
  cotId: string | number;
}>;

export type RefreshCotCompletionStatusMutation = {
  __typename: "Mutation";
  refreshCOTCompletionStatus: {
    __typename: "COTRefreshResult";
    success: boolean;
    message: string | null;
    officersRefreshed: number;
    completionsUpdated: number;
  };
};

export type RegisterForCotEventMutationVariables = Exact<{
  eventId: string | number;
  seekingCreditForRoles?: Array<Types.CotOfficerClubRoleInput> | Types.CotOfficerClubRoleInput | null | undefined;
  reminder24hBefore?: boolean | null | undefined;
  attendanceConfirmation?: boolean | null | undefined;
  creditEarned?: boolean | null | undefined;
  externalAttendee?: Types.ExternalAttendeeInput | null | undefined;
  joinWaitlist?: boolean | null | undefined;
}>;

export type RegisterForCotEventMutation = {
  __typename: "Mutation";
  registerForCOTEvent: {
    __typename: "COTEventResult";
    success: boolean;
    message: string | null;
    pendingVerification: boolean;
    waitlisted: boolean;
    event: { __typename: "COTEvent"; id: string } | null;
  };
};

export type VerifyCotRegistrationMutationVariables = Exact<{
  eventId: string | number;
  token: string;
}>;

export type VerifyCotRegistrationMutation = {
  __typename: "Mutation";
  verifyCOTRegistration: { __typename: "COTEventResult"; success: boolean; message: string | null };
};

export type CancelCotRegistrationMutationVariables = Exact<{
  eventId: string | number;
}>;

export type CancelCotRegistrationMutation = {
  __typename: "Mutation";
  cancelCOTRegistration: {
    __typename: "COTEventResult";
    success: boolean;
    message: string | null;
    event: { __typename: "COTEvent"; id: string } | null;
  };
};

export type AddAssertedClubRoleMutationVariables = Exact<{
  clubId: string | number;
  role: string;
  clubName?: string | null | undefined;
}>;

export type AddAssertedClubRoleMutation = {
  __typename: "Mutation";
  addAssertedClubRole: Array<{
    __typename: "COTOfficerClubRole";
    clubId: string;
    role: Types.CotOfficerRole;
    roleDisplayName: string;
    roleAbbreviation: string;
    clubName: string | null;
  }>;
};

export type RemoveAssertedClubRoleMutationVariables = Exact<{
  clubId: string | number;
  role: string;
}>;

export type RemoveAssertedClubRoleMutation = {
  __typename: "Mutation";
  removeAssertedClubRole: Array<{
    __typename: "COTOfficerClubRole";
    clubId: string;
    role: Types.CotOfficerRole;
    roleDisplayName: string;
    roleAbbreviation: string;
    clubName: string | null;
  }>;
};

export type SendCotBroadcastMutationVariables = Exact<{
  eventId: string | number;
  audience: Types.CotBroadcastAudienceInput;
  subject: string;
  bodyTemplate: string;
}>;

export type SendCotBroadcastMutation = {
  __typename: "Mutation";
  sendCOTBroadcast: {
    __typename: "COTBroadcastResult";
    success: boolean;
    message: string | null;
    broadcast: {
      __typename: "COTBroadcast";
      id: string;
      cotEventId: string;
      sentByName: string;
      sentAt: string;
      recipientCount: number;
      subject: string;
      bodyTemplate: string;
      audience: {
        __typename: "COTBroadcastAudience";
        kind: Types.CotBroadcastAudienceKind;
        registered: boolean | null;
        areaId: string | null;
        divisionId: string | null;
        filters: Array<{
          __typename: "COTBroadcastAudience";
          kind: Types.CotBroadcastAudienceKind;
          registered: boolean | null;
          areaId: string | null;
          divisionId: string | null;
        }>;
      };
    } | null;
  };
};

export type SendCotBroadcastTestMutationVariables = Exact<{
  eventId: string | number;
  subject: string;
  bodyTemplate: string;
}>;

export type SendCotBroadcastTestMutation = {
  __typename: "Mutation";
  sendCOTBroadcastTest: { __typename: "COTBroadcastResult"; success: boolean; message: string | null };
};

export type ApplyCotCrossDistrictHandoffMutationVariables = Exact<{
  eventId: string | number;
}>;

export type ApplyCotCrossDistrictHandoffMutation = {
  __typename: "Mutation";
  applyCOTCrossDistrictHandoff: {
    __typename: "COTCrossDistrictHandoffResult";
    success: boolean;
    message: string | null;
    totalCredited: number;
    offPlatformDistricts: Array<string>;
    onPlatform: Array<{
      __typename: "COTCrossDistrictHandoffDistrict";
      homeDistrictNumber: string;
      onPlatform: boolean;
      completedAttendees: number;
      creditedOfficers: number;
      newOfficers: number;
      skippedReason: string | null;
    }>;
  };
};

export type AddCotEventHostMutationVariables = Exact<{
  eventId: string | number;
  userId: string | number;
}>;

export type AddCotEventHostMutation = {
  __typename: "Mutation";
  addCOTEventHost: {
    __typename: "COTEventResult";
    success: boolean;
    message: string | null;
    event: {
      __typename: "COTEvent";
      id: string;
      viewerCapabilities: {
        __typename: "COTViewerCapabilities";
        canManageHosts: boolean;
        canListDistrictOfficers: boolean;
        canReadEvent: boolean;
      };
      hosts: Array<{ __typename: "COTEventHost"; userId: string; name: string }>;
    } | null;
  };
};

export type RemoveCotEventHostMutationVariables = Exact<{
  eventId: string | number;
  userId: string | number;
}>;

export type RemoveCotEventHostMutation = {
  __typename: "Mutation";
  removeCOTEventHost: {
    __typename: "COTEventResult";
    success: boolean;
    message: string | null;
    event: {
      __typename: "COTEvent";
      id: string;
      viewerCapabilities: {
        __typename: "COTViewerCapabilities";
        canManageHosts: boolean;
        canListDistrictOfficers: boolean;
        canReadEvent: boolean;
      };
      hosts: Array<{ __typename: "COTEventHost"; userId: string; name: string }>;
    } | null;
  };
};

export type SetCotRegistrationNotOfficerMarkMutationVariables = Exact<{
  cotId: string | number;
  eventId: string | number;
  email: string;
  registrationId?: string | null | undefined;
  reason: Types.CotNotOfficerReason;
  note?: string | null | undefined;
  alsoMark?: Array<Types.CotRegistrationTargetInput> | Types.CotRegistrationTargetInput | null | undefined;
}>;

export type SetCotRegistrationNotOfficerMarkMutation = {
  __typename: "Mutation";
  setCOTRegistrationNotOfficerMark: {
    __typename: "COTNotOfficerMarkResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    markedCount: number;
    refused: Array<{
      __typename: "COTNotOfficerMarkRefusal";
      eventId: string;
      email: string;
      registrationId: string | null;
      errorCode: string;
      message: string;
    }>;
  };
};

export type ClearCotRegistrationNotOfficerMarkMutationVariables = Exact<{
  cotId: string | number;
  eventId: string | number;
  email: string;
  registrationId?: string | null | undefined;
}>;

export type ClearCotRegistrationNotOfficerMarkMutation = {
  __typename: "Mutation";
  clearCOTRegistrationNotOfficerMark: {
    __typename: "COTNotOfficerMarkResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type SetCotOfficerNotOfficerMarkMutationVariables = Exact<{
  cotId: string | number;
  recordId: string | number;
  reason: Types.CotNotOfficerReason;
  note?: string | null | undefined;
}>;

export type SetCotOfficerNotOfficerMarkMutation = {
  __typename: "Mutation";
  setCOTOfficerNotOfficerMark: {
    __typename: "COTOfficerMutationResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: { __typename: "COTClubOfficerRecord"; recordId: string } | null;
  };
};

export type ClearCotOfficerNotOfficerMarkMutationVariables = Exact<{
  cotId: string | number;
  recordId: string | number;
}>;

export type ClearCotOfficerNotOfficerMarkMutation = {
  __typename: "Mutation";
  clearCOTOfficerNotOfficerMark: {
    __typename: "COTOfficerMutationResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    officer: { __typename: "COTClubOfficerRecord"; recordId: string } | null;
  };
};

export type GetCotRoundsQueryVariables = Exact<{
  districtId: string;
}>;

export type GetCotRoundsQuery = {
  __typename: "Query";
  cotRounds: Array<{
    __typename: "COTRound";
    id: string;
    districtId: string;
    toastmastersYear: number;
    roundNumber: number;
    name: string;
    startDate: string;
    endDate: string;
    yearRange: string;
    dateRange: string;
    displayName: string;
    isActive: boolean;
    status: Types.CotRoundStatus;
    isLocked: boolean;
    lockDate: string;
    officerCount: number;
    completedCount: number;
    completionPercentage: number;
  }>;
};

export type CotOfficerStatusFieldsFragment = {
  __typename: "COTClubOfficerRecord";
  distinctRoleCount: number;
  completedDistinctRoleCount: number;
  cotsCreditsEarned: number;
  memberCreditsEarned: number;
  memberDistinctRoleCount: number;
  memberKey: string;
  requiresManualAssignment: boolean;
  isUnderCredited: boolean;
  isScheduledNotTrained: boolean;
  activeRegistrationEventIds: Array<string>;
};

export type GetCotRoundLandingQueryVariables = Exact<{
  districtId: string;
  cotId: string | number;
}>;

export type GetCotRoundLandingQuery = {
  __typename: "Query";
  cotRound: {
    __typename: "COTRound";
    id: string;
    finishedEventIds: Array<string>;
    viewerSeesTestEvents: boolean;
    name: string;
    yearRange: string;
    roundNumber: number;
    dateRange: string;
    isActive: boolean;
    isLocked: boolean;
    lockDate: string;
    lastTIImportDate: string | null;
    officers: Array<{
      __typename: "COTClubOfficerRecord";
      recordId: string;
      userId: string | null;
      name: string;
      email: string;
      membershipNumber: string;
      districtId: string | null;
      divisionId: string | null;
      areaId: string | null;
      hasCompletedTraining: boolean;
      isMatched: boolean;
      source: string;
      effectiveName: string;
      effectiveEmail: string;
      effectiveMembershipNumber: string;
      mergedIntoEmail: string | null;
      attendedEvents: Array<string>;
      distinctRoleCount: number;
      completedDistinctRoleCount: number;
      cotsCreditsEarned: number;
      memberCreditsEarned: number;
      memberDistinctRoleCount: number;
      memberKey: string;
      requiresManualAssignment: boolean;
      isUnderCredited: boolean;
      isScheduledNotTrained: boolean;
      activeRegistrationEventIds: Array<string>;
      clubOfficerRoles: Array<{
        __typename: "COTOfficerClubRole";
        clubId: string;
        role: Types.CotOfficerRole;
        clubName: string | null;
        districtId: string | null;
        divisionId: string | null;
        areaId: string | null;
        isCorporate: boolean;
        hasCompletedTraining: boolean;
        tiHasCompletedTraining: boolean | null;
      }>;
      manualRoleAssignments: Array<{ __typename: "COTManualRoleAssignment"; roleType: Types.CotOfficerRole }>;
      externalCompletion: { __typename: "COTExternalCompletion"; dateOfTraining: string; nameOfCOT: string } | null;
      recordOverride: { __typename: "COTRecordOverride"; overriddenAt: string } | null;
      notOfficerMark: {
        __typename: "COTNotOfficerMark";
        reason: Types.CotNotOfficerReason;
        note: string | null;
        markedByName: string;
        markedAt: string;
      } | null;
    }>;
  } | null;
};

export type GetCotRoundForSessionQueryVariables = Exact<{
  districtId: string;
  cotId: string | number;
}>;

export type GetCotRoundForSessionQuery = {
  __typename: "Query";
  cotRound: {
    __typename: "COTRound";
    id: string;
    finishedEventIds: Array<string>;
    name: string;
    isLocked: boolean;
    lockDate: string;
    officers: Array<{
      __typename: "COTClubOfficerRecord";
      recordId: string;
      userId: string | null;
      matchedToUserId: string | null;
      name: string;
      email: string;
      membershipNumber: string;
      districtId: string | null;
      divisionId: string | null;
      areaId: string | null;
      hasCompletedTraining: boolean;
      isMatched: boolean;
      source: string;
      effectiveName: string;
      effectiveEmail: string;
      effectiveMembershipNumber: string;
      mergedIntoEmail: string | null;
      attendedEvents: Array<string>;
      distinctRoleCount: number;
      completedDistinctRoleCount: number;
      cotsCreditsEarned: number;
      memberCreditsEarned: number;
      memberDistinctRoleCount: number;
      memberKey: string;
      requiresManualAssignment: boolean;
      isUnderCredited: boolean;
      isScheduledNotTrained: boolean;
      activeRegistrationEventIds: Array<string>;
      clubOfficerRoles: Array<{
        __typename: "COTOfficerClubRole";
        clubId: string;
        role: Types.CotOfficerRole;
        clubName: string | null;
        districtId: string | null;
        divisionId: string | null;
        areaId: string | null;
        isCorporate: boolean;
        hasCompletedTraining: boolean;
        tiHasCompletedTraining: boolean | null;
      }>;
      externalCompletion: { __typename: "COTExternalCompletion"; dateOfTraining: string; nameOfCOT: string } | null;
      recordOverride: { __typename: "COTRecordOverride"; overriddenAt: string } | null;
    }>;
  } | null;
};

export type GetCotOfficerQueryVariables = Exact<{
  districtId: string;
  cotId: string | number;
  recordId: string | number;
}>;

export type GetCotOfficerQuery = {
  __typename: "Query";
  cotOfficerCanMarkNotOfficer: boolean | null;
  cotMemberAssignmentState: {
    __typename: "COTMemberAssignmentState";
    token: string;
    memberRecords: Array<{
      __typename: "COTClubOfficerRecord";
      recordId: string;
      memberKey: string;
      email: string;
      effectiveEmail: string;
      mergedIntoEmail: string | null;
      clubOfficerRoles: Array<{
        __typename: "COTOfficerClubRole";
        clubId: string;
        role: Types.CotOfficerRole;
        clubName: string | null;
        hasCompletedTraining: boolean;
      }>;
      manualRoleAssignments: Array<{ __typename: "COTManualRoleAssignment"; roleType: Types.CotOfficerRole }>;
    }>;
  } | null;
  cotOfficer: {
    __typename: "COTClubOfficerRecord";
    recordId: string;
    userId: string | null;
    matchedToUserId: string | null;
    name: string;
    email: string;
    membershipNumber: string;
    districtId: string | null;
    divisionId: string | null;
    areaId: string | null;
    hasCompletedTraining: boolean;
    isMatched: boolean;
    source: string;
    effectiveName: string;
    effectiveEmail: string;
    effectiveMembershipNumber: string;
    effectiveUserId: string | null;
    mergedIntoEmail: string | null;
    mergedFromEmails: Array<string>;
    distinctRoleTypes: Array<string>;
    unassignedRoleTypes: Array<string>;
    clubRolesToken: string;
    attendedEvents: Array<string>;
    distinctRoleCount: number;
    completedDistinctRoleCount: number;
    cotsCreditsEarned: number;
    memberCreditsEarned: number;
    memberDistinctRoleCount: number;
    memberKey: string;
    requiresManualAssignment: boolean;
    isUnderCredited: boolean;
    isScheduledNotTrained: boolean;
    activeRegistrationEventIds: Array<string>;
    notOfficerMark: {
      __typename: "COTNotOfficerMark";
      reason: Types.CotNotOfficerReason;
      note: string | null;
      markedByName: string;
      markedAt: string;
    } | null;
    clubOfficerRoles: Array<{
      __typename: "COTOfficerClubRole";
      clubId: string;
      role: Types.CotOfficerRole;
      roleDisplayName: string;
      roleAbbreviation: string;
      clubName: string | null;
      districtId: string | null;
      divisionId: string | null;
      areaId: string | null;
      isCorporate: boolean;
      hasCompletedTraining: boolean;
      completedEventId: string | null;
      tiHasCompletedTraining: boolean | null;
    }>;
    externalCompletion: {
      __typename: "COTExternalCompletion";
      dateOfTraining: string;
      nameOfCOT: string;
      loggedBy: string;
      dateLoggedOnDistrictCentral: string;
      source: string;
    } | null;
    recordOverride: {
      __typename: "COTRecordOverride";
      correctedName: string | null;
      originalName: string | null;
      correctedEmail: string | null;
      originalEmail: string | null;
      correctedMembershipNumber: string | null;
      originalMembershipNumber: string | null;
      overriddenAt: string;
      notes: string | null;
    } | null;
    districtNotes: Array<{
      __typename: "COTDistrictNote";
      note: string;
      addedBy: string;
      addedByName: string;
      addedAt: string;
    }>;
    manualRoleAssignments: Array<{
      __typename: "COTManualRoleAssignment";
      roleType: Types.CotOfficerRole;
      eventId: string | null;
      assignedBy: string;
      assignedAt: string;
      notes: string | null;
    }>;
    manualTrainingCredits: Array<{
      __typename: "COTManualTrainingCredit";
      creditId: string;
      reason: string;
      trainingDate: string | null;
      trainingDescription: string | null;
      addedByName: string;
      addedAt: string;
    }>;
    registrations: Array<{
      __typename: "COTEventRegistrationRef";
      eventId: string;
      sessionId: string | null;
      registrationTime: string;
      registrationData: {
        __typename: "COTEventRegistration";
        firstName: string;
        lastName: string;
        email: string;
        registrationTime: string;
        approvalStatus: string;
        displayName: string;
        clubName: string;
        memberNumber: string;
        area: string;
        division: string;
        district: string;
        clubRole: string;
        userId: string | null;
        officerRecordId: string | null;
        registrationId: string | null;
      };
    }>;
  } | null;
};

export type GetCotEventsQueryVariables = Exact<{
  cotId: string | number;
}>;

export type GetCotEventsQuery = {
  __typename: "Query";
  cotEvents: Array<{
    __typename: "COTEventSummary";
    eventId: string;
    name: string;
    registrationCount: number;
    sessionCount: number;
    completedCount: number;
    unmatchedCount: number;
    firstSessionDate: string | null;
    lastSessionDate: string | null;
    publishStatus: Types.CotEventPublishStatus;
    registrationOpensAt: string | null;
    registrationClosesAt: string | null;
    externalRegistration: boolean;
    isTest: boolean;
    sessions: Array<{
      __typename: "COTEventSessionSummary";
      sessionId: string;
      name: string;
      dateTime: string;
      duration: number;
      sessionType: number | null;
      timeState: Types.CotTimeState;
    }>;
  }>;
};

export type GetCotEventQueryVariables = Exact<{
  eventId: string | number;
}>;

export type GetCotEventQuery = {
  __typename: "Query";
  cotEvent: {
    __typename: "COTEventDetail";
    id: string;
    programId: string;
    name: string;
    description: string;
    registrationCount: number;
    matchedCount: number;
    unmatchedCount: number;
    publishStatus: Types.CotEventPublishStatus;
    requiredSessionCount: number;
    registrationOpensAt: string | null;
    registrationClosesAt: string | null;
    externalRegistration: boolean;
    isTest: boolean;
    cancelledAt: string | null;
    cancellationReason: string | null;
    viewerCapabilities: {
      __typename: "COTViewerCapabilities";
      canManageHosts: boolean;
      canManageEvent: boolean;
      canListDistrictOfficers: boolean;
      isDistrictOfficer: boolean;
      isSeniorOfficer: boolean;
    };
    hosts: Array<{ __typename: "COTEventHost"; userId: string; name: string }>;
    registrations: Array<{
      __typename: "COTEventRegistrationDetail";
      firstName: string;
      lastName: string;
      email: string;
      registrationTime: string;
      approvalStatus: string;
      displayName: string;
      clubName: string;
      memberNumber: string;
      area: string;
      division: string;
      district: string;
      clubRole: string;
      userId: string | null;
      officerRecordId: string | null;
      isMatched: boolean;
      isUnmatched: boolean;
      sessionsAttended: number;
      hasCompletedTraining: boolean;
      linkedOfficerRecordId: string | null;
      linkedOfficerMatchType: string;
      cancelledAt: string | null;
      isCancelled: boolean;
      registrationId: string | null;
      sessionsAttendedDetails: Array<{
        __typename: "COTSessionAttendanceDetail";
        sessionId: string;
        sessionName: string;
        sessionType: string;
        isQualifying: boolean;
        duration: number;
        minDuration: number;
      }>;
      notOfficerMark: {
        __typename: "COTNotOfficerMark";
        reason: Types.CotNotOfficerReason;
        note: string | null;
        markedByName: string;
        markedAt: string;
      } | null;
    }>;
  } | null;
};

export type GetCotSessionsQueryVariables = Exact<{
  eventId: string | number;
}>;

export type GetCotSessionsQuery = {
  __typename: "Query";
  cotSessions: Array<{
    __typename: "COTSession";
    id: string;
    eventId: string;
    name: string;
    description: string;
    dateTime: string;
    location: string | null;
    joiningUrl: string | null;
    duration: number;
    durationDisplay: string;
    maxAttendees: number | null;
    sessionType: number | null;
    sessionTypeDisplay: string;
    timeState: Types.CotTimeState;
    minimumDurationMinutes: number;
    attendanceCount: number;
    qualifyingAttendanceCount: number;
    isFull: boolean;
  }>;
};

export type GetCotSessionQueryVariables = Exact<{
  sessionId: string | number;
}>;

export type GetCotSessionQuery = {
  __typename: "Query";
  cotSession: {
    __typename: "COTSession";
    id: string;
    eventId: string;
    name: string;
    description: string;
    dateTime: string;
    location: string | null;
    joiningUrl: string | null;
    duration: number;
    durationDisplay: string;
    maxAttendees: number | null;
    sessionType: number | null;
    sessionTypeDisplay: string;
    timeState: Types.CotTimeState;
    minimumDurationMinutes: number;
    attendanceCount: number;
    qualifyingAttendanceCount: number;
    isFull: boolean;
    viewerCapabilities: {
      __typename: "COTViewerCapabilities";
      canRunLiveAttendance: boolean;
      canMarkAttendance: boolean;
      canManageAttendance: boolean;
      canAddManualAttendance: boolean;
      canManageHosts: boolean;
      canListDistrictOfficers: boolean;
      isDistrictOfficer: boolean;
    };
    attendance: Array<{
      __typename: "COTSessionAttendance";
      name: string;
      email: string;
      joinTime: string;
      leaveTime: string;
      durationMinutes: number;
      role: string | null;
      club: string | null;
      source: Types.CotAttendanceSource;
      registrationId: string | null;
    }>;
  } | null;
};

export type GetCotProgramMetaQueryVariables = Exact<{
  districtId: string;
  cotId: string | number;
}>;

export type GetCotProgramMetaQuery = {
  __typename: "Query";
  cotRound: {
    __typename: "COTRound";
    id: string;
    name: string;
    displayName: string;
    lastTIImportDate: string | null;
    isLocked: boolean;
    lockDate: string;
  } | null;
};

export type GetCotEventRoundMetaQueryVariables = Exact<{
  eventId: string | number;
}>;

export type GetCotEventRoundMetaQuery = {
  __typename: "Query";
  cotEventRoundMeta: {
    __typename: "COTRoundMeta";
    id: string;
    name: string;
    displayName: string;
    lastTIImportDate: string | null;
    isLocked: boolean;
    lockDate: string;
  } | null;
};

export type GetCotClubSummariesQueryVariables = Exact<{
  districtId: string;
  cotId: string | number;
}>;

export type GetCotClubSummariesQuery = {
  __typename: "Query";
  cotClubSummaries: Array<{
    __typename: "COTClubSummary";
    clubId: string;
    clubName: string;
    divisionId: string;
    areaId: string;
    completionPercentage: number;
    isCorporate: boolean;
    hasDisagreement: boolean;
    trainedOfficerCount: number;
    complianceStatus: string;
    lifecycleStatus: string;
    isChartered: boolean;
    suspendDate: string | null;
    completedRoles: Array<string>;
    incompleteRoles: Array<string>;
    officers: Array<{
      __typename: "COTClubRoleStatus";
      role: Types.CotOfficerRole;
      roleDisplayName: string;
      officerName: string | null;
      email: string | null;
      hasCompleted: boolean;
      tiHasCompleted: boolean | null;
      recordId: string | null;
    }>;
  }>;
};

export type GetCotClubDetailQueryVariables = Exact<{
  districtId: string;
  cotId: string | number;
  clubId: string | number;
}>;

export type GetCotClubDetailQuery = {
  __typename: "Query";
  cotClubDetail: {
    __typename: "COTClubDetail";
    clubId: string;
    clubName: string;
    divisionId: string;
    areaId: number;
    officers: Array<{
      __typename: "COTClubRoleDetail";
      role: string;
      officers: Array<{
        __typename: "COTClubDetailOfficer";
        name: string;
        email: string;
        membershipNumber: string;
        hasCompleted: boolean;
        tiHasCompleted: boolean | null;
        hasBookendsTraining: boolean;
        distinctRoleCount: number;
        completedDistinctRoleCount: number;
        cotsCreditsEarned: number;
        memberCreditsEarned: number;
        memberDistinctRoleCount: number;
        requiresManualAssignment: boolean;
        isUnderCredited: boolean;
        unassignedRoleTypes: Array<string>;
        attendance: Array<{
          __typename: "COTClubAttendanceRecord";
          eventId: string;
          eventName: string;
          sessionId: string;
          sessionName: string;
          sessionType: number | null;
          attendanceTime: string;
          duration: number;
          qualifying: boolean;
        }>;
      }>;
    }>;
  } | null;
};

export type CotNotOfficerMarkFieldsFragment = {
  __typename: "COTNotOfficerMark";
  reason: Types.CotNotOfficerReason;
  note: string | null;
  markedByName: string;
  markedAt: string;
};

export type GetCotUnmatchedAttendeesQueryVariables = Exact<{
  cotId: string | number;
  markedNotOfficer?: boolean | null | undefined;
}>;

export type GetCotUnmatchedAttendeesQuery = {
  __typename: "Query";
  cotUnmatchedAttendees: Array<{
    __typename: "COTUnmatchedAttendee";
    eventId: string;
    eventName: string;
    sessionId: string;
    sessionName: string;
    name: string;
    email: string;
    membershipNumber: string | null;
    club: string | null;
    role: string | null;
    attendanceTime: string;
    durationMinutes: number;
    isQualifying: boolean;
    matchStatus: string;
    registrationId: string | null;
    ambiguousCandidates: Array<{
      __typename: "COTOfficerMatchCandidate";
      recordId: string;
      name: string;
      email: string;
      clubName: string | null;
      membershipNumber: string | null;
    }>;
    notOfficerMark: {
      __typename: "COTNotOfficerMark";
      reason: Types.CotNotOfficerReason;
      note: string | null;
      markedByName: string;
      markedAt: string;
    } | null;
  }>;
};

export type OfficerCotEventViewFieldsFragment = {
  __typename: "OfficerCOTEventView";
  isRegistrationOpenNow: boolean;
  timeState: Types.CotTimeState | null;
  isRegistered: boolean;
  registeredCount: number;
  isFull: boolean;
  waitlistCount: number;
  isWaitlisted: boolean;
  waitlistPosition: number | null;
  knownClubRoles: Array<{
    __typename: "COTOfficerClubRole";
    clubId: string;
    role: Types.CotOfficerRole;
    roleDisplayName: string;
    roleAbbreviation: string;
    clubName: string | null;
    hasCompletedTraining: boolean;
  }>;
  event: {
    __typename: "OfficerCOTEventInfo";
    id: string;
    programId: string;
    districtId: string;
    name: string;
    description: string;
    publishStatus: Types.CotEventPublishStatus;
    requiredSessionCount: number;
    registrationOpensAt: string | null;
    registrationClosesAt: string | null;
    externalRegistration: boolean;
    isTest: boolean;
    cancelledAt: string | null;
    cancellationReason: string | null;
  };
  sessions: Array<{
    __typename: "COTSession";
    id: string;
    eventId: string;
    name: string;
    description: string;
    dateTime: string;
    location: string | null;
    joiningUrl: string | null;
    duration: number;
    durationDisplay: string;
    maxAttendees: number | null;
    sessionType: number | null;
    sessionTypeDisplay: string;
    timeState: Types.CotTimeState;
    minimumDurationMinutes: number;
    attendanceCount: number;
  }>;
  myRegistration: {
    __typename: "COTEventRegistration";
    email: string;
    displayName: string;
    registeredAt: string;
    cancelledAt: string | null;
    isCancelled: boolean;
    isWaitlisted: boolean;
    waitlistedAt: string | null;
    source: Types.RegistrationSource;
    clubRole: string;
    seekingCreditForRoles: Array<{
      __typename: "COTOfficerClubRole";
      clubId: string;
      role: Types.CotOfficerRole;
      roleDisplayName: string;
      clubName: string | null;
    }>;
    notificationPrefs: {
      __typename: "NotificationPrefs";
      reminder24hBefore: boolean;
      attendanceConfirmation: boolean;
      creditEarned: boolean;
    };
  } | null;
};

export type GetMyCotRegistrationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyCotRegistrationsQuery = {
  __typename: "Query";
  myCOTRegistrations: Array<{
    __typename: "OfficerCOTEventView";
    isRegistrationOpenNow: boolean;
    timeState: Types.CotTimeState | null;
    isRegistered: boolean;
    registeredCount: number;
    isFull: boolean;
    waitlistCount: number;
    isWaitlisted: boolean;
    waitlistPosition: number | null;
    knownClubRoles: Array<{
      __typename: "COTOfficerClubRole";
      clubId: string;
      role: Types.CotOfficerRole;
      roleDisplayName: string;
      roleAbbreviation: string;
      clubName: string | null;
      hasCompletedTraining: boolean;
    }>;
    event: {
      __typename: "OfficerCOTEventInfo";
      id: string;
      programId: string;
      districtId: string;
      name: string;
      description: string;
      publishStatus: Types.CotEventPublishStatus;
      requiredSessionCount: number;
      registrationOpensAt: string | null;
      registrationClosesAt: string | null;
      externalRegistration: boolean;
      isTest: boolean;
      cancelledAt: string | null;
      cancellationReason: string | null;
    };
    sessions: Array<{
      __typename: "COTSession";
      id: string;
      eventId: string;
      name: string;
      description: string;
      dateTime: string;
      location: string | null;
      joiningUrl: string | null;
      duration: number;
      durationDisplay: string;
      maxAttendees: number | null;
      sessionType: number | null;
      sessionTypeDisplay: string;
      timeState: Types.CotTimeState;
      minimumDurationMinutes: number;
      attendanceCount: number;
    }>;
    myRegistration: {
      __typename: "COTEventRegistration";
      email: string;
      displayName: string;
      registeredAt: string;
      cancelledAt: string | null;
      isCancelled: boolean;
      isWaitlisted: boolean;
      waitlistedAt: string | null;
      source: Types.RegistrationSource;
      clubRole: string;
      seekingCreditForRoles: Array<{
        __typename: "COTOfficerClubRole";
        clubId: string;
        role: Types.CotOfficerRole;
        roleDisplayName: string;
        clubName: string | null;
      }>;
      notificationPrefs: {
        __typename: "NotificationPrefs";
        reminder24hBefore: boolean;
        attendanceConfirmation: boolean;
        creditEarned: boolean;
      };
    } | null;
  }>;
};

export type GetCotEventForOfficerQueryVariables = Exact<{
  eventId: string | number;
}>;

export type GetCotEventForOfficerQuery = {
  __typename: "Query";
  cotEventForOfficer: {
    __typename: "OfficerCOTEventView";
    isRegistrationOpenNow: boolean;
    timeState: Types.CotTimeState | null;
    isRegistered: boolean;
    registeredCount: number;
    isFull: boolean;
    waitlistCount: number;
    isWaitlisted: boolean;
    waitlistPosition: number | null;
    knownClubRoles: Array<{
      __typename: "COTOfficerClubRole";
      clubId: string;
      role: Types.CotOfficerRole;
      roleDisplayName: string;
      roleAbbreviation: string;
      clubName: string | null;
      hasCompletedTraining: boolean;
    }>;
    event: {
      __typename: "OfficerCOTEventInfo";
      id: string;
      programId: string;
      districtId: string;
      name: string;
      description: string;
      publishStatus: Types.CotEventPublishStatus;
      requiredSessionCount: number;
      registrationOpensAt: string | null;
      registrationClosesAt: string | null;
      externalRegistration: boolean;
      isTest: boolean;
      cancelledAt: string | null;
      cancellationReason: string | null;
    };
    sessions: Array<{
      __typename: "COTSession";
      id: string;
      eventId: string;
      name: string;
      description: string;
      dateTime: string;
      location: string | null;
      joiningUrl: string | null;
      duration: number;
      durationDisplay: string;
      maxAttendees: number | null;
      sessionType: number | null;
      sessionTypeDisplay: string;
      timeState: Types.CotTimeState;
      minimumDurationMinutes: number;
      attendanceCount: number;
    }>;
    myRegistration: {
      __typename: "COTEventRegistration";
      email: string;
      displayName: string;
      registeredAt: string;
      cancelledAt: string | null;
      isCancelled: boolean;
      isWaitlisted: boolean;
      waitlistedAt: string | null;
      source: Types.RegistrationSource;
      clubRole: string;
      seekingCreditForRoles: Array<{
        __typename: "COTOfficerClubRole";
        clubId: string;
        role: Types.CotOfficerRole;
        roleDisplayName: string;
        clubName: string | null;
      }>;
      notificationPrefs: {
        __typename: "NotificationPrefs";
        reminder24hBefore: boolean;
        attendanceConfirmation: boolean;
        creditEarned: boolean;
      };
    } | null;
  } | null;
};

export type GetMyCotActivityQueryVariables = Exact<{
  limit?: number | null | undefined;
}>;

export type GetMyCotActivityQuery = {
  __typename: "Query";
  myCotActivity: Array<{
    __typename: "CotActivityEntry";
    id: string;
    eventType: string;
    title: string;
    detail: string;
    entityId: string | null;
    occurredAt: string;
    userId: string | null;
    triggeredBy: string | null;
    districtId: string | null;
  }>;
};

export type GetDistrictCotActivityQueryVariables = Exact<{
  districtId: string;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  search?: string | null | undefined;
  eventTypes?: Array<string> | string | null | undefined;
  cotId?: string | null | undefined;
}>;

export type GetDistrictCotActivityQuery = {
  __typename: "Query";
  districtCotActivity: Array<{
    __typename: "CotActivityEntry";
    id: string;
    eventType: string;
    title: string;
    detail: string;
    entityId: string | null;
    cotId: string | null;
    eventId: string | null;
    officerRecordId: string | null;
    occurredAt: string;
    userId: string | null;
    triggeredBy: string | null;
    districtId: string | null;
  }>;
};

export type GetMyClubOfficerRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyClubOfficerRolesQuery = {
  __typename: "Query";
  myClubOfficerRoles: Array<{
    __typename: "COTOfficerClubRole";
    clubId: string;
    role: Types.CotOfficerRole;
    roleDisplayName: string;
    roleAbbreviation: string;
    clubName: string | null;
  }>;
};

export type GetMyAssertedClubRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyAssertedClubRolesQuery = {
  __typename: "Query";
  myAssertedClubRoles: Array<{
    __typename: "COTOfficerClubRole";
    clubId: string;
    role: Types.CotOfficerRole;
    roleDisplayName: string;
    roleAbbreviation: string;
    clubName: string | null;
  }>;
};

export type GetPublicCotEventForRegistrationQueryVariables = Exact<{
  eventId: string | number;
}>;

export type GetPublicCotEventForRegistrationQuery = {
  __typename: "Query";
  publicCOTEventForRegistration: {
    __typename: "PublicCOTEventInfo";
    id: string;
    programId: string;
    districtId: string;
    name: string;
    description: string;
    publishStatus: Types.CotEventPublishStatus;
    registrationOpensAt: string | null;
    registrationClosesAt: string | null;
    externalRegistration: boolean;
    publicLinkEnabled: boolean;
    isRegistrationOpenNow: boolean;
    timeState: Types.CotTimeState | null;
    isTest: boolean;
  } | null;
};

export type GetPublicPublishedCotEventsQueryVariables = Exact<{
  districtId: string;
}>;

export type GetPublicPublishedCotEventsQuery = {
  __typename: "Query";
  publicPublishedCOTEvents: Array<{
    __typename: "PublicCOTEventView";
    isRegistrationOpenNow: boolean;
    timeState: Types.CotTimeState | null;
    registeredCount: number;
    isFull: boolean;
    waitlistCount: number;
    event: {
      __typename: "PublicCOTEventInfo";
      id: string;
      programId: string;
      name: string;
      description: string;
      publishStatus: Types.CotEventPublishStatus;
      registrationOpensAt: string | null;
      registrationClosesAt: string | null;
      externalRegistration: boolean;
      publicLinkEnabled: boolean;
      isTest: boolean;
    };
    sessions: Array<{
      __typename: "PublicCOTSession";
      id: string;
      eventId: string;
      name: string;
      description: string;
      dateTime: string;
      location: string | null;
      isOnline: boolean;
      duration: number;
      durationDisplay: string;
      maxAttendees: number | null;
      sessionType: number | null;
      sessionTypeDisplay: string;
      timeState: Types.CotTimeState;
    }>;
  }>;
};

export type GetCotAudiencePreviewQueryVariables = Exact<{
  eventId: string | number;
  audience: Types.CotBroadcastAudienceInput;
}>;

export type GetCotAudiencePreviewQuery = {
  __typename: "Query";
  cotAudiencePreview: {
    __typename: "COTAudiencePreview";
    recipientCount: number;
    sample: Array<{ __typename: "COTBroadcastRecipient"; email: string; displayName: string; isExternal: boolean }>;
    audience: {
      __typename: "COTBroadcastAudience";
      kind: Types.CotBroadcastAudienceKind;
      registered: boolean | null;
      areaId: string | null;
      divisionId: string | null;
      filters: Array<{
        __typename: "COTBroadcastAudience";
        kind: Types.CotBroadcastAudienceKind;
        registered: boolean | null;
        areaId: string | null;
        divisionId: string | null;
      }>;
    };
  };
};

export type GetCotBroadcastPreviewContextQueryVariables = Exact<{
  eventId: string | number;
}>;

export type GetCotBroadcastPreviewContextQuery = {
  __typename: "Query";
  cotBroadcastPreviewContext: {
    __typename: "COTBroadcastPreviewContext";
    eventName: string;
    eventDescription: string | null;
    firstSessionDate: string | null;
    registrationLink: string;
    districtName: string;
    creditRequirement: string | null;
  };
};

export type GetCotExternalAttendeeHomeDistrictsQueryVariables = Exact<{
  eventId: string | number;
}>;

export type GetCotExternalAttendeeHomeDistrictsQuery = {
  __typename: "Query";
  cotExternalAttendeeHomeDistricts: Array<string>;
};

export type GetCotExternalAttendeeCsvQueryVariables = Exact<{
  eventId: string | number;
  homeDistrictNumber: string;
}>;

export type GetCotExternalAttendeeCsvQuery = { __typename: "Query"; cotExternalAttendeeCSV: string };

export type GetCotBroadcastsQueryVariables = Exact<{
  eventId: string | number;
}>;

export type GetCotBroadcastsQuery = {
  __typename: "Query";
  cotBroadcasts: Array<{
    __typename: "COTBroadcast";
    id: string;
    cotEventId: string;
    sentByUserId: string;
    sentByName: string;
    sentAt: string;
    recipientCount: number;
    subject: string;
    bodyTemplate: string;
    audience: {
      __typename: "COTBroadcastAudience";
      kind: Types.CotBroadcastAudienceKind;
      registered: boolean | null;
      areaId: string | null;
      divisionId: string | null;
      filters: Array<{
        __typename: "COTBroadcastAudience";
        kind: Types.CotBroadcastAudienceKind;
        registered: boolean | null;
        areaId: string | null;
        divisionId: string | null;
      }>;
    };
  }>;
};

export type GetCotTrainingSummaryQueryVariables = Exact<{
  districtId: string;
  cotId: string | number;
}>;

export type GetCotTrainingSummaryQuery = {
  __typename: "Query";
  cotTrainingSummary: {
    __typename: "COTTrainingSummary";
    officers: number;
    peopleFullyTrained: number;
    peoplePartlyTrained: number;
    peopleAwaitingAssignment: number;
    peopleAwaitingTraining: number;
    peopleDidNotComplete: number;
    peopleNotRegistered: number;
    peopleTrained: number;
    roleTypesHeld: number;
    roleTypesTrained: number;
    clubRoleSlots: number;
    clubRoleSlotsTrained: number;
    clubsCovered: number;
    clubsWithOfficers: number;
    clubsMeetingGoal: number;
    clubsAtRisk: number;
    clubsNotMet: number;
    clubsFullyTrained: number;
    recordsWithoutCoveredRole: number;
    roleRowsOutsideClubSet: number;
    roleRowsWithUnresolvedClub: number;
    tiRoleRows: number;
    tiRoleRowsWithData: number;
    tiDisagreements: number;
    divisions: Array<{
      __typename: "COTTrainingDivisionRow";
      division: string;
      officers: number;
      peopleFullyTrained: number;
      peoplePartlyTrained: number;
      peopleAwaitingAssignment: number;
      peopleAwaitingTraining: number;
      peopleDidNotComplete: number;
      peopleNotRegistered: number;
      peopleTrained: number;
      roleTypesHeld: number;
      roleTypesTrained: number;
    }>;
  } | null;
};

export type GetDashboardOverviewQueryVariables = Exact<{ [key: string]: never }>;

export type GetDashboardOverviewQuery = {
  __typename: "Query";
  dashboardOverview: {
    __typename: "OverviewDashboardData";
    totalDistricts: number;
    totalActiveClubs: number;
    asOfDate: string;
    districts: Array<{
      __typename: "OverviewDistrictSummary";
      region: string;
      district: string;
      activeClubs: number;
      paidClubs: number;
      totalYtdPayments: number;
      asOfDate: string;
      programYear: number;
    }>;
  } | null;
};

export type GetDashboardHierarchyQueryVariables = Exact<{ [key: string]: never }>;

export type GetDashboardHierarchyQuery = { __typename: "Query"; dashboardHierarchy: any };

export type GetDistrictDashboardQueryVariables = Exact<{
  districtId: string | number;
}>;

export type GetDistrictDashboardQuery = {
  __typename: "Query";
  districtDashboard: {
    __typename: "DistrictDashboardResponse";
    districtId: number;
    districtName: string;
    entriesByYear: any;
    membershipsByDate: any;
    divisions: any;
    divisionProvisionalCounts: any;
    totalPaidClubs: number;
    isProvisionalPeriod: boolean;
    shortDescription: string | null;
    longDescription: string | null;
    region: number | null;
    websiteUrl: string | null;
    timezones: Array<string>;
    membershipPaymentsChart: {
      __typename: "DashboardChart";
      title: string;
      yAxisMax: number | null;
      current: { __typename: "ChartSeries"; label: string; points: Array<number> };
      previous: { __typename: "ChartSeries"; label: string; points: Array<number> };
      thresholds: Array<{
        __typename: "ChartThreshold";
        label: string;
        value: number;
        qualified: boolean;
        level: string;
      }>;
    };
    clubsChart: {
      __typename: "DashboardChart";
      title: string;
      yAxisMax: number | null;
      current: { __typename: "ChartSeries"; label: string; points: Array<number> };
      previous: { __typename: "ChartSeries"; label: string; points: Array<number> };
      thresholds: Array<{
        __typename: "ChartThreshold";
        label: string;
        value: number;
        qualified: boolean;
        level: string;
      }>;
    };
    membersChart: {
      __typename: "DashboardChart";
      title: string;
      yAxisMax: number | null;
      current: { __typename: "ChartSeries"; label: string; points: Array<number> };
      previous: { __typename: "ChartSeries"; label: string; points: Array<number> };
      thresholds: Array<{
        __typename: "ChartThreshold";
        label: string;
        value: number;
        qualified: boolean;
        level: string;
      }>;
    };
  } | null;
};

export type GetDivisionDashboardQueryVariables = Exact<{
  districtId: string | number;
  divisionId: string;
}>;

export type GetDivisionDashboardQuery = {
  __typename: "Query";
  divisionDashboard: {
    __typename: "DivisionDashboardResponse";
    districtId: number;
    districtName: string;
    divisionId: string;
    divisionName: string;
    areas: any;
    areaProvisionalCounts: any;
    asOfDate: string;
    isProvisionalPeriod: boolean;
    clubsChart: {
      __typename: "DashboardChart";
      title: string;
      yAxisMax: number | null;
      current: { __typename: "ChartSeries"; label: string; points: Array<number> };
      previous: { __typename: "ChartSeries"; label: string; points: Array<number> };
      thresholds: Array<{
        __typename: "ChartThreshold";
        label: string;
        value: number;
        qualified: boolean;
        level: string;
      }>;
    };
    distClubsChart: {
      __typename: "DashboardChart";
      title: string;
      yAxisMax: number | null;
      current: { __typename: "ChartSeries"; label: string; points: Array<number> };
      previous: { __typename: "ChartSeries"; label: string; points: Array<number> };
      thresholds: Array<{
        __typename: "ChartThreshold";
        label: string;
        value: number;
        qualified: boolean;
        level: string;
      }>;
    };
  } | null;
};

export type GetAreaDashboardQueryVariables = Exact<{
  districtId: string | number;
  divisionId: string;
  areaId: string;
}>;

export type GetAreaDashboardQuery = {
  __typename: "Query";
  areaDashboard: {
    __typename: "AreaDashboardResponse";
    districtId: number;
    districtName: string;
    divisionId: string;
    divisionName: string;
    areaId: string;
    areaName: string;
    clubs: any;
    clubProvisionalStatus: any;
    asOfDate: string;
    isProvisionalPeriod: boolean;
    clubsChart: {
      __typename: "DashboardChart";
      title: string;
      yAxisMax: number | null;
      current: { __typename: "ChartSeries"; label: string; points: Array<number> };
      previous: { __typename: "ChartSeries"; label: string; points: Array<number> };
      thresholds: Array<{
        __typename: "ChartThreshold";
        label: string;
        value: number;
        qualified: boolean;
        level: string;
      }>;
    };
    distClubsChart: {
      __typename: "DashboardChart";
      title: string;
      yAxisMax: number | null;
      current: { __typename: "ChartSeries"; label: string; points: Array<number> };
      previous: { __typename: "ChartSeries"; label: string; points: Array<number> };
      thresholds: Array<{
        __typename: "ChartThreshold";
        label: string;
        value: number;
        qualified: boolean;
        level: string;
      }>;
    };
  } | null;
};

export type GetClubDashboardQueryVariables = Exact<{
  districtId: string | number;
  divisionId: string;
  areaId: string;
  clubId: string | number;
}>;

export type GetClubDashboardQuery = {
  __typename: "Query";
  clubDashboard: {
    __typename: "ClubDashboardResponse";
    districtId: number;
    districtName: string;
    divisionId: string;
    divisionName: string;
    areaId: string;
    areaName: string;
    clubId: number;
    clubName: string;
    clubNumber: number;
    shortName: string | null;
    tiStatus: string;
    suspendDate: string | null;
    clubInfo: any;
    clubData: any;
    asOfDate: string;
    isEligible: boolean;
    maxObtainableDCPPoints: number;
    membershipImportDate: string;
    clubWebsiteUrl: string | null;
    clubWebsiteSource: string | null;
    tiWebsiteUrl: string | null;
    nudges: Array<{ __typename: "NudgeSuggestion"; message: string; urgency: number; category: string }>;
    membersChart: {
      __typename: "DashboardChart";
      title: string;
      yAxisMax: number | null;
      current: { __typename: "ChartSeries"; label: string; points: Array<number> };
      previous: { __typename: "ChartSeries"; label: string; points: Array<number> };
      thresholds: Array<{
        __typename: "ChartThreshold";
        label: string;
        value: number;
        qualified: boolean;
        level: string;
      }>;
    };
    goalsChart: {
      __typename: "DashboardChart";
      title: string;
      yAxisMax: number | null;
      current: { __typename: "ChartSeries"; label: string; points: Array<number> };
      previous: { __typename: "ChartSeries"; label: string; points: Array<number> };
      thresholds: Array<{
        __typename: "ChartThreshold";
        label: string;
        value: number;
        qualified: boolean;
        level: string;
      }>;
    };
  } | null;
};

export type GetClubsDashboardQueryVariables = Exact<{
  districtId: string | number;
}>;

export type GetClubsDashboardQuery = {
  __typename: "Query";
  clubsDashboard: {
    __typename: "ClubsDashboard";
    districtId: number;
    districtName: string;
    totalActiveMembers: number;
    pathwaysEnrolledMembers: number;
    pathwaysTotalMembers: number;
    divisionStats: Array<{
      __typename: "DivisionStats";
      divisionId: string;
      totalActiveMembers: number;
      pathwaysEnrolledMembers: number;
      pathwaysTotalMembers: number;
      areaStats: Array<{
        __typename: "AreaStats";
        areaId: string;
        totalActiveMembers: number;
        pathwaysEnrolledMembers: number;
        pathwaysTotalMembers: number;
        clubs: Array<{
          __typename: "ClubStats";
          clubId: number;
          clubName: string;
          division: string;
          area: string;
          tiStatus: string;
          suspendDate: string | null;
          hasPerformanceData: boolean;
          activeMembers: number;
          membershipBase: number;
          membershipGrowth: number;
          goalsMet: number;
          isDCPEligible: boolean;
          clubStatus: string;
          awardsPerMember: number;
          pathwaysEnrolledMembers: number;
          pathwaysTotalMembers: number;
        }>;
      }>;
    }>;
  } | null;
};

export type GetDcpOverviewQueryVariables = Exact<{
  districtId: string | number;
}>;

export type GetDcpOverviewQuery = {
  __typename: "Query";
  dcpOverview: {
    __typename: "DCPOverview";
    districtId: number;
    districtName: string;
    totalClubs: number;
    activeClubs: number;
    lowClubs: number;
    ineligibleClubs: number;
    suspendedClubs: number;
    totalDistinguishedClubs: number;
    smedleyDistinguishedClubs: number;
    presidentsDistinguishedClubs: number;
    selectDistinguishedClubs: number;
    distinguishedClubs: number;
    nonEligibleWithDCP: number;
    eligibleWithoutDCP: number;
    clubs: Array<{
      __typename: "ClubDCPData";
      clubId: number;
      clubName: string;
      shortName: string | null;
      division: string;
      area: string;
      goalsMet: number;
      dcpEligibility: boolean;
      isActive: boolean;
      isLow: boolean;
      isIneligible: boolean;
      isSuspended: boolean;
      eligibleDCPPoints: number;
      activeMembers: number;
    }>;
  } | null;
};

export type UpdateDistrictConfigMutationVariables = Exact<{
  districtId: string | number;
  name: string;
  contactEmail: string;
  calendarEnabled: boolean;
}>;

export type UpdateDistrictConfigMutation = {
  __typename: "Mutation";
  updateDistrictConfig: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type AssignDistrictOfficerMutationVariables = Exact<{
  districtId: string | number;
  userId: string | number;
  membershipId: string;
  memberName: string;
  roleName: string;
  isSenior: boolean;
}>;

export type AssignDistrictOfficerMutation = {
  __typename: "Mutation";
  assignDistrictOfficer: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type RemoveDistrictOfficerMutationVariables = Exact<{
  districtId: string | number;
  userId: string | number;
  role: string;
}>;

export type RemoveDistrictOfficerMutation = {
  __typename: "Mutation";
  removeDistrictOfficer: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type RefreshDistrictDataMutationVariables = Exact<{
  districtId: string | number;
}>;

export type RefreshDistrictDataMutation = {
  __typename: "Mutation";
  refreshDistrictData: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type GetDistrictsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDistrictsQuery = {
  __typename: "Query";
  districts: Array<{
    __typename: "District";
    id: string;
    districtNumber: number;
    name: string;
    displayName: string;
    shortDisplayName: string;
    contactEmail: string | null;
    timezone: string;
    calendarEnabled: boolean;
    clubCount: number;
    memberCount: number;
  }>;
};

export type GetDistrictQueryVariables = Exact<{
  districtId: string | number;
}>;

export type GetDistrictQuery = {
  __typename: "Query";
  district: {
    __typename: "District";
    id: string;
    districtNumber: number;
    name: string;
    displayName: string;
    shortDisplayName: string;
    contactEmail: string | null;
    timezone: string;
    calendarEnabled: boolean;
    clubCount: number;
    memberCount: number;
  } | null;
};

export type GetDistrictOfficersQueryVariables = Exact<{
  districtId: string | number;
}>;

export type GetDistrictOfficersQuery = {
  __typename: "Query";
  districtOfficers: Array<{
    __typename: "DistrictOfficerDTO";
    userId: string;
    memberName: string;
    membershipId: string;
    role: string;
    displayName: string;
    isSenior: boolean;
    isAssigned: boolean;
    termStart: string;
    termEnd: string;
    area: string | null;
    division: string | null;
  }>;
};

export type GetDistrictMembersQueryVariables = Exact<{
  districtId: string | number;
}>;

export type GetDistrictMembersQuery = {
  __typename: "Query";
  districtMembers: Array<{
    __typename: "DistrictMember";
    userId: string;
    membershipId: string | null;
    name: string;
    email: string | null;
    clubName: string;
  }>;
};

export type SearchDistrictMembersQueryVariables = Exact<{
  districtId: string | number;
  query: string;
}>;

export type SearchDistrictMembersQuery = {
  __typename: "Query";
  searchDistrictMembers: Array<{
    __typename: "DistrictMember";
    userId: string;
    membershipId: string | null;
    name: string;
    email: string | null;
    clubName: string;
  }>;
};

export type GetClubEmailAddressesNotWorkingQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubEmailAddressesNotWorkingQuery = { __typename: "Query"; clubEmailAddressesNotWorking: number };

export type MarkEmailAddressWorkingMutationVariables = Exact<{
  clubId: string | number;
  address: string;
}>;

export type MarkEmailAddressWorkingMutation = {
  __typename: "Mutation";
  markEmailAddressWorking: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type GuestRegistrationFieldsFragment = {
  __typename: "GuestRegistration";
  firstName: string;
  lastName: string;
  emailAddress: string | null;
  phoneNumber: string | null;
  foundUsInfo: number;
  creationDate: string | null;
  lastSignedAt: string | null;
  signingCount: number | null;
  guestStatus: string;
  lastEmailSent: string | null;
  actionId: string;
  emailStatus: {
    __typename: "EmailAddressStatus";
    state: string;
    reason: string | null;
    since: string;
    address: string;
    canMarkWorking: boolean;
  } | null;
};

export type FoundUsEntryFieldsFragment = { __typename: "FoundUsEntry"; value: string; text: string };

export type GetClubGuestbookDataQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubGuestbookDataQuery = {
  __typename: "Query";
  clubGuestbookData: {
    __typename: "GuestbookData";
    enabled: boolean;
    guests: Array<{
      __typename: "GuestRegistration";
      firstName: string;
      lastName: string;
      emailAddress: string | null;
      phoneNumber: string | null;
      foundUsInfo: number;
      creationDate: string | null;
      lastSignedAt: string | null;
      signingCount: number | null;
      guestStatus: string;
      lastEmailSent: string | null;
      actionId: string;
      emailStatus: {
        __typename: "EmailAddressStatus";
        state: string;
        reason: string | null;
        since: string;
        address: string;
        canMarkWorking: boolean;
      } | null;
    }>;
    foundUsMap: Array<{ __typename: "FoundUsEntry"; value: string; text: string }>;
  };
};

export type GetClubGuestbookConfigQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubGuestbookConfigQuery = {
  __typename: "Query";
  clubGuestbookConfig: {
    __typename: "GuestbookConfig";
    enabled: boolean;
    welcomeEmailEnabled: boolean;
    firstEmailBody: string;
    returningGuestEmailBody: string;
    reminderEmailBody: string;
  };
};

export type GetGuestbookEmailOptionsQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetGuestbookEmailOptionsQuery = {
  __typename: "Query";
  guestbookEmailOptions: Array<{ __typename: "GuestEmailOption"; label: string; value: string }>;
};

export type GetFoundUsOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetFoundUsOptionsQuery = {
  __typename: "Query";
  foundUsOptions: Array<{ __typename: "FoundUsEntry"; value: string; text: string }>;
};

export type GetClubInfoForGuestQueryVariables = Exact<{
  clubShortName: string;
}>;

export type GetClubInfoForGuestQuery = {
  __typename: "Query";
  clubInfoForGuest: { __typename: "ClubGuestInfo"; shortName: string; longName: string; enabled: boolean } | null;
};

export type GetClubPendingGuestbookSubmissionsQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubPendingGuestbookSubmissionsQuery = {
  __typename: "Query";
  clubPendingGuestbookSubmissions: Array<{
    __typename: "PendingSubmission";
    id: string;
    name: string;
    email: string;
    submittedAt: string;
    expiresAt: string;
  }>;
};

export type RemoveGuestMutationVariables = Exact<{
  clubId: string | number;
  actionId: string;
}>;

export type RemoveGuestMutation = {
  __typename: "Mutation";
  removeGuest: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type ResendGuestWelcomeEmailMutationVariables = Exact<{
  clubId: string | number;
  actionId: string;
}>;

export type ResendGuestWelcomeEmailMutation = {
  __typename: "Mutation";
  resendGuestWelcomeEmail: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type SendGuestbookEmailMutationVariables = Exact<{
  clubId: string | number;
  emailBody: string;
  toWhom: string;
}>;

export type SendGuestbookEmailMutation = {
  __typename: "Mutation";
  sendGuestbookEmail: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type RegisterGuestMutationVariables = Exact<{
  clubShortName: string;
  formId: string;
  firstName: string;
  lastName: string;
  email: string;
  foundUsInfo: string;
  phoneNumber?: string | null | undefined;
}>;

export type RegisterGuestMutation = {
  __typename: "Mutation";
  registerGuest: {
    __typename: "RegisterGuestResult";
    success: boolean;
    message: string | null;
    verificationEmailSent: boolean;
    meetingInProgress: { __typename: "GuestSigningMeeting"; meetingId: string; title: string } | null;
  };
};

export type ConfirmPendingGuestbookSubmissionMutationVariables = Exact<{
  clubId: string | number;
  submissionId: string;
}>;

export type ConfirmPendingGuestbookSubmissionMutation = {
  __typename: "Mutation";
  confirmPendingGuestbookSubmission: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type ResendPendingGuestbookVerificationMutationVariables = Exact<{
  clubId: string | number;
  submissionId: string;
}>;

export type ResendPendingGuestbookVerificationMutation = {
  __typename: "Mutation";
  resendPendingGuestbookVerification: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type GetPublicLandingStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPublicLandingStatsQuery = {
  __typename: "Query";
  publicLandingStats: {
    __typename: "PublicLandingStats";
    activeClubs: number;
    meetingsOrganised: number;
    paperSlipsSaved: number;
  };
};

export type ClubLinkFieldsFragment = {
  __typename: "ClubLink";
  id: string;
  name: string;
  url: string;
  isActive: boolean;
  order: number;
  clubId: number;
  createdAt: any;
  updatedAt: any;
};

export type GetClubLinksQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubLinksQuery = {
  __typename: "Query";
  clubLinks: Array<{
    __typename: "ClubLink";
    id: string;
    name: string;
    url: string;
    isActive: boolean;
    order: number;
    clubId: number;
    createdAt: any;
    updatedAt: any;
  }>;
};

export type CreateClubLinkMutationVariables = Exact<{
  clubId: string | number;
  name: string;
  url: string;
}>;

export type CreateClubLinkMutation = {
  __typename: "Mutation";
  createClubLink: {
    __typename: "ClubLinkResult";
    success: boolean;
    message: string | null;
    data: {
      __typename: "ClubLink";
      id: string;
      name: string;
      url: string;
      isActive: boolean;
      order: number;
      clubId: number;
      createdAt: any;
      updatedAt: any;
    } | null;
  };
};

export type UpdateClubLinkMutationVariables = Exact<{
  clubId: string | number;
  linkId: string;
  name?: string | null | undefined;
  url?: string | null | undefined;
  isActive?: boolean | null | undefined;
  order?: number | null | undefined;
}>;

export type UpdateClubLinkMutation = {
  __typename: "Mutation";
  updateClubLink: {
    __typename: "ClubLinkResult";
    success: boolean;
    message: string | null;
    data: {
      __typename: "ClubLink";
      id: string;
      name: string;
      url: string;
      isActive: boolean;
      order: number;
      clubId: number;
      createdAt: any;
      updatedAt: any;
    } | null;
  };
};

export type DeleteClubLinkMutationVariables = Exact<{
  clubId: string | number;
  linkId: string;
}>;

export type DeleteClubLinkMutation = {
  __typename: "Mutation";
  deleteClubLink: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type ReorderClubLinksMutationVariables = Exact<{
  clubId: string | number;
  linkIds: Array<string> | string;
}>;

export type ReorderClubLinksMutation = {
  __typename: "Mutation";
  reorderClubLinks: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type MeetingMutationFieldsFragment = {
  __typename: "Meeting";
  id: string;
  clubId: string;
  title: string;
  datetime: string;
  theme: string | null;
  wordOfDay: string | null;
  status: Types.MeetingStatus;
  locationText: string | null;
  locationMapLink: string | null;
  participantCount: number;
};

export type MeetingResultFieldsFragment = {
  __typename: "MeetingResult";
  success: boolean;
  message: string | null;
  errorCode: string | null;
  data: {
    __typename: "Meeting";
    id: string;
    clubId: string;
    title: string;
    datetime: string;
    theme: string | null;
    wordOfDay: string | null;
    status: Types.MeetingStatus;
    locationText: string | null;
    locationMapLink: string | null;
    participantCount: number;
  } | null;
};

export type DeleteResultFieldsFragment = {
  __typename: "DeleteResult";
  success: boolean;
  message: string | null;
  deletedId: string | null;
  errorCode: string | null;
};

export type FinishMeetingResultFieldsFragment = {
  __typename: "FinishMeetingResult";
  success: boolean;
  message: string | null;
  errorCode: string | null;
  data: {
    __typename: "FinishMeetingData";
    speechesCredited: number;
    rolesCredited: number;
    speechesAttempted: number;
    rolesAttempted: number;
    meeting: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    };
  } | null;
};

export type MeetingAttendanceSummaryResultFieldsFragment = {
  __typename: "MeetingAttendanceSummaryResult";
  success: boolean;
  message: string | null;
  errorCode: string | null;
  data: {
    __typename: "MeetingAttendanceSummary";
    totalEligibleMembers: number;
    rsvpAttendingCount: number;
    rsvpMaybeCount: number;
    rsvpNotAttendingCount: number;
    attendedCount: number;
    notAttendedCount: number;
    myRsvpStatus: Types.RsvpStatus | null;
    myAttendanceStatus: Types.AttendanceStatus | null;
  } | null;
};

export type CreateMeetingMutationVariables = Exact<{
  clubId: string | number;
  title: string;
  date: string;
  locationText?: string | null | undefined;
  locationMapLink?: string | null | undefined;
  theme?: string | null | undefined;
  wordOfDay?: string | null | undefined;
  agendaTemplateId?: any;
}>;

export type CreateMeetingMutation = {
  __typename: "Mutation";
  createMeeting: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type UpdateMeetingDetailsMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  title?: string | null | undefined;
  theme?: string | null | undefined;
  wordOfDay?: string | null | undefined;
  datetime?: string | null | undefined;
  locationText?: string | null | undefined;
  locationMapLink?: string | null | undefined;
}>;

export type UpdateMeetingDetailsMutation = {
  __typename: "Mutation";
  updateMeetingDetails: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type DeleteMeetingMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type DeleteMeetingMutation = {
  __typename: "Mutation";
  deleteMeeting: {
    __typename: "DeleteResult";
    success: boolean;
    message: string | null;
    deletedId: string | null;
    errorCode: string | null;
  };
};

export type ScheduleMeetingMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type ScheduleMeetingMutation = {
  __typename: "Mutation";
  scheduleMeeting: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type StartMeetingMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type StartMeetingMutation = {
  __typename: "Mutation";
  startMeeting: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type FinishMeetingMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type FinishMeetingMutation = {
  __typename: "Mutation";
  finishMeeting: {
    __typename: "FinishMeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "FinishMeetingData";
      speechesCredited: number;
      rolesCredited: number;
      speechesAttempted: number;
      rolesAttempted: number;
      meeting: {
        __typename: "Meeting";
        id: string;
        clubId: string;
        title: string;
        datetime: string;
        theme: string | null;
        wordOfDay: string | null;
        status: Types.MeetingStatus;
        locationText: string | null;
        locationMapLink: string | null;
        participantCount: number;
      };
    } | null;
  };
};

export type RevertMeetingToDraftMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type RevertMeetingToDraftMutation = {
  __typename: "Mutation";
  revertMeetingToDraft: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type CancelMeetingMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  reason?: string | null | undefined;
}>;

export type CancelMeetingMutation = {
  __typename: "Mutation";
  cancelMeeting: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type ReinstateMeetingMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type ReinstateMeetingMutation = {
  __typename: "Mutation";
  reinstateMeeting: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type RevertMeetingToInProgressMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type RevertMeetingToInProgressMutation = {
  __typename: "Mutation";
  revertMeetingToInProgress: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type PreviewRemindAllMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type PreviewRemindAllMutation = {
  __typename: "Mutation";
  previewRemindAll: {
    __typename: "MeetingRemindAllPreview";
    actionSummary: string;
    defaultSubject: string;
    defaultBody: string;
    recipients: Array<{
      __typename: "MeetingReminderRecipient";
      name: string;
      email: string | null;
      actionReason: string | null;
    }>;
    skippedRecipients: Array<{
      __typename: "MeetingReminderSkippedRecipient";
      name: string;
      roles: Array<string>;
      reason: string;
    }>;
  };
};

export type SendRemindAllMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  subject: string;
  body: string;
}>;

export type SendRemindAllMutation = {
  __typename: "Mutation";
  sendRemindAll: {
    __typename: "MeetingRemindAllSendResult";
    sentCount: number;
    skippedCount: number;
    skippedRecipients: Array<{
      __typename: "MeetingReminderSkippedRecipient";
      name: string;
      roles: Array<string>;
      reason: string;
    }>;
  };
};

export type SetMyMeetingRsvpMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  status: Types.RsvpStatus;
}>;

export type SetMyMeetingRsvpMutation = {
  __typename: "Mutation";
  setMyMeetingRsvp: {
    __typename: "MeetingAttendanceSummaryResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "MeetingAttendanceSummary";
      totalEligibleMembers: number;
      rsvpAttendingCount: number;
      rsvpMaybeCount: number;
      rsvpNotAttendingCount: number;
      attendedCount: number;
      notAttendedCount: number;
      myRsvpStatus: Types.RsvpStatus | null;
      myAttendanceStatus: Types.AttendanceStatus | null;
    } | null;
  };
};

export type SetMemberMeetingRsvpMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  userId: string | number;
  status?: Types.RsvpStatus | null | undefined;
}>;

export type SetMemberMeetingRsvpMutation = {
  __typename: "Mutation";
  setMemberMeetingRsvp: {
    __typename: "MeetingAttendanceSummaryResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "MeetingAttendanceSummary";
      totalEligibleMembers: number;
      rsvpAttendingCount: number;
      rsvpMaybeCount: number;
      rsvpNotAttendingCount: number;
      attendedCount: number;
      notAttendedCount: number;
      myRsvpStatus: Types.RsvpStatus | null;
      myAttendanceStatus: Types.AttendanceStatus | null;
    } | null;
  };
};

export type MarkMeetingAttendanceMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  userId: string | number;
  status?: Types.AttendanceStatus | null | undefined;
}>;

export type MarkMeetingAttendanceMutation = {
  __typename: "Mutation";
  markMeetingAttendance: {
    __typename: "MeetingAttendanceSummaryResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "MeetingAttendanceSummary";
      totalEligibleMembers: number;
      rsvpAttendingCount: number;
      rsvpMaybeCount: number;
      rsvpNotAttendingCount: number;
      attendedCount: number;
      notAttendedCount: number;
      myRsvpStatus: Types.RsvpStatus | null;
      myAttendanceStatus: Types.AttendanceStatus | null;
    } | null;
  };
};

export type BulkMarkMeetingAttendanceMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  marks: Array<Types.AttendanceMarkInput> | Types.AttendanceMarkInput;
}>;

export type BulkMarkMeetingAttendanceMutation = {
  __typename: "Mutation";
  bulkMarkMeetingAttendance: {
    __typename: "MeetingAttendanceSummaryResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "MeetingAttendanceSummary";
      totalEligibleMembers: number;
      rsvpAttendingCount: number;
      rsvpMaybeCount: number;
      rsvpNotAttendingCount: number;
      attendedCount: number;
      notAttendedCount: number;
      myRsvpStatus: Types.RsvpStatus | null;
      myAttendanceStatus: Types.AttendanceStatus | null;
    } | null;
  };
};

export type RequestRoleMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  agendaItemId: string;
}>;

export type RequestRoleMutation = {
  __typename: "Mutation";
  requestRole: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type CancelRoleRequestMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  agendaItemId: string;
  requestId: string;
}>;

export type CancelRoleRequestMutation = {
  __typename: "Mutation";
  cancelRoleRequest: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type CancelMyRoleAssignmentMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  agendaItemId: string;
  markNotAttending: boolean;
  baseVersion?: any;
}>;

export type CancelMyRoleAssignmentMutation = {
  __typename: "Mutation";
  cancelMyRoleAssignment: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type ApproveRoleRequestMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  agendaItemId: string;
  requestId: string;
  sendEmail?: boolean | null | undefined;
  personalNote?: string | null | undefined;
  targetAgendaItemId?: string | null | undefined;
}>;

export type ApproveRoleRequestMutation = {
  __typename: "Mutation";
  approveRoleRequest: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type RejectRoleRequestMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  agendaItemId: string;
  requestId: string;
  reason?: string | null | undefined;
  sendEmail?: boolean | null | undefined;
}>;

export type RejectRoleRequestMutation = {
  __typename: "Mutation";
  rejectRoleRequest: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type SubmitFeedbackMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  feedbackSessionId: string;
  subjectId: string;
  content: string;
  aspects?: Array<string> | string | null | undefined;
  isAnonymous?: boolean | null | undefined;
  fromAttendeeUserId?: string | number | null | undefined;
  fromAttendeeGuestId?: string | null | undefined;
}>;

export type SubmitFeedbackMutation = {
  __typename: "Mutation";
  submitFeedback: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type SetFeedbackSessionStatusMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  feedbackSessionId: string;
  isOpen: boolean;
}>;

export type SetFeedbackSessionStatusMutation = {
  __typename: "Mutation";
  setFeedbackSessionStatus: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type AddFeedbackSubjectMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  feedbackSessionId: string;
  name: string;
  meetingUserIdUserId?: string | number | null | undefined;
  meetingUserIdGuestId?: string | null | undefined;
  agendaSyncKey?: string | null | undefined;
}>;

export type AddFeedbackSubjectMutation = {
  __typename: "Mutation";
  addFeedbackSubject: {
    __typename: "AddFeedbackSubjectResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "AddFeedbackSubjectData";
      created: boolean;
      subject: {
        __typename: "FeedbackSubject";
        id: string;
        name: string;
        agendaSyncKey: string | null;
        feedbackSessionId: string;
        meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
      };
    } | null;
  };
};

export type RemoveFeedbackSubjectMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  feedbackSessionId: string;
  subjectId: string;
}>;

export type RemoveFeedbackSubjectMutation = {
  __typename: "Mutation";
  removeFeedbackSubject: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type UpdateFeedbackSubjectMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  feedbackSessionId: string;
  subjectId: string;
  name?: string | null | undefined;
  meetingUserIdUserId?: string | number | null | undefined;
  meetingUserIdGuestId?: string | null | undefined;
}>;

export type UpdateFeedbackSubjectMutation = {
  __typename: "Mutation";
  updateFeedbackSubject: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type SubmitVoteMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  votingRoomId: string;
  candidateId: string;
  meetingUserIdUserId?: string | number | null | undefined;
  meetingUserIdGuestId?: string | null | undefined;
}>;

export type SubmitVoteMutation = {
  __typename: "Mutation";
  submitVote: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type SetVotingRoomStatusMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  votingRoomId: string;
  isOpen: boolean;
}>;

export type SetVotingRoomStatusMutation = {
  __typename: "Mutation";
  setVotingRoomStatus: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type AddVotingRoomMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  displayName: string;
}>;

export type AddVotingRoomMutation = {
  __typename: "Mutation";
  addVotingRoom: {
    __typename: "VotingRoom";
    id: string;
    standardKey: string | null;
    displayName: string;
    category: string;
    isOpen: boolean;
    candidates: Array<{
      __typename: "VoteCandidate";
      id: string;
      name: string;
      agendaSyncKey: string | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    }>;
    voteCounts: Array<{ __typename: "VoteCount"; candidateId: string; count: number }>;
  };
};

export type RenameVotingRoomMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  votingRoomId: string;
  displayName: string;
}>;

export type RenameVotingRoomMutation = {
  __typename: "Mutation";
  renameVotingRoom: { __typename: "VotingRoom"; id: string; displayName: string };
};

export type DeleteVotingRoomMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  votingRoomId: string;
}>;

export type DeleteVotingRoomMutation = { __typename: "Mutation"; deleteVotingRoom: boolean };

export type AddCandidateMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  votingRoomId: string;
  name: string;
  meetingUserIdUserId?: string | number | null | undefined;
  meetingUserIdGuestId?: string | null | undefined;
  agendaSyncKey?: string | null | undefined;
}>;

export type AddCandidateMutation = {
  __typename: "Mutation";
  addCandidate: {
    __typename: "AddCandidateResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "AddCandidateData";
      candidate: {
        __typename: "VoteCandidate";
        id: string;
        name: string;
        agendaSyncKey: string | null;
        meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
      };
    } | null;
  };
};

export type RemoveCandidateMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  votingRoomId: string;
  candidateId: string;
}>;

export type RemoveCandidateMutation = {
  __typename: "Mutation";
  removeCandidate: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type UpdateCandidateMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  votingRoomId: string;
  candidateId: string;
  name?: string | null | undefined;
  meetingUserIdUserId?: string | number | null | undefined;
  meetingUserIdGuestId?: string | null | undefined;
}>;

export type UpdateCandidateMutation = {
  __typename: "Mutation";
  updateCandidate: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type ReorderCandidatesMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  votingRoomId: string;
  candidateIds: Array<string> | string;
}>;

export type ReorderCandidatesMutation = {
  __typename: "Mutation";
  reorderCandidates: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type CreateMeetingUserMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  name: string;
  userId?: string | number | null | undefined;
}>;

export type CreateMeetingUserMutation = {
  __typename: "Mutation";
  createMeetingUser: {
    __typename: "MeetingUser";
    name: string;
    tiName: string | null;
    meetingId: string | null;
    relationshipToClub: Types.ClubAuthLevel;
    isAssigneeNotified: boolean | null;
    meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
  };
};

export type UpdateMeetingAgendaMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  agenda: Array<Types.AgendaItemInput> | Types.AgendaItemInput;
  emailOptions?: Types.EmailControlOptionsInput | null | undefined;
  sourceAgendaTemplateId?: any;
  baseVersion?: any;
}>;

export type UpdateMeetingAgendaMutation = {
  __typename: "Mutation";
  updateMeetingAgenda: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type UpdateMeetingAgendaOpsMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  ops: Array<Types.AgendaOpInput> | Types.AgendaOpInput;
  emailOptions?: Types.EmailControlOptionsInput | null | undefined;
}>;

export type UpdateMeetingAgendaOpsMutation = {
  __typename: "Mutation";
  updateMeetingAgendaOps: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type PopulateDefaultAgendaMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type PopulateDefaultAgendaMutation = {
  __typename: "Mutation";
  populateDefaultAgenda: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type AssignProjectToAgendaItemMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  agendaItemId: string;
  requestId?: string | null | undefined;
  projectId?: string | null | undefined;
  speechTitle?: string | null | undefined;
}>;

export type AssignProjectToAgendaItemMutation = {
  __typename: "Mutation";
  assignProjectToAgendaItem: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type ConvertOfficerSpeechRequestMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  agendaItemId: string;
  projectId: string;
  speechTitle?: string | null | undefined;
}>;

export type ConvertOfficerSpeechRequestMutation = {
  __typename: "Mutation";
  convertOfficerSpeechRequest: {
    __typename: "MeetingResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "Meeting";
      id: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      locationText: string | null;
      locationMapLink: string | null;
      participantCount: number;
    } | null;
  };
};

export type ProposeRoleMutationVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  agendaItemId: string | number;
  slotIndex: number;
  proposeeUserId: string | number;
  expiresAt?: string | null | undefined;
}>;

export type ProposeRoleMutation = {
  __typename: "Mutation";
  proposeRole: {
    __typename: "RoleProposalResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "RoleProposal";
      id: string;
      clubId: string;
      meetingId: string;
      agendaItemId: string;
      slotIndex: number;
      proposedToUserId: string;
      proposedToName: string;
      proposedByUserId: string;
      proposedByName: string;
      proposedByRoleLabel: string;
      status: Types.RoleProposalStatus;
      createdAt: string;
      expiresAt: string;
      respondedAt: string | null;
      withdrawnAt: string | null;
    } | null;
  };
};

export type WithdrawRoleProposalMutationVariables = Exact<{
  proposalId: string | number;
}>;

export type WithdrawRoleProposalMutation = {
  __typename: "Mutation";
  withdrawRoleProposal: {
    __typename: "RoleProposalResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "RoleProposal";
      id: string;
      clubId: string;
      meetingId: string;
      agendaItemId: string;
      slotIndex: number;
      proposedToUserId: string;
      proposedToName: string;
      proposedByUserId: string;
      proposedByName: string;
      proposedByRoleLabel: string;
      status: Types.RoleProposalStatus;
      createdAt: string;
      expiresAt: string;
      respondedAt: string | null;
      withdrawnAt: string | null;
    } | null;
  };
};

export type RetryRoleProposalSendMutationVariables = Exact<{
  proposalId: string | number;
}>;

export type RetryRoleProposalSendMutation = {
  __typename: "Mutation";
  retryRoleProposalSend: {
    __typename: "RoleProposalResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "RoleProposal";
      id: string;
      clubId: string;
      meetingId: string;
      agendaItemId: string;
      slotIndex: number;
      proposedToUserId: string;
      proposedToName: string;
      proposedByUserId: string;
      proposedByName: string;
      proposedByRoleLabel: string;
      status: Types.RoleProposalStatus;
      createdAt: string;
      expiresAt: string;
      respondedAt: string | null;
      withdrawnAt: string | null;
    } | null;
  };
};

export type RespondToRoleProposalMutationVariables = Exact<{
  proposalId: string | number;
  accept: boolean;
}>;

export type RespondToRoleProposalMutation = {
  __typename: "Mutation";
  respondToRoleProposal: {
    __typename: "RoleProposalResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
    data: {
      __typename: "RoleProposal";
      id: string;
      clubId: string;
      meetingId: string;
      agendaItemId: string;
      slotIndex: number;
      proposedToUserId: string;
      proposedToName: string;
      proposedByUserId: string;
      proposedByName: string;
      proposedByRoleLabel: string;
      status: Types.RoleProposalStatus;
      createdAt: string;
      expiresAt: string;
      respondedAt: string | null;
      withdrawnAt: string | null;
    } | null;
  };
};

export type MeetingUserFieldsFragment = {
  __typename: "MeetingUser";
  name: string;
  tiName: string | null;
  meetingId: string | null;
  relationshipToClub: Types.ClubAuthLevel;
  isAssigneeNotified: boolean | null;
  meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
};

export type AgendaItemFieldsFragment = {
  __typename: "AgendaItem";
  id: string;
  role: string;
  rolePosition: number | null;
  duration: number;
  event: string;
  backgroundColor: string | null;
  greenMark: number;
  amberMark: number;
  redMark: number;
  maxAssignments: number;
  isCompleted: boolean;
  isRepeatableRole: boolean | null;
  pathwayProjectId: string | null;
  assignedUsers: Array<{
    __typename: "MeetingUser";
    name: string;
    tiName: string | null;
    meetingId: string | null;
    relationshipToClub: Types.ClubAuthLevel;
    isAssigneeNotified: boolean | null;
    meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
  } | null>;
  pathwayRoleTargets: Array<{
    __typename: "PathwayRoleTargetEntry";
    userId: any;
    pathwayId: number;
    level: number;
    roleName: string;
  }>;
  roleRequests: Array<{
    __typename: "RoleSignupRequest";
    id: string;
    userId: string;
    requestedAt: string;
    status: Types.RoleRequestStatus;
    approvedAt: string | null;
    rejectionReason: string | null;
    requestedBy: {
      __typename: "MeetingUser";
      name: string;
      tiName: string | null;
      meetingId: string | null;
      relationshipToClub: Types.ClubAuthLevel;
      isAssigneeNotified: boolean | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    };
    approvedBy: {
      __typename: "MeetingUser";
      name: string;
      tiName: string | null;
      meetingId: string | null;
      relationshipToClub: Types.ClubAuthLevel;
      isAssigneeNotified: boolean | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    } | null;
  }>;
};

export type VotingRoomFieldsFragment = {
  __typename: "VotingRoom";
  id: string;
  category: string;
  standardKey: string | null;
  displayName: string;
  isOpen: boolean;
  candidates: Array<{
    __typename: "VoteCandidate";
    id: string;
    name: string;
    agendaSyncKey: string | null;
    meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
  }>;
  voteCounts: Array<{ __typename: "VoteCount"; candidateId: string; count: number }>;
};

export type FeedbackSessionFieldsFragment = {
  __typename: "FeedbackSession";
  id: string;
  title: string;
  isOpen: boolean;
  feedbackCount: number;
  subjects: Array<{
    __typename: "FeedbackSubject";
    id: string;
    name: string;
    agendaSyncKey: string | null;
    meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
  }>;
  feedback: Array<{
    __typename: "Feedback";
    id: string;
    feedbackSubjectId: string;
    feedbackSessionId: string;
    content: string;
    timestamp: any;
    aspects: Array<string> | null;
    fromAttendee: {
      __typename: "MeetingUser";
      name: string;
      tiName: string | null;
      meetingId: string | null;
      relationshipToClub: Types.ClubAuthLevel;
      isAssigneeNotified: boolean | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    } | null;
  }>;
};

export type MeetingFieldsFragment = {
  __typename: "Meeting";
  id: string;
  title: string;
  theme: string | null;
  datetime: string;
  locationText: string | null;
  locationMapLink: string | null;
  wordOfDay: string | null;
  status: Types.MeetingStatus;
  clubId: string;
  hasBeenFinishedBefore: boolean;
  cancellationReason: string | null;
  version: any;
  sourceAgendaTemplateId: string | null;
  agenda: Array<{
    __typename: "AgendaItem";
    id: string;
    role: string;
    rolePosition: number | null;
    duration: number;
    event: string;
    backgroundColor: string | null;
    greenMark: number;
    amberMark: number;
    redMark: number;
    maxAssignments: number;
    isCompleted: boolean;
    isRepeatableRole: boolean | null;
    pathwayProjectId: string | null;
    assignedUsers: Array<{
      __typename: "MeetingUser";
      name: string;
      tiName: string | null;
      meetingId: string | null;
      relationshipToClub: Types.ClubAuthLevel;
      isAssigneeNotified: boolean | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    } | null>;
    pathwayRoleTargets: Array<{
      __typename: "PathwayRoleTargetEntry";
      userId: any;
      pathwayId: number;
      level: number;
      roleName: string;
    }>;
    roleRequests: Array<{
      __typename: "RoleSignupRequest";
      id: string;
      userId: string;
      requestedAt: string;
      status: Types.RoleRequestStatus;
      approvedAt: string | null;
      rejectionReason: string | null;
      requestedBy: {
        __typename: "MeetingUser";
        name: string;
        tiName: string | null;
        meetingId: string | null;
        relationshipToClub: Types.ClubAuthLevel;
        isAssigneeNotified: boolean | null;
        meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
      };
      approvedBy: {
        __typename: "MeetingUser";
        name: string;
        tiName: string | null;
        meetingId: string | null;
        relationshipToClub: Types.ClubAuthLevel;
        isAssigneeNotified: boolean | null;
        meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
      } | null;
    }>;
  }>;
  votingRooms: Array<{
    __typename: "VotingRoom";
    id: string;
    category: string;
    standardKey: string | null;
    displayName: string;
    isOpen: boolean;
    candidates: Array<{
      __typename: "VoteCandidate";
      id: string;
      name: string;
      agendaSyncKey: string | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    }>;
    voteCounts: Array<{ __typename: "VoteCount"; candidateId: string; count: number }>;
  }>;
  feedbackSessions: Array<{
    __typename: "FeedbackSession";
    id: string;
    title: string;
    isOpen: boolean;
    feedbackCount: number;
    subjects: Array<{
      __typename: "FeedbackSubject";
      id: string;
      name: string;
      agendaSyncKey: string | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    }>;
    feedback: Array<{
      __typename: "Feedback";
      id: string;
      feedbackSubjectId: string;
      feedbackSessionId: string;
      content: string;
      timestamp: any;
      aspects: Array<string> | null;
      fromAttendee: {
        __typename: "MeetingUser";
        name: string;
        tiName: string | null;
        meetingId: string | null;
        relationshipToClub: Types.ClubAuthLevel;
        isAssigneeNotified: boolean | null;
        meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
      } | null;
    }>;
  }>;
  participants: Array<{
    __typename: "MeetingUser";
    name: string;
    tiName: string | null;
    meetingId: string | null;
    relationshipToClub: Types.ClubAuthLevel;
    isAssigneeNotified: boolean | null;
    meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
  }>;
  projectRequests: Array<{
    __typename: "ProjectSignupRequest";
    id: string;
    userId: string;
    projectId: string | null;
    speechTitle: string | null;
    requestedAt: string;
    approvedAt: string | null;
    assignedMeetingId: string | null;
    assignedMeetingDateTime: string | null;
    preferredDates: Array<string>;
    notes: string | null;
    status: Types.RequestStatus;
    hasPendingDates: boolean;
    createdByOfficer: boolean;
    requestedBy: {
      __typename: "ProjectRequestUser";
      userId: string;
      firstName: string;
      lastName: string;
      email: string | null;
    };
    approvedBy: {
      __typename: "ProjectRequestUser";
      userId: string;
      firstName: string;
      lastName: string;
      email: string | null;
    } | null;
    rejections: Array<{
      __typename: "DateRejection";
      date: string;
      rejectedAt: string;
      reason: string;
      rejectedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
    }>;
  }>;
};

export type MeetingSummaryFieldsFragment = {
  __typename: "MeetingSummary";
  id: string;
  title: string;
  date: string;
  clubId: string;
  status: Types.MeetingStatus;
  theme: string | null;
  wordOfDay: string | null;
  cancellationReason: string | null;
};

export type ToastmasterRoleFieldsFragment = {
  __typename: "ToastmasterRole";
  id: string;
  name: string;
  description: string;
  greenMark: number | null;
  amberMark: number | null;
  redMark: number | null;
  icon: string | null;
  repeatable: boolean;
};

export type ClubMemberSummaryFieldsFragment = {
  __typename: "ClubMemberSummary";
  userId: string | null;
  name: string;
  email: string | null;
  isActive: boolean;
  membershipStatus: string;
};

export type ClubInfoSummaryFieldsFragment = {
  __typename: "ClubInfoSummary";
  id: string;
  shortName: string;
  longName: string;
  contactEmail: string;
  meetingConfig: {
    __typename: "ClubMeetingConfig";
    autoSyncAgendaToVoting: boolean;
    autoAddAgendaToFeedback: boolean;
    evaluatorVotingRoles: Array<string>;
    allowMemberRoleSelfAssign: boolean;
    memberSpeechRequestAdvanceDays: number;
  } | null;
  meetingSchedule: { __typename: "ClubInfoMeetingSchedule"; timezone: string } | null;
};

export type MeetingInitDataQueryVariables = Exact<{
  clubId: string | number;
  meetingId?: string | number | null | undefined;
  includeMembers?: boolean | null | undefined;
  includeAttendance?: boolean | null | undefined;
  includeManagerAttendanceRecords?: boolean | null | undefined;
  includeExpiredMembers?: boolean | null | undefined;
}>;

export type MeetingInitDataQuery = {
  __typename: "Query";
  meetingInitData: {
    __typename: "MeetingInitData";
    meeting: {
      __typename: "Meeting";
      id: string;
      title: string;
      theme: string | null;
      datetime: string;
      locationText: string | null;
      locationMapLink: string | null;
      wordOfDay: string | null;
      status: Types.MeetingStatus;
      clubId: string;
      hasBeenFinishedBefore: boolean;
      cancellationReason: string | null;
      version: any;
      sourceAgendaTemplateId: string | null;
      agenda: Array<{
        __typename: "AgendaItem";
        id: string;
        role: string;
        rolePosition: number | null;
        duration: number;
        event: string;
        backgroundColor: string | null;
        greenMark: number;
        amberMark: number;
        redMark: number;
        maxAssignments: number;
        isCompleted: boolean;
        isRepeatableRole: boolean | null;
        pathwayProjectId: string | null;
        assignedUsers: Array<{
          __typename: "MeetingUser";
          name: string;
          tiName: string | null;
          meetingId: string | null;
          relationshipToClub: Types.ClubAuthLevel;
          isAssigneeNotified: boolean | null;
          meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
        } | null>;
        pathwayRoleTargets: Array<{
          __typename: "PathwayRoleTargetEntry";
          userId: any;
          pathwayId: number;
          level: number;
          roleName: string;
        }>;
        roleRequests: Array<{
          __typename: "RoleSignupRequest";
          id: string;
          userId: string;
          requestedAt: string;
          status: Types.RoleRequestStatus;
          approvedAt: string | null;
          rejectionReason: string | null;
          requestedBy: {
            __typename: "MeetingUser";
            name: string;
            tiName: string | null;
            meetingId: string | null;
            relationshipToClub: Types.ClubAuthLevel;
            isAssigneeNotified: boolean | null;
            meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
          };
          approvedBy: {
            __typename: "MeetingUser";
            name: string;
            tiName: string | null;
            meetingId: string | null;
            relationshipToClub: Types.ClubAuthLevel;
            isAssigneeNotified: boolean | null;
            meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
          } | null;
        }>;
      }>;
      votingRooms: Array<{
        __typename: "VotingRoom";
        id: string;
        category: string;
        standardKey: string | null;
        displayName: string;
        isOpen: boolean;
        candidates: Array<{
          __typename: "VoteCandidate";
          id: string;
          name: string;
          agendaSyncKey: string | null;
          meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
        }>;
        voteCounts: Array<{ __typename: "VoteCount"; candidateId: string; count: number }>;
      }>;
      feedbackSessions: Array<{
        __typename: "FeedbackSession";
        id: string;
        title: string;
        isOpen: boolean;
        feedbackCount: number;
        subjects: Array<{
          __typename: "FeedbackSubject";
          id: string;
          name: string;
          agendaSyncKey: string | null;
          meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
        }>;
        feedback: Array<{
          __typename: "Feedback";
          id: string;
          feedbackSubjectId: string;
          feedbackSessionId: string;
          content: string;
          timestamp: any;
          aspects: Array<string> | null;
          fromAttendee: {
            __typename: "MeetingUser";
            name: string;
            tiName: string | null;
            meetingId: string | null;
            relationshipToClub: Types.ClubAuthLevel;
            isAssigneeNotified: boolean | null;
            meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
          } | null;
        }>;
      }>;
      participants: Array<{
        __typename: "MeetingUser";
        name: string;
        tiName: string | null;
        meetingId: string | null;
        relationshipToClub: Types.ClubAuthLevel;
        isAssigneeNotified: boolean | null;
        meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
      }>;
      projectRequests: Array<{
        __typename: "ProjectSignupRequest";
        id: string;
        userId: string;
        projectId: string | null;
        speechTitle: string | null;
        requestedAt: string;
        approvedAt: string | null;
        assignedMeetingId: string | null;
        assignedMeetingDateTime: string | null;
        preferredDates: Array<string>;
        notes: string | null;
        status: Types.RequestStatus;
        hasPendingDates: boolean;
        createdByOfficer: boolean;
        requestedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        };
        approvedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        } | null;
        rejections: Array<{
          __typename: "DateRejection";
          date: string;
          rejectedAt: string;
          reason: string;
          rejectedBy: {
            __typename: "ProjectRequestUser";
            userId: string;
            firstName: string;
            lastName: string;
            email: string | null;
          };
        }>;
      }>;
    } | null;
    availableMeetings: Array<{
      __typename: "MeetingSummary";
      id: string;
      title: string;
      date: string;
      clubId: string;
      status: Types.MeetingStatus;
      theme: string | null;
      wordOfDay: string | null;
      cancellationReason: string | null;
    }>;
    currentUser: {
      __typename: "MeetingUser";
      name: string;
      tiName: string | null;
      meetingId: string | null;
      relationshipToClub: Types.ClubAuthLevel;
      isAssigneeNotified: boolean | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    } | null;
    toastmasterRoles: Array<{
      __typename: "ToastmasterRole";
      id: string;
      name: string;
      description: string;
      greenMark: number | null;
      amberMark: number | null;
      redMark: number | null;
      icon: string | null;
      repeatable: boolean;
    }>;
    clubMembers: Array<{
      __typename: "ClubMemberSummary";
      userId: string | null;
      name: string;
      email: string | null;
      isActive: boolean;
      membershipStatus: string;
    }>;
    clubInfo: {
      __typename: "ClubInfoSummary";
      id: string;
      shortName: string;
      longName: string;
      contactEmail: string;
      meetingConfig: {
        __typename: "ClubMeetingConfig";
        autoSyncAgendaToVoting: boolean;
        autoAddAgendaToFeedback: boolean;
        evaluatorVotingRoles: Array<string>;
        allowMemberRoleSelfAssign: boolean;
        memberSpeechRequestAdvanceDays: number;
      } | null;
      meetingSchedule: { __typename: "ClubInfoMeetingSchedule"; timezone: string } | null;
    } | null;
    inProgressMeeting: {
      __typename: "InProgressMeetingResponse";
      hasInProgress: boolean;
      meetingId: string | null;
      title: string | null;
      datetime: string | null;
    };
    meetingAttendance: {
      __typename: "MeetingAttendanceBundle";
      summary: {
        __typename: "MeetingAttendanceSummary";
        totalEligibleMembers: number;
        rsvpAttendingCount: number;
        rsvpMaybeCount: number;
        rsvpNotAttendingCount: number;
        attendedCount: number;
        notAttendedCount: number;
        myRsvpStatus: Types.RsvpStatus | null;
        myAttendanceStatus: Types.AttendanceStatus | null;
      } | null;
      rsvpRecords: Array<{
        __typename: "MeetingRsvpRecord";
        userId: string;
        name: string;
        rsvpStatus: Types.RsvpStatus;
      }> | null;
      attendanceRecords: Array<{
        __typename: "MeetingAttendanceMemberRecord";
        userId: string;
        name: string;
        rsvpStatus: Types.RsvpStatus | null;
        attendanceStatus: Types.AttendanceStatus | null;
        attendanceSource: Types.AttendanceSource | null;
      }> | null;
    } | null;
  };
};

export type MeetingAttendanceSummaryFieldsFragment = {
  __typename: "MeetingAttendanceSummary";
  totalEligibleMembers: number;
  rsvpAttendingCount: number;
  rsvpMaybeCount: number;
  rsvpNotAttendingCount: number;
  attendedCount: number;
  notAttendedCount: number;
  myRsvpStatus: Types.RsvpStatus | null;
  myAttendanceStatus: Types.AttendanceStatus | null;
};

export type MeetingRsvpRecordFieldsFragment = {
  __typename: "MeetingRsvpRecord";
  userId: string;
  name: string;
  rsvpStatus: Types.RsvpStatus;
};

export type MeetingAttendanceMemberRecordFieldsFragment = {
  __typename: "MeetingAttendanceMemberRecord";
  userId: string;
  name: string;
  rsvpStatus: Types.RsvpStatus | null;
  attendanceStatus: Types.AttendanceStatus | null;
  attendanceSource: Types.AttendanceSource | null;
};

export type MeetingAttendanceDataQueryVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  includeManagerRecords: boolean;
  includeExpiredMembers: boolean;
}>;

export type MeetingAttendanceDataQuery = {
  __typename: "Query";
  meetingAttendanceSummary: {
    __typename: "MeetingAttendanceSummary";
    totalEligibleMembers: number;
    rsvpAttendingCount: number;
    rsvpMaybeCount: number;
    rsvpNotAttendingCount: number;
    attendedCount: number;
    notAttendedCount: number;
    myRsvpStatus: Types.RsvpStatus | null;
    myAttendanceStatus: Types.AttendanceStatus | null;
  };
  meetingRsvpRecords?: Array<{
    __typename: "MeetingRsvpRecord";
    userId: string;
    name: string;
    rsvpStatus: Types.RsvpStatus;
  }>;
  meetingAttendanceRecords?: Array<{
    __typename: "MeetingAttendanceMemberRecord";
    userId: string;
    name: string;
    rsvpStatus: Types.RsvpStatus | null;
    attendanceStatus: Types.AttendanceStatus | null;
    attendanceSource: Types.AttendanceSource | null;
  }>;
};

export type GetClubPastMeetingsQueryVariables = Exact<{
  clubId: string | number;
  first: number;
}>;

export type GetClubPastMeetingsQuery = {
  __typename: "Query";
  meetings: {
    __typename: "MeetingConnection";
    edges: Array<{
      __typename: "MeetingEdge";
      node: {
        __typename: "Meeting";
        id: string;
        title: string;
        datetime: string;
        localDate: string | null;
        status: Types.MeetingStatus;
      };
    }>;
  };
};

export type GetMeetingQueryVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
}>;

export type GetMeetingQuery = {
  __typename: "Query";
  meeting: {
    __typename: "Meeting";
    id: string;
    title: string;
    theme: string | null;
    datetime: string;
    locationText: string | null;
    locationMapLink: string | null;
    wordOfDay: string | null;
    status: Types.MeetingStatus;
    clubId: string;
    hasBeenFinishedBefore: boolean;
    cancellationReason: string | null;
    version: any;
    sourceAgendaTemplateId: string | null;
    agenda: Array<{
      __typename: "AgendaItem";
      id: string;
      role: string;
      rolePosition: number | null;
      duration: number;
      event: string;
      backgroundColor: string | null;
      greenMark: number;
      amberMark: number;
      redMark: number;
      maxAssignments: number;
      isCompleted: boolean;
      isRepeatableRole: boolean | null;
      pathwayProjectId: string | null;
      assignedUsers: Array<{
        __typename: "MeetingUser";
        name: string;
        tiName: string | null;
        meetingId: string | null;
        relationshipToClub: Types.ClubAuthLevel;
        isAssigneeNotified: boolean | null;
        meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
      } | null>;
      pathwayRoleTargets: Array<{
        __typename: "PathwayRoleTargetEntry";
        userId: any;
        pathwayId: number;
        level: number;
        roleName: string;
      }>;
      roleRequests: Array<{
        __typename: "RoleSignupRequest";
        id: string;
        userId: string;
        requestedAt: string;
        status: Types.RoleRequestStatus;
        approvedAt: string | null;
        rejectionReason: string | null;
        requestedBy: {
          __typename: "MeetingUser";
          name: string;
          tiName: string | null;
          meetingId: string | null;
          relationshipToClub: Types.ClubAuthLevel;
          isAssigneeNotified: boolean | null;
          meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
        };
        approvedBy: {
          __typename: "MeetingUser";
          name: string;
          tiName: string | null;
          meetingId: string | null;
          relationshipToClub: Types.ClubAuthLevel;
          isAssigneeNotified: boolean | null;
          meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
        } | null;
      }>;
    }>;
    votingRooms: Array<{
      __typename: "VotingRoom";
      id: string;
      category: string;
      standardKey: string | null;
      displayName: string;
      isOpen: boolean;
      candidates: Array<{
        __typename: "VoteCandidate";
        id: string;
        name: string;
        agendaSyncKey: string | null;
        meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
      }>;
      voteCounts: Array<{ __typename: "VoteCount"; candidateId: string; count: number }>;
    }>;
    feedbackSessions: Array<{
      __typename: "FeedbackSession";
      id: string;
      title: string;
      isOpen: boolean;
      feedbackCount: number;
      subjects: Array<{
        __typename: "FeedbackSubject";
        id: string;
        name: string;
        agendaSyncKey: string | null;
        meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
      }>;
      feedback: Array<{
        __typename: "Feedback";
        id: string;
        feedbackSubjectId: string;
        feedbackSessionId: string;
        content: string;
        timestamp: any;
        aspects: Array<string> | null;
        fromAttendee: {
          __typename: "MeetingUser";
          name: string;
          tiName: string | null;
          meetingId: string | null;
          relationshipToClub: Types.ClubAuthLevel;
          isAssigneeNotified: boolean | null;
          meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
        } | null;
      }>;
    }>;
    participants: Array<{
      __typename: "MeetingUser";
      name: string;
      tiName: string | null;
      meetingId: string | null;
      relationshipToClub: Types.ClubAuthLevel;
      isAssigneeNotified: boolean | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    }>;
    projectRequests: Array<{
      __typename: "ProjectSignupRequest";
      id: string;
      userId: string;
      projectId: string | null;
      speechTitle: string | null;
      requestedAt: string;
      approvedAt: string | null;
      assignedMeetingId: string | null;
      assignedMeetingDateTime: string | null;
      preferredDates: Array<string>;
      notes: string | null;
      status: Types.RequestStatus;
      hasPendingDates: boolean;
      createdByOfficer: boolean;
      requestedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
      approvedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      } | null;
      rejections: Array<{
        __typename: "DateRejection";
        date: string;
        rejectedAt: string;
        reason: string;
        rejectedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        };
      }>;
    }>;
  } | null;
};

export type GetFeedbackForSubjectQueryVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  feedbackSessionId: string;
  subjectId: string;
}>;

export type GetFeedbackForSubjectQuery = {
  __typename: "Query";
  getFeedbackForSubject: Array<{
    __typename: "Feedback";
    id: string;
    feedbackSubjectId: string;
    feedbackSessionId: string;
    content: string;
    timestamp: any;
    aspects: Array<string> | null;
    fromAttendee: {
      __typename: "MeetingUser";
      name: string;
      tiName: string | null;
      meetingId: string | null;
      relationshipToClub: Types.ClubAuthLevel;
      isAssigneeNotified: boolean | null;
      meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
    } | null;
  }>;
};

export type GetUserVotesQueryVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  meetingUserIdUserId?: string | number | null | undefined;
  meetingUserIdGuestId?: string | null | undefined;
}>;

export type GetUserVotesQuery = {
  __typename: "Query";
  getUserVotes: Array<{
    __typename: "SimpleVote";
    id: string;
    candidateId: string;
    votingRoomId: string;
    timestamp: any;
  }>;
};

export type GetInProgressMeetingQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetInProgressMeetingQuery = {
  __typename: "Query";
  getInProgressMeeting: {
    __typename: "InProgressMeetingResponse";
    hasInProgress: boolean;
    meetingId: string | null;
    title: string | null;
    datetime: string | null;
  };
};

export type GetMeetingUserQueryVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  userId?: string | number | null | undefined;
  guestId?: string | null | undefined;
}>;

export type GetMeetingUserQuery = {
  __typename: "Query";
  getMeetingUser: {
    __typename: "MeetingUser";
    name: string;
    tiName: string | null;
    meetingId: string | null;
    relationshipToClub: Types.ClubAuthLevel;
    isAssigneeNotified: boolean | null;
    meetingUserId: { __typename: "MeetingUserId"; userId: string | null; guestId: string | null } | null;
  } | null;
};

export type PreviewRoleEmailQueryVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  action: string;
  roleId: string;
  recipients: Array<Types.EmailRecipientInput> | Types.EmailRecipientInput;
  personalNote?: string | null | undefined;
}>;

export type PreviewRoleEmailQuery = {
  __typename: "Query";
  previewRoleEmail: {
    __typename: "EmailPreviewResponse";
    actionSummary: string;
    emailPreviews: Array<{
      __typename: "EmailPreviewResult";
      recipientEmail: string;
      subject: string;
      htmlContent: string;
    }>;
  };
};

export type RoleProposalFieldsFragment = {
  __typename: "RoleProposal";
  id: string;
  clubId: string;
  meetingId: string;
  agendaItemId: string;
  slotIndex: number;
  proposedToUserId: string;
  proposedToName: string;
  proposedByUserId: string;
  proposedByName: string;
  proposedByRoleLabel: string;
  status: Types.RoleProposalStatus;
  createdAt: string;
  expiresAt: string;
  respondedAt: string | null;
  withdrawnAt: string | null;
};

export type ProposalsForMeetingQueryVariables = Exact<{
  meetingId: string | number;
}>;

export type ProposalsForMeetingQuery = {
  __typename: "Query";
  proposalsForMeeting: Array<{
    __typename: "RoleProposal";
    id: string;
    clubId: string;
    meetingId: string;
    agendaItemId: string;
    slotIndex: number;
    proposedToUserId: string;
    proposedToName: string;
    proposedByUserId: string;
    proposedByName: string;
    proposedByRoleLabel: string;
    status: Types.RoleProposalStatus;
    createdAt: string;
    expiresAt: string;
    respondedAt: string | null;
    withdrawnAt: string | null;
  }>;
};

export type GetAgendaRemovalImpactQueryVariables = Exact<{
  clubId: string | number;
  meetingId: string | number;
  seats: Array<Types.AgendaSeatInput> | Types.AgendaSeatInput;
}>;

export type GetAgendaRemovalImpactQuery = {
  __typename: "Query";
  agendaRemovalImpact: {
    __typename: "AgendaRemovalImpact";
    meetingHasBeenFinished: boolean;
    credits: Array<{
      __typename: "AgendaCreditAtRisk";
      agendaItemId: string;
      roleName: string | null;
      userId: string;
      memberName: string | null;
      completionId: string;
      creditMethod: string;
      withdrawable: boolean;
      placement: {
        __typename: "SpeechPlacement";
        pathwayName: string | null;
        level: number;
        projectName: string | null;
        completionType: Types.CompletionType;
        isEducationSeries: boolean;
      };
    }>;
  } | null;
};

export type MeetingUpdatesSubscriptionVariables = Exact<{
  meetingId: string | number;
}>;

export type MeetingUpdatesSubscription = {
  __typename: "Subscription";
  meetingUpdates: { __typename: "MeetingUpdateEvent"; eventType: string; meetingId: string; changeType: string | null };
};

export type ClubMeetingUpdatesSubscriptionVariables = Exact<{
  clubId: string | number;
}>;

export type ClubMeetingUpdatesSubscription = {
  __typename: "Subscription";
  clubMeetingUpdates: {
    __typename: "MeetingUpdateEvent";
    eventType: string;
    meetingId: string;
    changeType: string | null;
  };
};

export type GetMemberActivityTrackerQueryVariables = Exact<{
  clubId: string | number;
  months?: number | null | undefined;
}>;

export type GetMemberActivityTrackerQuery = {
  __typename: "Query";
  memberActivityTracker: {
    __typename: "MemberActivityTracker";
    periodStart: string;
    periodEnd: string;
    summary: {
      __typename: "MemberActivitySummary";
      totalMembers: number;
      membersWithActivePathwayEnrollment: number;
      membersWithMultipleActivePathwayEnrollments: number;
      frequentMembers: number;
      infrequentMembers: number;
      dormantMembers: number;
      meetingsInPeriod: number;
    };
    members: Array<{
      __typename: "MemberActivityMember";
      memberId: string;
      memberName: string;
      activityLevel: Types.ActivityLevel;
      lastParticipationDate: string | null;
      lastAttendedDate: string | null;
      membershipStatus: Types.MembershipStatus;
      stats: {
        __typename: "MemberActivityStats";
        meetingsWithParticipation: number;
        rolesCount: number;
        speechesCount: number;
        tableTopicsCount: number;
        meetingsAttended: number;
      };
      meetingDates: Array<{ __typename: "CategorizedMeetingDate"; date: string; category: Types.MeetingDateCategory }>;
    }>;
  } | null;
};

export type GetMemberActivityDetailQueryVariables = Exact<{
  clubId: string | number;
  memberUserId: string | number;
  months?: number | null | undefined;
}>;

export type GetMemberActivityDetailQuery = {
  __typename: "Query";
  memberActivityDetail: {
    __typename: "MemberActivityDetail";
    memberId: string;
    memberName: string;
    lastParticipationDate: string | null;
    lastAttendedDate: string | null;
    periodStart: string;
    periodEnd: string;
    meetingsAttended: number;
    meetingDates: Array<{ __typename: "CategorizedMeetingDate"; date: string; category: Types.MeetingDateCategory }>;
    roleBreakdown: Array<{ __typename: "RoleBreakdownEntry"; roleType: string; count: number; lastDate: string }>;
    speechHistory: Array<{
      __typename: "SpeechHistoryEntry";
      date: string;
      title: string | null;
      meetingId: string;
      completionId: string | null;
    }>;
  } | null;
};

export type ClubOfficerFieldsFragment = {
  __typename: "ClubOfficer";
  userId: string;
  roleDisplayName: string;
  termBegin: string;
  termEnd: string;
};

export type OfficerResultFieldsFragment = {
  __typename: "OfficerResult";
  success: boolean;
  message: string | null;
  data: {
    __typename: "ClubOfficer";
    userId: string;
    roleDisplayName: string;
    termBegin: string;
    termEnd: string;
  } | null;
};

export type RemoveMemberMutationVariables = Exact<{
  clubId: string | number;
  actionId: string;
}>;

export type RemoveMemberMutation = {
  __typename: "Mutation";
  removeMember: { __typename: "SimpleResult"; success: boolean; message: string | null; errorCode: string | null };
};

export type SendPaymentReminderMutationVariables = Exact<{
  clubId: string | number;
  actionId: string;
}>;

export type SendPaymentReminderMutation = {
  __typename: "Mutation";
  sendPaymentReminder: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type MarkMemberPaidMutationVariables = Exact<{
  clubId: string | number;
  actionId: string;
}>;

export type MarkMemberPaidMutation = {
  __typename: "Mutation";
  markMemberPaid: { __typename: "SimpleResult"; success: boolean; message: string | null; errorCode: string | null };
};

export type MarkMemberNotRenewingMutationVariables = Exact<{
  clubId: string | number;
  actionId: string;
}>;

export type MarkMemberNotRenewingMutation = {
  __typename: "Mutation";
  markMemberNotRenewing: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type MarkMemberNotifiedAsPaidMutationVariables = Exact<{
  clubId: string | number;
  actionId: string;
}>;

export type MarkMemberNotifiedAsPaidMutation = {
  __typename: "Mutation";
  markMemberNotifiedAsPaid: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type ClearMemberPaymentStatusMutationVariables = Exact<{
  clubId: string | number;
  actionId: string;
}>;

export type ClearMemberPaymentStatusMutation = {
  __typename: "Mutation";
  clearMemberPaymentStatus: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type SendAllPaymentRemindersMutationVariables = Exact<{
  clubId: string | number;
}>;

export type SendAllPaymentRemindersMutation = {
  __typename: "Mutation";
  sendAllPaymentReminders: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type UpdateMembershipConfigMutationVariables = Exact<{
  clubId: string | number;
  config: Types.MembershipConfigInput;
  expected?: Types.MembershipConfigInput | null | undefined;
}>;

export type UpdateMembershipConfigMutation = {
  __typename: "Mutation";
  updateMembershipConfig: {
    __typename: "SimpleResult";
    success: boolean;
    message: string | null;
    errorCode: string | null;
  };
};

export type AssignOfficerMutationVariables = Exact<{
  clubId: string | number;
  userId: string | number;
  membershipId: string;
  memberName: string;
  roleName: string;
}>;

export type AssignOfficerMutation = {
  __typename: "Mutation";
  assignOfficer: {
    __typename: "OfficerResult";
    success: boolean;
    message: string | null;
    data: {
      __typename: "ClubOfficer";
      userId: string;
      roleDisplayName: string;
      termBegin: string;
      termEnd: string;
    } | null;
  };
};

export type RemoveOfficerMutationVariables = Exact<{
  clubId: string | number;
  officerId: string;
}>;

export type RemoveOfficerMutation = {
  __typename: "Mutation";
  removeOfficer: { __typename: "SimpleResult"; success: boolean; message: string | null; errorCode: string | null };
};

export type PublicMemberNotRenewingMutationVariables = Exact<{
  clubShortName: string;
  actionId: string;
}>;

export type PublicMemberNotRenewingMutation = {
  __typename: "Mutation";
  publicMemberNotRenewing: {
    __typename: "MemberActionResult";
    success: boolean;
    clubLongName: string | null;
    memberName: string | null;
    message: string | null;
  };
};

export type PublicMemberMarkAsPaidMutationVariables = Exact<{
  clubShortName: string;
  actionId: string;
}>;

export type PublicMemberMarkAsPaidMutation = {
  __typename: "Mutation";
  publicMemberMarkAsPaid: {
    __typename: "MemberActionResult";
    success: boolean;
    clubLongName: string | null;
    memberName: string | null;
    message: string | null;
  };
};

export type SubmitNewMemberFormMutationVariables = Exact<{
  clubShortName: string;
  data: Types.NewMemberFormInput;
}>;

export type SubmitNewMemberFormMutation = {
  __typename: "Mutation";
  submitNewMemberForm: {
    __typename: "NewMemberResponse";
    success: boolean;
    message: string | null;
    firstName: string | null;
    emailAddress: string | null;
    actionId: string | null;
    allowCardPayments: boolean | null;
  };
};

export type ConfirmPendingMembershipApplicationMutationVariables = Exact<{
  clubId: string | number;
  applicationId: string;
}>;

export type ConfirmPendingMembershipApplicationMutation = {
  __typename: "Mutation";
  confirmPendingMembershipApplication: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type ResendPendingMembershipVerificationMutationVariables = Exact<{
  clubId: string | number;
  applicationId: string;
}>;

export type ResendPendingMembershipVerificationMutation = {
  __typename: "Mutation";
  resendPendingMembershipVerification: { __typename: "SimpleResult"; success: boolean; message: string | null };
};

export type GetMembersSummaryQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetMembersSummaryQuery = {
  __typename: "Query";
  membersSummary: {
    __typename: "MembersSummary";
    totalMembers: number;
    tiMembers: number;
    activeMembers: number;
    dueCount: number;
    notRenewingCount: number;
    lastMembershipImport: string | null;
    members: Array<{
      __typename: "ClubMember";
      membershipId: string | null;
      userId: any;
      firstName: string;
      lastName: string;
      fullName: string;
      emailAddress: string | null;
      mobilePhone: string | null;
      memberType: Types.MemberType;
      thStatus: Types.ThStatus;
      tiStatus: Types.TiStatus;
      paidUntilTH: string | null;
      paidUntilTI: string | null;
      latestPaymentDate: string | null;
      markAsPaidUntil: string | null;
      clubJoinDate: string | null;
      isPaid: boolean;
      isDue: boolean;
      statusString: string;
      lastEmailSent: string | null;
      lastLogin: string | null;
      actionId: string;
      hasApplicationDetails: boolean;
      emailStatus: {
        __typename: "EmailAddressStatus";
        state: string;
        reason: string | null;
        since: string;
        address: string;
        canMarkWorking: boolean;
      } | null;
    }>;
  } | null;
};

export type GetMembershipConfigQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetMembershipConfigQuery = {
  __typename: "Query";
  membershipConfig: {
    __typename: "MembershipConfig";
    clubId: number;
    enabled: boolean;
    allowNewMembers: boolean;
    chargeInFullMonths: boolean;
    currency: string;
    newMemberFeePence: number;
    monthlyDuesPence: number;
    allowCardPayments: boolean;
    allowBankTransfers: boolean;
    sortCode: string;
    accountNo: string;
    accountName: string;
    iban: string;
    rolloverDays: number;
    minMonthsToCharge: number;
    renewalCycle: string;
    officerTermMonths: number;
    customRenewalText: string | null;
    hasCustomRenewalText: boolean;
    defaultRenewalText: string;
    customNewMemberText: string | null;
    defaultNewMemberText: string;
    customLongExpiredText: string | null;
    defaultLongExpiredText: string;
    cardsEnablable: boolean;
    validCurrencies: Array<string>;
  } | null;
};

export type GetActivePaidMembersQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetActivePaidMembersQuery = {
  __typename: "Query";
  activePaidMembers: Array<{
    __typename: "ClubMember";
    membershipId: string | null;
    firstName: string;
    lastName: string;
    fullName: string;
    emailAddress: string | null;
    isPaid: boolean;
    userId: any;
  }>;
};

export type GetClubMemberApplicationDetailsQueryVariables = Exact<{
  clubId: string | number;
  actionId: string;
}>;

export type GetClubMemberApplicationDetailsQuery = {
  __typename: "Query";
  clubMemberApplicationDetails: {
    __typename: "NewMemberApplicationDetails";
    newMemberType: string;
    previousMembershipDetails: string | null;
    lastName: string;
    firstName: string;
    middleName: string | null;
    gender: string;
    mobilePhone: string;
    homePhone: string;
    email: string;
    country: string;
    attentionCareOf: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    postcode: string;
    contactByMail: boolean;
    contactByEmail: boolean;
    contactByPhone: boolean;
    releaseAccepted: boolean;
    toastmastersPromiseAccepted: boolean;
  } | null;
};

export type GetMembershipEmailPreviewQueryVariables = Exact<{
  clubId: string | number;
  draftRenewalText?: string | null | undefined;
  draftNewMemberText?: string | null | undefined;
  draftLongExpiredText?: string | null | undefined;
}>;

export type GetMembershipEmailPreviewQuery = {
  __typename: "Query";
  membershipEmailPreview: {
    __typename: "MembershipEmailPreview";
    newMemberPreview: {
      __typename: "EmailPreview";
      subject: string;
      message: string;
      fromAddress: string;
      replyToAddress: string;
      toAddress: string;
    };
    renewalPreview: {
      __typename: "EmailPreview";
      subject: string;
      message: string;
      fromAddress: string;
      replyToAddress: string;
      toAddress: string;
    };
    longExpiredPreview: {
      __typename: "EmailPreview";
      subject: string;
      message: string;
      fromAddress: string;
      replyToAddress: string;
      toAddress: string;
    };
  } | null;
};

export type GetMembershipFeesPreviewQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetMembershipFeesPreviewQuery = {
  __typename: "Query";
  membershipFeesPreview: {
    __typename: "MembershipFeesPreview";
    today: string;
    paymentValues: Array<{
      __typename: "FeePreviewEntry";
      date: string;
      amount: string;
      shortAmount: string;
      startDate: string;
      endDate: string;
      months: string;
    }>;
  } | null;
};

export type GetTemplateVariablesQueryVariables = Exact<{
  clubId: string | number;
  templateType: string;
}>;

export type GetTemplateVariablesQuery = {
  __typename: "Query";
  templateVariables: Array<{
    __typename: "TemplateVariable";
    name: string;
    description: string;
    exampleValue: string;
    required: boolean;
    isHtml: boolean;
  }>;
};

export type GetNewMemberFormInfoQueryVariables = Exact<{
  clubShortName: string;
}>;

export type GetNewMemberFormInfoQuery = {
  __typename: "Query";
  newMemberFormInfo: {
    __typename: "NewMemberFormInfo";
    clubShortName: string;
    clubLongName: string;
    newMemberFee: string;
    monthlyClubFee: string;
    totalJoiningFee: string;
    allowNewMembers: boolean;
    clubContactEmail: string;
    newMemberTypes: Array<{ __typename: "NewMemberTypeOption"; value: string; title: string }>;
  };
};

export type GetMemberPaymentDataQueryVariables = Exact<{
  clubShortName: string;
  actionId: string;
}>;

export type GetMemberPaymentDataQuery = {
  __typename: "Query";
  memberPaymentData: {
    __typename: "MemberPaymentData";
    clientIntentSecret: string | null;
    stripePublishableKey: string | null;
    country: string | null;
    currency: string | null;
    amount: any;
    testMode: boolean | null;
    clubLongName: string | null;
    memberName: string | null;
    fullDuesAmountDesc: string | null;
    message: string | null;
    alreadyPaid: boolean;
  };
};

export type GetClubPendingMembershipApplicationsQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubPendingMembershipApplicationsQuery = {
  __typename: "Query";
  clubPendingMembershipApplications: Array<{
    __typename: "PendingSubmission";
    id: string;
    name: string;
    email: string;
    submittedAt: string;
    expiresAt: string;
  }>;
};

export type UpdateUserEnrollmentsMutationVariables = Exact<{
  pathwayIds: Array<number> | number;
}>;

export type UpdateUserEnrollmentsMutation = {
  __typename: "Mutation";
  updateUserEnrollments: {
    __typename: "EnrollmentListResult";
    success: boolean;
    message: string | null;
    data: Array<{
      __typename: "UserPathwayEnrollment";
      pathwayId: number;
      enrolledDate: string;
      currentLevel: number;
      completedDate: string | null;
    }> | null;
  };
};

export type EnrollMemberInPathwaysMutationVariables = Exact<{
  userId: any;
  clubId: string | number;
  pathwayIds: Array<number> | number;
}>;

export type EnrollMemberInPathwaysMutation = {
  __typename: "Mutation";
  enrollMemberInPathways: {
    __typename: "EnrollmentListResult";
    success: boolean;
    message: string | null;
    data: Array<{
      __typename: "UserPathwayEnrollment";
      pathwayId: number;
      enrolledDate: string;
      currentLevel: number;
      completedDate: string | null;
    }> | null;
  };
};

export type RemoveMemberPathwayEnrollmentMutationVariables = Exact<{
  userId: any;
  clubId: string | number;
  pathwayId: number;
}>;

export type RemoveMemberPathwayEnrollmentMutation = {
  __typename: "Mutation";
  removeMemberPathwayEnrollment: { __typename: "EnrollmentListResult"; success: boolean; message: string | null };
};

export type UpdateSpeechCompletionMutationVariables = Exact<{
  completionId: any;
  projectId?: string | null | undefined;
  speechTitle?: string | null | undefined;
  clearProjectLink?: boolean | null | undefined;
  clearSpeechTitle?: boolean | null | undefined;
  confirmationToken?: string | null | undefined;
}>;

export type UpdateSpeechCompletionMutation = {
  __typename: "Mutation";
  updateSpeechCompletion: {
    __typename: "CompletionResult";
    success: boolean;
    message: string | null;
    data: {
      __typename: "PathwayCompletionRecord";
      id: string | null;
      userId: string;
      clubId: string;
      pathwayId: number;
      level: number;
      completionType: Types.CompletionType;
      projectId: string | null;
      speechTitle: string | null;
      roleType: string | null;
      roleName: string | null;
      meetingId: string | null;
      completedDate: string;
      notes: string | null;
    } | null;
  };
};

export type RemoveSpeechCompletionMutationVariables = Exact<{
  completionId: any;
}>;

export type RemoveSpeechCompletionMutation = { __typename: "Mutation"; removeSpeechCompletion: boolean };

export type RecordManualSpeechCompletionMutationVariables = Exact<{
  userId: any;
  clubId: string | number;
  pathwayId: number;
  level: number;
  projectId: string;
  speechTitle: string;
  completedDate?: string | null | undefined;
}>;

export type RecordManualSpeechCompletionMutation = {
  __typename: "Mutation";
  recordManualSpeechCompletion: {
    __typename: "CompletionResult";
    success: boolean;
    message: string | null;
    data: {
      __typename: "PathwayCompletionRecord";
      id: string | null;
      userId: string;
      clubId: string;
      pathwayId: number;
      level: number;
      completionType: Types.CompletionType;
      projectId: string | null;
      speechTitle: string | null;
      roleType: string | null;
      roleName: string | null;
      meetingId: string | null;
      completedDate: string;
      notes: string | null;
    } | null;
  };
};

export type RecordNonSpeechCompletionMutationVariables = Exact<{
  userId: any;
  clubId: string | number;
  pathwayId: number;
  level: number;
  projectId: string;
  completedDate?: string | null | undefined;
}>;

export type RecordNonSpeechCompletionMutation = {
  __typename: "Mutation";
  recordNonSpeechCompletion: {
    __typename: "CompletionResult";
    success: boolean;
    message: string | null;
    data: {
      __typename: "PathwayCompletionRecord";
      id: string | null;
      userId: string;
      clubId: string;
      pathwayId: number;
      level: number;
      completionType: Types.CompletionType;
      projectId: string | null;
      speechTitle: string | null;
      roleType: string | null;
      roleName: string | null;
      meetingId: string | null;
      completedDate: string;
      notes: string | null;
    } | null;
  };
};

export type RecordManualRoleCompletionMutationVariables = Exact<{
  userId: any;
  clubId: string | number;
  meetingId?: string | null | undefined;
  meetingDate: string;
  roleName: string;
  pathwayId?: number | null | undefined;
  level?: number | null | undefined;
  pathwayRoleName?: string | null | undefined;
}>;

export type RecordManualRoleCompletionMutation = {
  __typename: "Mutation";
  recordManualRoleCompletion: {
    __typename: "CompletionResult";
    success: boolean;
    message: string | null;
    data: {
      __typename: "PathwayCompletionRecord";
      id: string | null;
      userId: string;
      clubId: string;
      pathwayId: number;
      level: number;
      completionType: Types.CompletionType;
      projectId: string | null;
      speechTitle: string | null;
      roleType: string | null;
      roleName: string | null;
      meetingId: string | null;
      completedDate: string;
      notes: string | null;
    } | null;
  };
};

export type LinkRoleParticipationMutationVariables = Exact<{
  participationId: any;
  targetUserId: any;
  pathwayId: any;
  level: number;
  roleName: string;
}>;

export type LinkRoleParticipationMutation = {
  __typename: "Mutation";
  linkRoleParticipation: {
    __typename: "PathwayCompletionRecordRef";
    completionId: any;
    pathwayId: any;
    level: number;
    roleName: string;
    roleKey: string;
    meetingId: string | null;
  };
};

export type UnlinkRoleParticipationMutationVariables = Exact<{
  completionId: any;
}>;

export type UnlinkRoleParticipationMutation = { __typename: "Mutation"; unlinkRoleParticipation: boolean };

export type GetPathwaysWithDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPathwaysWithDetailsQuery = {
  __typename: "Query";
  pathways: Array<{
    __typename: "Pathway";
    id: string;
    pathwayCode: string;
    name: string;
    description: string;
    isActive: boolean;
    projects: Array<{
      __typename: "PathwayProject";
      id: string;
      pathwayId: number;
      level: number;
      objectiveId: string;
      name: string;
      projectType: Types.ProjectType;
      sortOrder: number;
      officialProjectId: string | null;
      speechTimings: {
        __typename: "SpeechTimings";
        greenSeconds: number;
        amberSeconds: number;
        redSeconds: number;
      } | null;
    }>;
    levelRequirements: Array<{
      __typename: "LevelRequirement";
      level: number;
      requiredProjects: Array<string>;
      electiveProjects: Array<string>;
      electivesRequired: number;
      description: string;
      educationSeriesRequirement: {
        __typename: "EducationSeriesRequirement";
        enabled: boolean;
        series: Array<string>;
        count: number;
        presentationIds: Array<string>;
      } | null;
      roleRequirement: {
        __typename: "LevelRoleRequirement";
        enabled: boolean;
        roles: Array<string>;
        count: number;
        description: string | null;
        requiredRoleQuotas: Array<{
          __typename: "LevelRoleQuota";
          roles: Array<string>;
          minimum: number;
          description: string | null;
        }>;
      } | null;
    }>;
  }>;
};

export type GetPathwayProjectsProseQueryVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;

export type GetPathwayProjectsProseQuery = {
  __typename: "Query";
  pathwayProjects: Array<{
    __typename: "PathwayProject";
    id: string;
    description: string | null;
    objectives: string | null;
    agendaSummary: string | null;
  }>;
};

export type GetMyPathwayEnrollmentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyPathwayEnrollmentsQuery = {
  __typename: "Query";
  myPathwayEnrollments: Array<{
    __typename: "UserPathwayEnrollment";
    pathwayId: number;
    enrolledDate: string;
    currentLevel: number;
    completedDate: string | null;
  }>;
};

export type GetMyPathwayCompletionsQueryVariables = Exact<{
  pathwayId?: number | null | undefined;
}>;

export type GetMyPathwayCompletionsQuery = {
  __typename: "Query";
  myPathwayCompletions: Array<{
    __typename: "PathwayCompletionRecord";
    id: string | null;
    userId: string;
    clubId: string;
    pathwayId: number;
    level: number;
    completionType: Types.CompletionType;
    projectId: string | null;
    speechTitle: string | null;
    roleType: string | null;
    roleName: string | null;
    meetingId: string | null;
    completedDate: string;
    notes: string | null;
  }>;
};

export type GetMyMentorProgramPrerequisiteQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyMentorProgramPrerequisiteQuery = {
  __typename: "Query";
  myMentorProgramPrerequisite: { __typename: "MentorProgramPrerequisite"; pathwayId: number; prerequisiteMet: boolean };
};

export type GetUserPathwayDataQueryVariables = Exact<{
  pathwayId?: number | null | undefined;
  participationLimit?: number | null | undefined;
}>;

export type GetUserPathwayDataQuery = {
  __typename: "Query";
  myPathwayEnrollments: Array<{
    __typename: "UserPathwayEnrollment";
    pathwayId: number;
    enrolledDate: string;
    currentLevel: number;
    completedDate: string | null;
  }>;
  myPathwayCompletions: Array<{
    __typename: "PathwayCompletionRecord";
    id: string | null;
    userId: string;
    clubId: string;
    pathwayId: number;
    level: number;
    completionType: Types.CompletionType;
    projectId: string | null;
    speechTitle: string | null;
    roleType: string | null;
    roleName: string | null;
    meetingId: string | null;
    completedDate: string;
    notes: string | null;
  }>;
  myParticipationRecords: Array<{
    __typename: "MeetingParticipationRecord";
    id: string | null;
    userId: string;
    clubId: string;
    meetingId: string;
    agendaItemId: string | null;
    participationType: Types.ParticipationType;
    category: Types.ParticipationCategory;
    roleType: string | null;
    roleName: string | null;
    speechTitle: string | null;
    completedDate: string;
    creditedBy: string;
    creditSource: Types.ParticipationCreditSource;
    notes: string | null;
    pathwayCompletionId: string | null;
    pathwayProjectId: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetEducationSeriesCatalogQueryVariables = Exact<{ [key: string]: never }>;

export type GetEducationSeriesCatalogQuery = {
  __typename: "Query";
  educationSeriesCatalog: Array<{
    __typename: "EducationSeriesPresentation";
    id: string;
    seriesKey: string;
    seriesName: string;
    tiCode: string;
    title: string;
    slug: string;
    defaultDurationMinutes: number;
    recommendedAudience: string;
    description: string | null;
    facilitatorTips: Array<string>;
    speechTimings: {
      __typename: "SpeechTimings";
      greenSeconds: number;
      amberSeconds: number;
      redSeconds: number;
    } | null;
    pathwaysRequirement: { __typename: "EducationSeriesPathwaysRequirement"; level: number; count: number };
    assets: Array<{ __typename: "EducationSeriesAsset"; assetType: string; file: string }>;
    materialsLinks: {
      __typename: "EducationSeriesMaterialsLinks";
      facilitatorGuideUrl: string | null;
      slidesUrl: string | null;
    } | null;
  }>;
};

export type GetClubPathwayChartQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubPathwayChartQuery = {
  __typename: "Query";
  clubPathwayChart: Array<{
    __typename: "PathwayChartRow";
    memberId: string;
    memberName: string;
    pathwayId: number;
    pathwayName: string;
    enrolledDate: string;
    currentLevel: number;
    completedDate: string | null;
    lastSpokeDate: string | null;
    pendingRequestCount: number;
    completionCount: number;
    levels: Array<{
      __typename: "LevelProgress";
      level: number;
      status: string;
      required: { __typename: "RequirementProgress"; total: number; completed: number };
      electives: { __typename: "RequirementProgress"; total: number; completed: number };
      education: { __typename: "RequirementProgress"; total: number; completed: number };
      roleQuota: { __typename: "RequirementProgress"; total: number; completed: number };
      segments: Array<{
        __typename: "LevelSegment";
        status: string;
        meetingId: string | null;
        completionId: string | null;
        completionDate: string | null;
        projectName: string | null;
        speechTitle: string | null;
        completionType: Types.CompletionType | null;
      }> | null;
      roleBreakdown: Array<{
        __typename: "PathwayRoleBreakdown";
        roleName: string;
        count: number;
        requiredMinimum: number;
        meetsMinimum: boolean;
      }> | null;
    }>;
  }>;
};

export type GetMemberPathwayEnrollmentsQueryVariables = Exact<{
  clubId: string | number;
  memberUserId: string | number;
}>;

export type GetMemberPathwayEnrollmentsQuery = {
  __typename: "Query";
  memberPathwayEnrollments: Array<{
    __typename: "UserPathwayEnrollment";
    pathwayId: number;
    enrolledDate: string;
    currentLevel: number;
    completedDate: string | null;
  }>;
};

export type GetMemberPathwayProgressQueryVariables = Exact<{
  clubId: string | number;
  memberUserId: string | number;
}>;

export type GetMemberPathwayProgressQuery = {
  __typename: "Query";
  memberPathwayProgress: {
    __typename: "MemberPathwayProgress";
    enrollments: Array<{
      __typename: "UserPathwayEnrollment";
      pathwayId: number;
      enrolledDate: string;
      currentLevel: number;
      completedDate: string | null;
    }>;
    completions: Array<{
      __typename: "PathwayCompletionRecord";
      id: string | null;
      userId: string;
      pathwayId: number;
      level: number;
      projectId: string | null;
      speechTitle: string | null;
      completedDate: string;
    }>;
    projectRequests: Array<{
      __typename: "ProjectSignupRequest";
      id: string;
      userId: string;
      projectId: string | null;
      speechTitle: string | null;
      requestedAt: string;
      approvedAt: string | null;
      assignedMeetingId: string | null;
      assignedMeetingDateTime: string | null;
      preferredDates: Array<string>;
      status: Types.RequestStatus;
    }>;
  };
};

export type GetUpcomingMeetingDatesQueryVariables = Exact<{
  clubId: string | number;
  monthsAhead?: number | null | undefined;
}>;

export type GetUpcomingMeetingDatesQuery = {
  __typename: "Query";
  clubUpcomingMeetingDates: Array<{
    __typename: "MeetingDateInfo";
    date: string;
    availableSlots: number;
    isProjected: boolean;
  }>;
};

export type GetClubProjectRequestsQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubProjectRequestsQuery = {
  __typename: "Query";
  clubProjectRequests: Array<{
    __typename: "ProjectSignupRequest";
    id: string;
    userId: string;
    projectId: string | null;
    speechTitle: string | null;
    requestedAt: string;
    approvedAt: string | null;
    assignedMeetingId: string | null;
    assignedMeetingDateTime: string | null;
    preferredDates: Array<string>;
    notes: string | null;
    status: Types.RequestStatus;
    hasPendingDates: boolean;
    createdByOfficer: boolean;
    scheduledCancellable: boolean;
    requestedBy: {
      __typename: "ProjectRequestUser";
      userId: string;
      firstName: string;
      lastName: string;
      email: string | null;
    };
    approvedBy: {
      __typename: "ProjectRequestUser";
      userId: string;
      firstName: string;
      lastName: string;
      email: string | null;
    } | null;
    rejections: Array<{
      __typename: "DateRejection";
      date: string;
      rejectedAt: string;
      reason: string;
      rejectedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
    }>;
  }>;
};

export type GetMyClubProjectRequestsQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetMyClubProjectRequestsQuery = {
  __typename: "Query";
  myClubProjectRequests: Array<{
    __typename: "ProjectSignupRequest";
    id: string;
    userId: string;
    projectId: string | null;
    speechTitle: string | null;
    requestedAt: string;
    approvedAt: string | null;
    assignedMeetingId: string | null;
    assignedMeetingDateTime: string | null;
    preferredDates: Array<string>;
    notes: string | null;
    status: Types.RequestStatus;
    hasPendingDates: boolean;
    createdByOfficer: boolean;
    scheduledCancellable: boolean;
    requestedBy: {
      __typename: "ProjectRequestUser";
      userId: string;
      firstName: string;
      lastName: string;
      email: string | null;
    };
    approvedBy: {
      __typename: "ProjectRequestUser";
      userId: string;
      firstName: string;
      lastName: string;
      email: string | null;
    } | null;
    rejections: Array<{
      __typename: "DateRejection";
      date: string;
      rejectedAt: string;
      reason: string;
      rejectedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
    }>;
  }>;
};

export type GetRoleLinkCandidatesQueryVariables = Exact<{
  targetUserId: any;
  pathwayIds?: Array<any> | any | null | undefined;
  hideAlreadyLinked?: boolean | null | undefined;
}>;

export type GetRoleLinkCandidatesQuery = {
  __typename: "Query";
  roleLinkCandidates: Array<{
    __typename: "RoleLinkCandidate";
    participationId: any;
    meetingId: string;
    meetingDate: string;
    clubId: any;
    clubName: string;
    roleName: string;
    roleDescription: string | null;
    roleKey: string;
    alreadyLinked: boolean;
    linkedTo: {
      __typename: "PathwayCompletionRecordRef";
      completionId: any;
      pathwayId: any;
      level: number;
      roleName: string;
      roleKey: string;
      meetingId: string | null;
    } | null;
  }>;
};

export type GetRoleRequirementCandidatesQueryVariables = Exact<{
  targetUserId: any;
}>;

export type GetRoleRequirementCandidatesQuery = {
  __typename: "Query";
  roleRequirementCandidates: Array<{
    __typename: "RoleRequirementCandidate";
    pathwayId: any;
    pathwayName: string;
    level: number;
    levelStatus: string;
    roleName: string;
    roleNames: Array<string>;
    roleKey: string;
    doneCount: number;
    requiredMinimum: number;
    requirementSource: string;
    quotaSatisfied: boolean;
  }>;
  roleRequirementMatchKeys: Array<{ __typename: "RoleRequirementMatchKey"; spelling: string; matchKey: string }>;
};

export type GetRoleRequirementMatchKeysQueryVariables = Exact<{ [key: string]: never }>;

export type GetRoleRequirementMatchKeysQuery = {
  __typename: "Query";
  roleRequirementMatchKeys: Array<{ __typename: "RoleRequirementMatchKey"; spelling: string; matchKey: string }>;
};

export type CreateProjectRequestMutationVariables = Exact<{
  clubId: string | number;
  userId: string | number;
  projectId?: string | null | undefined;
  speechTitle?: string | null | undefined;
  preferredDates: Array<string> | string;
  notes?: string | null | undefined;
  notifyVpe?: boolean | null | undefined;
}>;

export type CreateProjectRequestMutation = {
  __typename: "Mutation";
  createProjectRequest: {
    __typename: "ProjectRequestResult";
    success: boolean;
    message: string | null;
    data: {
      __typename: "ProjectSignupRequest";
      id: string;
      userId: string;
      projectId: string | null;
      speechTitle: string | null;
      requestedAt: string;
      approvedAt: string | null;
      assignedMeetingId: string | null;
      assignedMeetingDateTime: string | null;
      preferredDates: Array<string>;
      notes: string | null;
      status: Types.RequestStatus;
      hasPendingDates: boolean;
      createdByOfficer: boolean;
      scheduledCancellable: boolean;
      requestedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
      approvedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      } | null;
      rejections: Array<{
        __typename: "DateRejection";
        date: string;
        rejectedAt: string;
        reason: string;
        rejectedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        };
      }>;
    } | null;
  };
};

export type UpdateProjectRequestMutationVariables = Exact<{
  clubId: string | number;
  requestId: string;
  projectId?: string | null | undefined;
  speechTitle?: string | null | undefined;
  preferredDates?: Array<string> | string | null | undefined;
  notifyVpe?: boolean | null | undefined;
  clearProjectLink?: boolean | null | undefined;
}>;

export type UpdateProjectRequestMutation = {
  __typename: "Mutation";
  updateProjectRequest: {
    __typename: "ProjectRequestListResult";
    success: boolean;
    message: string | null;
    data: Array<{
      __typename: "ProjectSignupRequest";
      id: string;
      userId: string;
      projectId: string | null;
      speechTitle: string | null;
      requestedAt: string;
      approvedAt: string | null;
      assignedMeetingId: string | null;
      assignedMeetingDateTime: string | null;
      preferredDates: Array<string>;
      notes: string | null;
      status: Types.RequestStatus;
      hasPendingDates: boolean;
      createdByOfficer: boolean;
      scheduledCancellable: boolean;
      requestedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
      approvedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      } | null;
      rejections: Array<{
        __typename: "DateRejection";
        date: string;
        rejectedAt: string;
        reason: string;
        rejectedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        };
      }>;
    }> | null;
  };
};

export type CancelProjectRequestMutationVariables = Exact<{
  clubId: string | number;
  requestId: string;
}>;

export type CancelProjectRequestMutation = {
  __typename: "Mutation";
  cancelProjectRequest: {
    __typename: "ProjectRequestListResult";
    success: boolean;
    message: string | null;
    data: Array<{
      __typename: "ProjectSignupRequest";
      id: string;
      userId: string;
      projectId: string | null;
      speechTitle: string | null;
      requestedAt: string;
      approvedAt: string | null;
      assignedMeetingId: string | null;
      assignedMeetingDateTime: string | null;
      preferredDates: Array<string>;
      notes: string | null;
      status: Types.RequestStatus;
      hasPendingDates: boolean;
      createdByOfficer: boolean;
      scheduledCancellable: boolean;
      requestedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
      approvedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      } | null;
      rejections: Array<{
        __typename: "DateRejection";
        date: string;
        rejectedAt: string;
        reason: string;
        rejectedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        };
      }>;
    }> | null;
  };
};

export type CancelOwnProjectRequestMutationVariables = Exact<{
  clubId: string | number;
  requestId: string;
}>;

export type CancelOwnProjectRequestMutation = {
  __typename: "Mutation";
  cancelOwnProjectRequest: {
    __typename: "ProjectRequestListResult";
    success: boolean;
    message: string | null;
    data: Array<{
      __typename: "ProjectSignupRequest";
      id: string;
      userId: string;
      projectId: string | null;
      speechTitle: string | null;
      requestedAt: string;
      approvedAt: string | null;
      assignedMeetingId: string | null;
      assignedMeetingDateTime: string | null;
      preferredDates: Array<string>;
      notes: string | null;
      status: Types.RequestStatus;
      hasPendingDates: boolean;
      createdByOfficer: boolean;
      scheduledCancellable: boolean;
      requestedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
      approvedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      } | null;
      rejections: Array<{
        __typename: "DateRejection";
        date: string;
        rejectedAt: string;
        reason: string;
        rejectedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        };
      }>;
    }> | null;
  };
};

export type RemoveProjectRequestMutationVariables = Exact<{
  clubId: string | number;
  requestId: string;
}>;

export type RemoveProjectRequestMutation = {
  __typename: "Mutation";
  removeProjectRequest: {
    __typename: "ProjectRequestListResult";
    success: boolean;
    message: string | null;
    data: Array<{
      __typename: "ProjectSignupRequest";
      id: string;
      userId: string;
      projectId: string | null;
      speechTitle: string | null;
      requestedAt: string;
      approvedAt: string | null;
      assignedMeetingId: string | null;
      assignedMeetingDateTime: string | null;
      preferredDates: Array<string>;
      notes: string | null;
      status: Types.RequestStatus;
      hasPendingDates: boolean;
      createdByOfficer: boolean;
      scheduledCancellable: boolean;
      requestedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
      approvedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      } | null;
      rejections: Array<{
        __typename: "DateRejection";
        date: string;
        rejectedAt: string;
        reason: string;
        rejectedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        };
      }>;
    }> | null;
  };
};

export type CancelScheduledProjectRequestMutationVariables = Exact<{
  clubId: string | number;
  requestId: string;
}>;

export type CancelScheduledProjectRequestMutation = {
  __typename: "Mutation";
  cancelScheduledProjectRequest: {
    __typename: "ProjectRequestListResult";
    success: boolean;
    message: string | null;
    data: Array<{
      __typename: "ProjectSignupRequest";
      id: string;
      userId: string;
      projectId: string | null;
      speechTitle: string | null;
      requestedAt: string;
      approvedAt: string | null;
      assignedMeetingId: string | null;
      assignedMeetingDateTime: string | null;
      preferredDates: Array<string>;
      notes: string | null;
      status: Types.RequestStatus;
      hasPendingDates: boolean;
      createdByOfficer: boolean;
      scheduledCancellable: boolean;
      requestedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
      approvedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      } | null;
      rejections: Array<{
        __typename: "DateRejection";
        date: string;
        rejectedAt: string;
        reason: string;
        rejectedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        };
      }>;
    }> | null;
  };
};

export type CancelOwnScheduledProjectRequestMutationVariables = Exact<{
  clubId: string | number;
  requestId: string;
}>;

export type CancelOwnScheduledProjectRequestMutation = {
  __typename: "Mutation";
  cancelOwnScheduledProjectRequest: {
    __typename: "ProjectRequestListResult";
    success: boolean;
    message: string | null;
    data: Array<{
      __typename: "ProjectSignupRequest";
      id: string;
      userId: string;
      projectId: string | null;
      speechTitle: string | null;
      requestedAt: string;
      approvedAt: string | null;
      assignedMeetingId: string | null;
      assignedMeetingDateTime: string | null;
      preferredDates: Array<string>;
      notes: string | null;
      status: Types.RequestStatus;
      hasPendingDates: boolean;
      createdByOfficer: boolean;
      scheduledCancellable: boolean;
      requestedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      };
      approvedBy: {
        __typename: "ProjectRequestUser";
        userId: string;
        firstName: string;
        lastName: string;
        email: string | null;
      } | null;
      rejections: Array<{
        __typename: "DateRejection";
        date: string;
        rejectedAt: string;
        reason: string;
        rejectedBy: {
          __typename: "ProjectRequestUser";
          userId: string;
          firstName: string;
          lastName: string;
          email: string | null;
        };
      }>;
    }> | null;
  };
};

export type GetClubRelationshipTimelineQueryVariables = Exact<{
  clubId: string | number;
  userId: string | number;
}>;

export type GetClubRelationshipTimelineQuery = {
  __typename: "Query";
  clubRelationshipTimeline: {
    __typename: "ClubRelationshipTimeline";
    userId: string;
    clubId: string;
    currentState: Types.RelationshipState;
    firstContactAt: string | null;
    lastContactAt: string | null;
    guestSignedAt: string | null;
    applicationSubmittedAt: string | null;
    convertedToMemberAt: string | null;
    paidUntil: string | null;
    paidUntilTI: string | null;
    notRenewing: boolean;
    updatedAt: string;
    events: Array<{
      __typename: "RelationshipTimelineEvent";
      id: string;
      eventType: Types.RelationshipEventType;
      fromState: Types.RelationshipState | null;
      toState: Types.RelationshipState | null;
      triggeredByUserId: string | null;
      occurredAt: string;
      businessOccurredAt: string | null;
      recordedAt: string;
      isBackfill: boolean;
      isInferred: boolean;
      role: string | null;
      reason: string | null;
      paidUntil: string | null;
    }>;
  };
};

export type UpdateClubEducationConfigMutationVariables = Exact<{
  clubId: string | number;
  hiddenRoleHistoryRoleTypes: Array<string> | string;
}>;

export type UpdateClubEducationConfigMutation = {
  __typename: "Mutation";
  updateClubEducationConfig: { __typename: "ClubEducationConfig"; hiddenRoleHistoryRoleTypes: Array<string> };
};

export type GetClubRoleHistoryChartQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetClubRoleHistoryChartQuery = {
  __typename: "Query";
  clubRoleHistoryChart: {
    __typename: "RoleHistoryChartResponse";
    membersTotal: number;
    membersWithAnyRoles: number;
    roleTypes: Array<string>;
    allKnownRoleTypes: Array<string>;
    hiddenRoleHistoryRoleTypes: Array<string>;
    rows: Array<{
      __typename: "RoleHistoryChartRow";
      memberId: string;
      memberName: string;
      roleStats: Array<{
        __typename: "RoleHistoryStatEntry";
        roleType: string;
        stat: { __typename: "RoleHistoryRoleStat"; count: number; lastDate: string; lastMeetingId: string | null };
      }>;
    }>;
  } | null;
};

export type SpeechCardFieldsFragment = {
  __typename: "SpeechCard";
  id: string | null;
  status: Types.SpeechStatus;
  userId: string;
  memberName: string | null;
  clubId: string;
  title: string | null;
  agendaItemId: string | null;
  isPlaced: boolean;
  deliveredAt: string | null;
  meeting: {
    __typename: "SpeechMeeting";
    meetingId: string;
    clubId: string;
    title: string;
    datetime: string;
    theme: string | null;
    status: Types.MeetingStatus;
  } | null;
  placement: {
    __typename: "SpeechPlacement";
    pathwayId: number;
    pathwayName: string | null;
    level: number;
    completionType: Types.CompletionType;
    projectId: string | null;
    projectName: string | null;
    isEducationSeries: boolean;
  } | null;
  provenance: {
    __typename: "SpeechProvenance";
    completionId: string;
    creditMethod: string;
    creditedBy: string;
    creditedByName: string | null;
    completedDate: string;
    notes: string | null;
    creditedTitle: string | null;
  } | null;
  history: Array<{
    __typename: "SpeechChangeEntry";
    id: string;
    eventType: Types.SpeechChangeKind;
    occurredAt: string;
    actorUserId: string | null;
    actorName: string | null;
    actorProcess: string | null;
    reason: Types.SpeechChangeReason;
    provenance: Types.SpeechChangeProvenance;
    changes: Array<{ __typename: "SpeechFieldChange"; field: string; from: any; to: any }>;
  }>;
};

export type GetSpeechCardQueryVariables = Exact<{
  speechId: string | number;
}>;

export type GetSpeechCardQuery = {
  __typename: "Query";
  speech: {
    __typename: "SpeechCard";
    id: string | null;
    status: Types.SpeechStatus;
    userId: string;
    memberName: string | null;
    clubId: string;
    title: string | null;
    agendaItemId: string | null;
    isPlaced: boolean;
    deliveredAt: string | null;
    meeting: {
      __typename: "SpeechMeeting";
      meetingId: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      status: Types.MeetingStatus;
    } | null;
    placement: {
      __typename: "SpeechPlacement";
      pathwayId: number;
      pathwayName: string | null;
      level: number;
      completionType: Types.CompletionType;
      projectId: string | null;
      projectName: string | null;
      isEducationSeries: boolean;
    } | null;
    provenance: {
      __typename: "SpeechProvenance";
      completionId: string;
      creditMethod: string;
      creditedBy: string;
      creditedByName: string | null;
      completedDate: string;
      notes: string | null;
      creditedTitle: string | null;
    } | null;
    history: Array<{
      __typename: "SpeechChangeEntry";
      id: string;
      eventType: Types.SpeechChangeKind;
      occurredAt: string;
      actorUserId: string | null;
      actorName: string | null;
      actorProcess: string | null;
      reason: Types.SpeechChangeReason;
      provenance: Types.SpeechChangeProvenance;
      changes: Array<{ __typename: "SpeechFieldChange"; field: string; from: any; to: any }>;
    }>;
  } | null;
};

export type GetSpeechCardForCompletionQueryVariables = Exact<{
  completionId: string | number;
}>;

export type GetSpeechCardForCompletionQuery = {
  __typename: "Query";
  speechForCompletion: {
    __typename: "SpeechCard";
    id: string | null;
    status: Types.SpeechStatus;
    userId: string;
    memberName: string | null;
    clubId: string;
    title: string | null;
    agendaItemId: string | null;
    isPlaced: boolean;
    deliveredAt: string | null;
    meeting: {
      __typename: "SpeechMeeting";
      meetingId: string;
      clubId: string;
      title: string;
      datetime: string;
      theme: string | null;
      status: Types.MeetingStatus;
    } | null;
    placement: {
      __typename: "SpeechPlacement";
      pathwayId: number;
      pathwayName: string | null;
      level: number;
      completionType: Types.CompletionType;
      projectId: string | null;
      projectName: string | null;
      isEducationSeries: boolean;
    } | null;
    provenance: {
      __typename: "SpeechProvenance";
      completionId: string;
      creditMethod: string;
      creditedBy: string;
      creditedByName: string | null;
      completedDate: string;
      notes: string | null;
      creditedTitle: string | null;
    } | null;
    history: Array<{
      __typename: "SpeechChangeEntry";
      id: string;
      eventType: Types.SpeechChangeKind;
      occurredAt: string;
      actorUserId: string | null;
      actorName: string | null;
      actorProcess: string | null;
      reason: Types.SpeechChangeReason;
      provenance: Types.SpeechChangeProvenance;
      changes: Array<{ __typename: "SpeechFieldChange"; field: string; from: any; to: any }>;
    }>;
  } | null;
};

export type GetSpeechEditImpactQueryVariables = Exact<{
  completionId: string | number;
  projectId?: string | null | undefined;
  clearProjectLink?: boolean | null | undefined;
}>;

export type GetSpeechEditImpactQuery = {
  __typename: "Query";
  speechEditImpact: {
    __typename: "SpeechEditImpact";
    changesCreditedProgress: boolean;
    changedFields: Array<Types.SpeechEditField>;
    confirmationToken: string;
    current: {
      __typename: "SpeechPlacement";
      pathwayId: number;
      pathwayName: string | null;
      level: number;
      completionType: Types.CompletionType;
      projectId: string | null;
      projectName: string | null;
      isEducationSeries: boolean;
    };
    proposed: {
      __typename: "SpeechPlacement";
      pathwayId: number;
      pathwayName: string | null;
      level: number;
      completionType: Types.CompletionType;
      projectId: string | null;
      projectName: string | null;
      isEducationSeries: boolean;
    };
    creditsOnTargetProject: Array<{
      __typename: "SpeechCreditOnProject";
      completionId: string;
      completedDate: string;
      creditedTitle: string | null;
      meetingId: string | null;
      level: number;
    }>;
  } | null;
};

export type GetSpeechesForMeetingsQueryVariables = Exact<{
  meetingIds: Array<string | number> | string | number;
}>;

export type GetSpeechesForMeetingsQuery = {
  __typename: "Query";
  speechesForMeetings: Array<{
    __typename: "SpeechSlotRef";
    id: string;
    meetingId: string;
    agendaItemId: string | null;
    userId: string;
    status: Types.SpeechStatus;
    completionId: string | null;
  }>;
};

export type GetMyUpcomingSpeechesWithoutRequestQueryVariables = Exact<{
  clubId: string | number;
}>;

export type GetMyUpcomingSpeechesWithoutRequestQuery = {
  __typename: "Query";
  myUpcomingSpeechesWithoutRequest: Array<{
    __typename: "UpcomingSpeech";
    id: string;
    clubId: string;
    agendaItemId: string | null;
    title: string | null;
    projectId: string | null;
    meeting: { __typename: "SpeechMeeting"; meetingId: string; datetime: string; title: string };
  }>;
};

export const AdminNudgeFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AdminNudgeFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AdminNudge" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "minMembers" } },
          { kind: "Field", name: { kind: "Name", value: "maxMembers" } },
          { kind: "Field", name: { kind: "Name", value: "isDCPEligible" } },
          { kind: "Field", name: { kind: "Name", value: "minDCPPoints" } },
          { kind: "Field", name: { kind: "Name", value: "maxDCPPoints" } },
          { kind: "Field", name: { kind: "Name", value: "officersTrainedRnd1" } },
          { kind: "Field", name: { kind: "Name", value: "officersTrainedRnd2" } },
          { kind: "Field", name: { kind: "Name", value: "officerListSubmittedOnTime" } },
          { kind: "Field", name: { kind: "Name", value: "maxPossibleDCPPoints" } },
          { kind: "Field", name: { kind: "Name", value: "months" } },
          { kind: "Field", name: { kind: "Name", value: "suggestion" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminNudgeFieldsFragment, unknown>;
export const AgendaTemplateMutationFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgendaTemplateMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgendaTemplate" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agenda" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "event" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                { kind: "Field", name: { kind: "Name", value: "greenMark" } },
                { kind: "Field", name: { kind: "Name", value: "amberMark" } },
                { kind: "Field", name: { kind: "Name", value: "redMark" } },
                { kind: "Field", name: { kind: "Name", value: "maxAssignments" } },
                { kind: "Field", name: { kind: "Name", value: "isRepeatableRole" } },
                { kind: "Field", name: { kind: "Name", value: "rolePosition" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "itemCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgendaTemplateMutationFieldsFragment, unknown>;
export const AgendaTemplateFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgendaTemplateFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgendaTemplate" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agenda" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "event" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                { kind: "Field", name: { kind: "Name", value: "greenMark" } },
                { kind: "Field", name: { kind: "Name", value: "amberMark" } },
                { kind: "Field", name: { kind: "Name", value: "redMark" } },
                { kind: "Field", name: { kind: "Name", value: "maxAssignments" } },
                { kind: "Field", name: { kind: "Name", value: "isRepeatableRole" } },
                { kind: "Field", name: { kind: "Name", value: "rolePosition" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "itemCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgendaTemplateFieldsFragment, unknown>;
export const ClubFinanceStoredFxRateFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredFxRateFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredFxRate" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rateMicros" } },
          { kind: "Field", name: { kind: "Name", value: "baseCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "quoteCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "enteredOn" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceStoredFxRateFieldsFragment, unknown>;
export const ClubFinanceStoredCostLineFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredCostLineFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredCostLine" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "amountMinor" } },
          { kind: "Field", name: { kind: "Name", value: "cadence" } },
          { kind: "Field", name: { kind: "Name", value: "cadenceLabel" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "categoryLabel" } },
          { kind: "Field", name: { kind: "Name", value: "otherLabel" } },
          { kind: "Field", name: { kind: "Name", value: "occursOn" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceStoredCostLineFieldsFragment, unknown>;
export const ClubFinanceStoredConfigFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "meetingsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "cardFeeBasisPoints" } },
          { kind: "Field", name: { kind: "Name", value: "unpriceableReasons" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fxRate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceStoredFxRateFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "costLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceStoredCostLineFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredCostLineFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredCostLine" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "amountMinor" } },
          { kind: "Field", name: { kind: "Name", value: "cadence" } },
          { kind: "Field", name: { kind: "Name", value: "cadenceLabel" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "categoryLabel" } },
          { kind: "Field", name: { kind: "Name", value: "otherLabel" } },
          { kind: "Field", name: { kind: "Name", value: "occursOn" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredFxRateFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredFxRate" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rateMicros" } },
          { kind: "Field", name: { kind: "Name", value: "baseCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "quoteCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "enteredOn" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceStoredConfigFieldsFragment, unknown>;
export const ClubFinanceOpeningBalanceFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceOpeningBalanceFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceOpeningBalance" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "postingId" } },
          { kind: "Field", name: { kind: "Name", value: "amountMinor" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "effectiveOn" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recordedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceOpeningBalanceFieldsFragment, unknown>;
export const ClubFinanceOptionFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceOptionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceOption" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceOptionFieldsFragment, unknown>;
export const ClubFinanceCohortFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceCohortFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceCohort" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "paidMembers" } },
          { kind: "Field", name: { kind: "Name", value: "overdueMembers" } },
          { kind: "Field", name: { kind: "Name", value: "unknownMembers" } },
          { kind: "Field", name: { kind: "Name", value: "currentMembers" } },
          { kind: "Field", name: { kind: "Name", value: "countedOn" } },
          { kind: "Field", name: { kind: "Name", value: "overridden" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceCohortFieldsFragment, unknown>;
export const ClubFinanceRosterModelFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceRosterModelFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceRosterModel" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "retentionBasisPoints" } },
          { kind: "Field", name: { kind: "Name", value: "joinersPerMonth" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceRosterModelFieldsFragment, unknown>;
export const ClubFinanceCostItemFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceCostItemFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceCostItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "categoryLabel" } },
          { kind: "Field", name: { kind: "Name", value: "annualMinor" } },
          { kind: "Field", name: { kind: "Name", value: "derivedFrom" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceCostItemFieldsFragment, unknown>;
export const ClubFinanceConversionFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceConversionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceConversion" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rateMicros" } },
          { kind: "Field", name: { kind: "Name", value: "ratedOn" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceConversionFieldsFragment, unknown>;
export const ClubFinanceTiChargeFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceTIChargeFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceTICharge" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "memberCount" } },
          { kind: "Field", name: { kind: "Name", value: "periodsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "duesPerPeriodMinor" } },
          { kind: "Field", name: { kind: "Name", value: "chargeCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "annualChargeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "convertedAnnualMinor" } },
          { kind: "Field", name: { kind: "Name", value: "cardFeeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "annualCostMinor" } },
          { kind: "Field", name: { kind: "Name", value: "assumedMemberPeriods" } },
          { kind: "Field", name: { kind: "Name", value: "newMembersCharged" } },
          { kind: "Field", name: { kind: "Name", value: "joinerChargeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "newMemberFeeMinor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "conversion" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceConversionFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceConversionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceConversion" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rateMicros" } },
          { kind: "Field", name: { kind: "Name", value: "ratedOn" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceTiChargeFieldsFragment, unknown>;
export const ClubFinanceUnavailableFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceUnavailableFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceUnavailable" } },
      selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reasons" } }] },
    },
  ],
} as unknown as DocumentNode<ClubFinanceUnavailableFieldsFragment, unknown>;
export const ClubFinanceIncomeFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceIncomeFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceIncome" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "monthlyDuesMinor" } },
          { kind: "Field", name: { kind: "Name", value: "annualIncomeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "annualSurplusMinor" } },
          { kind: "Field", name: { kind: "Name", value: "breakEvenMembers" } },
          { kind: "Field", name: { kind: "Name", value: "breakEvenUnreachable" } },
          { kind: "Field", name: { kind: "Name", value: "memberGap" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceIncomeFieldsFragment, unknown>;
export const ClubFinanceFlowFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceFlowFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceFlow" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "annualRunningCostMinor" } },
          { kind: "Field", name: { kind: "Name", value: "oneOffMinorInWindow" } },
          { kind: "Field", name: { kind: "Name", value: "twelveMonthSpendMinor" } },
          { kind: "Field", name: { kind: "Name", value: "payingMembers" } },
          { kind: "Field", name: { kind: "Name", value: "disclosure" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterModel" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceRosterModelFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "costLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceCostItemFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "tiCharge" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceTIChargeFields" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceUnavailableFields" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "income" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceIncomeFields" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceUnavailableFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceUnavailableFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceUnavailable" } },
      selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reasons" } }] },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceCostItemFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceCostItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "categoryLabel" } },
          { kind: "Field", name: { kind: "Name", value: "annualMinor" } },
          { kind: "Field", name: { kind: "Name", value: "derivedFrom" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceConversionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceConversion" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rateMicros" } },
          { kind: "Field", name: { kind: "Name", value: "ratedOn" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceTIChargeFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceTICharge" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "memberCount" } },
          { kind: "Field", name: { kind: "Name", value: "periodsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "duesPerPeriodMinor" } },
          { kind: "Field", name: { kind: "Name", value: "chargeCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "annualChargeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "convertedAnnualMinor" } },
          { kind: "Field", name: { kind: "Name", value: "cardFeeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "annualCostMinor" } },
          { kind: "Field", name: { kind: "Name", value: "assumedMemberPeriods" } },
          { kind: "Field", name: { kind: "Name", value: "newMembersCharged" } },
          { kind: "Field", name: { kind: "Name", value: "joinerChargeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "newMemberFeeMinor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "conversion" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceConversionFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceIncomeFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceIncome" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "monthlyDuesMinor" } },
          { kind: "Field", name: { kind: "Name", value: "annualIncomeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "annualSurplusMinor" } },
          { kind: "Field", name: { kind: "Name", value: "breakEvenMembers" } },
          { kind: "Field", name: { kind: "Name", value: "breakEvenUnreachable" } },
          { kind: "Field", name: { kind: "Name", value: "memberGap" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceRosterModelFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceRosterModel" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "retentionBasisPoints" } },
          { kind: "Field", name: { kind: "Name", value: "joinersPerMonth" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceFlowFieldsFragment, unknown>;
export const ClubFinanceMonthFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceMonthFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceMonth" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "currentMembers" } },
          { kind: "Field", name: { kind: "Name", value: "paidMembers" } },
          { kind: "Field", name: { kind: "Name", value: "spendMinor" } },
          { kind: "Field", name: { kind: "Name", value: "incomeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "closingBalanceMinor" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceMonthFieldsFragment, unknown>;
export const ClubFinanceRunwayFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceRunwayFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceRunway" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "runwayMonths" } },
          { kind: "Field", name: { kind: "Name", value: "projectedBalanceMinor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "months" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceMonthFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceMonthFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceMonth" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "currentMembers" } },
          { kind: "Field", name: { kind: "Name", value: "paidMembers" } },
          { kind: "Field", name: { kind: "Name", value: "spendMinor" } },
          { kind: "Field", name: { kind: "Name", value: "incomeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "closingBalanceMinor" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceRunwayFieldsFragment, unknown>;
export const ClubFinanceStockFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStockFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStock" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "openingBalanceMinor" } },
          { kind: "Field", name: { kind: "Name", value: "balanceBasis" } },
          { kind: "Field", name: { kind: "Name", value: "horizonMonths" } },
          { kind: "Field", name: { kind: "Name", value: "monthsOfCover" } },
          { kind: "Field", name: { kind: "Name", value: "evenlySpread" } },
          { kind: "Field", name: { kind: "Name", value: "disclosure" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "withIncome" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceRunwayFields" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceUnavailableFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceUnavailableFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceUnavailable" } },
      selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reasons" } }] },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceMonthFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceMonth" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "currentMembers" } },
          { kind: "Field", name: { kind: "Name", value: "paidMembers" } },
          { kind: "Field", name: { kind: "Name", value: "spendMinor" } },
          { kind: "Field", name: { kind: "Name", value: "incomeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "closingBalanceMinor" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceRunwayFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceRunway" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "runwayMonths" } },
          { kind: "Field", name: { kind: "Name", value: "projectedBalanceMinor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "months" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceMonthFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFinanceStockFieldsFragment, unknown>;
export const SimpleResultFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SimpleResultFieldsFragment, unknown>;
export const WebConfigFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hostingOption" } },
          { kind: "Field", name: { kind: "Name", value: "domainName" } },
          { kind: "Field", name: { kind: "Name", value: "clubUrl" } },
          { kind: "Field", name: { kind: "Name", value: "introductionText" } },
          { kind: "Field", name: { kind: "Name", value: "tagLine" } },
          { kind: "Field", name: { kind: "Name", value: "logoImage" } },
          { kind: "Field", name: { kind: "Name", value: "backgroundImage" } },
          { kind: "Field", name: { kind: "Name", value: "locationShortDesc" } },
          { kind: "Field", name: { kind: "Name", value: "mapLink" } },
          { kind: "Field", name: { kind: "Name", value: "meetingTimes" } },
          { kind: "Field", name: { kind: "Name", value: "metaDesc" } },
          { kind: "Field", name: { kind: "Name", value: "twitterLink" } },
          { kind: "Field", name: { kind: "Name", value: "facebookLink" } },
          { kind: "Field", name: { kind: "Name", value: "linkedInLink" } },
          { kind: "Field", name: { kind: "Name", value: "instagramLink" } },
          { kind: "Field", name: { kind: "Name", value: "youtubeLink" } },
          { kind: "Field", name: { kind: "Name", value: "meetupLink" } },
          { kind: "Field", name: { kind: "Name", value: "eventbriteLink" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebConfigFieldsFragment, unknown>;
export const WebConfigResultFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebConfigResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebConfigResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "refreshFailed" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebConfigFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hostingOption" } },
          { kind: "Field", name: { kind: "Name", value: "domainName" } },
          { kind: "Field", name: { kind: "Name", value: "clubUrl" } },
          { kind: "Field", name: { kind: "Name", value: "introductionText" } },
          { kind: "Field", name: { kind: "Name", value: "tagLine" } },
          { kind: "Field", name: { kind: "Name", value: "logoImage" } },
          { kind: "Field", name: { kind: "Name", value: "backgroundImage" } },
          { kind: "Field", name: { kind: "Name", value: "locationShortDesc" } },
          { kind: "Field", name: { kind: "Name", value: "mapLink" } },
          { kind: "Field", name: { kind: "Name", value: "meetingTimes" } },
          { kind: "Field", name: { kind: "Name", value: "metaDesc" } },
          { kind: "Field", name: { kind: "Name", value: "twitterLink" } },
          { kind: "Field", name: { kind: "Name", value: "facebookLink" } },
          { kind: "Field", name: { kind: "Name", value: "linkedInLink" } },
          { kind: "Field", name: { kind: "Name", value: "instagramLink" } },
          { kind: "Field", name: { kind: "Name", value: "youtubeLink" } },
          { kind: "Field", name: { kind: "Name", value: "meetupLink" } },
          { kind: "Field", name: { kind: "Name", value: "eventbriteLink" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebConfigResultFieldsFragment, unknown>;
export const GuestbookConfigFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GuestbookConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestbookConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "welcomeEmailEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "firstEmailBody" } },
          { kind: "Field", name: { kind: "Name", value: "returningGuestEmailBody" } },
          { kind: "Field", name: { kind: "Name", value: "reminderEmailBody" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GuestbookConfigFieldsFragment, unknown>;
export const GuestbookConfigResultFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GuestbookConfigResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestbookConfigResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GuestbookConfigFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GuestbookConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestbookConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "welcomeEmailEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "firstEmailBody" } },
          { kind: "Field", name: { kind: "Name", value: "returningGuestEmailBody" } },
          { kind: "Field", name: { kind: "Name", value: "reminderEmailBody" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GuestbookConfigResultFieldsFragment, unknown>;
export const CotOfficerStatusFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CotOfficerStatusFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "COTClubOfficerRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "distinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "completedDistinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "cotsCreditsEarned" } },
          { kind: "Field", name: { kind: "Name", value: "memberCreditsEarned" } },
          { kind: "Field", name: { kind: "Name", value: "memberDistinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "memberKey" } },
          { kind: "Field", name: { kind: "Name", value: "requiresManualAssignment" } },
          { kind: "Field", name: { kind: "Name", value: "isUnderCredited" } },
          { kind: "Field", name: { kind: "Name", value: "isScheduledNotTrained" } },
          { kind: "Field", name: { kind: "Name", value: "activeRegistrationEventIds" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CotOfficerStatusFieldsFragment, unknown>;
export const CotNotOfficerMarkFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "COTNotOfficerMarkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "COTNotOfficerMark" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "markedByName" } },
          { kind: "Field", name: { kind: "Name", value: "markedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CotNotOfficerMarkFieldsFragment, unknown>;
export const OfficerCotEventViewFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OfficerCOTEventViewFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OfficerCOTEventView" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isRegistrationOpenNow" } },
          { kind: "Field", name: { kind: "Name", value: "timeState" } },
          { kind: "Field", name: { kind: "Name", value: "isRegistered" } },
          { kind: "Field", name: { kind: "Name", value: "registeredCount" } },
          { kind: "Field", name: { kind: "Name", value: "isFull" } },
          { kind: "Field", name: { kind: "Name", value: "waitlistCount" } },
          { kind: "Field", name: { kind: "Name", value: "isWaitlisted" } },
          { kind: "Field", name: { kind: "Name", value: "waitlistPosition" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "knownClubRoles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                { kind: "Field", name: { kind: "Name", value: "roleAbbreviation" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "programId" } },
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                { kind: "Field", name: { kind: "Name", value: "requiredSessionCount" } },
                { kind: "Field", name: { kind: "Name", value: "registrationOpensAt" } },
                { kind: "Field", name: { kind: "Name", value: "registrationClosesAt" } },
                { kind: "Field", name: { kind: "Name", value: "externalRegistration" } },
                { kind: "Field", name: { kind: "Name", value: "isTest" } },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sessions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "dateTime" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                { kind: "Field", name: { kind: "Name", value: "joiningUrl" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "durationDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "maxAttendees" } },
                { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                { kind: "Field", name: { kind: "Name", value: "sessionTypeDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "timeState" } },
                { kind: "Field", name: { kind: "Name", value: "minimumDurationMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "attendanceCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "myRegistration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "registeredAt" } },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                { kind: "Field", name: { kind: "Name", value: "isCancelled" } },
                { kind: "Field", name: { kind: "Name", value: "isWaitlisted" } },
                { kind: "Field", name: { kind: "Name", value: "waitlistedAt" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "clubRole" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seekingCreditForRoles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationPrefs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "reminder24hBefore" } },
                      { kind: "Field", name: { kind: "Name", value: "attendanceConfirmation" } },
                      { kind: "Field", name: { kind: "Name", value: "creditEarned" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OfficerCotEventViewFieldsFragment, unknown>;
export const GuestRegistrationFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GuestRegistrationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestRegistration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "foundUsInfo" } },
          { kind: "Field", name: { kind: "Name", value: "creationDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastSignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "signingCount" } },
          { kind: "Field", name: { kind: "Name", value: "guestStatus" } },
          { kind: "Field", name: { kind: "Name", value: "lastEmailSent" } },
          { kind: "Field", name: { kind: "Name", value: "actionId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                { kind: "Field", name: { kind: "Name", value: "since" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "canMarkWorking" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GuestRegistrationFieldsFragment, unknown>;
export const FoundUsEntryFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FoundUsEntryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FoundUsEntry" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FoundUsEntryFieldsFragment, unknown>;
export const ClubLinkFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubLinkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubLinkFieldsFragment, unknown>;
export const MeetingMutationFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingMutationFieldsFragment, unknown>;
export const MeetingResultFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingResultFieldsFragment, unknown>;
export const DeleteResultFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeleteResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DeleteResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "deletedId" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteResultFieldsFragment, unknown>;
export const FinishMeetingResultFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinishMeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FinishMeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meeting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "speechesCredited" } },
                { kind: "Field", name: { kind: "Name", value: "rolesCredited" } },
                { kind: "Field", name: { kind: "Name", value: "speechesAttempted" } },
                { kind: "Field", name: { kind: "Name", value: "rolesAttempted" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FinishMeetingResultFieldsFragment, unknown>;
export const MeetingAttendanceSummaryFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalEligibleMembers" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpMaybeCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpNotAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "attendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "notAttendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "myRsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "myAttendanceStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingAttendanceSummaryFieldsFragment, unknown>;
export const MeetingAttendanceSummaryResultFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummaryResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalEligibleMembers" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpMaybeCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpNotAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "attendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "notAttendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "myRsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "myAttendanceStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingAttendanceSummaryResultFieldsFragment, unknown>;
export const MeetingUserFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingUserFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingUser" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingUserId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "guestId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "tiName" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "relationshipToClub" } },
          { kind: "Field", name: { kind: "Name", value: "isAssigneeNotified" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingUserFieldsFragment, unknown>;
export const AgendaItemFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgendaItemFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgendaItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "rolePosition" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "event" } },
          { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
          { kind: "Field", name: { kind: "Name", value: "greenMark" } },
          { kind: "Field", name: { kind: "Name", value: "amberMark" } },
          { kind: "Field", name: { kind: "Name", value: "redMark" } },
          { kind: "Field", name: { kind: "Name", value: "maxAssignments" } },
          { kind: "Field", name: { kind: "Name", value: "isCompleted" } },
          { kind: "Field", name: { kind: "Name", value: "isRepeatableRole" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignedUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pathwayProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathwayRoleTargets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roleRequests" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                { kind: "Field", name: { kind: "Name", value: "rejectionReason" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingUserFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingUser" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingUserId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "guestId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "tiName" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "relationshipToClub" } },
          { kind: "Field", name: { kind: "Name", value: "isAssigneeNotified" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgendaItemFieldsFragment, unknown>;
export const VotingRoomFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VotingRoomFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "VotingRoom" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "standardKey" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isOpen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "candidates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingUserId" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "guestId" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "voteCounts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "candidateId" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VotingRoomFieldsFragment, unknown>;
export const FeedbackSessionFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedbackSessionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedbackSession" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "isOpen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subjects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingUserId" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "guestId" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSubjectId" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSessionId" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
                { kind: "Field", name: { kind: "Name", value: "aspects" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromAttendee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "feedbackCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingUserFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingUser" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingUserId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "guestId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "tiName" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "relationshipToClub" } },
          { kind: "Field", name: { kind: "Name", value: "isAssigneeNotified" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeedbackSessionFieldsFragment, unknown>;
export const MeetingFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agenda" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AgendaItemFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "votingRooms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "VotingRoomFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbackSessions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FeedbackSessionFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "hasBeenFinishedBefore" } },
          { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "sourceAgendaTemplateId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectRequests" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rejections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejectedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingUserFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingUser" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingUserId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "guestId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "tiName" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "relationshipToClub" } },
          { kind: "Field", name: { kind: "Name", value: "isAssigneeNotified" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgendaItemFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgendaItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "rolePosition" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "event" } },
          { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
          { kind: "Field", name: { kind: "Name", value: "greenMark" } },
          { kind: "Field", name: { kind: "Name", value: "amberMark" } },
          { kind: "Field", name: { kind: "Name", value: "redMark" } },
          { kind: "Field", name: { kind: "Name", value: "maxAssignments" } },
          { kind: "Field", name: { kind: "Name", value: "isCompleted" } },
          { kind: "Field", name: { kind: "Name", value: "isRepeatableRole" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignedUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pathwayProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathwayRoleTargets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roleRequests" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                { kind: "Field", name: { kind: "Name", value: "rejectionReason" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VotingRoomFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "VotingRoom" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "standardKey" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isOpen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "candidates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingUserId" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "guestId" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "voteCounts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "candidateId" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedbackSessionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedbackSession" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "isOpen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subjects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingUserId" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "guestId" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSubjectId" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSessionId" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
                { kind: "Field", name: { kind: "Name", value: "aspects" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromAttendee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "feedbackCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingFieldsFragment, unknown>;
export const MeetingSummaryFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingSummaryFieldsFragment, unknown>;
export const ToastmasterRoleFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ToastmasterRoleFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ToastmasterRole" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "greenMark" } },
          { kind: "Field", name: { kind: "Name", value: "amberMark" } },
          { kind: "Field", name: { kind: "Name", value: "redMark" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "repeatable" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ToastmasterRoleFieldsFragment, unknown>;
export const ClubMemberSummaryFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubMemberSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubMemberSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "membershipStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubMemberSummaryFieldsFragment, unknown>;
export const ClubInfoSummaryFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubInfoSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubInfoSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "autoSyncAgendaToVoting" } },
                { kind: "Field", name: { kind: "Name", value: "autoAddAgendaToFeedback" } },
                { kind: "Field", name: { kind: "Name", value: "evaluatorVotingRoles" } },
                { kind: "Field", name: { kind: "Name", value: "allowMemberRoleSelfAssign" } },
                { kind: "Field", name: { kind: "Name", value: "memberSpeechRequestAdvanceDays" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "timezone" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubInfoSummaryFieldsFragment, unknown>;
export const MeetingRsvpRecordFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingRsvpRecordFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingRsvpRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingRsvpRecordFieldsFragment, unknown>;
export const MeetingAttendanceMemberRecordFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceMemberRecordFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceMemberRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceStatus" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceSource" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingAttendanceMemberRecordFieldsFragment, unknown>;
export const RoleProposalFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleProposalFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RoleProposal" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
          { kind: "Field", name: { kind: "Name", value: "slotIndex" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByRoleLabel" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
          { kind: "Field", name: { kind: "Name", value: "withdrawnAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoleProposalFieldsFragment, unknown>;
export const ClubOfficerFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubOfficerFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubOfficer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
          { kind: "Field", name: { kind: "Name", value: "termBegin" } },
          { kind: "Field", name: { kind: "Name", value: "termEnd" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubOfficerFieldsFragment, unknown>;
export const OfficerResultFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OfficerResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OfficerResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubOfficerFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubOfficerFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubOfficer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
          { kind: "Field", name: { kind: "Name", value: "termBegin" } },
          { kind: "Field", name: { kind: "Name", value: "termEnd" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OfficerResultFieldsFragment, unknown>;
export const SpeechCardFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpeechCardFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SpeechCard" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "memberName" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
          { kind: "Field", name: { kind: "Name", value: "isPlaced" } },
          { kind: "Field", name: { kind: "Name", value: "deliveredAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meeting" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "datetime" } },
                { kind: "Field", name: { kind: "Name", value: "theme" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "placement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayName" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "completionType" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "projectName" } },
                { kind: "Field", name: { kind: "Name", value: "isEducationSeries" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "provenance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "completionId" } },
                { kind: "Field", name: { kind: "Name", value: "creditMethod" } },
                { kind: "Field", name: { kind: "Name", value: "creditedBy" } },
                { kind: "Field", name: { kind: "Name", value: "creditedByName" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "creditedTitle" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "history" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventType" } },
                { kind: "Field", name: { kind: "Name", value: "occurredAt" } },
                { kind: "Field", name: { kind: "Name", value: "actorUserId" } },
                { kind: "Field", name: { kind: "Name", value: "actorName" } },
                { kind: "Field", name: { kind: "Name", value: "actorProcess" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                { kind: "Field", name: { kind: "Name", value: "provenance" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "field" } },
                      { kind: "Field", name: { kind: "Name", value: "from" } },
                      { kind: "Field", name: { kind: "Name", value: "to" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SpeechCardFieldsFragment, unknown>;
export const GetAdminDebugRepairPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminDebugRepairPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminDebugRepairPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "repair" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "outcome" } },
                { kind: "Field", name: { kind: "Name", value: "callerUserId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                { kind: "Field", name: { kind: "Name", value: "build" } },
                { kind: "Field", name: { kind: "Name", value: "runningBuild" } },
                { kind: "Field", name: { kind: "Name", value: "refusal" } },
                { kind: "Field", name: { kind: "Name", value: "planText" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminDebugRepairPlanQuery, GetAdminDebugRepairPlanQueryVariables>;
export const IssueAdminDebugRepairApprovalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "IssueAdminDebugRepairApproval" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "planId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminIssueDebugRepairApproval" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: { kind: "Variable", name: { kind: "Name", value: "planId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "planId" } },
                { kind: "Field", name: { kind: "Name", value: "approvalCode" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IssueAdminDebugRepairApprovalMutation, IssueAdminDebugRepairApprovalMutationVariables>;
export const AdminTriggerTmDataImportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminTriggerTMDataImport" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminTriggerTMDataImport" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminTriggerTmDataImportMutation, AdminTriggerTmDataImportMutationVariables>;
export const AdminTriggerClubImportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminTriggerClubImport" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminTriggerClubImport" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminTriggerClubImportMutation, AdminTriggerClubImportMutationVariables>;
export const AdminStartEasySpeakArchiveImportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminStartEasySpeakArchiveImport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "instance" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "easySpeakClubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "maxDate" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminStartEasySpeakArchiveImport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "instance" },
                value: { kind: "Variable", name: { kind: "Name", value: "instance" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "easySpeakClubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "easySpeakClubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "maxDate" },
                value: { kind: "Variable", name: { kind: "Name", value: "maxDate" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "accepted" } },
                { kind: "Field", name: { kind: "Name", value: "jobId" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStartEasySpeakArchiveImportMutation,
  AdminStartEasySpeakArchiveImportMutationVariables
>;
export const AdminCloseEasySpeakIdentityFlagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCloseEasySpeakIdentityFlags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "flagIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "resolution" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminCloseEasySpeakIdentityFlags" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "flagIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "flagIds" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "resolution" },
                value: { kind: "Variable", name: { kind: "Name", value: "resolution" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "closed" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCloseEasySpeakIdentityFlagsMutation,
  AdminCloseEasySpeakIdentityFlagsMutationVariables
>;
export const AdminRunEasySpeakAutoStageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminRunEasySpeakAutoStage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "instance" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubIds" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "maxClubs" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminRunEasySpeakAutoStage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "instance" },
                value: { kind: "Variable", name: { kind: "Name", value: "instance" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubIds" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "maxClubs" },
                value: { kind: "Variable", name: { kind: "Name", value: "maxClubs" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "accepted" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminRunEasySpeakAutoStageMutation, AdminRunEasySpeakAutoStageMutationVariables>;
export const AdminMintEasySpeakCaptureTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminMintEasySpeakCaptureToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "instance" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "label" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminMintEasySpeakCaptureToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "instance" },
                value: { kind: "Variable", name: { kind: "Name", value: "instance" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "label" },
                value: { kind: "Variable", name: { kind: "Name", value: "label" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "token" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "instance" } },
                      { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                      { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "lastUsedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "pagesUsed" } },
                      { kind: "Field", name: { kind: "Name", value: "maxPages" } },
                      { kind: "Field", name: { kind: "Name", value: "bytesUsed" } },
                      { kind: "Field", name: { kind: "Name", value: "maxBytes" } },
                      { kind: "Field", name: { kind: "Name", value: "live" } },
                      { kind: "Field", name: { kind: "Name", value: "refusedReason" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminMintEasySpeakCaptureTokenMutation, AdminMintEasySpeakCaptureTokenMutationVariables>;
export const AdminRevokeEasySpeakCaptureTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminRevokeEasySpeakCaptureToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminRevokeEasySpeakCaptureToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRevokeEasySpeakCaptureTokenMutation,
  AdminRevokeEasySpeakCaptureTokenMutationVariables
>;
export const AdminRequeueMutationOutboxRowsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminRequeueMutationOutboxRows" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminRequeueMutationOutboxRows" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: { kind: "Variable", name: { kind: "Name", value: "ids" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "requeued" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminRequeueMutationOutboxRowsMutation, AdminRequeueMutationOutboxRowsMutationVariables>;
export const GetAdminNudgesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminNudges" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminNudges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AdminNudgeFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AdminNudgeFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AdminNudge" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "minMembers" } },
          { kind: "Field", name: { kind: "Name", value: "maxMembers" } },
          { kind: "Field", name: { kind: "Name", value: "isDCPEligible" } },
          { kind: "Field", name: { kind: "Name", value: "minDCPPoints" } },
          { kind: "Field", name: { kind: "Name", value: "maxDCPPoints" } },
          { kind: "Field", name: { kind: "Name", value: "officersTrainedRnd1" } },
          { kind: "Field", name: { kind: "Name", value: "officersTrainedRnd2" } },
          { kind: "Field", name: { kind: "Name", value: "officerListSubmittedOnTime" } },
          { kind: "Field", name: { kind: "Name", value: "maxPossibleDCPPoints" } },
          { kind: "Field", name: { kind: "Name", value: "months" } },
          { kind: "Field", name: { kind: "Name", value: "suggestion" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminNudgesQuery, GetAdminNudgesQueryVariables>;
export const AdminSaveNudgeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminSaveNudge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Long" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "expectedVersion" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AdminNudgeInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminSaveNudge" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "expectedVersion" },
                value: { kind: "Variable", name: { kind: "Name", value: "expectedVersion" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nudge" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AdminNudgeFields" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AdminNudgeFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AdminNudge" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "minMembers" } },
          { kind: "Field", name: { kind: "Name", value: "maxMembers" } },
          { kind: "Field", name: { kind: "Name", value: "isDCPEligible" } },
          { kind: "Field", name: { kind: "Name", value: "minDCPPoints" } },
          { kind: "Field", name: { kind: "Name", value: "maxDCPPoints" } },
          { kind: "Field", name: { kind: "Name", value: "officersTrainedRnd1" } },
          { kind: "Field", name: { kind: "Name", value: "officersTrainedRnd2" } },
          { kind: "Field", name: { kind: "Name", value: "officerListSubmittedOnTime" } },
          { kind: "Field", name: { kind: "Name", value: "maxPossibleDCPPoints" } },
          { kind: "Field", name: { kind: "Name", value: "months" } },
          { kind: "Field", name: { kind: "Name", value: "suggestion" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminSaveNudgeMutation, AdminSaveNudgeMutationVariables>;
export const AdminSetNudgeEnabledDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminSetNudgeEnabled" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "enabled" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminSetNudgeEnabled" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "enabled" },
                value: { kind: "Variable", name: { kind: "Name", value: "enabled" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminSetNudgeEnabledMutation, AdminSetNudgeEnabledMutationVariables>;
export const AdminDeleteNudgeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteNudge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "expectedVersion" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminDeleteNudge" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "expectedVersion" },
                value: { kind: "Variable", name: { kind: "Name", value: "expectedVersion" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminDeleteNudgeMutation, AdminDeleteNudgeMutationVariables>;
export const GetAdminStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminStats" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminStats" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stats" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "properties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "config" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminStatsQuery, GetAdminStatsQueryVariables>;
export const GetAdminClubStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminClubStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminClubStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "shortName" } },
                { kind: "Field", name: { kind: "Name", value: "longName" } },
                { kind: "Field", name: { kind: "Name", value: "district" } },
                { kind: "Field", name: { kind: "Name", value: "division" } },
                { kind: "Field", name: { kind: "Name", value: "area" } },
                { kind: "Field", name: { kind: "Name", value: "memberCount" } },
                { kind: "Field", name: { kind: "Name", value: "guestbookEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "webHosting" } },
                { kind: "Field", name: { kind: "Name", value: "memberManagementEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "cardPaymentsEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "calendarEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "listedInTI" } },
                { kind: "Field", name: { kind: "Name", value: "isPioneerClub" } },
                { kind: "Field", name: { kind: "Name", value: "isCorporate" } },
                { kind: "Field", name: { kind: "Name", value: "newMemberFee" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyDues" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "charterDate" } },
                { kind: "Field", name: { kind: "Name", value: "tiStatus" } },
                { kind: "Field", name: { kind: "Name", value: "suspendDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminClubStatusQuery, GetAdminClubStatusQueryVariables>;
export const GetAdminUsageAnalyticsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminUsageAnalytics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "from" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "to" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "featureArea" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "officerOnly" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "converted" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminUsageAnalytics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "from" },
                value: { kind: "Variable", name: { kind: "Name", value: "from" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "to" },
                value: { kind: "Variable", name: { kind: "Name", value: "to" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "featureArea" },
                value: { kind: "Variable", name: { kind: "Name", value: "featureArea" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "officerOnly" },
                value: { kind: "Variable", name: { kind: "Name", value: "officerOnly" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "converted" },
                value: { kind: "Variable", name: { kind: "Name", value: "converted" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "fromDate" } },
                { kind: "Field", name: { kind: "Name", value: "toDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "kpis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uniqueUsers" } },
                      { kind: "Field", name: { kind: "Name", value: "uniqueClubs" } },
                      { kind: "Field", name: { kind: "Name", value: "trialConversionCount" } },
                      { kind: "Field", name: { kind: "Name", value: "trialConversionRate" } },
                      { kind: "Field", name: { kind: "Name", value: "faqViewCount" } },
                      { kind: "Field", name: { kind: "Name", value: "faqViewRate" } },
                      { kind: "Field", name: { kind: "Name", value: "docsClickCount" } },
                      { kind: "Field", name: { kind: "Name", value: "docsClickRate" } },
                      { kind: "Field", name: { kind: "Name", value: "returnedWithin7DaysCount" } },
                      { kind: "Field", name: { kind: "Name", value: "returnedWithin7DaysRate" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "funnel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "stepKey" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "userCount" } },
                      { kind: "Field", name: { kind: "Name", value: "dropOffCount" } },
                      { kind: "Field", name: { kind: "Name", value: "dropOffRate" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topRoutes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "segment" } },
                      { kind: "Field", name: { kind: "Name", value: "routeName" } },
                      { kind: "Field", name: { kind: "Name", value: "featureArea" } },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cohort" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                      { kind: "Field", name: { kind: "Name", value: "isOfficer" } },
                      { kind: "Field", name: { kind: "Name", value: "firstUnsubscribedVisitAt" } },
                      { kind: "Field", name: { kind: "Name", value: "firstKnownLoginAt" } },
                      { kind: "Field", name: { kind: "Name", value: "firstAction" } },
                      { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                      { kind: "Field", name: { kind: "Name", value: "converted" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminUsageAnalyticsQuery, GetAdminUsageAnalyticsQueryVariables>;
export const GetAdminTableStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminTableStats" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminTableStats" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tableName" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminTableStatsQuery, GetAdminTableStatsQueryVariables>;
export const AdminBrowseClubsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBrowseClubs" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminBrowseClubs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "shortName" } },
                { kind: "Field", name: { kind: "Name", value: "longName" } },
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "divisionCode" } },
                { kind: "Field", name: { kind: "Name", value: "areaNumber" } },
                { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                { kind: "Field", name: { kind: "Name", value: "listedInTI" } },
                { kind: "Field", name: { kind: "Name", value: "memberCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminBrowseClubsQuery, AdminBrowseClubsQueryVariables>;
export const AdminBrowseUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBrowseUsers" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminBrowseUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminBrowseUsersQuery, AdminBrowseUsersQueryVariables>;
export const AdminClubDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminClubDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminClubDetail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminClubDetailQuery, AdminClubDetailQueryVariables>;
export const AdminUserDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminUserDetail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminUserDetailQuery, AdminUserDetailQueryVariables>;
export const AdminBrowseGenericDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBrowseGeneric" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "typeName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminBrowseGeneric" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "typeName" },
                value: { kind: "Variable", name: { kind: "Name", value: "typeName" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminBrowseGenericQuery, AdminBrowseGenericQueryVariables>;
export const AdminDetailGenericDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminDetailGeneric" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "typeName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminDetailGeneric" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "typeName" },
                value: { kind: "Variable", name: { kind: "Name", value: "typeName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminDetailGenericQuery, AdminDetailGenericQueryVariables>;
export const AdminAvailableEmailAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAvailableEmailAccounts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminAvailableEmailAccounts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminAvailableEmailAccountsQuery, AdminAvailableEmailAccountsQueryVariables>;
export const GetAdminEmailLogDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminEmailLog" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "offset" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Long" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "limit" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Long" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipient" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subject" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "from" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "to" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminEmailLog" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: { kind: "Variable", name: { kind: "Name", value: "offset" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "Variable", name: { kind: "Name", value: "limit" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipient" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipient" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subject" },
                value: { kind: "Variable", name: { kind: "Name", value: "subject" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "from" },
                value: { kind: "Variable", name: { kind: "Name", value: "from" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "to" },
                value: { kind: "Variable", name: { kind: "Name", value: "to" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "offset" } },
                { kind: "Field", name: { kind: "Name", value: "limit" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubShortName" } },
                      { kind: "Field", name: { kind: "Name", value: "clubLongName" } },
                      { kind: "Field", name: { kind: "Name", value: "triggeredByUserId" } },
                      { kind: "Field", name: { kind: "Name", value: "activityType" } },
                      { kind: "Field", name: { kind: "Name", value: "emailCategory" } },
                      { kind: "Field", name: { kind: "Name", value: "templateKey" } },
                      { kind: "Field", name: { kind: "Name", value: "senderAccountId" } },
                      { kind: "Field", name: { kind: "Name", value: "fromAddress" } },
                      { kind: "Field", name: { kind: "Name", value: "replyToRecipients" } },
                      { kind: "Field", name: { kind: "Name", value: "toRecipients" } },
                      { kind: "Field", name: { kind: "Name", value: "ccRecipients" } },
                      { kind: "Field", name: { kind: "Name", value: "bccRecipients" } },
                      { kind: "Field", name: { kind: "Name", value: "subject" } },
                      { kind: "Field", name: { kind: "Name", value: "textBody" } },
                      { kind: "Field", name: { kind: "Name", value: "htmlBody" } },
                      { kind: "Field", name: { kind: "Name", value: "metadataJson" } },
                      { kind: "Field", name: { kind: "Name", value: "deliveryTrackingId" } },
                      { kind: "Field", name: { kind: "Name", value: "smtpMessageId" } },
                      { kind: "Field", name: { kind: "Name", value: "sendStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "failureReason" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminEmailLogQuery, GetAdminEmailLogQueryVariables>;
export const AdminSendClubEmailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminSendClubEmails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "fromAccountId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipientTypes" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "emailSubject" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "emailBodyMarkdown" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isTest" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminSendClubEmails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubIds" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromAccountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "fromAccountId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipientTypes" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipientTypes" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailSubject" },
                value: { kind: "Variable", name: { kind: "Name", value: "emailSubject" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailBodyMarkdown" },
                value: { kind: "Variable", name: { kind: "Name", value: "emailBodyMarkdown" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isTest" },
                value: { kind: "Variable", name: { kind: "Name", value: "isTest" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalClubs" } },
                { kind: "Field", name: { kind: "Name", value: "totalRecipients" } },
                { kind: "Field", name: { kind: "Name", value: "successfulSends" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "failures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "recipient" } },
                      { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminSendClubEmailsMutation, AdminSendClubEmailsMutationVariables>;
export const GetAdminEasySpeakCaptureDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminEasySpeakCapture" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminEasySpeakCapture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "ttlSeconds" } },
                { kind: "Field", name: { kind: "Name", value: "maxPages" } },
                { kind: "Field", name: { kind: "Name", value: "maxBytes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instances" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "host" } },
                      { kind: "Field", name: { kind: "Name", value: "archiveMarkerPresent" } },
                      { kind: "Field", name: { kind: "Name", value: "pending" } },
                      { kind: "Field", name: { kind: "Name", value: "captured" } },
                      { kind: "Field", name: { kind: "Name", value: "notFound" } },
                      { kind: "Field", name: { kind: "Name", value: "missing" } },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      { kind: "Field", name: { kind: "Name", value: "distinctClubs" } },
                      { kind: "Field", name: { kind: "Name", value: "totalBytes" } },
                      { kind: "Field", name: { kind: "Name", value: "lastCapturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "clubsKnown" } },
                      { kind: "Field", name: { kind: "Name", value: "clubsSeeded" } },
                      { kind: "Field", name: { kind: "Name", value: "clubListReadAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tokens" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "instance" } },
                      { kind: "Field", name: { kind: "Name", value: "createdByEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                      { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "lastUsedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "pagesUsed" } },
                      { kind: "Field", name: { kind: "Name", value: "maxPages" } },
                      { kind: "Field", name: { kind: "Name", value: "bytesUsed" } },
                      { kind: "Field", name: { kind: "Name", value: "maxBytes" } },
                      { kind: "Field", name: { kind: "Name", value: "live" } },
                      { kind: "Field", name: { kind: "Name", value: "refusedReason" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "archiveImportJobs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "jobId" } },
                      { kind: "Field", name: { kind: "Name", value: "instance" } },
                      { kind: "Field", name: { kind: "Name", value: "easySpeakClubId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "maxDate" } },
                      { kind: "Field", name: { kind: "Name", value: "dryRun" } },
                      { kind: "Field", name: { kind: "Name", value: "submittedByEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "durationMillis" } },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "considered" } },
                            { kind: "Field", name: { kind: "Name", value: "parsed" } },
                            { kind: "Field", name: { kind: "Name", value: "refused" } },
                            { kind: "Field", name: { kind: "Name", value: "meetingsWritten" } },
                            { kind: "Field", name: { kind: "Name", value: "attendanceRows" } },
                            { kind: "Field", name: { kind: "Name", value: "roleAssignments" } },
                            { kind: "Field", name: { kind: "Name", value: "stamped" } },
                            { kind: "Field", name: { kind: "Name", value: "usersTotal" } },
                            { kind: "Field", name: { kind: "Name", value: "usersUnmatched" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "refusals" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "easySpeakMeetingId" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "refusalsTruncated" } },
                      { kind: "Field", name: { kind: "Name", value: "warnings" } },
                      { kind: "Field", name: { kind: "Name", value: "warningsTruncated" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "autoStageLastRun" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "requestedByEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "startedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "finishedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "instance" } },
                      { kind: "Field", name: { kind: "Name", value: "clubIds" } },
                      { kind: "Field", name: { kind: "Name", value: "maxClubs" } },
                      { kind: "Field", name: { kind: "Name", value: "selected" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "considered" } },
                            { kind: "Field", name: { kind: "Name", value: "upToDate" } },
                            { kind: "Field", name: { kind: "Name", value: "submitted" } },
                            { kind: "Field", name: { kind: "Name", value: "staged" } },
                            { kind: "Field", name: { kind: "Name", value: "skipped" } },
                            { kind: "Field", name: { kind: "Name", value: "failed" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outcomes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "clubId" } },
                            { kind: "Field", name: { kind: "Name", value: "instance" } },
                            { kind: "Field", name: { kind: "Name", value: "easySpeakClubId" } },
                            { kind: "Field", name: { kind: "Name", value: "outcome" } },
                            { kind: "Field", name: { kind: "Name", value: "jobId" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminEasySpeakCaptureQuery, GetAdminEasySpeakCaptureQueryVariables>;
export const GetAdminEasySpeakSupportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminEasySpeakSupport" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminEasySpeakSupport" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "clubShortName" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "unsettledConflicts" } },
                { kind: "Field", name: { kind: "Name", value: "changedSinceDecided" } },
                { kind: "Field", name: { kind: "Name", value: "contestedMappings" } },
                { kind: "Field", name: { kind: "Name", value: "readError" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminEasySpeakSupportQuery, GetAdminEasySpeakSupportQueryVariables>;
export const GetAdminEasySpeakIdentityReviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminEasySpeakIdentityReview" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminEasySpeakIdentityReview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "instance" } },
                { kind: "Field", name: { kind: "Name", value: "easySpeakUserId" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identity" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "displayName" } },
                      { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "disputedAccounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "displayName" } },
                      { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flags" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                      { kind: "Field", name: { kind: "Name", value: "mappingId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "flaggedAccount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "displayName" } },
                            { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "flaggedByEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "flaggedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "mappingId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                      { kind: "Field", name: { kind: "Name", value: "easySpeakClubId" } },
                      { kind: "Field", name: { kind: "Name", value: "easySpeakDisplayName" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "namedAccount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "displayName" } },
                            { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "decisionRevision" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "actionRow" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "mappingId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                      { kind: "Field", name: { kind: "Name", value: "decisionRevision" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminEasySpeakIdentityReviewQuery, GetAdminEasySpeakIdentityReviewQueryVariables>;
export const GetAdminEasySpeakAutoStagePreviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminEasySpeakAutoStagePreview" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminEasySpeakAutoStagePreview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "scheduledEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "scheduledOperatorProblem" } },
                { kind: "Field", name: { kind: "Name", value: "running" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clubs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                      { kind: "Field", name: { kind: "Name", value: "instance" } },
                      { kind: "Field", name: { kind: "Name", value: "easySpeakClubId" } },
                      { kind: "Field", name: { kind: "Name", value: "decision" } },
                      { kind: "Field", name: { kind: "Name", value: "waiting" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminEasySpeakAutoStagePreviewQuery, GetAdminEasySpeakAutoStagePreviewQueryVariables>;
export const GetAdminMutationOutboxDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminMutationOutbox" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminMutationOutbox" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pending" } },
                { kind: "Field", name: { kind: "Name", value: "failedRowsTruncated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "failedRows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "aggregateType" } },
                      { kind: "Field", name: { kind: "Name", value: "aggregateKey" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "attempts" } },
                      { kind: "Field", name: { kind: "Name", value: "lastError" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "ageSeconds" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAdminMutationOutboxQuery, GetAdminMutationOutboxQueryVariables>;
export const CreateAgendaTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateAgendaTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItems" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "AgendaItemInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAgendaTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: { kind: "Variable", name: { kind: "Name", value: "description" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItems" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItems" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AgendaTemplateMutationFields" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgendaTemplateMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgendaTemplate" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agenda" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "event" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                { kind: "Field", name: { kind: "Name", value: "greenMark" } },
                { kind: "Field", name: { kind: "Name", value: "amberMark" } },
                { kind: "Field", name: { kind: "Name", value: "redMark" } },
                { kind: "Field", name: { kind: "Name", value: "maxAssignments" } },
                { kind: "Field", name: { kind: "Name", value: "isRepeatableRole" } },
                { kind: "Field", name: { kind: "Name", value: "rolePosition" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "itemCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAgendaTemplateMutation, CreateAgendaTemplateMutationVariables>;
export const UpdateAgendaTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateAgendaTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "templateId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItems" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "AgendaItemInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAgendaTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "templateId" },
                value: { kind: "Variable", name: { kind: "Name", value: "templateId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: { kind: "Variable", name: { kind: "Name", value: "description" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItems" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItems" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AgendaTemplateMutationFields" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgendaTemplateMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgendaTemplate" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agenda" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "event" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                { kind: "Field", name: { kind: "Name", value: "greenMark" } },
                { kind: "Field", name: { kind: "Name", value: "amberMark" } },
                { kind: "Field", name: { kind: "Name", value: "redMark" } },
                { kind: "Field", name: { kind: "Name", value: "maxAssignments" } },
                { kind: "Field", name: { kind: "Name", value: "isRepeatableRole" } },
                { kind: "Field", name: { kind: "Name", value: "rolePosition" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "itemCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAgendaTemplateMutation, UpdateAgendaTemplateMutationVariables>;
export const DeleteAgendaTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteAgendaTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "templateId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteAgendaTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "templateId" },
                value: { kind: "Variable", name: { kind: "Name", value: "templateId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "deletedId" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAgendaTemplateMutation, DeleteAgendaTemplateMutationVariables>;
export const SetDefaultAgendaTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetDefaultAgendaTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "templateId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setDefaultAgendaTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "templateId" },
                value: { kind: "Variable", name: { kind: "Name", value: "templateId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetDefaultAgendaTemplateMutation, SetDefaultAgendaTemplateMutationVariables>;
export const GetAgendaTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAgendaTemplates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agendaTemplates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "templates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AgendaTemplateFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "defaultTemplateId" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgendaTemplateFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgendaTemplate" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agenda" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "event" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                { kind: "Field", name: { kind: "Name", value: "greenMark" } },
                { kind: "Field", name: { kind: "Name", value: "amberMark" } },
                { kind: "Field", name: { kind: "Name", value: "redMark" } },
                { kind: "Field", name: { kind: "Name", value: "maxAssignments" } },
                { kind: "Field", name: { kind: "Name", value: "isRepeatableRole" } },
                { kind: "Field", name: { kind: "Name", value: "rolePosition" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "itemCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAgendaTemplatesQuery, GetAgendaTemplatesQueryVariables>;
export const ChatUpdatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "ChatUpdates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "nickname" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "chatUpdates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "chatId" },
                value: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "nickname" },
                value: { kind: "Variable", name: { kind: "Name", value: "nickname" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "eventType" } },
                { kind: "Field", name: { kind: "Name", value: "payload" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatUpdatesSubscription, ChatUpdatesSubscriptionVariables>;
export const GetClubFinanceSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubFinanceSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubFinanceSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "config" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceStoredConfigFields" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "openingBalances" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceOpeningBalanceFields" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceOptionFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cadenceOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceOptionFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceOptionFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "tiChargingCurrency" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredCostLineFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredCostLine" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "amountMinor" } },
          { kind: "Field", name: { kind: "Name", value: "cadence" } },
          { kind: "Field", name: { kind: "Name", value: "cadenceLabel" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "categoryLabel" } },
          { kind: "Field", name: { kind: "Name", value: "otherLabel" } },
          { kind: "Field", name: { kind: "Name", value: "occursOn" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredFxRateFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredFxRate" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rateMicros" } },
          { kind: "Field", name: { kind: "Name", value: "baseCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "quoteCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "enteredOn" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "meetingsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "cardFeeBasisPoints" } },
          { kind: "Field", name: { kind: "Name", value: "unpriceableReasons" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fxRate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceStoredFxRateFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "costLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceStoredCostLineFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceOpeningBalanceFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceOpeningBalance" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "postingId" } },
          { kind: "Field", name: { kind: "Name", value: "amountMinor" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "effectiveOn" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recordedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceOptionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceOption" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubFinanceSettingsQuery, GetClubFinanceSettingsQueryVariables>;
export const SaveClubFinanceConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SaveClubFinanceConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "config" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceConfigInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveClubFinanceConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "config" },
                value: { kind: "Variable", name: { kind: "Name", value: "config" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceStoredConfigFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredCostLineFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredCostLine" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "amountMinor" } },
          { kind: "Field", name: { kind: "Name", value: "cadence" } },
          { kind: "Field", name: { kind: "Name", value: "cadenceLabel" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "categoryLabel" } },
          { kind: "Field", name: { kind: "Name", value: "otherLabel" } },
          { kind: "Field", name: { kind: "Name", value: "occursOn" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredFxRateFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredFxRate" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rateMicros" } },
          { kind: "Field", name: { kind: "Name", value: "baseCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "quoteCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "enteredOn" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStoredConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStoredConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "meetingsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "cardFeeBasisPoints" } },
          { kind: "Field", name: { kind: "Name", value: "unpriceableReasons" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fxRate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceStoredFxRateFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "costLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceStoredCostLineFields" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveClubFinanceConfigMutation, SaveClubFinanceConfigMutationVariables>;
export const SetClubFinanceOpeningBalanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetClubFinanceOpeningBalance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "amountMinor" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "effectiveOn" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setClubFinanceOpeningBalance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "amountMinor" },
                value: { kind: "Variable", name: { kind: "Name", value: "amountMinor" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "effectiveOn" },
                value: { kind: "Variable", name: { kind: "Name", value: "effectiveOn" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: { kind: "Variable", name: { kind: "Name", value: "note" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceOpeningBalanceFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceOpeningBalanceFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceOpeningBalance" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "postingId" } },
          { kind: "Field", name: { kind: "Name", value: "amountMinor" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "effectiveOn" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recordedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetClubFinanceOpeningBalanceMutation, SetClubFinanceOpeningBalanceMutationVariables>;
export const GetClubFinanceProjectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubFinanceProjection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "overrides" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceOverridesInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubFinanceProjection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "overrides" },
                value: { kind: "Variable", name: { kind: "Name", value: "overrides" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "asOf" } },
                { kind: "Field", name: { kind: "Name", value: "overridden" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cohort" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceCohortFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flow" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceFlowFields" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceUnavailableFields" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stock" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceStockFields" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceUnavailableFields" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceUnavailableFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceUnavailable" } },
      selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reasons" } }] },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceCohortFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceCohort" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "paidMembers" } },
          { kind: "Field", name: { kind: "Name", value: "overdueMembers" } },
          { kind: "Field", name: { kind: "Name", value: "unknownMembers" } },
          { kind: "Field", name: { kind: "Name", value: "currentMembers" } },
          { kind: "Field", name: { kind: "Name", value: "countedOn" } },
          { kind: "Field", name: { kind: "Name", value: "overridden" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceCostItemFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceCostItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "categoryLabel" } },
          { kind: "Field", name: { kind: "Name", value: "annualMinor" } },
          { kind: "Field", name: { kind: "Name", value: "derivedFrom" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceConversionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceConversion" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rateMicros" } },
          { kind: "Field", name: { kind: "Name", value: "ratedOn" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceTIChargeFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceTICharge" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "memberCount" } },
          { kind: "Field", name: { kind: "Name", value: "periodsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "duesPerPeriodMinor" } },
          { kind: "Field", name: { kind: "Name", value: "chargeCurrency" } },
          { kind: "Field", name: { kind: "Name", value: "annualChargeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "convertedAnnualMinor" } },
          { kind: "Field", name: { kind: "Name", value: "cardFeeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "annualCostMinor" } },
          { kind: "Field", name: { kind: "Name", value: "assumedMemberPeriods" } },
          { kind: "Field", name: { kind: "Name", value: "newMembersCharged" } },
          { kind: "Field", name: { kind: "Name", value: "joinerChargeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "newMemberFeeMinor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "conversion" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceConversionFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceIncomeFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceIncome" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "monthlyDuesMinor" } },
          { kind: "Field", name: { kind: "Name", value: "annualIncomeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "annualSurplusMinor" } },
          { kind: "Field", name: { kind: "Name", value: "breakEvenMembers" } },
          { kind: "Field", name: { kind: "Name", value: "breakEvenUnreachable" } },
          { kind: "Field", name: { kind: "Name", value: "memberGap" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceRosterModelFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceRosterModel" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "retentionBasisPoints" } },
          { kind: "Field", name: { kind: "Name", value: "joinersPerMonth" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceFlowFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceFlow" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "annualRunningCostMinor" } },
          { kind: "Field", name: { kind: "Name", value: "oneOffMinorInWindow" } },
          { kind: "Field", name: { kind: "Name", value: "twelveMonthSpendMinor" } },
          { kind: "Field", name: { kind: "Name", value: "payingMembers" } },
          { kind: "Field", name: { kind: "Name", value: "disclosure" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterModel" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceRosterModelFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "costLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceCostItemFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "tiCharge" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceTIChargeFields" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceUnavailableFields" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "income" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceIncomeFields" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceUnavailableFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceMonthFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceMonth" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "currentMembers" } },
          { kind: "Field", name: { kind: "Name", value: "paidMembers" } },
          { kind: "Field", name: { kind: "Name", value: "spendMinor" } },
          { kind: "Field", name: { kind: "Name", value: "incomeMinor" } },
          { kind: "Field", name: { kind: "Name", value: "closingBalanceMinor" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceRunwayFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceRunway" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "runwayMonths" } },
          { kind: "Field", name: { kind: "Name", value: "projectedBalanceMinor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "months" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceMonthFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubFinanceStockFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubFinanceStock" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "openingBalanceMinor" } },
          { kind: "Field", name: { kind: "Name", value: "balanceBasis" } },
          { kind: "Field", name: { kind: "Name", value: "horizonMonths" } },
          { kind: "Field", name: { kind: "Name", value: "monthsOfCover" } },
          { kind: "Field", name: { kind: "Name", value: "evenlySpread" } },
          { kind: "Field", name: { kind: "Name", value: "disclosure" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "withIncome" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceRunwayFields" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClubFinanceUnavailableFields" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubFinanceProjectionQuery, GetClubFinanceProjectionQueryVariables>;
export const GetClubMetaByShortNameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubMetaByShortName" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubMetaByShortName" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "shortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "shortName" } },
                { kind: "Field", name: { kind: "Name", value: "longName" } },
                { kind: "Field", name: { kind: "Name", value: "isOnToastHost" } },
                { kind: "Field", name: { kind: "Name", value: "district" } },
                { kind: "Field", name: { kind: "Name", value: "division" } },
                { kind: "Field", name: { kind: "Name", value: "area" } },
                { kind: "Field", name: { kind: "Name", value: "timezone" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubMetaByShortNameQuery, GetClubMetaByShortNameQueryVariables>;
export const GetClubInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "shortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubConnection" } },
                { kind: "Field", name: { kind: "Name", value: "isOnToastHost" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publicInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "shortName" } },
                      { kind: "Field", name: { kind: "Name", value: "longName" } },
                      { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "district" } },
                      { kind: "Field", name: { kind: "Name", value: "division" } },
                      { kind: "Field", name: { kind: "Name", value: "area" } },
                      { kind: "Field", name: { kind: "Name", value: "tiStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "suspendDate" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "website" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "clubWebsite" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "webConfig" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "enabled" } },
                                  { kind: "Field", name: { kind: "Name", value: "hostingOption" } },
                                  { kind: "Field", name: { kind: "Name", value: "domainName" } },
                                  { kind: "Field", name: { kind: "Name", value: "clubUrl" } },
                                  { kind: "Field", name: { kind: "Name", value: "introductionText" } },
                                  { kind: "Field", name: { kind: "Name", value: "tagLine" } },
                                  { kind: "Field", name: { kind: "Name", value: "logoImage" } },
                                  { kind: "Field", name: { kind: "Name", value: "backgroundImage" } },
                                  { kind: "Field", name: { kind: "Name", value: "locationShortDesc" } },
                                  { kind: "Field", name: { kind: "Name", value: "mapLink" } },
                                  { kind: "Field", name: { kind: "Name", value: "meetingTimes" } },
                                  { kind: "Field", name: { kind: "Name", value: "metaDesc" } },
                                  { kind: "Field", name: { kind: "Name", value: "twitterLink" } },
                                  { kind: "Field", name: { kind: "Name", value: "facebookLink" } },
                                  { kind: "Field", name: { kind: "Name", value: "linkedInLink" } },
                                  { kind: "Field", name: { kind: "Name", value: "instagramLink" } },
                                  { kind: "Field", name: { kind: "Name", value: "youtubeLink" } },
                                  { kind: "Field", name: { kind: "Name", value: "meetupLink" } },
                                  { kind: "Field", name: { kind: "Name", value: "eventbriteLink" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "guestbookConfig" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "firstEmailBody" } },
                            { kind: "Field", name: { kind: "Name", value: "reminderEmailBody" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "calendar" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "isEnabled" } },
                            { kind: "Field", name: { kind: "Name", value: "configState" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "futureMeetings" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "startDate" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nextMeeting" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "startDate" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "memberCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "membershipStatus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "newMemberRegistrationEnabled" } },
                            { kind: "Field", name: { kind: "Name", value: "cardPaymentsEnabled" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clubOfficers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "termBegin" } },
                            { kind: "Field", name: { kind: "Name", value: "termEnd" } },
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "membershipId" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meetingSchedule" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "timezone" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "meetingPatterns" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "weekNumbers" } },
                                  { kind: "Field", name: { kind: "Name", value: "dayOfWeek" } },
                                  { kind: "Field", name: { kind: "Name", value: "startTime" } },
                                  { kind: "Field", name: { kind: "Name", value: "durationHours" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "exclusions" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meetingConfig" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "autoSyncAgendaToVoting" } },
                            { kind: "Field", name: { kind: "Name", value: "autoAddAgendaToFeedback" } },
                            { kind: "Field", name: { kind: "Name", value: "evaluatorVotingRoles" } },
                            { kind: "Field", name: { kind: "Name", value: "allowMemberRoleSelfAssign" } },
                            { kind: "Field", name: { kind: "Name", value: "memberSpeechRequestAdvanceDays" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "managerInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "easyspeakId" } },
                      { kind: "Field", name: { kind: "Name", value: "easyspeakInstance" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "guestbook" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "firstEmailBody" } },
                            { kind: "Field", name: { kind: "Name", value: "reminderEmailBody" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "periodicEmail" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notificationPreferences" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "copyInboxOnMeetingRole" } },
                            { kind: "Field", name: { kind: "Name", value: "copyInboxOnMembership" } },
                            { kind: "Field", name: { kind: "Name", value: "copyInboxOnGuest" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "listedInTI" } },
                      { kind: "Field", name: { kind: "Name", value: "guestCount" } },
                      { kind: "Field", name: { kind: "Name", value: "memberCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "membershipStatus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "newMemberRegistrationEnabled" } },
                            { kind: "Field", name: { kind: "Name", value: "cardPaymentsEnabled" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "stripeConnected" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clubOfficers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "termBegin" } },
                            { kind: "Field", name: { kind: "Name", value: "termEnd" } },
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "membershipId" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailConfiguration" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
                            { kind: "Field", name: { kind: "Name", value: "emailPassword" } },
                            { kind: "Field", name: { kind: "Name", value: "imapServer" } },
                            { kind: "Field", name: { kind: "Name", value: "smtpServer" } },
                            { kind: "Field", name: { kind: "Name", value: "smtpPort" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "dcpData" } },
                { kind: "Field", name: { kind: "Name", value: "clubMeetingsId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubInfoQuery, GetClubInfoQueryVariables>;
export const GetEasySpeakInstancesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEasySpeakInstances" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "easySpeakInstances" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "host" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEasySpeakInstancesQuery, GetEasySpeakInstancesQueryVariables>;
export const GetEasySpeakMeetingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEasySpeakMeetings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "mappingId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Long" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "easySpeakMeetings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "mappingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "mappingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "easySpeakMeetingId" } },
                { kind: "Field", name: { kind: "Name", value: "meetingNumber" } },
                { kind: "Field", name: { kind: "Name", value: "meetingDate" } },
                { kind: "Field", name: { kind: "Name", value: "theme" } },
                { kind: "Field", name: { kind: "Name", value: "isImported" } },
                { kind: "Field", name: { kind: "Name", value: "isUpcoming" } },
                { kind: "Field", name: { kind: "Name", value: "easySpeakUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "people" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "mappingId" } },
                      { kind: "Field", name: { kind: "Name", value: "easySpeakUserId" } },
                      { kind: "Field", name: { kind: "Name", value: "easySpeakName" } },
                      { kind: "Field", name: { kind: "Name", value: "attended" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "toasthostName" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "roleName" } },
                            { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEasySpeakMeetingsQuery, GetEasySpeakMeetingsQueryVariables>;
export const GetClubWebConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubWebConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubWebConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "hostingOption" } },
                { kind: "Field", name: { kind: "Name", value: "domainName" } },
                { kind: "Field", name: { kind: "Name", value: "clubUrl" } },
                { kind: "Field", name: { kind: "Name", value: "introductionText" } },
                { kind: "Field", name: { kind: "Name", value: "tagLine" } },
                { kind: "Field", name: { kind: "Name", value: "logoImage" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundImage" } },
                { kind: "Field", name: { kind: "Name", value: "locationShortDesc" } },
                { kind: "Field", name: { kind: "Name", value: "mapLink" } },
                { kind: "Field", name: { kind: "Name", value: "meetingTimes" } },
                { kind: "Field", name: { kind: "Name", value: "metaDesc" } },
                { kind: "Field", name: { kind: "Name", value: "twitterLink" } },
                { kind: "Field", name: { kind: "Name", value: "facebookLink" } },
                { kind: "Field", name: { kind: "Name", value: "linkedInLink" } },
                { kind: "Field", name: { kind: "Name", value: "instagramLink" } },
                { kind: "Field", name: { kind: "Name", value: "youtubeLink" } },
                { kind: "Field", name: { kind: "Name", value: "meetupLink" } },
                { kind: "Field", name: { kind: "Name", value: "eventbriteLink" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "clubTiWebsiteMismatch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tiUrl" } },
                { kind: "Field", name: { kind: "Name", value: "effectiveUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubWebConfigQuery, GetClubWebConfigQueryVariables>;
export const GetClubImagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubImages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubImages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "imageName" } },
                { kind: "Field", name: { kind: "Name", value: "uploadDate" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubImagesQuery, GetClubImagesQueryVariables>;
export const GetClubMemberSummariesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubMemberSummaries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubMemberSummaries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
                { kind: "Field", name: { kind: "Name", value: "membershipStatus" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubMemberSummariesQuery, GetClubMemberSummariesQueryVariables>;
export const GetClubActivityLogDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubActivityLog" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "offset" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubActivityLog" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: { kind: "Variable", name: { kind: "Name", value: "offset" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "activityType" } },
                      { kind: "Field", name: { kind: "Name", value: "activityTypeDisplayName" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "shortDesc" } },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "isLegacyLocalTime" } },
                      { kind: "Field", name: { kind: "Name", value: "info" } },
                      { kind: "Field", name: { kind: "Name", value: "emailLogId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "displayName" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubActivityLogQuery, GetClubActivityLogQueryVariables>;
export const UpdateClubConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateClubConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "longName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "contactEmail" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "periodicEmail" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingSchedule" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "MeetingScheduleInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingConfig" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ClubMeetingConfigInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateClubConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "shortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "longName" },
                value: { kind: "Variable", name: { kind: "Name", value: "longName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "contactEmail" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "periodicEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "periodicEmail" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingSchedule" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingSchedule" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingConfig" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingConfig" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClubConfigMutation, UpdateClubConfigMutationVariables>;
export const SetClubEasySpeakMappingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetClubEasySpeakMapping" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "easyspeakId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "easyspeakInstance" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setClubEasySpeakMapping" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "easyspeakId" },
                value: { kind: "Variable", name: { kind: "Name", value: "easyspeakId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "easyspeakInstance" },
                value: { kind: "Variable", name: { kind: "Name", value: "easyspeakInstance" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetClubEasySpeakMappingMutation, SetClubEasySpeakMappingMutationVariables>;
export const UpdateNotificationPreferencesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateNotificationPreferences" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "copyInboxOnMeetingRole" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "copyInboxOnMembership" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "copyInboxOnGuest" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateNotificationPreferences" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "copyInboxOnMeetingRole" },
                value: { kind: "Variable", name: { kind: "Name", value: "copyInboxOnMeetingRole" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "copyInboxOnMembership" },
                value: { kind: "Variable", name: { kind: "Name", value: "copyInboxOnMembership" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "copyInboxOnGuest" },
                value: { kind: "Variable", name: { kind: "Name", value: "copyInboxOnGuest" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;
export const UpdateWebConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateWebConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "hostingOption" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "HostingOptionInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "domainName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubUrl" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "introductionText" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tagLine" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "logoImage" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "backgroundImage" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "locationShortDesc" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "mapLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingTimes" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "metaDesc" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "twitterLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "facebookLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "linkedInLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "instagramLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "youtubeLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetupLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventbriteLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateWebConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hostingOption" },
                value: { kind: "Variable", name: { kind: "Name", value: "hostingOption" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "domainName" },
                value: { kind: "Variable", name: { kind: "Name", value: "domainName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubUrl" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubUrl" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "introductionText" },
                value: { kind: "Variable", name: { kind: "Name", value: "introductionText" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tagLine" },
                value: { kind: "Variable", name: { kind: "Name", value: "tagLine" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "logoImage" },
                value: { kind: "Variable", name: { kind: "Name", value: "logoImage" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "backgroundImage" },
                value: { kind: "Variable", name: { kind: "Name", value: "backgroundImage" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationShortDesc" },
                value: { kind: "Variable", name: { kind: "Name", value: "locationShortDesc" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "mapLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "mapLink" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingTimes" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingTimes" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "metaDesc" },
                value: { kind: "Variable", name: { kind: "Name", value: "metaDesc" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "twitterLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "twitterLink" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "facebookLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "facebookLink" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "linkedInLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "linkedInLink" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "instagramLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "instagramLink" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "youtubeLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "youtubeLink" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetupLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetupLink" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventbriteLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventbriteLink" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebConfigResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hostingOption" } },
          { kind: "Field", name: { kind: "Name", value: "domainName" } },
          { kind: "Field", name: { kind: "Name", value: "clubUrl" } },
          { kind: "Field", name: { kind: "Name", value: "introductionText" } },
          { kind: "Field", name: { kind: "Name", value: "tagLine" } },
          { kind: "Field", name: { kind: "Name", value: "logoImage" } },
          { kind: "Field", name: { kind: "Name", value: "backgroundImage" } },
          { kind: "Field", name: { kind: "Name", value: "locationShortDesc" } },
          { kind: "Field", name: { kind: "Name", value: "mapLink" } },
          { kind: "Field", name: { kind: "Name", value: "meetingTimes" } },
          { kind: "Field", name: { kind: "Name", value: "metaDesc" } },
          { kind: "Field", name: { kind: "Name", value: "twitterLink" } },
          { kind: "Field", name: { kind: "Name", value: "facebookLink" } },
          { kind: "Field", name: { kind: "Name", value: "linkedInLink" } },
          { kind: "Field", name: { kind: "Name", value: "instagramLink" } },
          { kind: "Field", name: { kind: "Name", value: "youtubeLink" } },
          { kind: "Field", name: { kind: "Name", value: "meetupLink" } },
          { kind: "Field", name: { kind: "Name", value: "eventbriteLink" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebConfigResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebConfigResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "refreshFailed" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebConfigFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWebConfigMutation, UpdateWebConfigMutationVariables>;
export const UpdateGuestbookConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateGuestbookConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "enabled" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "firstEmailBody" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "returningGuestEmailBody" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reminderEmailBody" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateGuestbookConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "enabled" },
                value: { kind: "Variable", name: { kind: "Name", value: "enabled" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstEmailBody" },
                value: { kind: "Variable", name: { kind: "Name", value: "firstEmailBody" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "returningGuestEmailBody" },
                value: { kind: "Variable", name: { kind: "Name", value: "returningGuestEmailBody" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reminderEmailBody" },
                value: { kind: "Variable", name: { kind: "Name", value: "reminderEmailBody" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GuestbookConfigResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GuestbookConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestbookConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "welcomeEmailEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "firstEmailBody" } },
          { kind: "Field", name: { kind: "Name", value: "returningGuestEmailBody" } },
          { kind: "Field", name: { kind: "Name", value: "reminderEmailBody" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GuestbookConfigResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestbookConfigResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GuestbookConfigFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateGuestbookConfigMutation, UpdateGuestbookConfigMutationVariables>;
export const DeleteClubImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteClubImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "imageName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteClubImage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "imageName" },
                value: { kind: "Variable", name: { kind: "Name", value: "imageName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "wasLogoImage" } },
                { kind: "Field", name: { kind: "Name", value: "wasBackgroundImage" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteClubImageMutation, DeleteClubImageMutationVariables>;
export const UpdateEmailConfigurationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateEmailConfiguration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "emailConfig" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "EmailConfigInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateEmailConfiguration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailConfig" },
                value: { kind: "Variable", name: { kind: "Name", value: "emailConfig" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEmailConfigurationMutation, UpdateEmailConfigurationMutationVariables>;
export const TestEmailConfigurationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TestEmailConfiguration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "emailConfig" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "EmailConfigInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "testEmailConfiguration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailConfig" },
                value: { kind: "Variable", name: { kind: "Name", value: "emailConfig" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TestEmailConfigurationMutation, TestEmailConfigurationMutationVariables>;
export const TriggerPeriodicEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TriggerPeriodicEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "triggerPeriodicEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TriggerPeriodicEmailMutation, TriggerPeriodicEmailMutationVariables>;
export const GetClubIdByShortNameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubIdByShortName" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubIdByShortName" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "shortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubIdByShortNameQuery, GetClubIdByShortNameQueryVariables>;
export const CheckShortNameAvailabilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CheckShortNameAvailability" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "currentClubId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkShortNameAvailability" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "shortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "shortName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "currentClubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "currentClubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "available" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckShortNameAvailabilityQuery, CheckShortNameAvailabilityQueryVariables>;
export const GetClubHierarchyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubHierarchy" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubHierarchy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "districtName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "divisions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "areas" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "areaId" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "clubs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "clubNumber" } },
                                  { kind: "Field", name: { kind: "Name", value: "clubShortName" } },
                                  { kind: "Field", name: { kind: "Name", value: "clubLongName" } },
                                  { kind: "Field", name: { kind: "Name", value: "isActive" } },
                                  { kind: "Field", name: { kind: "Name", value: "isSuspended" } },
                                  { kind: "Field", name: { kind: "Name", value: "tiStatus" } },
                                  { kind: "Field", name: { kind: "Name", value: "suspendDate" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubHierarchyQuery, GetClubHierarchyQueryVariables>;
export const SearchTiClubsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchTIClubs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "limit" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchTIClubs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "Variable", name: { kind: "Name", value: "limit" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubNumber" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "district" } },
                { kind: "Field", name: { kind: "Name", value: "division" } },
                { kind: "Field", name: { kind: "Name", value: "area" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "meetingDay" } },
                { kind: "Field", name: { kind: "Name", value: "isOnToastHost" } },
                { kind: "Field", name: { kind: "Name", value: "isProspective" } },
                { kind: "Field", name: { kind: "Name", value: "clubShortName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchTiClubsQuery, SearchTiClubsQueryVariables>;
export const ActivateClubDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ActivateClub" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubNumber" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activateClub" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubNumber" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "clubShortName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivateClubMutation, ActivateClubMutationVariables>;
export const GetPeriodicEmailPreviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPeriodicEmailPreview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "periodicEmailPreview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "emailHtml" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPeriodicEmailPreviewQuery, GetPeriodicEmailPreviewQueryVariables>;
export const CreateCotEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateCOTEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requiredSessionCount" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationOpensAt" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationClosesAt" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "externalRegistration" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isTest" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCOTEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: { kind: "Variable", name: { kind: "Name", value: "description" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requiredSessionCount" },
                value: { kind: "Variable", name: { kind: "Name", value: "requiredSessionCount" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationOpensAt" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationOpensAt" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationClosesAt" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationClosesAt" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "externalRegistration" },
                value: { kind: "Variable", name: { kind: "Name", value: "externalRegistration" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isTest" },
                value: { kind: "Variable", name: { kind: "Name", value: "isTest" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "isTest" } },
                      { kind: "Field", name: { kind: "Name", value: "programId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationCount" } },
                      { kind: "Field", name: { kind: "Name", value: "matchedCount" } },
                      { kind: "Field", name: { kind: "Name", value: "unmatchedCount" } },
                      { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "requiredSessionCount" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationOpensAt" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationClosesAt" } },
                      { kind: "Field", name: { kind: "Name", value: "externalRegistration" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCotEventMutation, CreateCotEventMutationVariables>;
export const DeleteCotEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteCOTEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCOTEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "deletedId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCotEventMutation, DeleteCotEventMutationVariables>;
export const UpdateCotEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCOTEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requiredSessionCount" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationOpensAt" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationClosesAt" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "externalRegistration" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCOTEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: { kind: "Variable", name: { kind: "Name", value: "description" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requiredSessionCount" },
                value: { kind: "Variable", name: { kind: "Name", value: "requiredSessionCount" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationOpensAt" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationOpensAt" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationClosesAt" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationClosesAt" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "externalRegistration" },
                value: { kind: "Variable", name: { kind: "Name", value: "externalRegistration" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "programId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "requiredSessionCount" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationOpensAt" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationClosesAt" } },
                      { kind: "Field", name: { kind: "Name", value: "externalRegistration" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCotEventMutation, UpdateCotEventMutationVariables>;
export const PublishCotEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PublishCOTEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publishCOTEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishCotEventMutation, PublishCotEventMutationVariables>;
export const UnpublishCotEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UnpublishCOTEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unpublishCOTEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnpublishCotEventMutation, UnpublishCotEventMutationVariables>;
export const CancelCotEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelCOTEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reason" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelCOTEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: { kind: "Variable", name: { kind: "Name", value: "reason" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                      { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelCotEventMutation, CancelCotEventMutationVariables>;
export const CreateCotSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateCOTSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateTime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "location" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "joiningUrl" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "duration" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "maxAttendees" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionType" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCOTSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: { kind: "Variable", name: { kind: "Name", value: "description" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "dateTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "location" },
                value: { kind: "Variable", name: { kind: "Name", value: "location" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "joiningUrl" },
                value: { kind: "Variable", name: { kind: "Name", value: "joiningUrl" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "duration" },
                value: { kind: "Variable", name: { kind: "Name", value: "duration" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "maxAttendees" },
                value: { kind: "Variable", name: { kind: "Name", value: "maxAttendees" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionType" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionType" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "session" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "eventId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "dateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "location" } },
                      { kind: "Field", name: { kind: "Name", value: "joiningUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "duration" } },
                      { kind: "Field", name: { kind: "Name", value: "durationDisplay" } },
                      { kind: "Field", name: { kind: "Name", value: "maxAttendees" } },
                      { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                      { kind: "Field", name: { kind: "Name", value: "sessionTypeDisplay" } },
                      { kind: "Field", name: { kind: "Name", value: "minimumDurationMinutes" } },
                      { kind: "Field", name: { kind: "Name", value: "attendanceCount" } },
                      { kind: "Field", name: { kind: "Name", value: "qualifyingAttendanceCount" } },
                      { kind: "Field", name: { kind: "Name", value: "isFull" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCotSessionMutation, CreateCotSessionMutationVariables>;
export const UpdateCotSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCOTSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "location" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "joiningUrl" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "duration" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "maxAttendees" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionType" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCOTSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: { kind: "Variable", name: { kind: "Name", value: "description" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "dateTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "location" },
                value: { kind: "Variable", name: { kind: "Name", value: "location" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "joiningUrl" },
                value: { kind: "Variable", name: { kind: "Name", value: "joiningUrl" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "duration" },
                value: { kind: "Variable", name: { kind: "Name", value: "duration" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "maxAttendees" },
                value: { kind: "Variable", name: { kind: "Name", value: "maxAttendees" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionType" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionType" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "session" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "eventId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "dateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "location" } },
                      { kind: "Field", name: { kind: "Name", value: "joiningUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "duration" } },
                      { kind: "Field", name: { kind: "Name", value: "durationDisplay" } },
                      { kind: "Field", name: { kind: "Name", value: "maxAttendees" } },
                      { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                      { kind: "Field", name: { kind: "Name", value: "sessionTypeDisplay" } },
                      { kind: "Field", name: { kind: "Name", value: "minimumDurationMinutes" } },
                      { kind: "Field", name: { kind: "Name", value: "attendanceCount" } },
                      { kind: "Field", name: { kind: "Name", value: "qualifyingAttendanceCount" } },
                      { kind: "Field", name: { kind: "Name", value: "isFull" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCotSessionMutation, UpdateCotSessionMutationVariables>;
export const MarkCotAttendanceLiveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MarkCOTAttendanceLive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationEmails" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationIds" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markCOTAttendanceLive" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationEmails" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationEmails" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationIds" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "registrationEmail" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attendance" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "joinTime" } },
                            { kind: "Field", name: { kind: "Name", value: "leaveTime" } },
                            { kind: "Field", name: { kind: "Name", value: "durationMinutes" } },
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                            { kind: "Field", name: { kind: "Name", value: "club" } },
                            { kind: "Field", name: { kind: "Name", value: "source" } },
                            { kind: "Field", name: { kind: "Name", value: "registrationId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "session" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attendance" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "source" } },
                            { kind: "Field", name: { kind: "Name", value: "durationMinutes" } },
                            { kind: "Field", name: { kind: "Name", value: "registrationId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkCotAttendanceLiveMutation, MarkCotAttendanceLiveMutationVariables>;
export const UnmarkCotAttendanceLiveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UnmarkCOTAttendanceLive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationEmails" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationIds" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unmarkCOTAttendanceLive" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationEmails" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationEmails" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationIds" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "session" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attendance" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "source" } },
                            { kind: "Field", name: { kind: "Name", value: "durationMinutes" } },
                            { kind: "Field", name: { kind: "Name", value: "registrationId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnmarkCotAttendanceLiveMutation, UnmarkCotAttendanceLiveMutationVariables>;
export const DeleteCotSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteCOTSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCOTSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "deletedId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCotSessionMutation, DeleteCotSessionMutationVariables>;
export const AddCotManualAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddCOTManualAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "club" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "joinTime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "leaveTime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addCOTManualAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "club" },
                value: { kind: "Variable", name: { kind: "Name", value: "club" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "role" },
                value: { kind: "Variable", name: { kind: "Name", value: "role" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "joinTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "joinTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "leaveTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "leaveTime" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "recordsProcessed" } },
                { kind: "Field", name: { kind: "Name", value: "recordsMatched" } },
                { kind: "Field", name: { kind: "Name", value: "recordsUnmatched" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCotManualAttendanceMutation, AddCotManualAttendanceMutationVariables>;
export const UpdateCotAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCOTAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "originalEmail" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "club" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "joinTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "leaveTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "attendanceRegistrationId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCOTAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "originalEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "originalEmail" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attendanceRegistrationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "attendanceRegistrationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "club" },
                value: { kind: "Variable", name: { kind: "Name", value: "club" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "role" },
                value: { kind: "Variable", name: { kind: "Name", value: "role" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "joinTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "joinTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "leaveTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "leaveTime" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attendance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "joinTime" } },
                      { kind: "Field", name: { kind: "Name", value: "leaveTime" } },
                      { kind: "Field", name: { kind: "Name", value: "durationMinutes" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "club" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCotAttendanceMutation, UpdateCotAttendanceMutationVariables>;
export const DeleteCotAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteCOTAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "attendanceRegistrationId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCOTAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attendanceRegistrationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "attendanceRegistrationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attendance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "durationMinutes" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "club" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCotAttendanceMutation, DeleteCotAttendanceMutationVariables>;
export const OverrideCotOfficerRecordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OverrideCOTOfficerRecord" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "correctedName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "correctedEmail" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "correctedMembershipNumber" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "correctedUserId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notes" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "overrideCOTOfficerRecord" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "correctedName" },
                value: { kind: "Variable", name: { kind: "Name", value: "correctedName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "correctedEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "correctedEmail" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "correctedMembershipNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "correctedMembershipNumber" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "correctedUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "correctedUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "notes" },
                value: { kind: "Variable", name: { kind: "Name", value: "notes" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "recordId" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "membershipNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
                      { kind: "Field", name: { kind: "Name", value: "isMatched" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveName" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveMembershipNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveUserId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recordOverride" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "overriddenBy" } },
                            { kind: "Field", name: { kind: "Name", value: "overriddenAt" } },
                            { kind: "Field", name: { kind: "Name", value: "correctedName" } },
                            { kind: "Field", name: { kind: "Name", value: "correctedEmail" } },
                            { kind: "Field", name: { kind: "Name", value: "correctedMembershipNumber" } },
                            { kind: "Field", name: { kind: "Name", value: "correctedUserId" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OverrideCotOfficerRecordMutation, OverrideCotOfficerRecordMutationVariables>;
export const UnmergeCotOfficerRecordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UnmergeCOTOfficerRecord" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "mergedFromEmail" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unmergeCOTOfficerRecord" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "mergedFromEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "mergedFromEmail" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "recordId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "mergedFromEmails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnmergeCotOfficerRecordMutation, UnmergeCotOfficerRecordMutationVariables>;
export const UpdateCotOfficerClubRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCOTOfficerClubRoles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubRoles" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "COTOfficerClubRoleInput" } },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "expectedClubRolesToken" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCOTOfficerClubRoles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubRoles" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubRoles" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "expectedClubRolesToken" },
                value: { kind: "Variable", name: { kind: "Name", value: "expectedClubRolesToken" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "recordId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCotOfficerClubRolesMutation, UpdateCotOfficerClubRolesMutationVariables>;
export const AddCotOfficerNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddCOTOfficerNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addCOTOfficerNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: { kind: "Variable", name: { kind: "Name", value: "note" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "recordId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCotOfficerNoteMutation, AddCotOfficerNoteMutationVariables>;
export const SetCotManualRoleAssignmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetCOTManualRoleAssignments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roleAssignments" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "COTManualRoleAssignmentInput" } },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "expectedAssignmentToken" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setCOTManualRoleAssignments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roleAssignments" },
                value: { kind: "Variable", name: { kind: "Name", value: "roleAssignments" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "expectedAssignmentToken" },
                value: { kind: "Variable", name: { kind: "Name", value: "expectedAssignmentToken" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "recordId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCotManualRoleAssignmentsMutation, SetCotManualRoleAssignmentsMutationVariables>;
export const AddCotManualTrainingCreditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddCOTManualTrainingCredit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reason" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "trainingDate" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "trainingDescription" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addCOTManualTrainingCredit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: { kind: "Variable", name: { kind: "Name", value: "reason" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "trainingDate" },
                value: { kind: "Variable", name: { kind: "Name", value: "trainingDate" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "trainingDescription" },
                value: { kind: "Variable", name: { kind: "Name", value: "trainingDescription" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "recordId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCotManualTrainingCreditMutation, AddCotManualTrainingCreditMutationVariables>;
export const RemoveCotManualTrainingCreditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveCOTManualTrainingCredit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "creditId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeCOTManualTrainingCredit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "creditId" },
                value: { kind: "Variable", name: { kind: "Name", value: "creditId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "recordId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveCotManualTrainingCreditMutation, RemoveCotManualTrainingCreditMutationVariables>;
export const LinkCotRegistrationToOfficerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LinkCOTRegistrationToOfficer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "targetOfficerEmail" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "targetOfficerRecordId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "createFromMember" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "createNew" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubRoles" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "COTOfficerClubRoleInput" } },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "targetClubId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notes" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "linkCOTRegistrationToOfficer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetOfficerEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "targetOfficerEmail" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetOfficerRecordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "targetOfficerRecordId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "createFromMember" },
                value: { kind: "Variable", name: { kind: "Name", value: "createFromMember" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "createNew" },
                value: { kind: "Variable", name: { kind: "Name", value: "createNew" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubRoles" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubRoles" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetClubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "targetClubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "notes" },
                value: { kind: "Variable", name: { kind: "Name", value: "notes" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "recordId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkCotRegistrationToOfficerMutation, LinkCotRegistrationToOfficerMutationVariables>;
export const RefreshCotCompletionStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RefreshCOTCompletionStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refreshCOTCompletionStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "officersRefreshed" } },
                { kind: "Field", name: { kind: "Name", value: "completionsUpdated" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefreshCotCompletionStatusMutation, RefreshCotCompletionStatusMutationVariables>;
export const RegisterForCotEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterForCOTEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "seekingCreditForRoles" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "COTOfficerClubRoleInput" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reminder24hBefore" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "attendanceConfirmation" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "creditEarned" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "externalAttendee" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ExternalAttendeeInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "joinWaitlist" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerForCOTEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "seekingCreditForRoles" },
                value: { kind: "Variable", name: { kind: "Name", value: "seekingCreditForRoles" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reminder24hBefore" },
                value: { kind: "Variable", name: { kind: "Name", value: "reminder24hBefore" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attendanceConfirmation" },
                value: { kind: "Variable", name: { kind: "Name", value: "attendanceConfirmation" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "creditEarned" },
                value: { kind: "Variable", name: { kind: "Name", value: "creditEarned" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "externalAttendee" },
                value: { kind: "Variable", name: { kind: "Name", value: "externalAttendee" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "joinWaitlist" },
                value: { kind: "Variable", name: { kind: "Name", value: "joinWaitlist" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "pendingVerification" } },
                { kind: "Field", name: { kind: "Name", value: "waitlisted" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterForCotEventMutation, RegisterForCotEventMutationVariables>;
export const VerifyCotRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "VerifyCOTRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyCOTRegistration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyCotRegistrationMutation, VerifyCotRegistrationMutationVariables>;
export const CancelCotRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelCOTRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelCOTRegistration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelCotRegistrationMutation, CancelCotRegistrationMutationVariables>;
export const AddAssertedClubRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddAssertedClubRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addAssertedClubRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "role" },
                value: { kind: "Variable", name: { kind: "Name", value: "role" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubName" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                { kind: "Field", name: { kind: "Name", value: "roleAbbreviation" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddAssertedClubRoleMutation, AddAssertedClubRoleMutationVariables>;
export const RemoveAssertedClubRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveAssertedClubRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeAssertedClubRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "role" },
                value: { kind: "Variable", name: { kind: "Name", value: "role" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                { kind: "Field", name: { kind: "Name", value: "roleAbbreviation" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveAssertedClubRoleMutation, RemoveAssertedClubRoleMutationVariables>;
export const SendCotBroadcastDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendCOTBroadcast" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "audience" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "COTBroadcastAudienceInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subject" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bodyTemplate" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendCOTBroadcast" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "audience" },
                value: { kind: "Variable", name: { kind: "Name", value: "audience" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subject" },
                value: { kind: "Variable", name: { kind: "Name", value: "subject" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bodyTemplate" },
                value: { kind: "Variable", name: { kind: "Name", value: "bodyTemplate" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "broadcast" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "cotEventId" } },
                      { kind: "Field", name: { kind: "Name", value: "sentByName" } },
                      { kind: "Field", name: { kind: "Name", value: "sentAt" } },
                      { kind: "Field", name: { kind: "Name", value: "recipientCount" } },
                      { kind: "Field", name: { kind: "Name", value: "subject" } },
                      { kind: "Field", name: { kind: "Name", value: "bodyTemplate" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "audience" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "kind" } },
                            { kind: "Field", name: { kind: "Name", value: "registered" } },
                            { kind: "Field", name: { kind: "Name", value: "areaId" } },
                            { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "filters" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "kind" } },
                                  { kind: "Field", name: { kind: "Name", value: "registered" } },
                                  { kind: "Field", name: { kind: "Name", value: "areaId" } },
                                  { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendCotBroadcastMutation, SendCotBroadcastMutationVariables>;
export const SendCotBroadcastTestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendCOTBroadcastTest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subject" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bodyTemplate" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendCOTBroadcastTest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subject" },
                value: { kind: "Variable", name: { kind: "Name", value: "subject" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bodyTemplate" },
                value: { kind: "Variable", name: { kind: "Name", value: "bodyTemplate" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendCotBroadcastTestMutation, SendCotBroadcastTestMutationVariables>;
export const ApplyCotCrossDistrictHandoffDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplyCOTCrossDistrictHandoff" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applyCOTCrossDistrictHandoff" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "totalCredited" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onPlatform" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "homeDistrictNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "onPlatform" } },
                      { kind: "Field", name: { kind: "Name", value: "completedAttendees" } },
                      { kind: "Field", name: { kind: "Name", value: "creditedOfficers" } },
                      { kind: "Field", name: { kind: "Name", value: "newOfficers" } },
                      { kind: "Field", name: { kind: "Name", value: "skippedReason" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "offPlatformDistricts" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplyCotCrossDistrictHandoffMutation, ApplyCotCrossDistrictHandoffMutationVariables>;
export const AddCotEventHostDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddCOTEventHost" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addCOTEventHost" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "viewerCapabilities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "canManageHosts" } },
                            { kind: "Field", name: { kind: "Name", value: "canListDistrictOfficers" } },
                            { kind: "Field", name: { kind: "Name", value: "canReadEvent" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hosts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCotEventHostMutation, AddCotEventHostMutationVariables>;
export const RemoveCotEventHostDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveCOTEventHost" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeCOTEventHost" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "viewerCapabilities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "canManageHosts" } },
                            { kind: "Field", name: { kind: "Name", value: "canListDistrictOfficers" } },
                            { kind: "Field", name: { kind: "Name", value: "canReadEvent" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hosts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveCotEventHostMutation, RemoveCotEventHostMutationVariables>;
export const SetCotRegistrationNotOfficerMarkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetCOTRegistrationNotOfficerMark" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reason" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "COTNotOfficerReason" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "alsoMark" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "COTRegistrationTargetInput" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setCOTRegistrationNotOfficerMark" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: { kind: "Variable", name: { kind: "Name", value: "reason" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: { kind: "Variable", name: { kind: "Name", value: "note" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "alsoMark" },
                value: { kind: "Variable", name: { kind: "Name", value: "alsoMark" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                { kind: "Field", name: { kind: "Name", value: "markedCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refused" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "eventId" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationId" } },
                      { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetCotRegistrationNotOfficerMarkMutation,
  SetCotRegistrationNotOfficerMarkMutationVariables
>;
export const ClearCotRegistrationNotOfficerMarkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ClearCOTRegistrationNotOfficerMark" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registrationId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearCOTRegistrationNotOfficerMark" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "registrationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClearCotRegistrationNotOfficerMarkMutation,
  ClearCotRegistrationNotOfficerMarkMutationVariables
>;
export const SetCotOfficerNotOfficerMarkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetCOTOfficerNotOfficerMark" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reason" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "COTNotOfficerReason" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setCOTOfficerNotOfficerMark" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: { kind: "Variable", name: { kind: "Name", value: "reason" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: { kind: "Variable", name: { kind: "Name", value: "note" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "recordId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCotOfficerNotOfficerMarkMutation, SetCotOfficerNotOfficerMarkMutationVariables>;
export const ClearCotOfficerNotOfficerMarkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ClearCOTOfficerNotOfficerMark" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearCOTOfficerNotOfficerMark" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "recordId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClearCotOfficerNotOfficerMarkMutation, ClearCotOfficerNotOfficerMarkMutationVariables>;
export const GetCotRoundsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTRounds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotRounds" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "toastmastersYear" } },
                { kind: "Field", name: { kind: "Name", value: "roundNumber" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "yearRange" } },
                { kind: "Field", name: { kind: "Name", value: "dateRange" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "isLocked" } },
                { kind: "Field", name: { kind: "Name", value: "lockDate" } },
                { kind: "Field", name: { kind: "Name", value: "officerCount" } },
                { kind: "Field", name: { kind: "Name", value: "completedCount" } },
                { kind: "Field", name: { kind: "Name", value: "completionPercentage" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotRoundsQuery, GetCotRoundsQueryVariables>;
export const GetCotRoundLandingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTRoundLanding" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotRound" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "finishedEventIds" } },
                { kind: "Field", name: { kind: "Name", value: "viewerSeesTestEvents" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "yearRange" } },
                { kind: "Field", name: { kind: "Name", value: "roundNumber" } },
                { kind: "Field", name: { kind: "Name", value: "dateRange" } },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
                { kind: "Field", name: { kind: "Name", value: "isLocked" } },
                { kind: "Field", name: { kind: "Name", value: "lockDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastTIImportDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "recordId" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "membershipNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "districtId" } },
                      { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                      { kind: "Field", name: { kind: "Name", value: "areaId" } },
                      { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
                      { kind: "Field", name: { kind: "Name", value: "isMatched" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveName" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveMembershipNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "mergedIntoEmail" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CotOfficerStatusFields" } },
                      { kind: "Field", name: { kind: "Name", value: "attendedEvents" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clubOfficerRoles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "clubId" } },
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                            { kind: "Field", name: { kind: "Name", value: "clubName" } },
                            { kind: "Field", name: { kind: "Name", value: "districtId" } },
                            { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                            { kind: "Field", name: { kind: "Name", value: "areaId" } },
                            { kind: "Field", name: { kind: "Name", value: "isCorporate" } },
                            { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
                            { kind: "Field", name: { kind: "Name", value: "tiHasCompletedTraining" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manualRoleAssignments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "roleType" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalCompletion" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "dateOfTraining" } },
                            { kind: "Field", name: { kind: "Name", value: "nameOfCOT" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recordOverride" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "overriddenAt" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notOfficerMark" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "COTNotOfficerMarkFields" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CotOfficerStatusFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "COTClubOfficerRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "distinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "completedDistinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "cotsCreditsEarned" } },
          { kind: "Field", name: { kind: "Name", value: "memberCreditsEarned" } },
          { kind: "Field", name: { kind: "Name", value: "memberDistinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "memberKey" } },
          { kind: "Field", name: { kind: "Name", value: "requiresManualAssignment" } },
          { kind: "Field", name: { kind: "Name", value: "isUnderCredited" } },
          { kind: "Field", name: { kind: "Name", value: "isScheduledNotTrained" } },
          { kind: "Field", name: { kind: "Name", value: "activeRegistrationEventIds" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "COTNotOfficerMarkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "COTNotOfficerMark" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "markedByName" } },
          { kind: "Field", name: { kind: "Name", value: "markedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotRoundLandingQuery, GetCotRoundLandingQueryVariables>;
export const GetCotRoundForSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTRoundForSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotRound" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "finishedEventIds" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "isLocked" } },
                { kind: "Field", name: { kind: "Name", value: "lockDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "recordId" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "matchedToUserId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "membershipNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "districtId" } },
                      { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                      { kind: "Field", name: { kind: "Name", value: "areaId" } },
                      { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
                      { kind: "Field", name: { kind: "Name", value: "isMatched" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveName" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveMembershipNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "mergedIntoEmail" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CotOfficerStatusFields" } },
                      { kind: "Field", name: { kind: "Name", value: "attendedEvents" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clubOfficerRoles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "clubId" } },
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                            { kind: "Field", name: { kind: "Name", value: "clubName" } },
                            { kind: "Field", name: { kind: "Name", value: "districtId" } },
                            { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                            { kind: "Field", name: { kind: "Name", value: "areaId" } },
                            { kind: "Field", name: { kind: "Name", value: "isCorporate" } },
                            { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
                            { kind: "Field", name: { kind: "Name", value: "tiHasCompletedTraining" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalCompletion" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "dateOfTraining" } },
                            { kind: "Field", name: { kind: "Name", value: "nameOfCOT" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recordOverride" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "overriddenAt" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CotOfficerStatusFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "COTClubOfficerRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "distinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "completedDistinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "cotsCreditsEarned" } },
          { kind: "Field", name: { kind: "Name", value: "memberCreditsEarned" } },
          { kind: "Field", name: { kind: "Name", value: "memberDistinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "memberKey" } },
          { kind: "Field", name: { kind: "Name", value: "requiresManualAssignment" } },
          { kind: "Field", name: { kind: "Name", value: "isUnderCredited" } },
          { kind: "Field", name: { kind: "Name", value: "isScheduledNotTrained" } },
          { kind: "Field", name: { kind: "Name", value: "activeRegistrationEventIds" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotRoundForSessionQuery, GetCotRoundForSessionQueryVariables>;
export const GetCotOfficerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTOfficer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotOfficerCanMarkNotOfficer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cotMemberAssignmentState" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memberRecords" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "recordId" } },
                      { kind: "Field", name: { kind: "Name", value: "memberKey" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "effectiveEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "mergedIntoEmail" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clubOfficerRoles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "clubId" } },
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                            { kind: "Field", name: { kind: "Name", value: "clubName" } },
                            { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manualRoleAssignments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "roleType" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cotOfficer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recordId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recordId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recordId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "matchedToUserId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "membershipNumber" } },
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                { kind: "Field", name: { kind: "Name", value: "areaId" } },
                { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
                { kind: "Field", name: { kind: "Name", value: "isMatched" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "effectiveName" } },
                { kind: "Field", name: { kind: "Name", value: "effectiveEmail" } },
                { kind: "Field", name: { kind: "Name", value: "effectiveMembershipNumber" } },
                { kind: "Field", name: { kind: "Name", value: "effectiveUserId" } },
                { kind: "Field", name: { kind: "Name", value: "mergedIntoEmail" } },
                { kind: "Field", name: { kind: "Name", value: "mergedFromEmails" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notOfficerMark" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "COTNotOfficerMarkFields" } }],
                  },
                },
                { kind: "FragmentSpread", name: { kind: "Name", value: "CotOfficerStatusFields" } },
                { kind: "Field", name: { kind: "Name", value: "distinctRoleTypes" } },
                { kind: "Field", name: { kind: "Name", value: "unassignedRoleTypes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clubOfficerRoles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                      { kind: "Field", name: { kind: "Name", value: "roleAbbreviation" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                      { kind: "Field", name: { kind: "Name", value: "districtId" } },
                      { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                      { kind: "Field", name: { kind: "Name", value: "areaId" } },
                      { kind: "Field", name: { kind: "Name", value: "isCorporate" } },
                      { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
                      { kind: "Field", name: { kind: "Name", value: "completedEventId" } },
                      { kind: "Field", name: { kind: "Name", value: "tiHasCompletedTraining" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "clubRolesToken" } },
                { kind: "Field", name: { kind: "Name", value: "attendedEvents" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "externalCompletion" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "dateOfTraining" } },
                      { kind: "Field", name: { kind: "Name", value: "nameOfCOT" } },
                      { kind: "Field", name: { kind: "Name", value: "loggedBy" } },
                      { kind: "Field", name: { kind: "Name", value: "dateLoggedOnDistrictCentral" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recordOverride" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "correctedName" } },
                      { kind: "Field", name: { kind: "Name", value: "originalName" } },
                      { kind: "Field", name: { kind: "Name", value: "correctedEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "originalEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "correctedMembershipNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "originalMembershipNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "overriddenAt" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "districtNotes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                      { kind: "Field", name: { kind: "Name", value: "addedBy" } },
                      { kind: "Field", name: { kind: "Name", value: "addedByName" } },
                      { kind: "Field", name: { kind: "Name", value: "addedAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manualRoleAssignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "roleType" } },
                      { kind: "Field", name: { kind: "Name", value: "eventId" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedBy" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manualTrainingCredits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "creditId" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                      { kind: "Field", name: { kind: "Name", value: "trainingDate" } },
                      { kind: "Field", name: { kind: "Name", value: "trainingDescription" } },
                      { kind: "Field", name: { kind: "Name", value: "addedByName" } },
                      { kind: "Field", name: { kind: "Name", value: "addedAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "eventId" } },
                      { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationTime" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registrationData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "registrationTime" } },
                            { kind: "Field", name: { kind: "Name", value: "approvalStatus" } },
                            { kind: "Field", name: { kind: "Name", value: "displayName" } },
                            { kind: "Field", name: { kind: "Name", value: "clubName" } },
                            { kind: "Field", name: { kind: "Name", value: "memberNumber" } },
                            { kind: "Field", name: { kind: "Name", value: "area" } },
                            { kind: "Field", name: { kind: "Name", value: "division" } },
                            { kind: "Field", name: { kind: "Name", value: "district" } },
                            { kind: "Field", name: { kind: "Name", value: "clubRole" } },
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "officerRecordId" } },
                            { kind: "Field", name: { kind: "Name", value: "registrationId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CotOfficerStatusFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "COTClubOfficerRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "distinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "completedDistinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "cotsCreditsEarned" } },
          { kind: "Field", name: { kind: "Name", value: "memberCreditsEarned" } },
          { kind: "Field", name: { kind: "Name", value: "memberDistinctRoleCount" } },
          { kind: "Field", name: { kind: "Name", value: "memberKey" } },
          { kind: "Field", name: { kind: "Name", value: "requiresManualAssignment" } },
          { kind: "Field", name: { kind: "Name", value: "isUnderCredited" } },
          { kind: "Field", name: { kind: "Name", value: "isScheduledNotTrained" } },
          { kind: "Field", name: { kind: "Name", value: "activeRegistrationEventIds" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "COTNotOfficerMarkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "COTNotOfficerMark" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "markedByName" } },
          { kind: "Field", name: { kind: "Name", value: "markedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotOfficerQuery, GetCotOfficerQueryVariables>;
export const GetCotEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "eventId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "registrationCount" } },
                { kind: "Field", name: { kind: "Name", value: "sessionCount" } },
                { kind: "Field", name: { kind: "Name", value: "completedCount" } },
                { kind: "Field", name: { kind: "Name", value: "unmatchedCount" } },
                { kind: "Field", name: { kind: "Name", value: "firstSessionDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastSessionDate" } },
                { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                { kind: "Field", name: { kind: "Name", value: "registrationOpensAt" } },
                { kind: "Field", name: { kind: "Name", value: "registrationClosesAt" } },
                { kind: "Field", name: { kind: "Name", value: "externalRegistration" } },
                { kind: "Field", name: { kind: "Name", value: "isTest" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sessions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "dateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "duration" } },
                      { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                      { kind: "Field", name: { kind: "Name", value: "timeState" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotEventsQuery, GetCotEventsQueryVariables>;
export const GetCotEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "programId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "registrationCount" } },
                { kind: "Field", name: { kind: "Name", value: "matchedCount" } },
                { kind: "Field", name: { kind: "Name", value: "unmatchedCount" } },
                { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                { kind: "Field", name: { kind: "Name", value: "requiredSessionCount" } },
                { kind: "Field", name: { kind: "Name", value: "registrationOpensAt" } },
                { kind: "Field", name: { kind: "Name", value: "registrationClosesAt" } },
                { kind: "Field", name: { kind: "Name", value: "externalRegistration" } },
                { kind: "Field", name: { kind: "Name", value: "isTest" } },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "viewerCapabilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "canManageHosts" } },
                      { kind: "Field", name: { kind: "Name", value: "canManageEvent" } },
                      { kind: "Field", name: { kind: "Name", value: "canListDistrictOfficers" } },
                      { kind: "Field", name: { kind: "Name", value: "isDistrictOfficer" } },
                      { kind: "Field", name: { kind: "Name", value: "isSeniorOfficer" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hosts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationTime" } },
                      { kind: "Field", name: { kind: "Name", value: "approvalStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "displayName" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                      { kind: "Field", name: { kind: "Name", value: "memberNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "area" } },
                      { kind: "Field", name: { kind: "Name", value: "division" } },
                      { kind: "Field", name: { kind: "Name", value: "district" } },
                      { kind: "Field", name: { kind: "Name", value: "clubRole" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "officerRecordId" } },
                      { kind: "Field", name: { kind: "Name", value: "isMatched" } },
                      { kind: "Field", name: { kind: "Name", value: "isUnmatched" } },
                      { kind: "Field", name: { kind: "Name", value: "sessionsAttended" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sessionsAttendedDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                            { kind: "Field", name: { kind: "Name", value: "sessionName" } },
                            { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                            { kind: "Field", name: { kind: "Name", value: "isQualifying" } },
                            { kind: "Field", name: { kind: "Name", value: "duration" } },
                            { kind: "Field", name: { kind: "Name", value: "minDuration" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
                      { kind: "Field", name: { kind: "Name", value: "linkedOfficerRecordId" } },
                      { kind: "Field", name: { kind: "Name", value: "linkedOfficerMatchType" } },
                      { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                      { kind: "Field", name: { kind: "Name", value: "isCancelled" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notOfficerMark" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "COTNotOfficerMarkFields" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "COTNotOfficerMarkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "COTNotOfficerMark" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "markedByName" } },
          { kind: "Field", name: { kind: "Name", value: "markedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotEventQuery, GetCotEventQueryVariables>;
export const GetCotSessionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTSessions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotSessions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "dateTime" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                { kind: "Field", name: { kind: "Name", value: "joiningUrl" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "durationDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "maxAttendees" } },
                { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                { kind: "Field", name: { kind: "Name", value: "sessionTypeDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "timeState" } },
                { kind: "Field", name: { kind: "Name", value: "minimumDurationMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "attendanceCount" } },
                { kind: "Field", name: { kind: "Name", value: "qualifyingAttendanceCount" } },
                { kind: "Field", name: { kind: "Name", value: "isFull" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotSessionsQuery, GetCotSessionsQueryVariables>;
export const GetCotSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "dateTime" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                { kind: "Field", name: { kind: "Name", value: "joiningUrl" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "durationDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "maxAttendees" } },
                { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                { kind: "Field", name: { kind: "Name", value: "sessionTypeDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "timeState" } },
                { kind: "Field", name: { kind: "Name", value: "minimumDurationMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "attendanceCount" } },
                { kind: "Field", name: { kind: "Name", value: "qualifyingAttendanceCount" } },
                { kind: "Field", name: { kind: "Name", value: "isFull" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "viewerCapabilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "canRunLiveAttendance" } },
                      { kind: "Field", name: { kind: "Name", value: "canMarkAttendance" } },
                      { kind: "Field", name: { kind: "Name", value: "canManageAttendance" } },
                      { kind: "Field", name: { kind: "Name", value: "canAddManualAttendance" } },
                      { kind: "Field", name: { kind: "Name", value: "canManageHosts" } },
                      { kind: "Field", name: { kind: "Name", value: "canListDistrictOfficers" } },
                      { kind: "Field", name: { kind: "Name", value: "isDistrictOfficer" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attendance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "joinTime" } },
                      { kind: "Field", name: { kind: "Name", value: "leaveTime" } },
                      { kind: "Field", name: { kind: "Name", value: "durationMinutes" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "club" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotSessionQuery, GetCotSessionQueryVariables>;
export const GetCotProgramMetaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTProgramMeta" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotRound" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "lastTIImportDate" } },
                { kind: "Field", name: { kind: "Name", value: "isLocked" } },
                { kind: "Field", name: { kind: "Name", value: "lockDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotProgramMetaQuery, GetCotProgramMetaQueryVariables>;
export const GetCotEventRoundMetaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTEventRoundMeta" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotEventRoundMeta" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "lastTIImportDate" } },
                { kind: "Field", name: { kind: "Name", value: "isLocked" } },
                { kind: "Field", name: { kind: "Name", value: "lockDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotEventRoundMetaQuery, GetCotEventRoundMetaQueryVariables>;
export const GetCotClubSummariesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTClubSummaries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotClubSummaries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                { kind: "Field", name: { kind: "Name", value: "areaId" } },
                { kind: "Field", name: { kind: "Name", value: "completionPercentage" } },
                { kind: "Field", name: { kind: "Name", value: "isCorporate" } },
                { kind: "Field", name: { kind: "Name", value: "hasDisagreement" } },
                { kind: "Field", name: { kind: "Name", value: "trainedOfficerCount" } },
                { kind: "Field", name: { kind: "Name", value: "complianceStatus" } },
                { kind: "Field", name: { kind: "Name", value: "lifecycleStatus" } },
                { kind: "Field", name: { kind: "Name", value: "isChartered" } },
                { kind: "Field", name: { kind: "Name", value: "suspendDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                      { kind: "Field", name: { kind: "Name", value: "officerName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "hasCompleted" } },
                      { kind: "Field", name: { kind: "Name", value: "tiHasCompleted" } },
                      { kind: "Field", name: { kind: "Name", value: "recordId" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "completedRoles" } },
                { kind: "Field", name: { kind: "Name", value: "incompleteRoles" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotClubSummariesQuery, GetCotClubSummariesQueryVariables>;
export const GetCotClubDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTClubDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotClubDetail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                { kind: "Field", name: { kind: "Name", value: "areaId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "officers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "officers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "membershipNumber" } },
                            { kind: "Field", name: { kind: "Name", value: "hasCompleted" } },
                            { kind: "Field", name: { kind: "Name", value: "tiHasCompleted" } },
                            { kind: "Field", name: { kind: "Name", value: "hasBookendsTraining" } },
                            { kind: "Field", name: { kind: "Name", value: "distinctRoleCount" } },
                            { kind: "Field", name: { kind: "Name", value: "completedDistinctRoleCount" } },
                            { kind: "Field", name: { kind: "Name", value: "cotsCreditsEarned" } },
                            { kind: "Field", name: { kind: "Name", value: "memberCreditsEarned" } },
                            { kind: "Field", name: { kind: "Name", value: "memberDistinctRoleCount" } },
                            { kind: "Field", name: { kind: "Name", value: "requiresManualAssignment" } },
                            { kind: "Field", name: { kind: "Name", value: "isUnderCredited" } },
                            { kind: "Field", name: { kind: "Name", value: "unassignedRoleTypes" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attendance" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "eventId" } },
                                  { kind: "Field", name: { kind: "Name", value: "eventName" } },
                                  { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                                  { kind: "Field", name: { kind: "Name", value: "sessionName" } },
                                  { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                                  { kind: "Field", name: { kind: "Name", value: "attendanceTime" } },
                                  { kind: "Field", name: { kind: "Name", value: "duration" } },
                                  { kind: "Field", name: { kind: "Name", value: "qualifying" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotClubDetailQuery, GetCotClubDetailQueryVariables>;
export const GetCotUnmatchedAttendeesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTUnmatchedAttendees" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "markedNotOfficer" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotUnmatchedAttendees" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "markedNotOfficer" },
                value: { kind: "Variable", name: { kind: "Name", value: "markedNotOfficer" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "eventId" } },
                { kind: "Field", name: { kind: "Name", value: "eventName" } },
                { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                { kind: "Field", name: { kind: "Name", value: "sessionName" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "membershipNumber" } },
                { kind: "Field", name: { kind: "Name", value: "club" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "attendanceTime" } },
                { kind: "Field", name: { kind: "Name", value: "durationMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "isQualifying" } },
                { kind: "Field", name: { kind: "Name", value: "matchStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ambiguousCandidates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "recordId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                      { kind: "Field", name: { kind: "Name", value: "membershipNumber" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "registrationId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notOfficerMark" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "COTNotOfficerMarkFields" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "COTNotOfficerMarkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "COTNotOfficerMark" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "markedByName" } },
          { kind: "Field", name: { kind: "Name", value: "markedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotUnmatchedAttendeesQuery, GetCotUnmatchedAttendeesQueryVariables>;
export const GetMyCotRegistrationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyCOTRegistrations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myCOTRegistrations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OfficerCOTEventViewFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OfficerCOTEventViewFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OfficerCOTEventView" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isRegistrationOpenNow" } },
          { kind: "Field", name: { kind: "Name", value: "timeState" } },
          { kind: "Field", name: { kind: "Name", value: "isRegistered" } },
          { kind: "Field", name: { kind: "Name", value: "registeredCount" } },
          { kind: "Field", name: { kind: "Name", value: "isFull" } },
          { kind: "Field", name: { kind: "Name", value: "waitlistCount" } },
          { kind: "Field", name: { kind: "Name", value: "isWaitlisted" } },
          { kind: "Field", name: { kind: "Name", value: "waitlistPosition" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "knownClubRoles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                { kind: "Field", name: { kind: "Name", value: "roleAbbreviation" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "programId" } },
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                { kind: "Field", name: { kind: "Name", value: "requiredSessionCount" } },
                { kind: "Field", name: { kind: "Name", value: "registrationOpensAt" } },
                { kind: "Field", name: { kind: "Name", value: "registrationClosesAt" } },
                { kind: "Field", name: { kind: "Name", value: "externalRegistration" } },
                { kind: "Field", name: { kind: "Name", value: "isTest" } },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sessions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "dateTime" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                { kind: "Field", name: { kind: "Name", value: "joiningUrl" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "durationDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "maxAttendees" } },
                { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                { kind: "Field", name: { kind: "Name", value: "sessionTypeDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "timeState" } },
                { kind: "Field", name: { kind: "Name", value: "minimumDurationMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "attendanceCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "myRegistration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "registeredAt" } },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                { kind: "Field", name: { kind: "Name", value: "isCancelled" } },
                { kind: "Field", name: { kind: "Name", value: "isWaitlisted" } },
                { kind: "Field", name: { kind: "Name", value: "waitlistedAt" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "clubRole" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seekingCreditForRoles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationPrefs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "reminder24hBefore" } },
                      { kind: "Field", name: { kind: "Name", value: "attendanceConfirmation" } },
                      { kind: "Field", name: { kind: "Name", value: "creditEarned" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyCotRegistrationsQuery, GetMyCotRegistrationsQueryVariables>;
export const GetCotEventForOfficerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTEventForOfficer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotEventForOfficer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OfficerCOTEventViewFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OfficerCOTEventViewFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OfficerCOTEventView" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isRegistrationOpenNow" } },
          { kind: "Field", name: { kind: "Name", value: "timeState" } },
          { kind: "Field", name: { kind: "Name", value: "isRegistered" } },
          { kind: "Field", name: { kind: "Name", value: "registeredCount" } },
          { kind: "Field", name: { kind: "Name", value: "isFull" } },
          { kind: "Field", name: { kind: "Name", value: "waitlistCount" } },
          { kind: "Field", name: { kind: "Name", value: "isWaitlisted" } },
          { kind: "Field", name: { kind: "Name", value: "waitlistPosition" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "knownClubRoles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                { kind: "Field", name: { kind: "Name", value: "roleAbbreviation" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "hasCompletedTraining" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "programId" } },
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                { kind: "Field", name: { kind: "Name", value: "requiredSessionCount" } },
                { kind: "Field", name: { kind: "Name", value: "registrationOpensAt" } },
                { kind: "Field", name: { kind: "Name", value: "registrationClosesAt" } },
                { kind: "Field", name: { kind: "Name", value: "externalRegistration" } },
                { kind: "Field", name: { kind: "Name", value: "isTest" } },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sessions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "dateTime" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                { kind: "Field", name: { kind: "Name", value: "joiningUrl" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "durationDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "maxAttendees" } },
                { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                { kind: "Field", name: { kind: "Name", value: "sessionTypeDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "timeState" } },
                { kind: "Field", name: { kind: "Name", value: "minimumDurationMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "attendanceCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "myRegistration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "registeredAt" } },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                { kind: "Field", name: { kind: "Name", value: "isCancelled" } },
                { kind: "Field", name: { kind: "Name", value: "isWaitlisted" } },
                { kind: "Field", name: { kind: "Name", value: "waitlistedAt" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "clubRole" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seekingCreditForRoles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationPrefs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "reminder24hBefore" } },
                      { kind: "Field", name: { kind: "Name", value: "attendanceConfirmation" } },
                      { kind: "Field", name: { kind: "Name", value: "creditEarned" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotEventForOfficerQuery, GetCotEventForOfficerQueryVariables>;
export const GetMyCotActivityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyCotActivity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "limit" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myCotActivity" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "Variable", name: { kind: "Name", value: "limit" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventType" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "detail" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "occurredAt" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "triggeredBy" } },
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyCotActivityQuery, GetMyCotActivityQueryVariables>;
export const GetDistrictCotActivityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDistrictCotActivity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "limit" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "offset" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventTypes" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "districtCotActivity" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "Variable", name: { kind: "Name", value: "limit" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: { kind: "Variable", name: { kind: "Name", value: "offset" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventTypes" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventTypes" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventType" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "detail" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "cotId" } },
                { kind: "Field", name: { kind: "Name", value: "eventId" } },
                { kind: "Field", name: { kind: "Name", value: "officerRecordId" } },
                { kind: "Field", name: { kind: "Name", value: "occurredAt" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "triggeredBy" } },
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDistrictCotActivityQuery, GetDistrictCotActivityQueryVariables>;
export const GetMyClubOfficerRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyClubOfficerRoles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myClubOfficerRoles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                { kind: "Field", name: { kind: "Name", value: "roleAbbreviation" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyClubOfficerRolesQuery, GetMyClubOfficerRolesQueryVariables>;
export const GetMyAssertedClubRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyAssertedClubRoles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myAssertedClubRoles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
                { kind: "Field", name: { kind: "Name", value: "roleAbbreviation" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyAssertedClubRolesQuery, GetMyAssertedClubRolesQueryVariables>;
export const GetPublicCotEventForRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPublicCOTEventForRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicCOTEventForRegistration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "programId" } },
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                { kind: "Field", name: { kind: "Name", value: "registrationOpensAt" } },
                { kind: "Field", name: { kind: "Name", value: "registrationClosesAt" } },
                { kind: "Field", name: { kind: "Name", value: "externalRegistration" } },
                { kind: "Field", name: { kind: "Name", value: "publicLinkEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "isRegistrationOpenNow" } },
                { kind: "Field", name: { kind: "Name", value: "timeState" } },
                { kind: "Field", name: { kind: "Name", value: "isTest" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPublicCotEventForRegistrationQuery, GetPublicCotEventForRegistrationQueryVariables>;
export const GetPublicPublishedCotEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPublicPublishedCOTEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicPublishedCOTEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isRegistrationOpenNow" } },
                { kind: "Field", name: { kind: "Name", value: "timeState" } },
                { kind: "Field", name: { kind: "Name", value: "registeredCount" } },
                { kind: "Field", name: { kind: "Name", value: "isFull" } },
                { kind: "Field", name: { kind: "Name", value: "waitlistCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "programId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "publishStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationOpensAt" } },
                      { kind: "Field", name: { kind: "Name", value: "registrationClosesAt" } },
                      { kind: "Field", name: { kind: "Name", value: "externalRegistration" } },
                      { kind: "Field", name: { kind: "Name", value: "publicLinkEnabled" } },
                      { kind: "Field", name: { kind: "Name", value: "isTest" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sessions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "eventId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "dateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "location" } },
                      { kind: "Field", name: { kind: "Name", value: "isOnline" } },
                      { kind: "Field", name: { kind: "Name", value: "duration" } },
                      { kind: "Field", name: { kind: "Name", value: "durationDisplay" } },
                      { kind: "Field", name: { kind: "Name", value: "maxAttendees" } },
                      { kind: "Field", name: { kind: "Name", value: "sessionType" } },
                      { kind: "Field", name: { kind: "Name", value: "sessionTypeDisplay" } },
                      { kind: "Field", name: { kind: "Name", value: "timeState" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPublicPublishedCotEventsQuery, GetPublicPublishedCotEventsQueryVariables>;
export const GetCotAudiencePreviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTAudiencePreview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "audience" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "COTBroadcastAudienceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotAudiencePreview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "audience" },
                value: { kind: "Variable", name: { kind: "Name", value: "audience" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipientCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sample" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "displayName" } },
                      { kind: "Field", name: { kind: "Name", value: "isExternal" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "audience" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "registered" } },
                      { kind: "Field", name: { kind: "Name", value: "areaId" } },
                      { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "filters" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "kind" } },
                            { kind: "Field", name: { kind: "Name", value: "registered" } },
                            { kind: "Field", name: { kind: "Name", value: "areaId" } },
                            { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotAudiencePreviewQuery, GetCotAudiencePreviewQueryVariables>;
export const GetCotBroadcastPreviewContextDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTBroadcastPreviewContext" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotBroadcastPreviewContext" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "eventName" } },
                { kind: "Field", name: { kind: "Name", value: "eventDescription" } },
                { kind: "Field", name: { kind: "Name", value: "firstSessionDate" } },
                { kind: "Field", name: { kind: "Name", value: "registrationLink" } },
                { kind: "Field", name: { kind: "Name", value: "districtName" } },
                { kind: "Field", name: { kind: "Name", value: "creditRequirement" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotBroadcastPreviewContextQuery, GetCotBroadcastPreviewContextQueryVariables>;
export const GetCotExternalAttendeeHomeDistrictsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTExternalAttendeeHomeDistricts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotExternalAttendeeHomeDistricts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCotExternalAttendeeHomeDistrictsQuery,
  GetCotExternalAttendeeHomeDistrictsQueryVariables
>;
export const GetCotExternalAttendeeCsvDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTExternalAttendeeCSV" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "homeDistrictNumber" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotExternalAttendeeCSV" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "homeDistrictNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "homeDistrictNumber" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotExternalAttendeeCsvQuery, GetCotExternalAttendeeCsvQueryVariables>;
export const GetCotBroadcastsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTBroadcasts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotBroadcasts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: { kind: "Variable", name: { kind: "Name", value: "eventId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "cotEventId" } },
                { kind: "Field", name: { kind: "Name", value: "sentByUserId" } },
                { kind: "Field", name: { kind: "Name", value: "sentByName" } },
                { kind: "Field", name: { kind: "Name", value: "sentAt" } },
                { kind: "Field", name: { kind: "Name", value: "recipientCount" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "bodyTemplate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "audience" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "registered" } },
                      { kind: "Field", name: { kind: "Name", value: "areaId" } },
                      { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "filters" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "kind" } },
                            { kind: "Field", name: { kind: "Name", value: "registered" } },
                            { kind: "Field", name: { kind: "Name", value: "areaId" } },
                            { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotBroadcastsQuery, GetCotBroadcastsQueryVariables>;
export const GetCotTrainingSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCOTTrainingSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cotTrainingSummary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cotId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cotId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "officers" } },
                { kind: "Field", name: { kind: "Name", value: "peopleFullyTrained" } },
                { kind: "Field", name: { kind: "Name", value: "peoplePartlyTrained" } },
                { kind: "Field", name: { kind: "Name", value: "peopleAwaitingAssignment" } },
                { kind: "Field", name: { kind: "Name", value: "peopleAwaitingTraining" } },
                { kind: "Field", name: { kind: "Name", value: "peopleDidNotComplete" } },
                { kind: "Field", name: { kind: "Name", value: "peopleNotRegistered" } },
                { kind: "Field", name: { kind: "Name", value: "peopleTrained" } },
                { kind: "Field", name: { kind: "Name", value: "roleTypesHeld" } },
                { kind: "Field", name: { kind: "Name", value: "roleTypesTrained" } },
                { kind: "Field", name: { kind: "Name", value: "clubRoleSlots" } },
                { kind: "Field", name: { kind: "Name", value: "clubRoleSlotsTrained" } },
                { kind: "Field", name: { kind: "Name", value: "clubsCovered" } },
                { kind: "Field", name: { kind: "Name", value: "clubsWithOfficers" } },
                { kind: "Field", name: { kind: "Name", value: "clubsMeetingGoal" } },
                { kind: "Field", name: { kind: "Name", value: "clubsAtRisk" } },
                { kind: "Field", name: { kind: "Name", value: "clubsNotMet" } },
                { kind: "Field", name: { kind: "Name", value: "clubsFullyTrained" } },
                { kind: "Field", name: { kind: "Name", value: "recordsWithoutCoveredRole" } },
                { kind: "Field", name: { kind: "Name", value: "roleRowsOutsideClubSet" } },
                { kind: "Field", name: { kind: "Name", value: "roleRowsWithUnresolvedClub" } },
                { kind: "Field", name: { kind: "Name", value: "tiRoleRows" } },
                { kind: "Field", name: { kind: "Name", value: "tiRoleRowsWithData" } },
                { kind: "Field", name: { kind: "Name", value: "tiDisagreements" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "divisions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "division" } },
                      { kind: "Field", name: { kind: "Name", value: "officers" } },
                      { kind: "Field", name: { kind: "Name", value: "peopleFullyTrained" } },
                      { kind: "Field", name: { kind: "Name", value: "peoplePartlyTrained" } },
                      { kind: "Field", name: { kind: "Name", value: "peopleAwaitingAssignment" } },
                      { kind: "Field", name: { kind: "Name", value: "peopleAwaitingTraining" } },
                      { kind: "Field", name: { kind: "Name", value: "peopleDidNotComplete" } },
                      { kind: "Field", name: { kind: "Name", value: "peopleNotRegistered" } },
                      { kind: "Field", name: { kind: "Name", value: "peopleTrained" } },
                      { kind: "Field", name: { kind: "Name", value: "roleTypesHeld" } },
                      { kind: "Field", name: { kind: "Name", value: "roleTypesTrained" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCotTrainingSummaryQuery, GetCotTrainingSummaryQueryVariables>;
export const GetDashboardOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDashboardOverview" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dashboardOverview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "districts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "region" } },
                      { kind: "Field", name: { kind: "Name", value: "district" } },
                      { kind: "Field", name: { kind: "Name", value: "activeClubs" } },
                      { kind: "Field", name: { kind: "Name", value: "paidClubs" } },
                      { kind: "Field", name: { kind: "Name", value: "totalYtdPayments" } },
                      { kind: "Field", name: { kind: "Name", value: "asOfDate" } },
                      { kind: "Field", name: { kind: "Name", value: "programYear" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalDistricts" } },
                { kind: "Field", name: { kind: "Name", value: "totalActiveClubs" } },
                { kind: "Field", name: { kind: "Name", value: "asOfDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDashboardOverviewQuery, GetDashboardOverviewQueryVariables>;
export const GetDashboardHierarchyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDashboardHierarchy" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "dashboardHierarchy" } }],
      },
    },
  ],
} as unknown as DocumentNode<GetDashboardHierarchyQuery, GetDashboardHierarchyQueryVariables>;
export const GetDistrictDashboardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDistrictDashboard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "districtDashboard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "districtName" } },
                { kind: "Field", name: { kind: "Name", value: "entriesByYear" } },
                { kind: "Field", name: { kind: "Name", value: "membershipsByDate" } },
                { kind: "Field", name: { kind: "Name", value: "divisions" } },
                { kind: "Field", name: { kind: "Name", value: "divisionProvisionalCounts" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "membershipPaymentsChart" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "yAxisMax" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "current" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previous" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thresholds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "qualified" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clubsChart" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "yAxisMax" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "current" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previous" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thresholds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "qualified" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "membersChart" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "yAxisMax" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "current" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previous" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thresholds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "qualified" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalPaidClubs" } },
                { kind: "Field", name: { kind: "Name", value: "isProvisionalPeriod" } },
                { kind: "Field", name: { kind: "Name", value: "shortDescription" } },
                { kind: "Field", name: { kind: "Name", value: "longDescription" } },
                { kind: "Field", name: { kind: "Name", value: "region" } },
                { kind: "Field", name: { kind: "Name", value: "websiteUrl" } },
                { kind: "Field", name: { kind: "Name", value: "timezones" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDistrictDashboardQuery, GetDistrictDashboardQueryVariables>;
export const GetDivisionDashboardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDivisionDashboard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "divisionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "divisionDashboard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "divisionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "divisionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "districtName" } },
                { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                { kind: "Field", name: { kind: "Name", value: "divisionName" } },
                { kind: "Field", name: { kind: "Name", value: "areas" } },
                { kind: "Field", name: { kind: "Name", value: "areaProvisionalCounts" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clubsChart" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "yAxisMax" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "current" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previous" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thresholds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "qualified" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "distClubsChart" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "yAxisMax" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "current" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previous" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thresholds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "qualified" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "asOfDate" } },
                { kind: "Field", name: { kind: "Name", value: "isProvisionalPeriod" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDivisionDashboardQuery, GetDivisionDashboardQueryVariables>;
export const GetAreaDashboardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAreaDashboard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "divisionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "areaId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areaDashboard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "divisionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "divisionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: { kind: "Variable", name: { kind: "Name", value: "areaId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "districtName" } },
                { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                { kind: "Field", name: { kind: "Name", value: "divisionName" } },
                { kind: "Field", name: { kind: "Name", value: "areaId" } },
                { kind: "Field", name: { kind: "Name", value: "areaName" } },
                { kind: "Field", name: { kind: "Name", value: "clubs" } },
                { kind: "Field", name: { kind: "Name", value: "clubProvisionalStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clubsChart" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "yAxisMax" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "current" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previous" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thresholds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "qualified" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "distClubsChart" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "yAxisMax" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "current" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previous" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thresholds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "qualified" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "asOfDate" } },
                { kind: "Field", name: { kind: "Name", value: "isProvisionalPeriod" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAreaDashboardQuery, GetAreaDashboardQueryVariables>;
export const GetClubDashboardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubDashboard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "divisionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "areaId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubDashboard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "divisionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "divisionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: { kind: "Variable", name: { kind: "Name", value: "areaId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "districtName" } },
                { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                { kind: "Field", name: { kind: "Name", value: "divisionName" } },
                { kind: "Field", name: { kind: "Name", value: "areaId" } },
                { kind: "Field", name: { kind: "Name", value: "areaName" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "clubNumber" } },
                { kind: "Field", name: { kind: "Name", value: "shortName" } },
                { kind: "Field", name: { kind: "Name", value: "tiStatus" } },
                { kind: "Field", name: { kind: "Name", value: "suspendDate" } },
                { kind: "Field", name: { kind: "Name", value: "clubInfo" } },
                { kind: "Field", name: { kind: "Name", value: "clubData" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nudges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "urgency" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "membersChart" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "yAxisMax" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "current" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previous" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thresholds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "qualified" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "goalsChart" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "yAxisMax" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "current" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previous" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "points" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thresholds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "qualified" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "asOfDate" } },
                { kind: "Field", name: { kind: "Name", value: "isEligible" } },
                { kind: "Field", name: { kind: "Name", value: "maxObtainableDCPPoints" } },
                { kind: "Field", name: { kind: "Name", value: "membershipImportDate" } },
                { kind: "Field", name: { kind: "Name", value: "clubWebsiteUrl" } },
                { kind: "Field", name: { kind: "Name", value: "clubWebsiteSource" } },
                { kind: "Field", name: { kind: "Name", value: "tiWebsiteUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubDashboardQuery, GetClubDashboardQueryVariables>;
export const GetClubsDashboardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubsDashboard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubsDashboard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "districtName" } },
                { kind: "Field", name: { kind: "Name", value: "totalActiveMembers" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "divisionStats" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "divisionId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "areaStats" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "areaId" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "clubs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "clubId" } },
                                  { kind: "Field", name: { kind: "Name", value: "clubName" } },
                                  { kind: "Field", name: { kind: "Name", value: "division" } },
                                  { kind: "Field", name: { kind: "Name", value: "area" } },
                                  { kind: "Field", name: { kind: "Name", value: "tiStatus" } },
                                  { kind: "Field", name: { kind: "Name", value: "suspendDate" } },
                                  { kind: "Field", name: { kind: "Name", value: "hasPerformanceData" } },
                                  { kind: "Field", name: { kind: "Name", value: "activeMembers" } },
                                  { kind: "Field", name: { kind: "Name", value: "membershipBase" } },
                                  { kind: "Field", name: { kind: "Name", value: "membershipGrowth" } },
                                  { kind: "Field", name: { kind: "Name", value: "goalsMet" } },
                                  { kind: "Field", name: { kind: "Name", value: "isDCPEligible" } },
                                  { kind: "Field", name: { kind: "Name", value: "clubStatus" } },
                                  { kind: "Field", name: { kind: "Name", value: "awardsPerMember" } },
                                  { kind: "Field", name: { kind: "Name", value: "pathwaysEnrolledMembers" } },
                                  { kind: "Field", name: { kind: "Name", value: "pathwaysTotalMembers" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "totalActiveMembers" } },
                            { kind: "Field", name: { kind: "Name", value: "pathwaysEnrolledMembers" } },
                            { kind: "Field", name: { kind: "Name", value: "pathwaysTotalMembers" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "totalActiveMembers" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwaysEnrolledMembers" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwaysTotalMembers" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "pathwaysEnrolledMembers" } },
                { kind: "Field", name: { kind: "Name", value: "pathwaysTotalMembers" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubsDashboardQuery, GetClubsDashboardQueryVariables>;
export const GetDcpOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDCPOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dcpOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "districtId" } },
                { kind: "Field", name: { kind: "Name", value: "districtName" } },
                { kind: "Field", name: { kind: "Name", value: "totalClubs" } },
                { kind: "Field", name: { kind: "Name", value: "activeClubs" } },
                { kind: "Field", name: { kind: "Name", value: "lowClubs" } },
                { kind: "Field", name: { kind: "Name", value: "ineligibleClubs" } },
                { kind: "Field", name: { kind: "Name", value: "suspendedClubs" } },
                { kind: "Field", name: { kind: "Name", value: "totalDistinguishedClubs" } },
                { kind: "Field", name: { kind: "Name", value: "smedleyDistinguishedClubs" } },
                { kind: "Field", name: { kind: "Name", value: "presidentsDistinguishedClubs" } },
                { kind: "Field", name: { kind: "Name", value: "selectDistinguishedClubs" } },
                { kind: "Field", name: { kind: "Name", value: "distinguishedClubs" } },
                { kind: "Field", name: { kind: "Name", value: "nonEligibleWithDCP" } },
                { kind: "Field", name: { kind: "Name", value: "eligibleWithoutDCP" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clubs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubName" } },
                      { kind: "Field", name: { kind: "Name", value: "shortName" } },
                      { kind: "Field", name: { kind: "Name", value: "division" } },
                      { kind: "Field", name: { kind: "Name", value: "area" } },
                      { kind: "Field", name: { kind: "Name", value: "goalsMet" } },
                      { kind: "Field", name: { kind: "Name", value: "dcpEligibility" } },
                      { kind: "Field", name: { kind: "Name", value: "isActive" } },
                      { kind: "Field", name: { kind: "Name", value: "isLow" } },
                      { kind: "Field", name: { kind: "Name", value: "isIneligible" } },
                      { kind: "Field", name: { kind: "Name", value: "isSuspended" } },
                      { kind: "Field", name: { kind: "Name", value: "eligibleDCPPoints" } },
                      { kind: "Field", name: { kind: "Name", value: "activeMembers" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDcpOverviewQuery, GetDcpOverviewQueryVariables>;
export const UpdateDistrictConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateDistrictConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "contactEmail" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "calendarEnabled" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateDistrictConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "contactEmail" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "calendarEnabled" },
                value: { kind: "Variable", name: { kind: "Name", value: "calendarEnabled" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDistrictConfigMutation, UpdateDistrictConfigMutationVariables>;
export const AssignDistrictOfficerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AssignDistrictOfficer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "membershipId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "memberName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roleName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isSenior" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignDistrictOfficer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "membershipId" },
                value: { kind: "Variable", name: { kind: "Name", value: "membershipId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "memberName" },
                value: { kind: "Variable", name: { kind: "Name", value: "memberName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roleName" },
                value: { kind: "Variable", name: { kind: "Name", value: "roleName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isSenior" },
                value: { kind: "Variable", name: { kind: "Name", value: "isSenior" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignDistrictOfficerMutation, AssignDistrictOfficerMutationVariables>;
export const RemoveDistrictOfficerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveDistrictOfficer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeDistrictOfficer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "role" },
                value: { kind: "Variable", name: { kind: "Name", value: "role" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveDistrictOfficerMutation, RemoveDistrictOfficerMutationVariables>;
export const RefreshDistrictDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RefreshDistrictData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refreshDistrictData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefreshDistrictDataMutation, RefreshDistrictDataMutationVariables>;
export const GetDistrictsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDistricts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "districts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "districtNumber" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "shortDisplayName" } },
                { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                { kind: "Field", name: { kind: "Name", value: "timezone" } },
                { kind: "Field", name: { kind: "Name", value: "calendarEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "clubCount" } },
                { kind: "Field", name: { kind: "Name", value: "memberCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDistrictsQuery, GetDistrictsQueryVariables>;
export const GetDistrictDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDistrict" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "district" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "districtNumber" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "shortDisplayName" } },
                { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                { kind: "Field", name: { kind: "Name", value: "timezone" } },
                { kind: "Field", name: { kind: "Name", value: "calendarEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "clubCount" } },
                { kind: "Field", name: { kind: "Name", value: "memberCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDistrictQuery, GetDistrictQueryVariables>;
export const GetDistrictOfficersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDistrictOfficers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "districtOfficers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "memberName" } },
                { kind: "Field", name: { kind: "Name", value: "membershipId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "isSenior" } },
                { kind: "Field", name: { kind: "Name", value: "isAssigned" } },
                { kind: "Field", name: { kind: "Name", value: "termStart" } },
                { kind: "Field", name: { kind: "Name", value: "termEnd" } },
                { kind: "Field", name: { kind: "Name", value: "area" } },
                { kind: "Field", name: { kind: "Name", value: "division" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDistrictOfficersQuery, GetDistrictOfficersQueryVariables>;
export const GetDistrictMembersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDistrictMembers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "districtMembers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "membershipId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDistrictMembersQuery, GetDistrictMembersQueryVariables>;
export const SearchDistrictMembersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchDistrictMembers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "query" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchDistrictMembers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "districtId" },
                value: { kind: "Variable", name: { kind: "Name", value: "districtId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: { kind: "Variable", name: { kind: "Name", value: "query" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "membershipId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchDistrictMembersQuery, SearchDistrictMembersQueryVariables>;
export const GetClubEmailAddressesNotWorkingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubEmailAddressesNotWorking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubEmailAddressesNotWorking" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubEmailAddressesNotWorkingQuery, GetClubEmailAddressesNotWorkingQueryVariables>;
export const MarkEmailAddressWorkingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MarkEmailAddressWorking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "address" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markEmailAddressWorking" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "address" },
                value: { kind: "Variable", name: { kind: "Name", value: "address" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkEmailAddressWorkingMutation, MarkEmailAddressWorkingMutationVariables>;
export const GetClubGuestbookDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubGuestbookData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubGuestbookData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guests" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GuestRegistrationFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "foundUsMap" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FoundUsEntryFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GuestRegistrationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestRegistration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "foundUsInfo" } },
          { kind: "Field", name: { kind: "Name", value: "creationDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastSignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "signingCount" } },
          { kind: "Field", name: { kind: "Name", value: "guestStatus" } },
          { kind: "Field", name: { kind: "Name", value: "lastEmailSent" } },
          { kind: "Field", name: { kind: "Name", value: "actionId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                { kind: "Field", name: { kind: "Name", value: "since" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "canMarkWorking" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FoundUsEntryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FoundUsEntry" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubGuestbookDataQuery, GetClubGuestbookDataQueryVariables>;
export const GetClubGuestbookConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubGuestbookConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubGuestbookConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GuestbookConfigFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GuestbookConfigFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestbookConfig" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "welcomeEmailEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "firstEmailBody" } },
          { kind: "Field", name: { kind: "Name", value: "returningGuestEmailBody" } },
          { kind: "Field", name: { kind: "Name", value: "reminderEmailBody" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubGuestbookConfigQuery, GetClubGuestbookConfigQueryVariables>;
export const GetGuestbookEmailOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetGuestbookEmailOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "guestbookEmailOptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetGuestbookEmailOptionsQuery, GetGuestbookEmailOptionsQueryVariables>;
export const GetFoundUsOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFoundUsOptions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "foundUsOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FoundUsEntryFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FoundUsEntryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FoundUsEntry" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFoundUsOptionsQuery, GetFoundUsOptionsQueryVariables>;
export const GetClubInfoForGuestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubInfoForGuest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubInfoForGuest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubShortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "shortName" } },
                { kind: "Field", name: { kind: "Name", value: "longName" } },
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubInfoForGuestQuery, GetClubInfoForGuestQueryVariables>;
export const GetClubPendingGuestbookSubmissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubPendingGuestbookSubmissions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubPendingGuestbookSubmissions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubPendingGuestbookSubmissionsQuery, GetClubPendingGuestbookSubmissionsQueryVariables>;
export const RemoveGuestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveGuest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeGuest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveGuestMutation, RemoveGuestMutationVariables>;
export const ResendGuestWelcomeEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResendGuestWelcomeEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resendGuestWelcomeEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResendGuestWelcomeEmailMutation, ResendGuestWelcomeEmailMutationVariables>;
export const SendGuestbookEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendGuestbookEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "emailBody" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "toWhom" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendGuestbookEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailBody" },
                value: { kind: "Variable", name: { kind: "Name", value: "emailBody" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toWhom" },
                value: { kind: "Variable", name: { kind: "Name", value: "toWhom" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendGuestbookEmailMutation, SendGuestbookEmailMutationVariables>;
export const RegisterGuestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterGuest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "formId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "foundUsInfo" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumber" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerGuest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubShortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "formId" },
                value: { kind: "Variable", name: { kind: "Name", value: "formId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstName" },
                value: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastName" },
                value: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "foundUsInfo" },
                value: { kind: "Variable", name: { kind: "Name", value: "foundUsInfo" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phoneNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "phoneNumber" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "verificationEmailSent" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingInProgress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterGuestMutation, RegisterGuestMutationVariables>;
export const ConfirmPendingGuestbookSubmissionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmPendingGuestbookSubmission" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "submissionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmPendingGuestbookSubmission" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "submissionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "submissionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmPendingGuestbookSubmissionMutation,
  ConfirmPendingGuestbookSubmissionMutationVariables
>;
export const ResendPendingGuestbookVerificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResendPendingGuestbookVerification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "submissionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resendPendingGuestbookVerification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "submissionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "submissionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResendPendingGuestbookVerificationMutation,
  ResendPendingGuestbookVerificationMutationVariables
>;
export const GetPublicLandingStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPublicLandingStats" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicLandingStats" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "activeClubs" } },
                { kind: "Field", name: { kind: "Name", value: "meetingsOrganised" } },
                { kind: "Field", name: { kind: "Name", value: "paperSlipsSaved" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPublicLandingStatsQuery, GetPublicLandingStatsQueryVariables>;
export const GetClubLinksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubLinks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubLinks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubLinkFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubLinkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubLinksQuery, GetClubLinksQueryVariables>;
export const CreateClubLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateClubLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "url" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createClubLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "url" },
                value: { kind: "Variable", name: { kind: "Name", value: "url" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubLinkFields" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubLinkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClubLinkMutation, CreateClubLinkMutationVariables>;
export const UpdateClubLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateClubLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "linkId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "url" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isActive" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateClubLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "linkId" },
                value: { kind: "Variable", name: { kind: "Name", value: "linkId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "url" },
                value: { kind: "Variable", name: { kind: "Name", value: "url" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isActive" },
                value: { kind: "Variable", name: { kind: "Name", value: "isActive" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order" },
                value: { kind: "Variable", name: { kind: "Name", value: "order" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubLinkFields" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubLinkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClubLinkMutation, UpdateClubLinkMutationVariables>;
export const DeleteClubLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteClubLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "linkId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteClubLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "linkId" },
                value: { kind: "Variable", name: { kind: "Name", value: "linkId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteClubLinkMutation, DeleteClubLinkMutationVariables>;
export const ReorderClubLinksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReorderClubLinks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "linkIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reorderClubLinks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "linkIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "linkIds" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReorderClubLinksMutation, ReorderClubLinksMutationVariables>;
export const CreateMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "title" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "locationText" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "locationMapLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "theme" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "wordOfDay" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaTemplateId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Long" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createMeeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "title" },
                value: { kind: "Variable", name: { kind: "Name", value: "title" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "date" },
                value: { kind: "Variable", name: { kind: "Name", value: "date" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationText" },
                value: { kind: "Variable", name: { kind: "Name", value: "locationText" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationMapLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "locationMapLink" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "theme" },
                value: { kind: "Variable", name: { kind: "Name", value: "theme" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "wordOfDay" },
                value: { kind: "Variable", name: { kind: "Name", value: "wordOfDay" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaTemplateId" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaTemplateId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const UpdateMeetingDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMeetingDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "title" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "theme" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "wordOfDay" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "datetime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "locationText" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "locationMapLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMeetingDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "title" },
                value: { kind: "Variable", name: { kind: "Name", value: "title" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "theme" },
                value: { kind: "Variable", name: { kind: "Name", value: "theme" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "wordOfDay" },
                value: { kind: "Variable", name: { kind: "Name", value: "wordOfDay" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "datetime" },
                value: { kind: "Variable", name: { kind: "Name", value: "datetime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationText" },
                value: { kind: "Variable", name: { kind: "Name", value: "locationText" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationMapLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "locationMapLink" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMeetingDetailsMutation, UpdateMeetingDetailsMutationVariables>;
export const DeleteMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteMeeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DeleteResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeleteResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DeleteResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "deletedId" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMeetingMutation, DeleteMeetingMutationVariables>;
export const ScheduleMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ScheduleMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "scheduleMeeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleMeetingMutation, ScheduleMeetingMutationVariables>;
export const StartMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StartMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startMeeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StartMeetingMutation, StartMeetingMutationVariables>;
export const FinishMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FinishMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "finishMeeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FinishMeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinishMeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FinishMeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meeting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "speechesCredited" } },
                { kind: "Field", name: { kind: "Name", value: "rolesCredited" } },
                { kind: "Field", name: { kind: "Name", value: "speechesAttempted" } },
                { kind: "Field", name: { kind: "Name", value: "rolesAttempted" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FinishMeetingMutation, FinishMeetingMutationVariables>;
export const RevertMeetingToDraftDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RevertMeetingToDraft" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revertMeetingToDraft" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RevertMeetingToDraftMutation, RevertMeetingToDraftMutationVariables>;
export const CancelMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reason" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelMeeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: { kind: "Variable", name: { kind: "Name", value: "reason" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelMeetingMutation, CancelMeetingMutationVariables>;
export const ReinstateMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReinstateMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reinstateMeeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReinstateMeetingMutation, ReinstateMeetingMutationVariables>;
export const RevertMeetingToInProgressDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RevertMeetingToInProgress" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revertMeetingToInProgress" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RevertMeetingToInProgressMutation, RevertMeetingToInProgressMutationVariables>;
export const PreviewRemindAllDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PreviewRemindAll" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "previewRemindAll" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "actionSummary" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "actionReason" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skippedRecipients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "roles" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "defaultSubject" } },
                { kind: "Field", name: { kind: "Name", value: "defaultBody" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PreviewRemindAllMutation, PreviewRemindAllMutationVariables>;
export const SendRemindAllDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendRemindAll" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subject" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "body" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendRemindAll" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subject" },
                value: { kind: "Variable", name: { kind: "Name", value: "subject" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "body" },
                value: { kind: "Variable", name: { kind: "Name", value: "body" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "sentCount" } },
                { kind: "Field", name: { kind: "Name", value: "skippedCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skippedRecipients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "roles" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendRemindAllMutation, SendRemindAllMutationVariables>;
export const SetMyMeetingRsvpDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetMyMeetingRsvp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RsvpStatus" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setMyMeetingRsvp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryResultFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummaryResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalEligibleMembers" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpMaybeCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpNotAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "attendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "notAttendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "myRsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "myAttendanceStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetMyMeetingRsvpMutation, SetMyMeetingRsvpMutationVariables>;
export const SetMemberMeetingRsvpDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetMemberMeetingRsvp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "RsvpStatus" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setMemberMeetingRsvp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryResultFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummaryResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalEligibleMembers" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpMaybeCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpNotAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "attendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "notAttendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "myRsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "myAttendanceStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetMemberMeetingRsvpMutation, SetMemberMeetingRsvpMutationVariables>;
export const MarkMeetingAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MarkMeetingAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "AttendanceStatus" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markMeetingAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryResultFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummaryResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalEligibleMembers" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpMaybeCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpNotAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "attendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "notAttendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "myRsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "myAttendanceStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkMeetingAttendanceMutation, MarkMeetingAttendanceMutationVariables>;
export const BulkMarkMeetingAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "BulkMarkMeetingAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "marks" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "AttendanceMarkInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bulkMarkMeetingAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "marks" },
                value: { kind: "Variable", name: { kind: "Name", value: "marks" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryResultFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummaryResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalEligibleMembers" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpMaybeCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpNotAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "attendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "notAttendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "myRsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "myAttendanceStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkMarkMeetingAttendanceMutation, BulkMarkMeetingAttendanceMutationVariables>;
export const RequestRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RequestRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItemId" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestRoleMutation, RequestRoleMutationVariables>;
export const CancelRoleRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelRoleRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelRoleRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItemId" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelRoleRequestMutation, CancelRoleRequestMutationVariables>;
export const CancelMyRoleAssignmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelMyRoleAssignment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "markNotAttending" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "baseVersion" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Long" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelMyRoleAssignment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItemId" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "markNotAttending" },
                value: { kind: "Variable", name: { kind: "Name", value: "markNotAttending" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "baseVersion" },
                value: { kind: "Variable", name: { kind: "Name", value: "baseVersion" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelMyRoleAssignmentMutation, CancelMyRoleAssignmentMutationVariables>;
export const ApproveRoleRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApproveRoleRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sendEmail" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "personalNote" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "targetAgendaItemId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "approveRoleRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItemId" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sendEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "sendEmail" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "personalNote" },
                value: { kind: "Variable", name: { kind: "Name", value: "personalNote" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetAgendaItemId" },
                value: { kind: "Variable", name: { kind: "Name", value: "targetAgendaItemId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApproveRoleRequestMutation, ApproveRoleRequestMutationVariables>;
export const RejectRoleRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RejectRoleRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reason" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sendEmail" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rejectRoleRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItemId" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: { kind: "Variable", name: { kind: "Name", value: "reason" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sendEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "sendEmail" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RejectRoleRequestMutation, RejectRoleRequestMutationVariables>;
export const SubmitFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subjectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "content" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "aspects" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isAnonymous" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "fromAttendeeUserId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "fromAttendeeGuestId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feedbackSessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subjectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subjectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "content" },
                value: { kind: "Variable", name: { kind: "Name", value: "content" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "aspects" },
                value: { kind: "Variable", name: { kind: "Name", value: "aspects" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isAnonymous" },
                value: { kind: "Variable", name: { kind: "Name", value: "isAnonymous" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromAttendeeUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "fromAttendeeUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromAttendeeGuestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "fromAttendeeGuestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>;
export const SetFeedbackSessionStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetFeedbackSessionStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isOpen" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setFeedbackSessionStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feedbackSessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isOpen" },
                value: { kind: "Variable", name: { kind: "Name", value: "isOpen" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetFeedbackSessionStatusMutation, SetFeedbackSessionStatusMutationVariables>;
export const AddFeedbackSubjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddFeedbackSubject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaSyncKey" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "addFeedbackSubject" },
            name: { kind: "Name", value: "addFeedbackSubjectCanonical" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feedbackSessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdGuestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaSyncKey" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaSyncKey" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "created" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                            { kind: "Field", name: { kind: "Name", value: "feedbackSessionId" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "meetingUserId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "userId" } },
                                  { kind: "Field", name: { kind: "Name", value: "guestId" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddFeedbackSubjectMutation, AddFeedbackSubjectMutationVariables>;
export const RemoveFeedbackSubjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveFeedbackSubject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subjectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeFeedbackSubject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feedbackSessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subjectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subjectId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveFeedbackSubjectMutation, RemoveFeedbackSubjectMutationVariables>;
export const UpdateFeedbackSubjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateFeedbackSubject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subjectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateFeedbackSubject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feedbackSessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subjectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subjectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdGuestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFeedbackSubjectMutation, UpdateFeedbackSubjectMutationVariables>;
export const SubmitVoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitVote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "candidateId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitVote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "votingRoomId" },
                value: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "candidateId" },
                value: { kind: "Variable", name: { kind: "Name", value: "candidateId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdGuestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitVoteMutation, SubmitVoteMutationVariables>;
export const SetVotingRoomStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetVotingRoomStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isOpen" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setVotingRoomStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "votingRoomId" },
                value: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isOpen" },
                value: { kind: "Variable", name: { kind: "Name", value: "isOpen" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetVotingRoomStatusMutation, SetVotingRoomStatusMutationVariables>;
export const AddVotingRoomDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddVotingRoom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "displayName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addVotingRoom" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "displayName" },
                value: { kind: "Variable", name: { kind: "Name", value: "displayName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "standardKey" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "isOpen" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "candidates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meetingUserId" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "guestId" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "voteCounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "candidateId" } },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddVotingRoomMutation, AddVotingRoomMutationVariables>;
export const RenameVotingRoomDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RenameVotingRoom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "displayName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "renameVotingRoom" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "votingRoomId" },
                value: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "displayName" },
                value: { kind: "Variable", name: { kind: "Name", value: "displayName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RenameVotingRoomMutation, RenameVotingRoomMutationVariables>;
export const DeleteVotingRoomDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteVotingRoom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteVotingRoom" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "votingRoomId" },
                value: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteVotingRoomMutation, DeleteVotingRoomMutationVariables>;
export const AddCandidateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddCandidate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaSyncKey" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addCandidate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "votingRoomId" },
                value: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdGuestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaSyncKey" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaSyncKey" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "candidate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "meetingUserId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "userId" } },
                                  { kind: "Field", name: { kind: "Name", value: "guestId" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCandidateMutation, AddCandidateMutationVariables>;
export const RemoveCandidateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveCandidate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "candidateId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeCandidate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "votingRoomId" },
                value: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "candidateId" },
                value: { kind: "Variable", name: { kind: "Name", value: "candidateId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveCandidateMutation, RemoveCandidateMutationVariables>;
export const UpdateCandidateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCandidate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "candidateId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCandidate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "votingRoomId" },
                value: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "candidateId" },
                value: { kind: "Variable", name: { kind: "Name", value: "candidateId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdGuestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCandidateMutation, UpdateCandidateMutationVariables>;
export const ReorderCandidatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReorderCandidates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "candidateIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reorderCandidates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "votingRoomId" },
                value: { kind: "Variable", name: { kind: "Name", value: "votingRoomId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "candidateIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "candidateIds" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReorderCandidatesMutation, ReorderCandidatesMutationVariables>;
export const CreateMeetingUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateMeetingUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createMeetingUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingUserId" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "guestId" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tiName" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "relationshipToClub" } },
                { kind: "Field", name: { kind: "Name", value: "isAssigneeNotified" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMeetingUserMutation, CreateMeetingUserMutationVariables>;
export const UpdateMeetingAgendaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMeetingAgenda" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agenda" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "AgendaItemInput" } },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "emailOptions" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "EmailControlOptionsInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sourceAgendaTemplateId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Long" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "baseVersion" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Long" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMeetingAgenda" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agenda" },
                value: { kind: "Variable", name: { kind: "Name", value: "agenda" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailOptions" },
                value: { kind: "Variable", name: { kind: "Name", value: "emailOptions" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sourceAgendaTemplateId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sourceAgendaTemplateId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "baseVersion" },
                value: { kind: "Variable", name: { kind: "Name", value: "baseVersion" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMeetingAgendaMutation, UpdateMeetingAgendaMutationVariables>;
export const UpdateMeetingAgendaOpsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMeetingAgendaOps" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ops" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "AgendaOpInput" } },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "emailOptions" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "EmailControlOptionsInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMeetingAgendaOps" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ops" },
                value: { kind: "Variable", name: { kind: "Name", value: "ops" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailOptions" },
                value: { kind: "Variable", name: { kind: "Name", value: "emailOptions" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMeetingAgendaOpsMutation, UpdateMeetingAgendaOpsMutationVariables>;
export const PopulateDefaultAgendaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PopulateDefaultAgenda" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "populateDefaultAgenda" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PopulateDefaultAgendaMutation, PopulateDefaultAgendaMutationVariables>;
export const AssignProjectToAgendaItemDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AssignProjectToAgendaItem" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignProjectToAgendaItem" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItemId" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speechTitle" },
                value: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignProjectToAgendaItemMutation, AssignProjectToAgendaItemMutationVariables>;
export const ConvertOfficerSpeechRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConvertOfficerSpeechRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "convertOfficerSpeechRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItemId" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speechTitle" },
                value: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingMutationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "participantCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingMutationFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConvertOfficerSpeechRequestMutation, ConvertOfficerSpeechRequestMutationVariables>;
export const ProposeRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProposeRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slotIndex" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "proposeeUserId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "expiresAt" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "proposeRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "agendaItemId" },
                value: { kind: "Variable", name: { kind: "Name", value: "agendaItemId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "slotIndex" },
                value: { kind: "Variable", name: { kind: "Name", value: "slotIndex" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "proposeeUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "proposeeUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "expiresAt" },
                value: { kind: "Variable", name: { kind: "Name", value: "expiresAt" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RoleProposalFields" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleProposalFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RoleProposal" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
          { kind: "Field", name: { kind: "Name", value: "slotIndex" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByRoleLabel" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
          { kind: "Field", name: { kind: "Name", value: "withdrawnAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProposeRoleMutation, ProposeRoleMutationVariables>;
export const WithdrawRoleProposalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WithdrawRoleProposal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "proposalId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "withdrawRoleProposal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "proposalId" },
                value: { kind: "Variable", name: { kind: "Name", value: "proposalId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RoleProposalFields" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleProposalFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RoleProposal" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
          { kind: "Field", name: { kind: "Name", value: "slotIndex" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByRoleLabel" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
          { kind: "Field", name: { kind: "Name", value: "withdrawnAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WithdrawRoleProposalMutation, WithdrawRoleProposalMutationVariables>;
export const RetryRoleProposalSendDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RetryRoleProposalSend" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "proposalId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retryRoleProposalSend" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "proposalId" },
                value: { kind: "Variable", name: { kind: "Name", value: "proposalId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RoleProposalFields" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleProposalFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RoleProposal" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
          { kind: "Field", name: { kind: "Name", value: "slotIndex" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByRoleLabel" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
          { kind: "Field", name: { kind: "Name", value: "withdrawnAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RetryRoleProposalSendMutation, RetryRoleProposalSendMutationVariables>;
export const RespondToRoleProposalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RespondToRoleProposal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "proposalId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accept" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "respondToRoleProposal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "proposalId" },
                value: { kind: "Variable", name: { kind: "Name", value: "proposalId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accept" },
                value: { kind: "Variable", name: { kind: "Name", value: "accept" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "errorCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RoleProposalFields" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleProposalFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RoleProposal" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
          { kind: "Field", name: { kind: "Name", value: "slotIndex" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByRoleLabel" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
          { kind: "Field", name: { kind: "Name", value: "withdrawnAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RespondToRoleProposalMutation, RespondToRoleProposalMutationVariables>;
export const MeetingInitDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MeetingInitData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeMembers" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeAttendance" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeManagerAttendanceRecords" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeExpiredMembers" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingInitData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeMembers" },
                value: { kind: "Variable", name: { kind: "Name", value: "includeMembers" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeAttendance" },
                value: { kind: "Variable", name: { kind: "Name", value: "includeAttendance" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeManagerAttendanceRecords" },
                value: { kind: "Variable", name: { kind: "Name", value: "includeManagerAttendanceRecords" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeExpiredMembers" },
                value: { kind: "Variable", name: { kind: "Name", value: "includeExpiredMembers" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meeting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableMeetings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingSummaryFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "toastmasterRoles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ToastmasterRoleFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clubMembers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubMemberSummaryFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clubInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubInfoSummaryFields" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inProgressMeeting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasInProgress" } },
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "datetime" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingAttendance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryFields" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rsvpRecords" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "MeetingRsvpRecordFields" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attendanceRecords" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "MeetingAttendanceMemberRecordFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingUserFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingUser" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingUserId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "guestId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "tiName" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "relationshipToClub" } },
          { kind: "Field", name: { kind: "Name", value: "isAssigneeNotified" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgendaItemFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgendaItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "rolePosition" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "event" } },
          { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
          { kind: "Field", name: { kind: "Name", value: "greenMark" } },
          { kind: "Field", name: { kind: "Name", value: "amberMark" } },
          { kind: "Field", name: { kind: "Name", value: "redMark" } },
          { kind: "Field", name: { kind: "Name", value: "maxAssignments" } },
          { kind: "Field", name: { kind: "Name", value: "isCompleted" } },
          { kind: "Field", name: { kind: "Name", value: "isRepeatableRole" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignedUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pathwayProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathwayRoleTargets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roleRequests" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                { kind: "Field", name: { kind: "Name", value: "rejectionReason" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VotingRoomFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "VotingRoom" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "standardKey" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isOpen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "candidates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingUserId" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "guestId" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "voteCounts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "candidateId" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedbackSessionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedbackSession" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "isOpen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subjects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingUserId" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "guestId" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSubjectId" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSessionId" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
                { kind: "Field", name: { kind: "Name", value: "aspects" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromAttendee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "feedbackCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agenda" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AgendaItemFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "votingRooms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "VotingRoomFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbackSessions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FeedbackSessionFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "hasBeenFinishedBefore" } },
          { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "sourceAgendaTemplateId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectRequests" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rejections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejectedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ToastmasterRoleFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ToastmasterRole" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "greenMark" } },
          { kind: "Field", name: { kind: "Name", value: "amberMark" } },
          { kind: "Field", name: { kind: "Name", value: "redMark" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "repeatable" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubMemberSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubMemberSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "membershipStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubInfoSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubInfoSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "autoSyncAgendaToVoting" } },
                { kind: "Field", name: { kind: "Name", value: "autoAddAgendaToFeedback" } },
                { kind: "Field", name: { kind: "Name", value: "evaluatorVotingRoles" } },
                { kind: "Field", name: { kind: "Name", value: "allowMemberRoleSelfAssign" } },
                { kind: "Field", name: { kind: "Name", value: "memberSpeechRequestAdvanceDays" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "timezone" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalEligibleMembers" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpMaybeCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpNotAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "attendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "notAttendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "myRsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "myAttendanceStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingRsvpRecordFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingRsvpRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceMemberRecordFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceMemberRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceStatus" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceSource" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingInitDataQuery, MeetingInitDataQueryVariables>;
export const MeetingAttendanceDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MeetingAttendanceData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeManagerRecords" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeExpiredMembers" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingAttendanceSummary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeExpiredMembers" },
                value: { kind: "Variable", name: { kind: "Name", value: "includeExpiredMembers" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceSummaryFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingRsvpRecords" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeExpiredMembers" },
                value: { kind: "Variable", name: { kind: "Name", value: "includeExpiredMembers" } },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: { kind: "Variable", name: { kind: "Name", value: "includeManagerRecords" } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingRsvpRecordFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingAttendanceRecords" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeExpiredMembers" },
                value: { kind: "Variable", name: { kind: "Name", value: "includeExpiredMembers" } },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: { kind: "Variable", name: { kind: "Name", value: "includeManagerRecords" } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "MeetingAttendanceMemberRecordFields" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceSummaryFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceSummary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalEligibleMembers" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpMaybeCount" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpNotAttendingCount" } },
          { kind: "Field", name: { kind: "Name", value: "attendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "notAttendedCount" } },
          { kind: "Field", name: { kind: "Name", value: "myRsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "myAttendanceStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingRsvpRecordFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingRsvpRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingAttendanceMemberRecordFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingAttendanceMemberRecord" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "rsvpStatus" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceStatus" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceSource" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingAttendanceDataQuery, MeetingAttendanceDataQueryVariables>;
export const GetClubPastMeetingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubPastMeetings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "FINISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "datetime" } },
                            { kind: "Field", name: { kind: "Name", value: "localDate" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubPastMeetingsQuery, GetClubPastMeetingsQueryVariables>;
export const GetMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingUserFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingUser" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingUserId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "guestId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "tiName" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "relationshipToClub" } },
          { kind: "Field", name: { kind: "Name", value: "isAssigneeNotified" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgendaItemFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgendaItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "rolePosition" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "event" } },
          { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
          { kind: "Field", name: { kind: "Name", value: "greenMark" } },
          { kind: "Field", name: { kind: "Name", value: "amberMark" } },
          { kind: "Field", name: { kind: "Name", value: "redMark" } },
          { kind: "Field", name: { kind: "Name", value: "maxAssignments" } },
          { kind: "Field", name: { kind: "Name", value: "isCompleted" } },
          { kind: "Field", name: { kind: "Name", value: "isRepeatableRole" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignedUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pathwayProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathwayRoleTargets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roleRequests" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                { kind: "Field", name: { kind: "Name", value: "rejectionReason" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VotingRoomFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "VotingRoom" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "standardKey" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isOpen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "candidates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingUserId" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "guestId" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "voteCounts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "candidateId" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedbackSessionFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedbackSession" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "isOpen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subjects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "agendaSyncKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingUserId" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "guestId" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSubjectId" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSessionId" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
                { kind: "Field", name: { kind: "Name", value: "aspects" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromAttendee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "feedbackCount" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Meeting" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "theme" } },
          { kind: "Field", name: { kind: "Name", value: "datetime" } },
          { kind: "Field", name: { kind: "Name", value: "locationText" } },
          { kind: "Field", name: { kind: "Name", value: "locationMapLink" } },
          { kind: "Field", name: { kind: "Name", value: "wordOfDay" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agenda" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AgendaItemFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "votingRooms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "VotingRoomFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbackSessions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FeedbackSessionFields" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "participants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "hasBeenFinishedBefore" } },
          { kind: "Field", name: { kind: "Name", value: "cancellationReason" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "sourceAgendaTemplateId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectRequests" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rejections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejectedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMeetingQuery, GetMeetingQueryVariables>;
export const GetFeedbackForSubjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFeedbackForSubject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subjectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getFeedbackForSubject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feedbackSessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "feedbackSessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subjectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subjectId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSubjectId" } },
                { kind: "Field", name: { kind: "Name", value: "feedbackSessionId" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
                { kind: "Field", name: { kind: "Name", value: "aspects" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fromAttendee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingUserFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingUser" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingUserId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "guestId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "tiName" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "relationshipToClub" } },
          { kind: "Field", name: { kind: "Name", value: "isAssigneeNotified" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFeedbackForSubjectQuery, GetFeedbackForSubjectQueryVariables>;
export const GetUserVotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserVotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserVotes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingUserIdGuestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingUserIdGuestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "candidateId" } },
                { kind: "Field", name: { kind: "Name", value: "votingRoomId" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserVotesQuery, GetUserVotesQueryVariables>;
export const GetInProgressMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInProgressMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInProgressMeeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "hasInProgress" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "datetime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInProgressMeetingQuery, GetInProgressMeetingQueryVariables>;
export const GetMeetingUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMeetingUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "guestId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMeetingUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "guestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "guestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MeetingUserFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MeetingUserFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeetingUser" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingUserId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "guestId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "tiName" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "relationshipToClub" } },
          { kind: "Field", name: { kind: "Name", value: "isAssigneeNotified" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMeetingUserQuery, GetMeetingUserQueryVariables>;
export const PreviewRoleEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PreviewRoleEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "action" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roleId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipients" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "EmailRecipientInput" } },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "personalNote" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "previewRoleEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "action" },
                value: { kind: "Variable", name: { kind: "Name", value: "action" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roleId" },
                value: { kind: "Variable", name: { kind: "Name", value: "roleId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipients" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipients" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "personalNote" },
                value: { kind: "Variable", name: { kind: "Name", value: "personalNote" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "actionSummary" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailPreviews" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "recipientEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "subject" } },
                      { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PreviewRoleEmailQuery, PreviewRoleEmailQueryVariables>;
export const ProposalsForMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProposalsForMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "proposalsForMeeting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RoleProposalFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleProposalFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RoleProposal" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "meetingId" } },
          { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
          { kind: "Field", name: { kind: "Name", value: "slotIndex" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedToName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByUserId" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByName" } },
          { kind: "Field", name: { kind: "Name", value: "proposedByRoleLabel" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
          { kind: "Field", name: { kind: "Name", value: "withdrawnAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProposalsForMeetingQuery, ProposalsForMeetingQueryVariables>;
export const GetAgendaRemovalImpactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAgendaRemovalImpact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "seats" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "AgendaSeatInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agendaRemovalImpact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "seats" },
                value: { kind: "Variable", name: { kind: "Name", value: "seats" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "meetingHasBeenFinished" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "credits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
                      { kind: "Field", name: { kind: "Name", value: "roleName" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "memberName" } },
                      { kind: "Field", name: { kind: "Name", value: "completionId" } },
                      { kind: "Field", name: { kind: "Name", value: "creditMethod" } },
                      { kind: "Field", name: { kind: "Name", value: "withdrawable" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placement" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "pathwayName" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                            { kind: "Field", name: { kind: "Name", value: "projectName" } },
                            { kind: "Field", name: { kind: "Name", value: "completionType" } },
                            { kind: "Field", name: { kind: "Name", value: "isEducationSeries" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAgendaRemovalImpactQuery, GetAgendaRemovalImpactQueryVariables>;
export const MeetingUpdatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "MeetingUpdates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingUpdates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "eventType" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingUpdatesSubscription, MeetingUpdatesSubscriptionVariables>;
export const ClubMeetingUpdatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "ClubMeetingUpdates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubMeetingUpdates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "eventType" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubMeetingUpdatesSubscription, ClubMeetingUpdatesSubscriptionVariables>;
export const GetMemberActivityTrackerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMemberActivityTracker" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "months" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "memberActivityTracker" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "months" },
                value: { kind: "Variable", name: { kind: "Name", value: "months" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "periodStart" } },
                { kind: "Field", name: { kind: "Name", value: "periodEnd" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "totalMembers" } },
                      { kind: "Field", name: { kind: "Name", value: "membersWithActivePathwayEnrollment" } },
                      { kind: "Field", name: { kind: "Name", value: "membersWithMultipleActivePathwayEnrollments" } },
                      { kind: "Field", name: { kind: "Name", value: "frequentMembers" } },
                      { kind: "Field", name: { kind: "Name", value: "infrequentMembers" } },
                      { kind: "Field", name: { kind: "Name", value: "dormantMembers" } },
                      { kind: "Field", name: { kind: "Name", value: "meetingsInPeriod" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "memberId" } },
                      { kind: "Field", name: { kind: "Name", value: "memberName" } },
                      { kind: "Field", name: { kind: "Name", value: "activityLevel" } },
                      { kind: "Field", name: { kind: "Name", value: "lastParticipationDate" } },
                      { kind: "Field", name: { kind: "Name", value: "lastAttendedDate" } },
                      { kind: "Field", name: { kind: "Name", value: "membershipStatus" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stats" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "meetingsWithParticipation" } },
                            { kind: "Field", name: { kind: "Name", value: "rolesCount" } },
                            { kind: "Field", name: { kind: "Name", value: "speechesCount" } },
                            { kind: "Field", name: { kind: "Name", value: "tableTopicsCount" } },
                            { kind: "Field", name: { kind: "Name", value: "meetingsAttended" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meetingDates" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "date" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMemberActivityTrackerQuery, GetMemberActivityTrackerQueryVariables>;
export const GetMemberActivityDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMemberActivityDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "memberUserId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "months" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "memberActivityDetail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "memberUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "memberUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "months" },
                value: { kind: "Variable", name: { kind: "Name", value: "months" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "memberId" } },
                { kind: "Field", name: { kind: "Name", value: "memberName" } },
                { kind: "Field", name: { kind: "Name", value: "lastParticipationDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastAttendedDate" } },
                { kind: "Field", name: { kind: "Name", value: "periodStart" } },
                { kind: "Field", name: { kind: "Name", value: "periodEnd" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingDates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "meetingsAttended" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roleBreakdown" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "roleType" } },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                      { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "speechHistory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "completionId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMemberActivityDetailQuery, GetMemberActivityDetailQueryVariables>;
export const RemoveMemberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveMember" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeMember" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const SendPaymentReminderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendPaymentReminder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendPaymentReminder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendPaymentReminderMutation, SendPaymentReminderMutationVariables>;
export const MarkMemberPaidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MarkMemberPaid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markMemberPaid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkMemberPaidMutation, MarkMemberPaidMutationVariables>;
export const MarkMemberNotRenewingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MarkMemberNotRenewing" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markMemberNotRenewing" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkMemberNotRenewingMutation, MarkMemberNotRenewingMutationVariables>;
export const MarkMemberNotifiedAsPaidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MarkMemberNotifiedAsPaid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markMemberNotifiedAsPaid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkMemberNotifiedAsPaidMutation, MarkMemberNotifiedAsPaidMutationVariables>;
export const ClearMemberPaymentStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ClearMemberPaymentStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearMemberPaymentStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClearMemberPaymentStatusMutation, ClearMemberPaymentStatusMutationVariables>;
export const SendAllPaymentRemindersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendAllPaymentReminders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendAllPaymentReminders" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendAllPaymentRemindersMutation, SendAllPaymentRemindersMutationVariables>;
export const UpdateMembershipConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMembershipConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "config" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "MembershipConfigInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "expected" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "MembershipConfigInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMembershipConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "config" },
                value: { kind: "Variable", name: { kind: "Name", value: "config" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "expected" },
                value: { kind: "Variable", name: { kind: "Name", value: "expected" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMembershipConfigMutation, UpdateMembershipConfigMutationVariables>;
export const AssignOfficerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AssignOfficer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "membershipId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "memberName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roleName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignOfficer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "membershipId" },
                value: { kind: "Variable", name: { kind: "Name", value: "membershipId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "memberName" },
                value: { kind: "Variable", name: { kind: "Name", value: "memberName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roleName" },
                value: { kind: "Variable", name: { kind: "Name", value: "roleName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OfficerResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClubOfficerFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClubOfficer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "roleDisplayName" } },
          { kind: "Field", name: { kind: "Name", value: "termBegin" } },
          { kind: "Field", name: { kind: "Name", value: "termEnd" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OfficerResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OfficerResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClubOfficerFields" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignOfficerMutation, AssignOfficerMutationVariables>;
export const RemoveOfficerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveOfficer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "officerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeOfficer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "officerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "officerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SimpleResultFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimpleResultFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SimpleResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "errorCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveOfficerMutation, RemoveOfficerMutationVariables>;
export const PublicMemberNotRenewingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PublicMemberNotRenewing" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicMemberNotRenewing" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubShortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "clubLongName" } },
                { kind: "Field", name: { kind: "Name", value: "memberName" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicMemberNotRenewingMutation, PublicMemberNotRenewingMutationVariables>;
export const PublicMemberMarkAsPaidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PublicMemberMarkAsPaid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicMemberMarkAsPaid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubShortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "clubLongName" } },
                { kind: "Field", name: { kind: "Name", value: "memberName" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicMemberMarkAsPaidMutation, PublicMemberMarkAsPaidMutationVariables>;
export const SubmitNewMemberFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitNewMemberForm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "NewMemberFormInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitNewMemberForm" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubShortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: { kind: "Variable", name: { kind: "Name", value: "data" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
                { kind: "Field", name: { kind: "Name", value: "actionId" } },
                { kind: "Field", name: { kind: "Name", value: "allowCardPayments" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitNewMemberFormMutation, SubmitNewMemberFormMutationVariables>;
export const ConfirmPendingMembershipApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmPendingMembershipApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "applicationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmPendingMembershipApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "applicationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "applicationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmPendingMembershipApplicationMutation,
  ConfirmPendingMembershipApplicationMutationVariables
>;
export const ResendPendingMembershipVerificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResendPendingMembershipVerification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "applicationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resendPendingMembershipVerification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "applicationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "applicationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResendPendingMembershipVerificationMutation,
  ResendPendingMembershipVerificationMutationVariables
>;
export const GetMembersSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMembersSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "membersSummary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "membershipId" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "fullName" } },
                      { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
                      { kind: "Field", name: { kind: "Name", value: "mobilePhone" } },
                      { kind: "Field", name: { kind: "Name", value: "memberType" } },
                      { kind: "Field", name: { kind: "Name", value: "thStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "tiStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "paidUntilTH" } },
                      { kind: "Field", name: { kind: "Name", value: "paidUntilTI" } },
                      { kind: "Field", name: { kind: "Name", value: "latestPaymentDate" } },
                      { kind: "Field", name: { kind: "Name", value: "markAsPaidUntil" } },
                      { kind: "Field", name: { kind: "Name", value: "clubJoinDate" } },
                      { kind: "Field", name: { kind: "Name", value: "isPaid" } },
                      { kind: "Field", name: { kind: "Name", value: "isDue" } },
                      { kind: "Field", name: { kind: "Name", value: "statusString" } },
                      { kind: "Field", name: { kind: "Name", value: "lastEmailSent" } },
                      { kind: "Field", name: { kind: "Name", value: "lastLogin" } },
                      { kind: "Field", name: { kind: "Name", value: "actionId" } },
                      { kind: "Field", name: { kind: "Name", value: "hasApplicationDetails" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailStatus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                            { kind: "Field", name: { kind: "Name", value: "since" } },
                            { kind: "Field", name: { kind: "Name", value: "address" } },
                            { kind: "Field", name: { kind: "Name", value: "canMarkWorking" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalMembers" } },
                { kind: "Field", name: { kind: "Name", value: "tiMembers" } },
                { kind: "Field", name: { kind: "Name", value: "activeMembers" } },
                { kind: "Field", name: { kind: "Name", value: "dueCount" } },
                { kind: "Field", name: { kind: "Name", value: "notRenewingCount" } },
                { kind: "Field", name: { kind: "Name", value: "lastMembershipImport" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMembersSummaryQuery, GetMembersSummaryQueryVariables>;
export const GetMembershipConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMembershipConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "membershipConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "allowNewMembers" } },
                { kind: "Field", name: { kind: "Name", value: "chargeInFullMonths" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "newMemberFeePence" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyDuesPence" } },
                { kind: "Field", name: { kind: "Name", value: "allowCardPayments" } },
                { kind: "Field", name: { kind: "Name", value: "allowBankTransfers" } },
                { kind: "Field", name: { kind: "Name", value: "sortCode" } },
                { kind: "Field", name: { kind: "Name", value: "accountNo" } },
                { kind: "Field", name: { kind: "Name", value: "accountName" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                { kind: "Field", name: { kind: "Name", value: "rolloverDays" } },
                { kind: "Field", name: { kind: "Name", value: "minMonthsToCharge" } },
                { kind: "Field", name: { kind: "Name", value: "renewalCycle" } },
                { kind: "Field", name: { kind: "Name", value: "officerTermMonths" } },
                { kind: "Field", name: { kind: "Name", value: "customRenewalText" } },
                { kind: "Field", name: { kind: "Name", value: "hasCustomRenewalText" } },
                { kind: "Field", name: { kind: "Name", value: "defaultRenewalText" } },
                { kind: "Field", name: { kind: "Name", value: "customNewMemberText" } },
                { kind: "Field", name: { kind: "Name", value: "defaultNewMemberText" } },
                { kind: "Field", name: { kind: "Name", value: "customLongExpiredText" } },
                { kind: "Field", name: { kind: "Name", value: "defaultLongExpiredText" } },
                { kind: "Field", name: { kind: "Name", value: "cardsEnablable" } },
                { kind: "Field", name: { kind: "Name", value: "validCurrencies" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMembershipConfigQuery, GetMembershipConfigQueryVariables>;
export const GetActivePaidMembersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActivePaidMembers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activePaidMembers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "membershipId" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "emailAddress" } },
                { kind: "Field", name: { kind: "Name", value: "isPaid" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActivePaidMembersQuery, GetActivePaidMembersQueryVariables>;
export const GetClubMemberApplicationDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubMemberApplicationDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubMemberApplicationDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "newMemberType" } },
                { kind: "Field", name: { kind: "Name", value: "previousMembershipDetails" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "middleName" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                { kind: "Field", name: { kind: "Name", value: "mobilePhone" } },
                { kind: "Field", name: { kind: "Name", value: "homePhone" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "attentionCareOf" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "postcode" } },
                { kind: "Field", name: { kind: "Name", value: "contactByMail" } },
                { kind: "Field", name: { kind: "Name", value: "contactByEmail" } },
                { kind: "Field", name: { kind: "Name", value: "contactByPhone" } },
                { kind: "Field", name: { kind: "Name", value: "releaseAccepted" } },
                { kind: "Field", name: { kind: "Name", value: "toastmastersPromiseAccepted" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubMemberApplicationDetailsQuery, GetClubMemberApplicationDetailsQueryVariables>;
export const GetMembershipEmailPreviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMembershipEmailPreview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "draftRenewalText" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "draftNewMemberText" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "draftLongExpiredText" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "membershipEmailPreview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "draftRenewalText" },
                value: { kind: "Variable", name: { kind: "Name", value: "draftRenewalText" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "draftNewMemberText" },
                value: { kind: "Variable", name: { kind: "Name", value: "draftNewMemberText" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "draftLongExpiredText" },
                value: { kind: "Variable", name: { kind: "Name", value: "draftLongExpiredText" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "newMemberPreview" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subject" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "fromAddress" } },
                      { kind: "Field", name: { kind: "Name", value: "replyToAddress" } },
                      { kind: "Field", name: { kind: "Name", value: "toAddress" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "renewalPreview" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subject" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "fromAddress" } },
                      { kind: "Field", name: { kind: "Name", value: "replyToAddress" } },
                      { kind: "Field", name: { kind: "Name", value: "toAddress" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "longExpiredPreview" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subject" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "fromAddress" } },
                      { kind: "Field", name: { kind: "Name", value: "replyToAddress" } },
                      { kind: "Field", name: { kind: "Name", value: "toAddress" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMembershipEmailPreviewQuery, GetMembershipEmailPreviewQueryVariables>;
export const GetMembershipFeesPreviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMembershipFeesPreview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "membershipFeesPreview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "today" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentValues" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "amount" } },
                      { kind: "Field", name: { kind: "Name", value: "shortAmount" } },
                      { kind: "Field", name: { kind: "Name", value: "startDate" } },
                      { kind: "Field", name: { kind: "Name", value: "endDate" } },
                      { kind: "Field", name: { kind: "Name", value: "months" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMembershipFeesPreviewQuery, GetMembershipFeesPreviewQueryVariables>;
export const GetTemplateVariablesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTemplateVariables" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "templateType" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "templateVariables" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "templateType" },
                value: { kind: "Variable", name: { kind: "Name", value: "templateType" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "exampleValue" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "isHtml" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTemplateVariablesQuery, GetTemplateVariablesQueryVariables>;
export const GetNewMemberFormInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetNewMemberFormInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "newMemberFormInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubShortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clubShortName" } },
                { kind: "Field", name: { kind: "Name", value: "clubLongName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "newMemberTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "newMemberFee" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyClubFee" } },
                { kind: "Field", name: { kind: "Name", value: "totalJoiningFee" } },
                { kind: "Field", name: { kind: "Name", value: "allowNewMembers" } },
                { kind: "Field", name: { kind: "Name", value: "clubContactEmail" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetNewMemberFormInfoQuery, GetNewMemberFormInfoQueryVariables>;
export const GetMemberPaymentDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMemberPaymentData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "memberPaymentData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubShortName" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubShortName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "actionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "actionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientIntentSecret" } },
                { kind: "Field", name: { kind: "Name", value: "stripePublishableKey" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "testMode" } },
                { kind: "Field", name: { kind: "Name", value: "clubLongName" } },
                { kind: "Field", name: { kind: "Name", value: "memberName" } },
                { kind: "Field", name: { kind: "Name", value: "fullDuesAmountDesc" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "alreadyPaid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMemberPaymentDataQuery, GetMemberPaymentDataQueryVariables>;
export const GetClubPendingMembershipApplicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubPendingMembershipApplications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubPendingMembershipApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetClubPendingMembershipApplicationsQuery,
  GetClubPendingMembershipApplicationsQueryVariables
>;
export const UpdateUserEnrollmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUserEnrollments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserEnrollments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayIds" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
                      { kind: "Field", name: { kind: "Name", value: "currentLevel" } },
                      { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserEnrollmentsMutation, UpdateUserEnrollmentsMutationVariables>;
export const EnrollMemberInPathwaysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EnrollMemberInPathways" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "enrollMemberInPathways" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayIds" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
                      { kind: "Field", name: { kind: "Name", value: "currentLevel" } },
                      { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnrollMemberInPathwaysMutation, EnrollMemberInPathwaysMutationVariables>;
export const RemoveMemberPathwayEnrollmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveMemberPathwayEnrollment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeMemberPathwayEnrollment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayId" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveMemberPathwayEnrollmentMutation, RemoveMemberPathwayEnrollmentMutationVariables>;
export const UpdateSpeechCompletionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateSpeechCompletion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clearProjectLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clearSpeechTitle" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "confirmationToken" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateSpeechCompletion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "completionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speechTitle" },
                value: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clearProjectLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "clearProjectLink" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clearSpeechTitle" },
                value: { kind: "Variable", name: { kind: "Name", value: "clearSpeechTitle" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "confirmationToken" },
                value: { kind: "Variable", name: { kind: "Name", value: "confirmationToken" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "completionType" } },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "roleType" } },
                      { kind: "Field", name: { kind: "Name", value: "roleName" } },
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSpeechCompletionMutation, UpdateSpeechCompletionMutationVariables>;
export const RemoveSpeechCompletionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveSpeechCompletion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeSpeechCompletion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "completionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveSpeechCompletionMutation, RemoveSpeechCompletionMutationVariables>;
export const RecordManualSpeechCompletionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RecordManualSpeechCompletion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "level" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "completedDate" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recordManualSpeechCompletion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayId" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: { kind: "Variable", name: { kind: "Name", value: "level" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speechTitle" },
                value: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "completedDate" },
                value: { kind: "Variable", name: { kind: "Name", value: "completedDate" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "completionType" } },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "roleType" } },
                      { kind: "Field", name: { kind: "Name", value: "roleName" } },
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecordManualSpeechCompletionMutation, RecordManualSpeechCompletionMutationVariables>;
export const RecordNonSpeechCompletionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RecordNonSpeechCompletion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "level" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "completedDate" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recordNonSpeechCompletion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayId" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: { kind: "Variable", name: { kind: "Name", value: "level" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "completedDate" },
                value: { kind: "Variable", name: { kind: "Name", value: "completedDate" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "completionType" } },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "roleType" } },
                      { kind: "Field", name: { kind: "Name", value: "roleName" } },
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecordNonSpeechCompletionMutation, RecordNonSpeechCompletionMutationVariables>;
export const RecordManualRoleCompletionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RecordManualRoleCompletion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingDate" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roleName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "level" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayRoleName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recordManualRoleCompletion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingId" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingDate" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingDate" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roleName" },
                value: { kind: "Variable", name: { kind: "Name", value: "roleName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayId" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: { kind: "Variable", name: { kind: "Name", value: "level" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayRoleName" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayRoleName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "clubId" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "completionType" } },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "roleType" } },
                      { kind: "Field", name: { kind: "Name", value: "roleName" } },
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecordManualRoleCompletionMutation, RecordManualRoleCompletionMutationVariables>;
export const LinkRoleParticipationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LinkRoleParticipation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "participationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "targetUserId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "level" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roleName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "linkRoleParticipation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "participationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "participationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "targetUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayId" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "level" },
                value: { kind: "Variable", name: { kind: "Name", value: "level" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roleName" },
                value: { kind: "Variable", name: { kind: "Name", value: "roleName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "completionId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
                { kind: "Field", name: { kind: "Name", value: "roleKey" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkRoleParticipationMutation, LinkRoleParticipationMutationVariables>;
export const UnlinkRoleParticipationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UnlinkRoleParticipation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unlinkRoleParticipation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "completionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnlinkRoleParticipationMutation, UnlinkRoleParticipationMutationVariables>;
export const GetPathwaysWithDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPathwaysWithDetails" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "pathways" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayCode" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projects" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "objectiveId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "projectType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "speechTimings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "greenSeconds" } },
                            { kind: "Field", name: { kind: "Name", value: "amberSeconds" } },
                            { kind: "Field", name: { kind: "Name", value: "redSeconds" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                      { kind: "Field", name: { kind: "Name", value: "officialProjectId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "levelRequirements" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "requiredProjects" } },
                      { kind: "Field", name: { kind: "Name", value: "electiveProjects" } },
                      { kind: "Field", name: { kind: "Name", value: "electivesRequired" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "educationSeriesRequirement" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "series" } },
                            { kind: "Field", name: { kind: "Name", value: "count" } },
                            { kind: "Field", name: { kind: "Name", value: "presentationIds" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roleRequirement" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "roles" } },
                            { kind: "Field", name: { kind: "Name", value: "count" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "requiredRoleQuotas" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "roles" } },
                                  { kind: "Field", name: { kind: "Name", value: "minimum" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPathwaysWithDetailsQuery, GetPathwaysWithDetailsQueryVariables>;
export const GetPathwayProjectsProseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPathwayProjectsProse" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "pathwayProjects" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: { kind: "Variable", name: { kind: "Name", value: "ids" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "objectives" } },
                { kind: "Field", name: { kind: "Name", value: "agendaSummary" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPathwayProjectsProseQuery, GetPathwayProjectsProseQueryVariables>;
export const GetMyPathwayEnrollmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyPathwayEnrollments" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myPathwayEnrollments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
                { kind: "Field", name: { kind: "Name", value: "currentLevel" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyPathwayEnrollmentsQuery, GetMyPathwayEnrollmentsQueryVariables>;
export const GetMyPathwayCompletionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyPathwayCompletions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myPathwayCompletions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayId" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "completionType" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                { kind: "Field", name: { kind: "Name", value: "roleType" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyPathwayCompletionsQuery, GetMyPathwayCompletionsQueryVariables>;
export const GetMyMentorProgramPrerequisiteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyMentorProgramPrerequisite" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myMentorProgramPrerequisite" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "prerequisiteMet" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyMentorProgramPrerequisiteQuery, GetMyMentorProgramPrerequisiteQueryVariables>;
export const GetUserPathwayDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserPathwayData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "participationLimit" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myPathwayEnrollments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
                { kind: "Field", name: { kind: "Name", value: "currentLevel" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "myPathwayCompletions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayId" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "completionType" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                { kind: "Field", name: { kind: "Name", value: "roleType" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "myParticipationRecords" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "Variable", name: { kind: "Name", value: "participationLimit" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
                { kind: "Field", name: { kind: "Name", value: "participationType" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "roleType" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
                { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                { kind: "Field", name: { kind: "Name", value: "creditedBy" } },
                { kind: "Field", name: { kind: "Name", value: "creditSource" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayCompletionId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayProjectId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserPathwayDataQuery, GetUserPathwayDataQueryVariables>;
export const GetEducationSeriesCatalogDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEducationSeriesCatalog" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "educationSeriesCatalog" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "seriesKey" } },
                { kind: "Field", name: { kind: "Name", value: "seriesName" } },
                { kind: "Field", name: { kind: "Name", value: "tiCode" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "defaultDurationMinutes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "speechTimings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "greenSeconds" } },
                      { kind: "Field", name: { kind: "Name", value: "amberSeconds" } },
                      { kind: "Field", name: { kind: "Name", value: "redSeconds" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "recommendedAudience" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pathwaysRequirement" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "assetType" } },
                      { kind: "Field", name: { kind: "Name", value: "file" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "facilitatorTips" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "materialsLinks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "facilitatorGuideUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "slidesUrl" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEducationSeriesCatalogQuery, GetEducationSeriesCatalogQueryVariables>;
export const GetClubPathwayChartDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubPathwayChart" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubPathwayChart" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "memberId" } },
                { kind: "Field", name: { kind: "Name", value: "memberName" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayName" } },
                { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
                { kind: "Field", name: { kind: "Name", value: "currentLevel" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastSpokeDate" } },
                { kind: "Field", name: { kind: "Name", value: "pendingRequestCount" } },
                { kind: "Field", name: { kind: "Name", value: "completionCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "levels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "required" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "total" } },
                            { kind: "Field", name: { kind: "Name", value: "completed" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "electives" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "total" } },
                            { kind: "Field", name: { kind: "Name", value: "completed" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "education" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "total" } },
                            { kind: "Field", name: { kind: "Name", value: "completed" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roleQuota" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "total" } },
                            { kind: "Field", name: { kind: "Name", value: "completed" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "segments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                            { kind: "Field", name: { kind: "Name", value: "completionId" } },
                            { kind: "Field", name: { kind: "Name", value: "completionDate" } },
                            { kind: "Field", name: { kind: "Name", value: "projectName" } },
                            { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                            { kind: "Field", name: { kind: "Name", value: "completionType" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roleBreakdown" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "roleName" } },
                            { kind: "Field", name: { kind: "Name", value: "count" } },
                            { kind: "Field", name: { kind: "Name", value: "requiredMinimum" } },
                            { kind: "Field", name: { kind: "Name", value: "meetsMinimum" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubPathwayChartQuery, GetClubPathwayChartQueryVariables>;
export const GetMemberPathwayEnrollmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMemberPathwayEnrollments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "memberUserId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "memberPathwayEnrollments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "memberUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "memberUserId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
                { kind: "Field", name: { kind: "Name", value: "currentLevel" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMemberPathwayEnrollmentsQuery, GetMemberPathwayEnrollmentsQueryVariables>;
export const GetMemberPathwayProgressDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMemberPathwayProgress" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "memberUserId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "memberPathwayProgress" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "memberUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "memberUserId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrollments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
                      { kind: "Field", name: { kind: "Name", value: "currentLevel" } },
                      { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "completions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projectRequests" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMemberPathwayProgressQuery, GetMemberPathwayProgressQueryVariables>;
export const GetUpcomingMeetingDatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUpcomingMeetingDates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "monthsAhead" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubUpcomingMeetingDates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "monthsAhead" },
                value: { kind: "Variable", name: { kind: "Name", value: "monthsAhead" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "availableSlots" } },
                { kind: "Field", name: { kind: "Name", value: "isProjected" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUpcomingMeetingDatesQuery, GetUpcomingMeetingDatesQueryVariables>;
export const GetClubProjectRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubProjectRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubProjectRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rejections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejectedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
                { kind: "Field", name: { kind: "Name", value: "scheduledCancellable" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubProjectRequestsQuery, GetClubProjectRequestsQueryVariables>;
export const GetMyClubProjectRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyClubProjectRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myClubProjectRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rejections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejectedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
                { kind: "Field", name: { kind: "Name", value: "scheduledCancellable" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyClubProjectRequestsQuery, GetMyClubProjectRequestsQueryVariables>;
export const GetRoleLinkCandidatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRoleLinkCandidates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "targetUserId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pathwayIds" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "hideAlreadyLinked" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          defaultValue: { kind: "BooleanValue", value: true },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roleLinkCandidates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "targetUserId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathwayIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "pathwayIds" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hideAlreadyLinked" },
                value: { kind: "Variable", name: { kind: "Name", value: "hideAlreadyLinked" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "participationId" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "meetingDate" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "clubName" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
                { kind: "Field", name: { kind: "Name", value: "roleDescription" } },
                { kind: "Field", name: { kind: "Name", value: "roleKey" } },
                { kind: "Field", name: { kind: "Name", value: "alreadyLinked" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linkedTo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "completionId" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "roleName" } },
                      { kind: "Field", name: { kind: "Name", value: "roleKey" } },
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRoleLinkCandidatesQuery, GetRoleLinkCandidatesQueryVariables>;
export const GetRoleRequirementCandidatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRoleRequirementCandidates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "targetUserId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roleRequirementCandidates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetUserId" },
                value: { kind: "Variable", name: { kind: "Name", value: "targetUserId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayName" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "levelStatus" } },
                { kind: "Field", name: { kind: "Name", value: "roleName" } },
                { kind: "Field", name: { kind: "Name", value: "roleNames" } },
                { kind: "Field", name: { kind: "Name", value: "roleKey" } },
                { kind: "Field", name: { kind: "Name", value: "doneCount" } },
                { kind: "Field", name: { kind: "Name", value: "requiredMinimum" } },
                { kind: "Field", name: { kind: "Name", value: "requirementSource" } },
                { kind: "Field", name: { kind: "Name", value: "quotaSatisfied" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roleRequirementMatchKeys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "spelling" } },
                { kind: "Field", name: { kind: "Name", value: "matchKey" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRoleRequirementCandidatesQuery, GetRoleRequirementCandidatesQueryVariables>;
export const GetRoleRequirementMatchKeysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRoleRequirementMatchKeys" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roleRequirementMatchKeys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "spelling" } },
                { kind: "Field", name: { kind: "Name", value: "matchKey" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRoleRequirementMatchKeysQuery, GetRoleRequirementMatchKeysQueryVariables>;
export const CreateProjectRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateProjectRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "preferredDates" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notes" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notifyVpe" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createProjectRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speechTitle" },
                value: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preferredDates" },
                value: { kind: "Variable", name: { kind: "Name", value: "preferredDates" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "notes" },
                value: { kind: "Variable", name: { kind: "Name", value: "notes" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "notifyVpe" },
                value: { kind: "Variable", name: { kind: "Name", value: "notifyVpe" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approvedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "date" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rejectedBy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "userId" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                      { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
                      { kind: "Field", name: { kind: "Name", value: "scheduledCancellable" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProjectRequestMutation, CreateProjectRequestMutationVariables>;
export const UpdateProjectRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateProjectRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "preferredDates" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notifyVpe" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clearProjectLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProjectRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "speechTitle" },
                value: { kind: "Variable", name: { kind: "Name", value: "speechTitle" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preferredDates" },
                value: { kind: "Variable", name: { kind: "Name", value: "preferredDates" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "notifyVpe" },
                value: { kind: "Variable", name: { kind: "Name", value: "notifyVpe" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clearProjectLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "clearProjectLink" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approvedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "date" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rejectedBy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "userId" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                      { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
                      { kind: "Field", name: { kind: "Name", value: "scheduledCancellable" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProjectRequestMutation, UpdateProjectRequestMutationVariables>;
export const CancelProjectRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelProjectRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelProjectRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approvedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "date" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rejectedBy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "userId" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                      { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
                      { kind: "Field", name: { kind: "Name", value: "scheduledCancellable" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelProjectRequestMutation, CancelProjectRequestMutationVariables>;
export const CancelOwnProjectRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelOwnProjectRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelOwnProjectRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approvedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "date" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rejectedBy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "userId" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                      { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
                      { kind: "Field", name: { kind: "Name", value: "scheduledCancellable" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelOwnProjectRequestMutation, CancelOwnProjectRequestMutationVariables>;
export const RemoveProjectRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveProjectRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeProjectRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approvedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "date" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rejectedBy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "userId" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                      { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
                      { kind: "Field", name: { kind: "Name", value: "scheduledCancellable" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveProjectRequestMutation, RemoveProjectRequestMutationVariables>;
export const CancelScheduledProjectRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelScheduledProjectRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelScheduledProjectRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approvedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "date" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rejectedBy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "userId" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                      { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
                      { kind: "Field", name: { kind: "Name", value: "scheduledCancellable" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelScheduledProjectRequestMutation, CancelScheduledProjectRequestMutationVariables>;
export const CancelOwnScheduledProjectRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelOwnScheduledProjectRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelOwnScheduledProjectRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requestId" },
                value: { kind: "Variable", name: { kind: "Name", value: "requestId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "speechTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "requestedAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approvedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "userId" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "assignedMeetingDateTime" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredDates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "date" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rejectedBy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "userId" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPendingDates" } },
                      { kind: "Field", name: { kind: "Name", value: "createdByOfficer" } },
                      { kind: "Field", name: { kind: "Name", value: "scheduledCancellable" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelOwnScheduledProjectRequestMutation,
  CancelOwnScheduledProjectRequestMutationVariables
>;
export const GetClubRelationshipTimelineDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubRelationshipTimeline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubRelationshipTimeline" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "currentState" } },
                { kind: "Field", name: { kind: "Name", value: "firstContactAt" } },
                { kind: "Field", name: { kind: "Name", value: "lastContactAt" } },
                { kind: "Field", name: { kind: "Name", value: "guestSignedAt" } },
                { kind: "Field", name: { kind: "Name", value: "applicationSubmittedAt" } },
                { kind: "Field", name: { kind: "Name", value: "convertedToMemberAt" } },
                { kind: "Field", name: { kind: "Name", value: "paidUntil" } },
                { kind: "Field", name: { kind: "Name", value: "paidUntilTI" } },
                { kind: "Field", name: { kind: "Name", value: "notRenewing" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "events" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "eventType" } },
                      { kind: "Field", name: { kind: "Name", value: "fromState" } },
                      { kind: "Field", name: { kind: "Name", value: "toState" } },
                      { kind: "Field", name: { kind: "Name", value: "triggeredByUserId" } },
                      { kind: "Field", name: { kind: "Name", value: "occurredAt" } },
                      { kind: "Field", name: { kind: "Name", value: "businessOccurredAt" } },
                      { kind: "Field", name: { kind: "Name", value: "recordedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "isBackfill" } },
                      { kind: "Field", name: { kind: "Name", value: "isInferred" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                      { kind: "Field", name: { kind: "Name", value: "paidUntil" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubRelationshipTimelineQuery, GetClubRelationshipTimelineQueryVariables>;
export const UpdateClubEducationConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateClubEducationConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "hiddenRoleHistoryRoleTypes" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateClubEducationConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hiddenRoleHistoryRoleTypes" },
                value: { kind: "Variable", name: { kind: "Name", value: "hiddenRoleHistoryRoleTypes" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "hiddenRoleHistoryRoleTypes" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClubEducationConfigMutation, UpdateClubEducationConfigMutationVariables>;
export const GetClubRoleHistoryChartDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClubRoleHistoryChart" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clubRoleHistoryChart" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "membersTotal" } },
                { kind: "Field", name: { kind: "Name", value: "membersWithAnyRoles" } },
                { kind: "Field", name: { kind: "Name", value: "roleTypes" } },
                { kind: "Field", name: { kind: "Name", value: "allKnownRoleTypes" } },
                { kind: "Field", name: { kind: "Name", value: "hiddenRoleHistoryRoleTypes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "memberId" } },
                      { kind: "Field", name: { kind: "Name", value: "memberName" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roleStats" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "roleType" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stat" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "count" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastMeetingId" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubRoleHistoryChartQuery, GetClubRoleHistoryChartQueryVariables>;
export const GetSpeechCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSpeechCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "speechId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "speech" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "speechId" },
                value: { kind: "Variable", name: { kind: "Name", value: "speechId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SpeechCardFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpeechCardFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SpeechCard" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "memberName" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
          { kind: "Field", name: { kind: "Name", value: "isPlaced" } },
          { kind: "Field", name: { kind: "Name", value: "deliveredAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meeting" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "datetime" } },
                { kind: "Field", name: { kind: "Name", value: "theme" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "placement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayName" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "completionType" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "projectName" } },
                { kind: "Field", name: { kind: "Name", value: "isEducationSeries" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "provenance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "completionId" } },
                { kind: "Field", name: { kind: "Name", value: "creditMethod" } },
                { kind: "Field", name: { kind: "Name", value: "creditedBy" } },
                { kind: "Field", name: { kind: "Name", value: "creditedByName" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "creditedTitle" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "history" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventType" } },
                { kind: "Field", name: { kind: "Name", value: "occurredAt" } },
                { kind: "Field", name: { kind: "Name", value: "actorUserId" } },
                { kind: "Field", name: { kind: "Name", value: "actorName" } },
                { kind: "Field", name: { kind: "Name", value: "actorProcess" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                { kind: "Field", name: { kind: "Name", value: "provenance" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "field" } },
                      { kind: "Field", name: { kind: "Name", value: "from" } },
                      { kind: "Field", name: { kind: "Name", value: "to" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSpeechCardQuery, GetSpeechCardQueryVariables>;
export const GetSpeechCardForCompletionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSpeechCardForCompletion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "speechForCompletion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "completionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SpeechCardFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpeechCardFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SpeechCard" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "memberName" } },
          { kind: "Field", name: { kind: "Name", value: "clubId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
          { kind: "Field", name: { kind: "Name", value: "isPlaced" } },
          { kind: "Field", name: { kind: "Name", value: "deliveredAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meeting" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "datetime" } },
                { kind: "Field", name: { kind: "Name", value: "theme" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "placement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                { kind: "Field", name: { kind: "Name", value: "pathwayName" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "completionType" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "projectName" } },
                { kind: "Field", name: { kind: "Name", value: "isEducationSeries" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "provenance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "completionId" } },
                { kind: "Field", name: { kind: "Name", value: "creditMethod" } },
                { kind: "Field", name: { kind: "Name", value: "creditedBy" } },
                { kind: "Field", name: { kind: "Name", value: "creditedByName" } },
                { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "creditedTitle" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "history" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "eventType" } },
                { kind: "Field", name: { kind: "Name", value: "occurredAt" } },
                { kind: "Field", name: { kind: "Name", value: "actorUserId" } },
                { kind: "Field", name: { kind: "Name", value: "actorName" } },
                { kind: "Field", name: { kind: "Name", value: "actorProcess" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                { kind: "Field", name: { kind: "Name", value: "provenance" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "field" } },
                      { kind: "Field", name: { kind: "Name", value: "from" } },
                      { kind: "Field", name: { kind: "Name", value: "to" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSpeechCardForCompletionQuery, GetSpeechCardForCompletionQueryVariables>;
export const GetSpeechEditImpactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSpeechEditImpact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clearProjectLink" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "speechEditImpact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "completionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "completionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clearProjectLink" },
                value: { kind: "Variable", name: { kind: "Name", value: "clearProjectLink" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "changesCreditedProgress" } },
                { kind: "Field", name: { kind: "Name", value: "changedFields" } },
                { kind: "Field", name: { kind: "Name", value: "confirmationToken" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "current" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwayName" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "completionType" } },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "projectName" } },
                      { kind: "Field", name: { kind: "Name", value: "isEducationSeries" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "proposed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "pathwayId" } },
                      { kind: "Field", name: { kind: "Name", value: "pathwayName" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "completionType" } },
                      { kind: "Field", name: { kind: "Name", value: "projectId" } },
                      { kind: "Field", name: { kind: "Name", value: "projectName" } },
                      { kind: "Field", name: { kind: "Name", value: "isEducationSeries" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditsOnTargetProject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "completionId" } },
                      { kind: "Field", name: { kind: "Name", value: "completedDate" } },
                      { kind: "Field", name: { kind: "Name", value: "creditedTitle" } },
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSpeechEditImpactQuery, GetSpeechEditImpactQueryVariables>;
export const GetSpeechesForMeetingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSpeechesForMeetings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meetingIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "speechesForMeetings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "meetingIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "meetingIds" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "completionId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSpeechesForMeetingsQuery, GetSpeechesForMeetingsQueryVariables>;
export const GetMyUpcomingSpeechesWithoutRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyUpcomingSpeechesWithoutRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myUpcomingSpeechesWithoutRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clubId" },
                value: { kind: "Variable", name: { kind: "Name", value: "clubId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "clubId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meeting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "meetingId" } },
                      { kind: "Field", name: { kind: "Name", value: "datetime" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "agendaItemId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMyUpcomingSpeechesWithoutRequestQuery,
  GetMyUpcomingSpeechesWithoutRequestQueryVariables
>;
